import PropTypes from 'prop-types';
import * as React from 'react';
import React__default, { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import { Modal, Backdrop, Grid, ToggleButtonGroup, ToggleButton, FormControl, Select, MenuItem, RadioGroup, FormControlLabel, Radio, Box, Tabs, Tab, Accordion, AccordionSummary, AccordionDetails, Paper, InputBase, IconButton } from '@mui/material';
import { createRoot } from 'react-dom/client';
import { ArrowDropDown, CloseOutlined, SearchRounded } from '@mui/icons-material';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: true
          } : {
            done: false,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = true,
    u = false;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = true, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2.apply(null, arguments);
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = true,
      o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = true, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = false,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function (t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = true, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), true), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function () {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function (e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      function o(r, n) {
        _regeneratorDefine(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      }
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine(e, r, n, t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$h = ".tc-collection-card_container__sIstd,\n.tc-collection-card_container-fluid__mGbhp,\n.tc-collection-card_container-xxxl2__i0aa2,\n.tc-collection-card_container-xxxl__Ca-rK,\n.tc-collection-card_container-xxl__JXLHS,\n.tc-collection-card_container-xl__Fvzns,\n.tc-collection-card_container-lg__ZZ1Pm,\n.tc-collection-card_container-md__hvwfN,\n.tc-collection-card_container-sm__va5ln {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-collection-card_container-sm__va5ln, .tc-collection-card_container__sIstd {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-collection-card_container-md__hvwfN, .tc-collection-card_container-sm__va5ln, .tc-collection-card_container__sIstd {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-collection-card_container-lg__ZZ1Pm, .tc-collection-card_container-md__hvwfN, .tc-collection-card_container-sm__va5ln, .tc-collection-card_container__sIstd {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-collection-card_container-xl__Fvzns, .tc-collection-card_container-lg__ZZ1Pm, .tc-collection-card_container-md__hvwfN, .tc-collection-card_container-sm__va5ln, .tc-collection-card_container__sIstd {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-collection-card_container-xxl__JXLHS, .tc-collection-card_container-xl__Fvzns, .tc-collection-card_container-lg__ZZ1Pm, .tc-collection-card_container-md__hvwfN, .tc-collection-card_container-sm__va5ln, .tc-collection-card_container__sIstd {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-collection-card_container-xxxl__Ca-rK, .tc-collection-card_container-xxl__JXLHS, .tc-collection-card_container-xl__Fvzns, .tc-collection-card_container-lg__ZZ1Pm, .tc-collection-card_container-md__hvwfN, .tc-collection-card_container-sm__va5ln, .tc-collection-card_container__sIstd {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-collection-card_container-xxxl2__i0aa2, .tc-collection-card_container-xxxl__Ca-rK, .tc-collection-card_container-xxl__JXLHS, .tc-collection-card_container-xl__Fvzns, .tc-collection-card_container-lg__ZZ1Pm, .tc-collection-card_container-md__hvwfN, .tc-collection-card_container-sm__va5ln, .tc-collection-card_container__sIstd {\n    max-width: 182rem;\n  }\n}\n.tc-collection-card_item__label--on-sale__P2rZo {\n  white-space: nowrap;\n}\n.tc-collection-card_item__label--on-sale__P2rZo :not(.tc-collection-card_item__price-label__QgjQj) {\n  color: #c23326;\n  font-weight: 700;\n}\n.tc-collection-card_item__label--on-sale__P2rZo .tc-collection-card_item__price-label__QgjQj {\n  margin-left: 0.5rem;\n  padding-left: 0.5rem;\n  color: #acacac;\n  font-weight: 400;\n  text-decoration: line-through;\n  border-left: 0.1rem solid #528d6f;\n}\n\n.tc-collection-card_item__qGrva {\n  margin-bottom: calc((3.2rem) / 2);\n}\n@media (max-width: 991.98px) {\n  .tc-collection-card_item__qGrva {\n    padding-right: 0.8rem;\n    padding-left: 0.8rem;\n  }\n}\n.tc-collection-card_item__block__Wh-x3 {\n  overflow: hidden;\n  background-color: #fff;\n  border-radius: 2rem;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.17);\n  transition: 0.15s ease-in-out;\n}\n.tc-collection-card_item__content__gLV-a {\n  position: relative;\n  z-index: 1;\n  padding: 1.5rem 1rem;\n  font-size: 0;\n  background-color: #f7f7f7;\n  transition: 0.5s;\n  will-change: background-color;\n}\n.tc-collection-card_item__media__kOSRM {\n  padding-bottom: 82%;\n}\n.tc-collection-card_item__img-link__7S49l {\n  width: 100%;\n  height: 100%;\n}\n.tc-collection-card_item__img-link__7S49l .tc-collection-card_responsive-image__DcW6D {\n  position: relative;\n  max-width: 100%;\n  margin-top: -1px;\n  background: #fff;\n}\n.tc-collection-card_item__img-link__7S49l .tc-collection-card_responsive-image__img__8f5A5 {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: auto;\n  height: 100%;\n  max-height: 100%;\n  transform: translate(-50%, -50%);\n}\n.tc-collection-card_item__img__rTBYy {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: auto;\n  max-width: 100%;\n  height: 100%;\n  transform: translate(-50%, -50%);\n}\n.tc-collection-card_item__title__8-8YA {\n  display: -webkit-box !important;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  overflow-wrap: break-word;\n  height: 3.1rem;\n  margin-top: 0.5rem;\n  margin-bottom: 0;\n  font-size: 1.2rem;\n  line-height: 1.3;\n  transition: 0.5s;\n  will-change: color;\n}\n.tc-collection-card_item__wrapper__UICOj {\n  position: relative;\n  text-align: center;\n  background-color: #fff;\n}\n.tc-collection-card_item__top-label__OMJHZ {\n  min-height: 2.88rem;\n  color: #1b8158;\n  font-weight: 700;\n  font-size: 1.6rem;\n}\n.tc-collection-card_item__advertise__P-qaQ {\n  position: absolute;\n  top: 2rem;\n  left: 1.5rem;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 4.7rem;\n  height: 4.7rem;\n  color: #fff;\n  font-weight: 700;\n  font-size: 1rem;\n  line-height: 1;\n  text-align: center;\n  word-spacing: 1rem;\n  background: #c23326;\n  border-radius: 50%;\n}\n@media (max-width: 991.98px) {\n  .tc-collection-card_item__advertise__P-qaQ {\n    width: 3.2rem;\n    height: 3.2rem;\n    font-size: 0.7rem;\n  }\n}\n.tc-collection-card_item__label__RrrNv {\n  color: #1b8158;\n  font-weight: 700;\n  font-size: 1.2rem;\n  transition: 0.5s;\n  will-change: color;\n}\n.tc-collection-card_item__collect__IYBkS {\n  height: 1.7rem;\n  margin-bottom: 0.5rem;\n  color: #13220f;\n  font-weight: 500;\n  font-size: 1rem;\n}\n.tc-collection-card_item__label__RrrNv, .tc-collection-card_item__price-label__QgjQj {\n  color: #13220f;\n  font-weight: 700;\n  font-size: 1.2rem;\n  transition: 0.5s;\n  will-change: color;\n}\n.tc-collection-card_item__button__WTqKd {\n  min-width: auto;\n  margin-top: 1rem;\n  white-space: nowrap;\n}\n.tc-collection-card_item__qGrva .collectionCard_quickView {\n  position: absolute;\n  bottom: -2rem;\n  left: 50%;\n  z-index: 3;\n  width: max-content;\n  background-color: rgba(255, 255, 255, 0.8);\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: 0.5s;\n  will-change: opacity;\n}\n@media (max-width: 991.98px) {\n  .tc-collection-card_item__list__BIduZ {\n    margin: 0 -0.8rem;\n  }\n  .tc-collection-card_item__list__BIduZ .slick-slide {\n    padding: 0;\n  }\n  .tc-collection-card_item__button__WTqKd {\n    display: none !important;\n  }\n  .tc-collection-card_item__qGrva .collectionCard_quickView {\n    display: none;\n  }\n}\n@media (min-width: 992px) {\n  .tc-collection-card_item__qGrva {\n    margin-bottom: 3.2rem;\n  }\n  .tc-collection-card_item__block__Wh-x3 {\n    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.17);\n  }\n  .tc-collection-card_item__block__Wh-x3:hover {\n    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.33);\n  }\n  .tc-collection-card_item__block__Wh-x3:hover .collectionCard_quickView {\n    opacity: 1;\n  }\n  .tc-collection-card_item__advertise__P-qaQ {\n    width: 3.2rem;\n    height: 3.2rem;\n    font-size: 0.7rem;\n  }\n  .tc-collection-card_item__content__gLV-a {\n    padding: 1.5rem 1.5rem 2rem;\n  }\n  .tc-collection-card_item__title__8-8YA, .tc-collection-card_item__label__RrrNv, .tc-collection-card_item__top-label__OMJHZ, .tc-collection-card_item__price-label__QgjQj {\n    font-size: 1.4rem;\n  }\n  .tc-collection-card_item__title__8-8YA {\n    height: 3.8rem;\n    line-height: 1.3;\n  }\n  .tc-collection-card_item__collect__IYBkS {\n    height: 2.5rem;\n    font-size: 1.4rem;\n  }\n  .tc-collection-card_item__text-wrapper__h0Cu9 {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 7rem;\n  }\n}";
var css$a = {"item__label--on-sale":"tc-collection-card_item__label--on-sale__P2rZo","item__price-label":"tc-collection-card_item__price-label__QgjQj","item":"tc-collection-card_item__qGrva","item__block":"tc-collection-card_item__block__Wh-x3","item__content":"tc-collection-card_item__content__gLV-a","item__media":"tc-collection-card_item__media__kOSRM","item__img-link":"tc-collection-card_item__img-link__7S49l","responsive-image":"tc-collection-card_responsive-image__DcW6D","responsive-image__img":"tc-collection-card_responsive-image__img__8f5A5","item__img":"tc-collection-card_item__img__rTBYy","item__title":"tc-collection-card_item__title__8-8YA","item__wrapper":"tc-collection-card_item__wrapper__UICOj","item__top-label":"tc-collection-card_item__top-label__OMJHZ","item__advertise":"tc-collection-card_item__advertise__P-qaQ","item__label":"tc-collection-card_item__label__RrrNv","item__collect":"tc-collection-card_item__collect__IYBkS","item__text-wrapper":"tc-collection-card_item__text-wrapper__h0Cu9"};
styleInject(css_248z$h);

var global$2 = (typeof global !== "undefined" ? global :
  typeof self !== "undefined" ? self :
  typeof window !== "undefined" ? window : {});

// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$2.setTimeout === 'function') {
    cachedSetTimeout = setTimeout;
}
if (typeof global$2.clearTimeout === 'function') {
    cachedClearTimeout = clearTimeout;
}

function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
}
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
var title = 'browser';
var platform$2 = 'browser';
var browser = true;
var env = {};
var argv = [];
var version = ''; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config = {};

function noop$1() {}

var on$1 = noop$1;
var addListener = noop$1;
var once = noop$1;
var off$1 = noop$1;
var removeListener = noop$1;
var removeAllListeners = noop$1;
var emit = noop$1;

function binding(name) {
    throw new Error('process.binding is not supported');
}

function cwd () { return '/' }
function chdir (dir) {
    throw new Error('process.chdir is not supported');
}function umask() { return 0; }

// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$2.performance || {};
var performanceNow =
  performance.now        ||
  performance.mozNow     ||
  performance.msNow      ||
  performance.oNow       ||
  performance.webkitNow  ||
  function(){ return (new Date()).getTime() };

// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp){
  var clocktime = performanceNow.call(performance)*1e-3;
  var seconds = Math.floor(clocktime);
  var nanoseconds = Math.floor((clocktime%1)*1e9);
  if (previousTimestamp) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];
    if (nanoseconds<0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }
  return [seconds,nanoseconds]
}

var startTime = new Date();
function uptime() {
  var currentTime = new Date();
  var dif = currentTime - startTime;
  return dif / 1000;
}

var browser$1 = {
  nextTick: nextTick,
  title: title,
  browser: browser,
  env: env,
  argv: argv,
  version: version,
  versions: versions,
  on: on$1,
  addListener: addListener,
  once: once,
  off: off$1,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform$2,
  release: release,
  config: config,
  uptime: uptime
};

function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

// utils is a library of generic helper functions non-specific to axios

const {toString: toString$1} = Object.prototype;
const {getPrototypeOf} = Object;
const {iterator, toStringTag} = Symbol;

const kindOf = (cache => thing => {
    const str = toString$1.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
};

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray: isArray$2} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer$1(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString$1 = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject$1 = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject$1 = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(toStringTag in val) && !(iterator in val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject$1(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$2(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global$2)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject$1(result[targetKey]) && isPlainObject$1(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject$1(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray$2(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray$2(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[iterator];

  const _iterator = generator.call(obj);

  let result;

  while ((result = _iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty$1 = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };

  isArray$2(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

const noop = () => {};

const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[toStringTag] === 'FormData' && thing[iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject$1(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray$2(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject$1(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }

  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({source, data}) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);

    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    }
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === 'function',
  isFunction(_global.postMessage)
);

const asap = typeof queueMicrotask !== 'undefined' ?
  queueMicrotask.bind(_global) : ( typeof browser$1 !== 'undefined' && browser$1.nextTick || _setImmediate);

// *********************


const isIterable = (thing) => thing != null && isFunction(thing[iterator]);


var utils$1 = {
  isArray: isArray$2,
  isArrayBuffer,
  isBuffer: isBuffer$1,
  isFormData,
  isArrayBufferView,
  isString: isString$1,
  isNumber,
  isBoolean,
  isObject: isObject$1,
  isPlainObject: isPlainObject$1,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: hasOwnProperty$1,
  hasOwnProp: hasOwnProperty$1, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap,
  isIterable
};

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var inited = false;
function init () {
  inited = true;
  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  for (var i = 0, len = code.length; i < len; ++i) {
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
  }

  revLookup['-'.charCodeAt(0)] = 62;
  revLookup['_'.charCodeAt(0)] = 63;
}

function toByteArray (b64) {
  if (!inited) {
    init();
  }
  var i, j, l, tmp, placeHolders, arr;
  var len = b64.length;

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

  // base64 is 4/3 + up to two characters of the original data
  arr = new Arr(len * 3 / 4 - placeHolders);

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len;

  var L = 0;

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
    arr[L++] = (tmp >> 16) & 0xFF;
    arr[L++] = (tmp >> 8) & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
    arr[L++] = tmp & 0xFF;
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
    arr[L++] = (tmp >> 8) & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
    output.push(tripletToBase64(tmp));
  }
  return output.join('')
}

function fromByteArray (uint8) {
  if (!inited) {
    init();
  }
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var output = '';
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    output += lookup[tmp >> 2];
    output += lookup[(tmp << 4) & 0x3F];
    output += '==';
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
    output += lookup[tmp >> 10];
    output += lookup[(tmp >> 4) & 0x3F];
    output += lookup[(tmp << 2) & 0x3F];
    output += '=';
  }

  parts.push(output);

  return parts.join('')
}

function read (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? (nBytes - 1) : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];

  i += d;

  e = s & ((1 << (-nBits)) - 1);
  s >>= (-nBits);
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1);
  e >>= (-nBits);
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

function write (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
  var i = isLE ? 0 : (nBytes - 1);
  var d = isLE ? 1 : -1;
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
}

var toString = {}.toString;

var isArray$1 = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */


var INSPECT_MAX_BYTES = 50;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global$2.TYPED_ARRAY_SUPPORT !== undefined
  ? global$2.TYPED_ARRAY_SUPPORT
  : true;

/*
 * Export kMaxLength after typed array support is determined.
 */
kMaxLength();

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length);
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length);
    }
    that.length = length;
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192; // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype;
  return arr
};

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
};

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) ;
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
};

function allocUnsafe (that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
};

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0;
  that = createBuffer(that, length);

  var actual = that.write(string, encoding);

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length);
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255;
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array);
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length);
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array;
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
  }
  return that
}

function fromObject (that, obj) {
  if (internalIsBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len);
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray$1(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}
Buffer.isBuffer = isBuffer;
function internalIsBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
};

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
};

Buffer.concat = function concat (list, length) {
  if (!isArray$1(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }

  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (!internalIsBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer
};

function byteLength (string, encoding) {
  if (internalIsBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string;
  }

  var len = string.length;
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;

function slowToString (encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length;
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8';

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;

function swap (b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this
};

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this
};

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this
};

Buffer.prototype.toString = function toString () {
  var length = this.length | 0;
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
};

Buffer.prototype.equals = function equals (b) {
  if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
};

Buffer.prototype.inspect = function inspect () {
  var str = '';
  var max = INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    if (this.length > max) str += ' ... ';
  }
  return '<Buffer ' + str + '>'
};

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!internalIsBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;

  if (this === target) return 0

  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);

  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -2147483648) {
    byteOffset = -2147483648;
  }
  byteOffset = +byteOffset;  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1);
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (internalIsBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
};

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
};

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
};

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }

  // must be an even number of digits
  var strLen = string.length;
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed;
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0;
    if (isFinite(length)) {
      length = length | 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8';

  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
};

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return fromByteArray(buf)
  } else {
    return fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];

  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1;

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }

    res.push(codePoint);
    i += bytesPerSequence;
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    );
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length;

  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;

  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;

  var newBuf;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer.prototype;
  } else {
    var sliceLen = end - start;
    newBuf = new Buffer(sliceLen, undefined);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start];
    }
  }

  return newBuf
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  return val
};

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }

  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }

  return val
};

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset]
};

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | (this[offset + 1] << 8)
};

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return (this[offset] << 8) | this[offset + 1]
};

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
};

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
};

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val
};

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val
};

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
};

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | (this[offset + 1] << 8);
  return (val & 0x8000) ? val | 0xFFFF0000 : val
};

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | (this[offset] << 8);
  return (val & 0x8000) ? val | 0xFFFF0000 : val
};

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
};

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
};

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return read(this, offset, true, 23, 4)
};

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return read(this, offset, false, 23, 4)
};

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return read(this, offset, true, 52, 8)
};

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return read(this, offset, false, 52, 8)
};

function checkInt (buf, value, offset, ext, max, min) {
  if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF;
  }

  return offset + byteLength
};

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF;
  }

  return offset + byteLength
};

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset] = (value & 0xff);
  return offset + 1
};

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8;
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff);
    this[offset + 1] = (value >>> 8);
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2
};

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8);
    this[offset + 1] = (value & 0xff);
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2
};

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24);
    this[offset + 2] = (value >>> 16);
    this[offset + 1] = (value >>> 8);
    this[offset] = (value & 0xff);
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4
};

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24);
    this[offset + 1] = (value >>> 16);
    this[offset + 2] = (value >>> 8);
    this[offset + 3] = (value & 0xff);
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4
};

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
  }

  return offset + byteLength
};

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
  }

  return offset + byteLength
};

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = (value & 0xff);
  return offset + 1
};

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff);
    this[offset + 1] = (value >>> 8);
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2
};

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8);
    this[offset + 1] = (value & 0xff);
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2
};

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff);
    this[offset + 1] = (value >>> 8);
    this[offset + 2] = (value >>> 16);
    this[offset + 3] = (value >>> 24);
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4
};

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
  if (value < 0) value = 0xffffffff + value + 1;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24);
    this[offset + 1] = (value >>> 16);
    this[offset + 2] = (value >>> 8);
    this[offset + 3] = (value & 0xff);
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4
};

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4);
  }
  write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
};

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
};

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8);
  }
  write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
};

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }

  var len = end - start;
  var i;

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    );
  }

  return len
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;

  if (!val) val = 0;

  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = internalIsBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }

  return this
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue
        }

        // valid lead
        leadSurrogate = codePoint;

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }

    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      );
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      );
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      );
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }

  return byteArray
}


function base64ToBytes (str) {
  return toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i];
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}


// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function isBuffer(obj) {
  return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
}

function isFastBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
}

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError$1(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}

utils$1.inherits(AxiosError$1, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});

const prototype$1 = AxiosError$1.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError$1, descriptors);
Object.defineProperty(prototype$1, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError$1.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);

  utils$1.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError$1.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

// eslint-disable-next-line strict
var httpAdapter = null;

/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils$1.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData$1(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils$1.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);

  if (!utils$1.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils$1.isDate(value)) {
      return value.toISOString();
    }

    if (utils$1.isBoolean(value)) {
      return value.toString();
    }

    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError$1('Blob is not supported. Use a Buffer instead.');
    }

    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils$1.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils$1.isArray(value) && isFlatArray(value)) ||
        ((utils$1.isFileList(value) || utils$1.endsWith(key, '[]')) && (arr = utils$1.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils$1.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils$1.forEach(value, function each(el, key) {
      const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils$1.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils$1.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode$3(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData$1(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$3);
  } : encode$3;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode$2(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?(object|Function)} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode$2;

  if (utils$1.isFunction(options)) {
    options = {
      serialize: options
    };
  } 

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

var transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var URLSearchParams$2 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

var FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

var Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

var platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$2,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

const _navigator = typeof navigator === 'object' && navigator || undefined;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = hasBrowserEnv &&
  (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

const origin = hasBrowserEnv && window.location.href || 'http://localhost';

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  hasBrowserEnv: hasBrowserEnv,
  hasStandardBrowserEnv: hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv: hasStandardBrowserWebWorkerEnv,
  navigator: _navigator,
  origin: origin
});

var platform = {
  ...utils,
  ...platform$1
};

function toURLEncodedForm(data, options) {
  return toFormData$1(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};

    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: transitionalDefaults,

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils$1.isObject(data);

    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils$1.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data) ||
      utils$1.isReadableStream(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils$1.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return toFormData$1(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
      return data;
    }

    if (data && utils$1.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils$1.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils$1.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils$1.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils$1.isString(value)) return;

  if (utils$1.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils$1.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

let AxiosHeaders$1 = class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils$1.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if(utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils$1.isObject(header) && utils$1.isIterable(header)) {
      let obj = {}, dest, key;
      for (const entry of header) {
        if (!utils$1.isArray(entry)) {
          throw TypeError('Object iterator must return a key-value pair');
        }

        obj[key = entry[0]] = (dest = obj[key]) ?
          (utils$1.isArray(dest) ? [...dest, entry[1]] : [dest, entry[1]]) : entry[1];
      }

      setHeaders(obj, valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils$1.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  getSetCookie() {
    return this.get("set-cookie") || [];
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
};

AxiosHeaders$1.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils$1.reduceDescriptors(AxiosHeaders$1.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils$1.freezeMethods(AxiosHeaders$1);

/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || defaults;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;

  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

function isCancel$1(value) {
  return !!(value && value.__CANCEL__);
}

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError$1(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError$1.call(this, message == null ? 'canceled' : message, AxiosError$1.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils$1.inherits(CanceledError$1, AxiosError$1, {
  __CANCEL__: true
});

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError$1(
      'Request failed with status code ' + response.status,
      [AxiosError$1.ERR_BAD_REQUEST, AxiosError$1.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle$1(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;

  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  };

  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if ( passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };

  const flush = () => lastArgs && invoke(lastArgs);

  return [throttled, flush];
}

const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);

  return throttle$1(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };

    listener(data);
  }, freq);
};

const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;

  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};

const asyncDecorator = (fn) => (...args) => utils$1.asap(() => fn(...args));

var isURLSameOrigin = platform.hasStandardBrowserEnv ? ((origin, isMSIE) => (url) => {
  url = new URL(url, platform.origin);

  return (
    origin.protocol === url.protocol &&
    origin.host === url.host &&
    (isMSIE || origin.port === url.port)
  );
})(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => true;

var cookies = platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils$1.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils$1.isString(path) && cookie.push('path=' + path);

      utils$1.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  };

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
  let isRelativeUrl = !isAbsoluteURL(requestedURL);
  if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig$1(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, prop, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({caseless}, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, prop , caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, prop , caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a, prop , caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b , prop) => mergeDeepProperties(headersToObject(a), headersToObject(b),prop, true)
  };

  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils$1.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

var resolveConfig = (config) => {
  const newConfig = mergeConfig$1({}, config);

  let {data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth} = newConfig;

  newConfig.headers = headers = AxiosHeaders$1.from(headers);

  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' +
      btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : ''))
    );
  }

  let contentType;

  if (utils$1.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));

    if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(newConfig.url))) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
};

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

var xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders$1.from(_config.headers).normalize();
    let {responseType, onUploadProgress, onDownloadProgress} = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;

    function done() {
      flushUpload && flushUpload(); // flush events
      flushDownload && flushDownload(); // flush events

      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);

      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }

    let request = new XMLHttpRequest();

    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = AxiosHeaders$1.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError$1('Request aborted', AxiosError$1.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError$1('Network Error', AxiosError$1.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError$1(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError$1.ETIMEDOUT : AxiosError$1.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (onDownloadProgress) {
      ([downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true));
      request.addEventListener('progress', downloadThrottled);
    }

    // Not all browsers support upload events
    if (onUploadProgress && request.upload) {
      ([uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress));

      request.upload.addEventListener('progress', uploadThrottled);

      request.upload.addEventListener('loadend', flushUpload);
    }

    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError$1(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(_config.url);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError$1('Unsupported protocol ' + protocol + ':', AxiosError$1.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
};

const composeSignals = (signals, timeout) => {
  const {length} = (signals = signals ? signals.filter(Boolean) : []);

  if (timeout || length) {
    let controller = new AbortController();

    let aborted;

    const onabort = function (reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof AxiosError$1 ? err : new CanceledError$1(err instanceof Error ? err.message : err));
      }
    };

    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new AxiosError$1(`timeout ${timeout} of ms exceeded`, AxiosError$1.ETIMEDOUT));
    }, timeout);

    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(signal => {
          signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
      }
    };

    signals.forEach((signal) => signal.addEventListener('abort', onabort));

    const {signal} = controller;

    signal.unsubscribe = () => utils$1.asap(unsubscribe);

    return signal;
  }
};

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};

const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
};

const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }

  const reader = stream.getReader();
  try {
    for (;;) {
      const {done, value} = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
};

const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);

  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };

  return new ReadableStream({
    async pull(controller) {
      try {
        const {done, value} = await iterator.next();

        if (done) {
         _onFinish();
          controller.close();
          return;
        }

        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  })
};

const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) :
    async (str) => new Uint8Array(await new Response(str).arrayBuffer())
);

const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false
  }
};

const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;

  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    },
  }).headers.has('Content-Type');

  return duplexAccessed && !hasContentType;
});

const DEFAULT_CHUNK_SIZE = 64 * 1024;

const supportsResponseStream = isReadableStreamSupported &&
  test(() => utils$1.isReadableStream(new Response('').body));


const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};

isFetchSupported && (((res) => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = utils$1.isFunction(res[type]) ? (res) => res[type]() :
      (_, config) => {
        throw new AxiosError$1(`Response type '${type}' is not supported`, AxiosError$1.ERR_NOT_SUPPORT, config);
      });
  });
})(new Response));

const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }

  if(utils$1.isBlob(body)) {
    return body.size;
  }

  if(utils$1.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: 'POST',
      body,
    });
    return (await _request.arrayBuffer()).byteLength;
  }

  if(utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
    return body.byteLength;
  }

  if(utils$1.isURLSearchParams(body)) {
    body = body + '';
  }

  if(utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};

const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());

  return length == null ? getBodyLength(body) : length;
};

var fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);

  responseType = responseType ? (responseType + '').toLowerCase() : 'text';

  let composedSignal = composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);

  let request;

  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
      composedSignal.unsubscribe();
  });

  let requestContentLength;

  try {
    if (
      onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' &&
      (requestContentLength = await resolveBodyLength(headers, data)) !== 0
    ) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });

      let contentTypeHeader;

      if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader);
      }

      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );

        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }

    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }

    // Cloudflare Workers throws when credentials are defined
    // see https://github.com/cloudflare/workerd/issues/902
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : undefined
    });

    let response = await fetch(request, fetchOptions);

    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

    if (supportsResponseStream && (onDownloadProgress || (isStreamResponse && unsubscribe))) {
      const options = {};

      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });

      const responseContentLength = utils$1.toFiniteNumber(response.headers.get('content-length'));

      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];

      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }

    responseType = responseType || 'text';

    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || 'text'](response, config);

    !isStreamResponse && unsubscribe && unsubscribe();

    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: AxiosHeaders$1.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    })
  } catch (err) {
    unsubscribe && unsubscribe();

    if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError$1('Network Error', AxiosError$1.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      )
    }

    throw AxiosError$1.from(err, err && err.code, config, request);
  }
});

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};

utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;

var adapters = {
  getAdapter: (adapters) => {
    adapters = utils$1.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new AxiosError$1(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new AxiosError$1(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError$1(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = AxiosHeaders$1.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = AxiosHeaders$1.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel$1(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

const VERSION$1 = "1.10.0";

const validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION$1 + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError$1(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError$1.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

validators$1.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    // eslint-disable-next-line no-console
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  }
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError$1('options must be an object', AxiosError$1.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError$1('option ' + opt + ' must be ' + result, AxiosError$1.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError$1('Unknown option ' + opt, AxiosError$1.ERR_BAD_OPTION);
    }
  }
}

var validator = {
  assertOptions,
  validators: validators$1
};

const validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
let Axios$1 = class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig || {};
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};

        Error.captureStackTrace ? Error.captureStackTrace(dummy) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack;
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig$1(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.allowAbsoluteUrls
    if (config.allowAbsoluteUrls !== undefined) ; else if (this.defaults.allowAbsoluteUrls !== undefined) {
      config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
    } else {
      config.allowAbsoluteUrls = true;
    }

    validator.assertOptions(config, {
      baseUrl: validators.spelling('baseURL'),
      withXsrfToken: validators.spelling('withXSRFToken')
    }, true);

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils$1.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig$1(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
};

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig$1(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios$1.prototype[method] = generateHTTPMethod();

  Axios$1.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
let CancelToken$1 = class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new CanceledError$1(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  toAbortSignal() {
    const controller = new AbortController();

    const abort = (err) => {
      controller.abort(err);
    };

    this.subscribe(abort);

    controller.signal.unsubscribe = () => this.unsubscribe(abort);

    return controller.signal;
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
};

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread$1(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError$1(payload) {
  return utils$1.isObject(payload) && (payload.isAxiosError === true);
}

const HttpStatusCode$1 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode$1).forEach(([key, value]) => {
  HttpStatusCode$1[value] = key;
});

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind(Axios$1.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios$1.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils$1.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig$1(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios$1;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError$1;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel$1;
axios.VERSION = VERSION$1;
axios.toFormData = toFormData$1;

// Expose AxiosError class
axios.AxiosError = AxiosError$1;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread$1;

// Expose isAxiosError
axios.isAxiosError = isAxiosError$1;

// Expose mergeConfig
axios.mergeConfig = mergeConfig$1;

axios.AxiosHeaders = AxiosHeaders$1;

axios.formToJSON = thing => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = HttpStatusCode$1;

axios.default = axios;

// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const {
  Axios,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken,
  VERSION,
  all,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders,
  HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig
} = axios;

function on(eventType, listener) {
  document.addEventListener(eventType, listener);
}
function off(eventType, listener) {
  document.removeEventListener(eventType, listener);
}
function trigger(eventType, data) {
  var event = new CustomEvent(eventType, {
    detail: data
  });
  document.dispatchEvent(event);
}

var TcQuickView = function TcQuickView(_ref) {
  var id = _ref.id,
    buttonStyles = _ref.buttonStyles,
    config = _ref.config,
    cartType = _ref.cartType,
    dataLayerItem = _ref.dataLayerItem;
  var endpoints = config.endpoints,
    translations = config.translations;
  var getProductData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      var _window$ElevarDataLay, response, result, _window$ElevarDataLay2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            e.stopPropagation();
            e.preventDefault();
            if (dataLayerItem) {
              (_window$ElevarDataLay = window.ElevarDataLayerHelper) === null || _window$ElevarDataLay === void 0 || _window$ElevarDataLay.pushSelectItem({
                cart_type: 'quick_view',
                item: dataLayerItem
              });
            }
            _context.p = 1;
            _context.n = 2;
            return axios.get("".concat(endpoints.get_product).concat(id));
          case 2:
            response = _context.v;
            result = response.data;
            trigger('closeAddToCartSuccessModal', {});
            trigger('openQuickViewModal', {
              paymentData: result,
              product_url: "".concat(endpoints.product_url).concat(id),
              cartType: cartType
            });
            if (result.data_layer_item) {
              (_window$ElevarDataLay2 = window.ElevarDataLayerHelper) === null || _window$ElevarDataLay2 === void 0 || _window$ElevarDataLay2.pushViewItem({
                item: result.data_layer_item,
                referer: window.location.href,
                cart_type: 'quick_view'
              });
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _context.v;
            $.gritter.add({
              class_name: 'alert',
              fade: true,
              text: 'Failed to load Quick View modal',
              time: '10000',
              title: 'Notification'
            });
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function getProductData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React__default.createElement("button", {
    className: "collectionCard_quickView buttonComponent--secondary",
    onClick: function onClick(e) {
      return getProductData(e);
    },
    style: buttonStyles
  }, translations.quick_view_title);
};
TcQuickView.propTypes = {
  buttonStyles: PropTypes.object,
  cartType: PropTypes.string,
  config: PropTypes.object.isRequired,
  dataLayerItem: PropTypes.object,
  id: PropTypes.number
};

var CollectionCard = function CollectionCard(_ref) {
  var _ref$additionalClasse = _ref.additionalClasses,
    additionalClasses = _ref$additionalClasse === void 0 ? '' : _ref$additionalClasse,
    advertise = _ref.advertise,
    dataLayerItem = _ref.dataLayerItem,
    id = _ref.id,
    image = _ref.image,
    imageAlt = _ref.imageAlt,
    moreThanOneVariant = _ref.moreThanOneVariant,
    isLoading = _ref.isLoading,
    _ref$isShopProduct = _ref.isShopProduct,
    isShopProduct = _ref$isShopProduct === void 0 ? true : _ref$isShopProduct,
    name = _ref.name,
    oldPrice = _ref.oldPrice,
    onSale = _ref.onSale,
    price = _ref.price,
    topLabel = _ref.topLabel,
    translations = _ref.translations,
    url = _ref.url,
    quickViewModalData = _ref.quickViewModalData,
    cartType = _ref.cartType,
    recyclingProgramTag = _ref.recyclingProgramTag,
    _ref$isListingItem = _ref.isListingItem,
    isListingItem = _ref$isListingItem === void 0 ? false : _ref$isListingItem;
  var responsiveImgPlaceholder = image ? 'responsiveImageEmpty' : 'responsiveImage_img';
  var sendDLSelectItem = function sendDLSelectItem() {
    var _window$ElevarDataLay;
    (_window$ElevarDataLay = window.ElevarDataLayerHelper) === null || _window$ElevarDataLay === void 0 || _window$ElevarDataLay.pushSelectItem({
      item: dataLayerItem
    });
  };
  var cardContent = function cardContent() {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(css$a['item__top-label'], " collection-item__top-label")
    }, topLabel ? _typeof(topLabel) === 'object' ? topLabel.name : topLabel : ''), advertise && /*#__PURE__*/React__default.createElement("span", {
      className: "".concat(css$a.item__advertise, " collection-item__advertise")
    }, translations.on_sale), /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(css$a['responsive-image'], " ").concat(css$a.item__media, " ").concat(responsiveImgPlaceholder, " collection-item__media")
    }, /*#__PURE__*/React__default.createElement("img", {
      alt: imageAlt || "image-".concat(id),
      className: "".concat(css$a['responsive-image__img'], " ").concat(css$a.item__img, " collection-item__img"),
      "data-sizes": "auto",
      src: image
    }), !isLoading && isShopProduct ? /*#__PURE__*/React__default.createElement(TcQuickView, _extends$2({
      cartType: cartType,
      config: quickViewModalData
    }, dataLayerItem ? {
      dataLayerItem: dataLayerItem
    } : {}, {
      id: id
    })) : null), /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(css$a.item__collect, " collection-item__collect")
    }, recyclingProgramTag && recyclingProgramTag), /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(css$a.item__content, " collection-item__content")
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(css$a['item__text-wrapper'], " collection-item__text-wrapper")
    }, /*#__PURE__*/React__default.createElement("h4", {
      className: "".concat(css$a.item__title, " collection-item__title"),
      title: name
    }, name), /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(css$a.item__label, " ").concat(onSale ? css$a['item__label--on-sale'] : '', " collection-item__price")
    }, /*#__PURE__*/React__default.createElement("span", null, moreThanOneVariant ? 'From ' : null), /*#__PURE__*/React__default.createElement("span", null, price), /*#__PURE__*/React__default.createElement("span", {
      className: "".concat(css$a['item__price-label'], " collection-item__price-label")
    }, onSale ? oldPrice : '')))));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "collection-item ".concat(css$a.item, " ").concat(additionalClasses)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$a.item__block
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$a.item__wrapper
  }, isListingItem ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("a", _extends$2({
    className: "collectionCard_img-link 1 ".concat(css$a['item__img-link'], " ").concat(isLoading ? 'blurred' : ''),
    href: url,
    tabIndex: "-1"
  }, dataLayerItem ? {
    onClick: sendDLSelectItem
  } : {})), cardContent()) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("a", _extends$2({
    className: "collectionCard_img-link 2 ".concat(css$a['item__img-link'], " ").concat(isLoading ? 'blurred' : ''),
    href: url,
    tabIndex: "-1"
  }, dataLayerItem ? {
    onClick: sendDLSelectItem
  } : {}), cardContent())))));
};
CollectionCard.propTypes = {
  additionalClasses: PropTypes.string,
  advertise: PropTypes.bool,
  cartType: PropTypes.string,
  dataLayerItem: PropTypes.object,
  id: PropTypes.number,
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  isListingItem: PropTypes.bool,
  isLoading: PropTypes.bool,
  isShopProduct: PropTypes.bool,
  moreThanOneVariant: PropTypes.bool,
  name: PropTypes.string,
  oldPrice: PropTypes.string,
  onSale: PropTypes.bool,
  price: PropTypes.string,
  quickViewModalData: PropTypes.object.isRequired,
  recyclingProgramTag: PropTypes.string,
  topLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  translations: PropTypes.object.isRequired,
  url: PropTypes.string
};

var css_248z$g = ".tc-loader_loader__TratA {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.tc-loader_loader_spinner__txL5Z {\n  width: 2.5rem;\n  height: 2.5rem;\n  border: 0.3rem solid #1b8158;\n  border-radius: 50%;\n  animation: tc-loader_spinner-bulqg1__1sJoZ 0.8s infinite linear alternate, tc-loader_spinner-oaa3wk__mZpoc 1.6s infinite linear;\n}\n\n@keyframes tc-loader_spinner-bulqg1__1sJoZ {\n  0% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);\n  }\n  12.5% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%);\n  }\n  25% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%);\n  }\n  50% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%);\n  }\n  62.5% {\n    clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%);\n  }\n  75% {\n    clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%);\n  }\n  100% {\n    clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%);\n  }\n}\n@keyframes tc-loader_spinner-oaa3wk__mZpoc {\n  0% {\n    transform: scaleY(1) rotate(0deg);\n  }\n  49.99% {\n    transform: scaleY(1) rotate(135deg);\n  }\n  50% {\n    transform: scaleY(-1) rotate(0deg);\n  }\n  100% {\n    transform: scaleY(-1) rotate(-135deg);\n  }\n}";
var css$9 = {"loader":"tc-loader_loader__TratA","loader_spinner":"tc-loader_loader_spinner__txL5Z"};
styleInject(css_248z$g);

var Loader = function Loader(_ref) {
  var isLarge = _ref.isLarge;
  var largeSpinner = {
    height: '5rem',
    width: '5rem'
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$9.loader
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$9.loader_spinner,
    style: isLarge ? largeSpinner : {}
  }));
};
Loader.propTypes = {
  isLarge: PropTypes.bool
};

var css_248z$f = ".tc-main-modal_container__jvNbe,\n.tc-main-modal_container-fluid__fwkKt,\n.tc-main-modal_container-xxxl2__0fFqN,\n.tc-main-modal_container-xxxl__0biiO,\n.tc-main-modal_container-xxl__MWnSi,\n.tc-main-modal_container-xl__6Q37y,\n.tc-main-modal_container-lg__EwArh,\n.tc-main-modal_container-md__SYpOp,\n.tc-main-modal_container-sm__3c-cK {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-main-modal_container-sm__3c-cK, .tc-main-modal_container__jvNbe {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-main-modal_container-md__SYpOp, .tc-main-modal_container-sm__3c-cK, .tc-main-modal_container__jvNbe {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-main-modal_container-lg__EwArh, .tc-main-modal_container-md__SYpOp, .tc-main-modal_container-sm__3c-cK, .tc-main-modal_container__jvNbe {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-main-modal_container-xl__6Q37y, .tc-main-modal_container-lg__EwArh, .tc-main-modal_container-md__SYpOp, .tc-main-modal_container-sm__3c-cK, .tc-main-modal_container__jvNbe {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-main-modal_container-xxl__MWnSi, .tc-main-modal_container-xl__6Q37y, .tc-main-modal_container-lg__EwArh, .tc-main-modal_container-md__SYpOp, .tc-main-modal_container-sm__3c-cK, .tc-main-modal_container__jvNbe {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-main-modal_container-xxxl__0biiO, .tc-main-modal_container-xxl__MWnSi, .tc-main-modal_container-xl__6Q37y, .tc-main-modal_container-lg__EwArh, .tc-main-modal_container-md__SYpOp, .tc-main-modal_container-sm__3c-cK, .tc-main-modal_container__jvNbe {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-main-modal_container-xxxl2__0fFqN, .tc-main-modal_container-xxxl__0biiO, .tc-main-modal_container-xxl__MWnSi, .tc-main-modal_container-xl__6Q37y, .tc-main-modal_container-lg__EwArh, .tc-main-modal_container-md__SYpOp, .tc-main-modal_container-sm__3c-cK, .tc-main-modal_container__jvNbe {\n    max-width: 182rem;\n  }\n}\n.tc-main-modal_modal-body-wrapper__DVeJL {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: block;\n  box-sizing: inherit;\n  width: 96%;\n  max-width: 110rem;\n  max-height: 99vh;\n  background: #fff;\n  border-radius: 2rem;\n  transform: translate(-50%, -50%);\n}\n.tc-main-modal_modal-body-wrapper__DVeJL.wide-modal {\n  width: 96%;\n  max-width: 140rem;\n}\n.tc-main-modal_modal-body-wrapper__DVeJL.small-modal {\n  width: 90%;\n  max-width: 110rem;\n}\n@media (min-width: 768px) {\n  .tc-main-modal_modal-body-wrapper__DVeJL.small-modal {\n    width: 86%;\n  }\n  .tc-main-modal_modal-body-wrapper__DVeJL.small-modal .tc-main-modal_modal-content-wrapper__NzVtT {\n    width: 86%;\n    margin: 0 auto;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-main-modal_modal-body-wrapper__DVeJL.small-modal {\n    width: 56%;\n  }\n}\n.tc-main-modal_modal-body-wrapper__DVeJL.country-selector__modal {\n  width: 90%;\n  overflow-y: auto;\n  border-radius: 60px;\n}\n.tc-main-modal_modal-body-wrapper__DVeJL.country-selector__modal .tc-main-modal_modal-content-wrapper__NzVtT {\n  max-height: 80vh;\n  margin-top: 4rem;\n  padding: 0;\n  overflow-y: auto;\n}\n.tc-main-modal_modal-body-wrapper__DVeJL .tc-main-modal_closeModalButton__WfMTs {\n  position: absolute;\n  top: 1.7rem;\n  right: 2.5rem;\n  cursor: pointer;\n}\n.tc-main-modal_modal-body-wrapper__DVeJL .tc-main-modal_modal-content-wrapper__NzVtT {\n  height: auto;\n  max-height: 99vh;\n  padding: 2rem 3rem;\n}";
var css$8 = {"modal-body-wrapper":"tc-main-modal_modal-body-wrapper__DVeJL","modal-content-wrapper":"tc-main-modal_modal-content-wrapper__NzVtT","closeModalButton":"tc-main-modal_closeModalButton__WfMTs"};
styleInject(css_248z$f);

var MainModal = function MainModal(_ref) {
  var isModalOpen = _ref.isModalOpen,
    handleClose = _ref.handleClose,
    _ref$modalBody = _ref.modalBody,
    modalBody = _ref$modalBody === void 0 ? null : _ref$modalBody,
    _ref$additionalClasse = _ref.additionalClasses,
    additionalClasses = _ref$additionalClasse === void 0 ? '' : _ref$additionalClasse,
    _ref$modalAttributes = _ref.modalAttributes,
    modalAttributes = _ref$modalAttributes === void 0 ? {} : _ref$modalAttributes;
  return /*#__PURE__*/React__default.createElement(Modal, _extends$2({
    closeAfterTransition: true,
    components: {
      Backdrop: Backdrop
    },
    componentsProps: {
      backdrop: {
        timeout: 500
      }
    },
    onClose: handleClose,
    open: isModalOpen
  }, modalAttributes), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(css$8['modal-body-wrapper'], " ").concat(additionalClasses)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$8.closeModalButton,
    onClick: handleClose
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "icon-times"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: css$8['modal-content-wrapper']
  }, modalBody)));
};
MainModal.propTypes = {
  additionalClasses: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  modalAttributes: PropTypes.object,
  modalBody: PropTypes.element
};

var css_248z$e = ".opening-hours_container__2HACk,\n.opening-hours_container-fluid__RApLJ,\n.opening-hours_container-xxxl2__d-bz2,\n.opening-hours_container-xxxl__MCAlD,\n.opening-hours_container-xxl__lNRph,\n.opening-hours_container-xl__h6L18,\n.opening-hours_container-lg__O3XBQ,\n.opening-hours_container-md__UUn9q,\n.opening-hours_container-sm__ctE4N {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .opening-hours_container-sm__ctE4N, .opening-hours_container__2HACk {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .opening-hours_container-md__UUn9q, .opening-hours_container-sm__ctE4N, .opening-hours_container__2HACk {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .opening-hours_container-lg__O3XBQ, .opening-hours_container-md__UUn9q, .opening-hours_container-sm__ctE4N, .opening-hours_container__2HACk {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .opening-hours_container-xl__h6L18, .opening-hours_container-lg__O3XBQ, .opening-hours_container-md__UUn9q, .opening-hours_container-sm__ctE4N, .opening-hours_container__2HACk {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .opening-hours_container-xxl__lNRph, .opening-hours_container-xl__h6L18, .opening-hours_container-lg__O3XBQ, .opening-hours_container-md__UUn9q, .opening-hours_container-sm__ctE4N, .opening-hours_container__2HACk {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .opening-hours_container-xxxl__MCAlD, .opening-hours_container-xxl__lNRph, .opening-hours_container-xl__h6L18, .opening-hours_container-lg__O3XBQ, .opening-hours_container-md__UUn9q, .opening-hours_container-sm__ctE4N, .opening-hours_container__2HACk {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .opening-hours_container-xxxl2__d-bz2, .opening-hours_container-xxxl__MCAlD, .opening-hours_container-xxl__lNRph, .opening-hours_container-xl__h6L18, .opening-hours_container-lg__O3XBQ, .opening-hours_container-md__UUn9q, .opening-hours_container-sm__ctE4N, .opening-hours_container__2HACk {\n    max-width: 182rem;\n  }\n}\n.opening-hours_opening_hours_list__1gd7k .opening-hours_dropdown__lezi7, .opening-hours_opening_hours__list__5nUvh .opening-hours_dropdown__lezi7 {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  margin: 0 -5px;\n  font-weight: 400;\n  font-size: 12px;\n}\n.opening-hours_opening_hours_list__1gd7k .opening-hours_dropdown__lezi7 .control-group, .opening-hours_opening_hours__list__5nUvh .opening-hours_dropdown__lezi7 .control-group {\n  padding: 0 !important;\n}\n.opening-hours_opening_hours_list__1gd7k .opening-hours_dropdown__lezi7 > div:first-of-type, .opening-hours_opening_hours__list__5nUvh .opening-hours_dropdown__lezi7 > div:first-of-type {\n  width: 100px;\n}\n@media (min-width: 992px) {\n  .opening-hours_opening_hours_list__1gd7k .opening-hours_dropdown__lezi7, .opening-hours_opening_hours__list__5nUvh .opening-hours_dropdown__lezi7 {\n    font-size: 14px;\n  }\n}\n@media (max-width: 575.98px) {\n  .opening-hours_opening_hours_list__1gd7k .opening-hours_dropdown__lezi7, .opening-hours_opening_hours__list__5nUvh .opening-hours_dropdown__lezi7 {\n    flex-wrap: wrap;\n  }\n  .opening-hours_opening_hours_list__1gd7k .opening-hours_dropdown__lezi7 > button, .opening-hours_opening_hours__list__5nUvh .opening-hours_dropdown__lezi7 > button {\n    order: 2;\n  }\n  .opening-hours_opening_hours_list__1gd7k .opening-hours_dropdown__lezi7 > div, .opening-hours_opening_hours__list__5nUvh .opening-hours_dropdown__lezi7 > div {\n    order: 1;\n  }\n  .opening-hours_opening_hours_list__1gd7k .opening-hours_dropdown__lezi7 > div:first-of-type, .opening-hours_opening_hours__list__5nUvh .opening-hours_dropdown__lezi7 > div:first-of-type {\n    flex-grow: 1;\n    order: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .opening-hours_opening_hours_list__1gd7k .opening-hours_dropdown__lezi7 .checkbox .control-label::before, .opening-hours_opening_hours__list__5nUvh .opening-hours_dropdown__lezi7 .checkbox .control-label::before {\n    top: 0;\n  }\n}\n.opening-hours_opening_hours_list__1gd7k ul, .opening-hours_opening_hours__list__5nUvh ul {\n  padding: 0;\n  list-style: none;\n}\n@media (max-width: 575.98px) {\n  .opening-hours_opening_hours_list__1gd7k ul, .opening-hours_opening_hours__list__5nUvh ul {\n    width: 65vw;\n    min-width: 240px;\n    margin: 0 auto 25px;\n  }\n}\n.opening-hours_opening_hours_list__1gd7k ul > div:first-of-type, .opening-hours_opening_hours__list__5nUvh ul > div:first-of-type {\n  padding-top: 50px;\n}\n@media (max-width: 575.98px) {\n  .opening-hours_opening_hours_list__1gd7k ul > div:first-of-type, .opening-hours_opening_hours__list__5nUvh ul > div:first-of-type {\n    padding-top: 0;\n  }\n}\n.opening-hours_opening_hours_list__1gd7k li, .opening-hours_opening_hours__list__5nUvh li {\n  padding: 5px 0;\n}\n@media (max-width: 575.98px) {\n  .opening-hours_opening_hours_list__1gd7k li, .opening-hours_opening_hours__list__5nUvh li {\n    padding: 15px 0;\n  }\n  .opening-hours_opening_hours_list__1gd7k li:last-of-type, .opening-hours_opening_hours__list__5nUvh li:last-of-type {\n    padding-bottom: 0;\n  }\n}\n.opening-hours_opening_hours_list__1gd7k button,\n.opening-hours_opening_hours_list__1gd7k button:hover,\n.opening-hours_opening_hours_list__1gd7k button:not(.opening-hours_disabled__Y5fya):hover, .opening-hours_opening_hours__list__5nUvh button,\n.opening-hours_opening_hours__list__5nUvh button:hover,\n.opening-hours_opening_hours__list__5nUvh button:not(.opening-hours_disabled__Y5fya):hover {\n  display: block;\n  float: right;\n  background-color: #1b8158 !important;\n}\n@media (max-width: 575.98px) {\n  .opening-hours_opening_hours_list__1gd7k button,\n  .opening-hours_opening_hours_list__1gd7k button:hover,\n  .opening-hours_opening_hours_list__1gd7k button:not(.opening-hours_disabled__Y5fya):hover, .opening-hours_opening_hours__list__5nUvh button,\n  .opening-hours_opening_hours__list__5nUvh button:hover,\n  .opening-hours_opening_hours__list__5nUvh button:not(.opening-hours_disabled__Y5fya):hover {\n    float: initial;\n    width: 65vw;\n    margin: auto !important;\n  }\n}\n.opening-hours_opening_hours_list__1gd7k .opening-hours_copy_btn_wrapper__S0txt, .opening-hours_opening_hours__list__5nUvh .opening-hours_copy_btn_wrapper__S0txt {\n  float: right;\n  width: 100%;\n  margin-top: 5px;\n  margin-bottom: 25px;\n}\n.opening-hours_opening_hours__list__5nUvh {\n  margin-bottom: 20px;\n}\n.opening-hours_opening_hours__list__5nUvh .opening-hours_dropdown__lezi7 > div {\n  width: 70px;\n  margin: 0 5px;\n}\n.opening-hours_opening_hours__list__5nUvh .opening-hours_dropdown__lezi7 > div:first-of-type {\n  width: 100px;\n  max-width: 100px;\n}\n.opening-hours_opening_hours__JT4Yx .opening-hours_toggle_button_group__IuF35 {\n  overflow-x: auto;\n}\n.opening-hours_opening_hours__JT4Yx form input[type=submit],\n.opening-hours_opening_hours__JT4Yx form input[type=button],\n.opening-hours_opening_hours__JT4Yx form button,\n.opening-hours_opening_hours__JT4Yx form button:hover {\n  background-image: unset;\n}\n.opening-hours_opening_hours__JT4Yx input,\n.opening-hours_opening_hours__JT4Yx textarea,\n.opening-hours_opening_hours__JT4Yx button {\n  font-size: 12px;\n  text-shadow: none;\n}\n.opening-hours_opening_hours__JT4Yx a.opening-hours_button__edFKO,\n.opening-hours_opening_hours__JT4Yx a:link.opening-hours_button__edFKO,\n.opening-hours_opening_hours__JT4Yx a:visited.opening-hours_button__edFKO,\n.opening-hours_opening_hours__JT4Yx a:hover.opening-hours_button__edFKO,\n.opening-hours_opening_hours__JT4Yx input[type=submit],\n.opening-hours_opening_hours__JT4Yx input[type=button],\n.opening-hours_opening_hours__JT4Yx button,\n.opening-hours_opening_hours__JT4Yx button:not(.opening-hours_disabled__Y5fya):hover {\n  margin: 0 !important;\n  background-color: #f7f7f7;\n  background-image: unset;\n  border: none !important;\n}\n.opening-hours_opening_hours_select__mtibU {\n  display: block;\n  min-width: 140px;\n  margin-top: 0 !important;\n  padding: 8px 24px;\n  color: #13220f;\n  font-size: 16px;\n  line-height: 25px;\n  border: 1px solid #e5e5e5;\n  border-radius: 23px;\n  box-shadow: inset 0 0 0 1px #1b8158;\n  transition: 0.15s ease-in-out;\n  appearance: none;\n}\n@media (min-width: 992px) and (max-width: 1599.98px) {\n  .opening-hours_opening_hours_select__mtibU {\n    font-size: 14.2px;\n  }\n}\n@media (max-width: 575.98px) {\n  .opening-hours_opening_hours_select__mtibU {\n    order: 2;\n    width: 100%;\n    max-width: 100%;\n    margin-top: 10px;\n    background-position-x: 94% !important;\n  }\n}\n.opening-hours_opening_hours_select__mtibU:focus {\n  outline: none;\n}\n.opening-hours_opening_hours_select__mtibU:hover {\n  cursor: pointer;\n}\n\n.opening_hours_view {\n  margin-top: 25px;\n}\n.opening_hours_view .opening-hours_widget_label__hLWDE {\n  margin-bottom: 5px;\n  color: #13220f;\n  font-weight: 700;\n}\n.opening_hours_view .opening-hours_opening_hours_list__1gd7k,\n.opening_hours_view .opening-hours_toggle_button_group__IuF35 {\n  margin-bottom: 25px;\n}\n\n.opening_hours_admin {\n  width: fit-content;\n  margin-top: 20px;\n  margin-bottom: 30px;\n  margin-left: 0.7em;\n  padding-top: 1em;\n  color: #5e6469;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.opening_hours_admin .opening-hours_toggle_button_group__IuF35 {\n  padding: 10px 0;\n}\n.opening_hours_admin .opening-hours_dropdown__lezi7 {\n  justify-content: space-between;\n}\n.opening_hours_admin .opening-hours_dropdown__lezi7 > div {\n  flex-basis: 100%;\n  min-width: 50px;\n  margin: 0 5px;\n  font-size: 14px;\n}\n.opening_hours_admin .opening-hours_dropdown__lezi7 > div .inline {\n  display: flex;\n  margin-left: 45px;\n}\n.opening_hours_admin .opening-hours_dropdown__lezi7 > div .inline > .checkbox {\n  margin-right: 5px;\n}\n.opening_hours_admin .MuiOutlinedInput-notchedOutline > legend {\n  display: none;\n}";
var css$7 = {"opening_hours_list":"opening-hours_opening_hours_list__1gd7k","dropdown":"opening-hours_dropdown__lezi7","opening_hours__list":"opening-hours_opening_hours__list__5nUvh","copy_btn_wrapper":"opening-hours_copy_btn_wrapper__S0txt","opening_hours":"opening-hours_opening_hours__JT4Yx","toggle_button_group":"opening-hours_toggle_button_group__IuF35","opening_hours_select":"opening-hours_opening_hours_select__mtibU","widget_label":"opening-hours_widget_label__hLWDE"};
styleInject(css_248z$e);

var triangle = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2214.907%22%20height%3D%228.325%22%3E%3Cpath%20d%3D%22M0%200l7.453%208.325L14.907%200z%22%20fill%3D%22%231b8158%22%2F%3E%3C%2Fsvg%3E";

var Dropdown = function Dropdown(_ref) {
  var _ref$additionalClass = _ref.additionalClass,
    additionalClass = _ref$additionalClass === void 0 ? '' : _ref$additionalClass,
    defaultValue = _ref.defaultValue,
    direction = _ref.direction,
    itemID = _ref.itemID,
    listItems = _ref.listItems,
    valueChange = _ref.valueChange;
  var handleChange = function handleChange(e) {
    var data = _defineProperty({}, itemID, e.target.value);
    valueChange(data);
  };
  return /*#__PURE__*/React__default.createElement("select", {
    className: "".concat(css$7.opening_hours_select, " ").concat(additionalClass),
    name: "openinghours",
    onChange: handleChange,
    style: {
      background: "url(".concat(triangle, ") no-repeat 87% center / 14px #fff")
    },
    value: defaultValue
  }, listItems.map(function (hour) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: "".concat(direction, "-").concat(hour.valueItem),
      value: hour.valueItem
    }, hour.displayItem);
  }));
};
Dropdown.propTypes = {
  additionalClass: PropTypes.string,
  defaultValue: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  itemID: PropTypes.string.isRequired,
  listItems: PropTypes.arrayOf(PropTypes.shape({
    displayItem: PropTypes.string.isRequired,
    valueItem: PropTypes.string.isRequired
  })).isRequired,
  valueChange: PropTypes.func.isRequired
};

var ToggleButtonGroupControlled = function ToggleButtonGroupControlled(props) {
  // react hook for handling selected days internally.
  var _useState = useState(props.value),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var handleChange = function handleChange(e, v) {
    // sorting selected weekdays
    // prop function to pass updated data to the parent
    props.weekdayChange(v.sort());
    setValue(v);
  };
  return /*#__PURE__*/React__default.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React__default.createElement(ToggleButtonGroup, {
    onChange: handleChange,
    size: "small",
    value: value.map(function (item) {
      return Number(item);
    })
  }, props.listItems.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(ToggleButton, {
      disableRipple: true,
      key: "toggle-btn-".concat(index),
      tabIndex: index,
      value: index
    }, item);
  })));
};
ToggleButtonGroupControlled.propTypes = {
  listItems: PropTypes.array,
  value: PropTypes.array,
  weekdayChange: PropTypes.any
};

var OpeningHours = function OpeningHours(_ref) {
  var _ref$additionalClass = _ref.additionalClass,
    additionalClass = _ref$additionalClass === void 0 ? '' : _ref$additionalClass,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    inputID = _ref.inputID,
    _ref$locale = _ref.locale,
    propLocale = _ref$locale === void 0 ? 'en-US' : _ref$locale,
    _ref$preloadData = _ref.preloadData,
    preloadData = _ref$preloadData === void 0 ? {} : _ref$preloadData,
    t = _ref.t,
    _ref$timeFormat24hour = _ref.timeFormat24hours,
    timeFormat24hours = _ref$timeFormat24hour === void 0 ? false : _ref$timeFormat24hour,
    _ref$weekDays = _ref.weekDays,
    weekDays = _ref$weekDays === void 0 ? ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] : _ref$weekDays;
  // Time and Date Constants
  var MINUTES_IN_HOUR = 60;
  var HOURS_IN_DAY = 24;
  var INTERVAL_MINUTES = 30;
  var INTERVALS_IN_DAY = HOURS_IN_DAY * MINUTES_IN_HOUR / INTERVAL_MINUTES;
  var END_OF_DAY_VALUE = '24:00';

  // Default Opening and Closing Times
  var DEFAULT_OPENING_HOUR = 9; // 9:00 AM
  var DEFAULT_CLOSING_HOUR = 17; // 5:00 PM

  var getTimeIndex = function getTimeIndex(hour) {
    var minute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return (hour * MINUTES_IN_HOUR + minute) / INTERVAL_MINUTES;
  };
  var DEFAULT_OPENING_INDEX = getTimeIndex(DEFAULT_OPENING_HOUR);
  var DEFAULT_CLOSING_INDEX = getTimeIndex(DEFAULT_CLOSING_HOUR);
  var shouldUse12HourFormat = function shouldUse12HourFormat(locale, timeFormat24hours) {
    var localesUsing12HourFormat = ['en-US', 'en-GB', 'en-CA', 'en-AU'];
    return !timeFormat24hours && localesUsing12HourFormat.includes(locale);
  };
  var generateHours = function generateHours(timeFormat24hours, locale) {
    var date = new Date(0, 0, 0, 0, 0, 0, 0);
    var hours = [];
    var use12HourFormat = shouldUse12HourFormat(locale, timeFormat24hours);
    for (var i = 0; i < INTERVALS_IN_DAY; i++) {
      var hourFormat = {
        hour: '2-digit',
        minute: '2-digit'
      };
      if (!use12HourFormat) {
        hourFormat.hour12 = false;
      }
      hours.push({
        displayItem: date.toLocaleString(locale, hourFormat),
        valueItem: date.toLocaleTimeString(locale, {
          hour12: false
        }).substring(0, 5)
      });
      date.setMinutes(date.getMinutes() + INTERVAL_MINUTES);
    }
    hours.push({
      displayItem: use12HourFormat ? '12:00 AM' : END_OF_DAY_VALUE,
      valueItem: END_OF_DAY_VALUE
    });
    return hours;
  };
  var initializeAllDayData = function initializeAllDayData() {
    return weekDays.reduce(function (acc, _, index) {
      acc[String(index)] = false;
      return acc;
    }, {});
  };
  var preloadedData = _objectSpread2({}, preloadData);
  for (var p in preloadedData) {
    if (preloadedData[p].opening === '00:00' && preloadedData[p].closing === '00:00') {
      preloadedData[p].allDay = true;
    }
  }
  var _useState = useState(initializeAllDayData()),
    _useState2 = _slicedToArray(_useState, 2),
    allDay = _useState2[0],
    setAllDay = _useState2[1];
  var _useState3 = useState(preloadedData),
    _useState4 = _slicedToArray(_useState3, 2),
    openingHoursData = _useState4[0],
    setOpeningHoursData = _useState4[1];
  var _useState5 = useState(Object.keys(preloadedData)),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedWeekdays = _useState6[0],
    setSelectedWeekdays = _useState6[1];
  var listItems = useMemo(function () {
    return generateHours(timeFormat24hours, propLocale);
  }, [timeFormat24hours, propLocale]);
  var initialValue = useMemo(function () {
    return {
      closing: listItems[DEFAULT_CLOSING_INDEX].valueItem,
      opening: listItems[DEFAULT_OPENING_INDEX].valueItem
    };
  }, [listItems]);
  useEffect(function () {
    var data = JSON.stringify(openingHoursData);
    var inputField = document.querySelector("#".concat(inputID));
    if (inputField) {
      if (data !== '{}' && enabled) {
        inputField.value = data;
      } else {
        inputField.value = null;
      }
    }
  }, [openingHoursData, enabled, inputID]);
  useEffect(function () {
    if (selectedWeekdays.length) {
      setOpeningHoursData(function (prevOpeningHoursData) {
        var selectedOpeningHours = selectedWeekdays.reduce(function (acc, item) {
          acc[item] = prevOpeningHoursData[item] || _objectSpread2({}, initialValue);
          return acc;
        }, {});
        return selectedOpeningHours;
      });
    }
  }, [selectedWeekdays, initialValue]);
  var getDefaultValue = function getDefaultValue(weekday, fromTo) {
    var _openingHoursData$wee;
    return ((_openingHoursData$wee = openingHoursData[weekday]) === null || _openingHoursData$wee === void 0 ? void 0 : _openingHoursData$wee[fromTo]) || listItems[0].valueItem;
  };
  var getDisplayValue = function getDisplayValue(timeValue) {
    var timeItem = listItems.find(function (item) {
      return item.valueItem === timeValue;
    });
    return timeItem ? timeItem.displayItem : timeValue;
  };
  var handleTimeChange = function handleTimeChange(time, fromTo) {
    var key = Object.keys(time)[0];
    setOpeningHoursData(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, _defineProperty({}, key, _objectSpread2(_objectSpread2({}, prevState[key]), {}, _defineProperty({}, fromTo, time[key]))));
    });
  };
  var handleWeekdaysChange = function handleWeekdaysChange(value) {
    setSelectedWeekdays(value.map(String));
  };
  var handleCopyTime = function handleCopyTime() {
    var baseValue = openingHoursData[selectedWeekdays[0]];
    var newValue = selectedWeekdays.reduce(function (acc, item) {
      acc[item] = _objectSpread2({}, baseValue);
      return acc;
    }, {});
    var baseCheckboxValue = allDay[selectedWeekdays[0]];
    var newCheckboxValue = selectedWeekdays.reduce(function (acc, item) {
      acc[item] = baseCheckboxValue;
      return acc;
    }, {});
    setAllDay(function (prevAllDay) {
      return _objectSpread2(_objectSpread2({}, prevAllDay), newCheckboxValue);
    });
    setOpeningHoursData(function (prevData) {
      return _objectSpread2(_objectSpread2({}, prevData), newValue);
    });
  };
  var handleAllDayToggle = function handleAllDayToggle(weekday) {
    setAllDay(function (prevState) {
      var newAllDay = _objectSpread2(_objectSpread2({}, prevState), {}, _defineProperty({}, weekday, !prevState[weekday]));
      setOpeningHoursData(function (prevData) {
        var newOpeningHoursData = _objectSpread2({}, prevData);
        if (newAllDay[weekday]) {
          newOpeningHoursData[weekday] = {
            closing: END_OF_DAY_VALUE,
            opening: listItems[0].valueItem
          };
        } else {
          newOpeningHoursData[weekday] = {
            closing: listItems[DEFAULT_CLOSING_INDEX].valueItem,
            opening: listItems[DEFAULT_OPENING_INDEX].valueItem
          };
        }
        return newOpeningHoursData;
      });
      return newAllDay;
    });
  };
  var renderDropdown = function renderDropdown(weekday, timeType) {
    return /*#__PURE__*/React__default.createElement(Dropdown, {
      additionalClass: additionalClass,
      defaultValue: getDefaultValue(weekday, timeType),
      direction: timeType,
      itemID: weekday,
      listItems: listItems,
      valueChange: function valueChange(value) {
        return handleTimeChange(value, timeType);
      }
    });
  };
  var renderCopyButton = function renderCopyButton() {
    return /*#__PURE__*/React__default.createElement("button", {
      className: "buttonComponent--primary",
      onClick: handleCopyTime,
      type: "button"
    }, t['opening_hours.widget.copy_to_all_label']);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(css$7.opening_hours, " ").concat(additionalClass)
  }, /*#__PURE__*/React__default.createElement("label", {
    className: css$7.widget_label
  }, t['opening_hours.widget.title']), enabled && /*#__PURE__*/React__default.createElement("div", {
    className: css$7.toggle_button_group
  }, /*#__PURE__*/React__default.createElement(ToggleButtonGroupControlled, {
    className: css$7.toggle_button_group,
    listItems: weekDays,
    value: selectedWeekdays.map(Number),
    weekdayChange: handleWeekdaysChange
  })), /*#__PURE__*/React__default.createElement("div", {
    className: css$7.opening_hours_list
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$7.copy_btn_wrapper
  }, enabled && selectedWeekdays.length > 1 && renderCopyButton()), /*#__PURE__*/React__default.createElement("ul", null, selectedWeekdays.map(function (weekday) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: "weekday-".concat(weekday)
    }, /*#__PURE__*/React__default.createElement("div", {
      className: css$7.dropdown
    }, /*#__PURE__*/React__default.createElement("div", null, weekDays[Number(weekday)]), enabled ? renderDropdown(weekday, 'opening') : /*#__PURE__*/React__default.createElement("div", null, getDisplayValue(getDefaultValue(weekday, 'opening'))), enabled ? renderDropdown(weekday, 'closing') : /*#__PURE__*/React__default.createElement("div", null, getDisplayValue(getDefaultValue(weekday, 'closing'))), enabled && /*#__PURE__*/React__default.createElement("div", {
      className: "control-group"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "checkbox inline"
    }, /*#__PURE__*/React__default.createElement("input", {
      checked: allDay[weekday],
      className: "checkbox",
      id: "allDayCheckbox".concat(weekday),
      onChange: function onChange() {
        return handleAllDayToggle(weekday);
      },
      type: "checkbox"
    }), /*#__PURE__*/React__default.createElement("label", {
      className: "control-label",
      htmlFor: "allDayCheckbox".concat(weekday)
    }, t['opening_hours.widget.all_day'])))));
  }))));
};
OpeningHours.propTypes = {
  additionalClass: PropTypes.string,
  enabled: PropTypes.bool,
  inputID: PropTypes.string.isRequired,
  locale: PropTypes.string,
  preloadData: PropTypes.object,
  t: PropTypes.object.isRequired,
  timeFormat24hours: PropTypes.bool,
  weekDays: PropTypes.arrayOf(PropTypes.string)
};

var OpeningHoursViewer = function OpeningHoursViewer(_ref) {
  var _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en-US' : _ref$locale,
    preloadData = _ref.preloadData,
    t = _ref.t,
    _ref$timeFormat24hour = _ref.timeFormat24hours,
    timeFormat24hours = _ref$timeFormat24hour === void 0 ? true : _ref$timeFormat24hour,
    weekDays = _ref.weekDays;
  var openingHoursData = preloadData;
  var selectedWeekdays = Object.keys(preloadData);
  var formatTime = function formatTime(time, fromTo) {
    var formattedTime = time;
    if (fromTo === 'opening' && time === '24:00') {
      formattedTime = '00:00';
    }
    var _formattedTime$split$ = formattedTime.split(':').map(Number),
      _formattedTime$split$2 = _slicedToArray(_formattedTime$split$, 2),
      hours = _formattedTime$split$2[0],
      minutes = _formattedTime$split$2[1];
    var date = new Date();
    date.setHours(hours, minutes);
    return date.toLocaleTimeString(locale, {
      hour: '2-digit',
      hour12: !timeFormat24hours,
      minute: '2-digit'
    });
  };
  var getDisplayValue = function getDisplayValue(weekday, fromTo) {
    var _openingHoursData$wee;
    var timeValue = (_openingHoursData$wee = openingHoursData[weekday]) === null || _openingHoursData$wee === void 0 ? void 0 : _openingHoursData$wee[fromTo];
    if (!timeValue) {
      return '';
    }
    return formatTime(timeValue, fromTo);
  };
  var weekDaysLabels = useMemo(function () {
    return weekDays;
  }, [weekDays]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$7.opening_hours
  }, /*#__PURE__*/React__default.createElement("h6", null, /*#__PURE__*/React__default.createElement("b", null, t['opening_hours.widget.title'])), /*#__PURE__*/React__default.createElement("div", {
    className: css$7.opening_hours__list
  }, /*#__PURE__*/React__default.createElement("ul", null, selectedWeekdays.map(function (weekday) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: weekday
    }, /*#__PURE__*/React__default.createElement("div", {
      className: css$7.dropdown
    }, /*#__PURE__*/React__default.createElement("div", null, weekDaysLabels[Number(weekday)]), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", null, getDisplayValue(weekday, 'opening'))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", null, getDisplayValue(weekday, 'closing')))));
  }))));
};
OpeningHoursViewer.propTypes = {
  locale: PropTypes.string,
  preloadData: PropTypes.object.isRequired,
  t: PropTypes.object.isRequired,
  timeFormat24hours: PropTypes.bool,
  weekDays: PropTypes.arrayOf(PropTypes.string).isRequired
};

var css_248z$d = "@charset \"UTF-8\";\n.tc-product-right-side_container__F-G0M,\n.tc-product-right-side_container-fluid__oER5O,\n.tc-product-right-side_container-xxxl2__baeNZ,\n.tc-product-right-side_container-xxxl__LkyVj,\n.tc-product-right-side_container-xxl__boJpZ,\n.tc-product-right-side_container-xl__ZVTpM,\n.tc-product-right-side_container-lg__JW5QW,\n.tc-product-right-side_container-md__yNHOz,\n.tc-product-right-side_container-sm__8OGmL {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-product-right-side_container-sm__8OGmL, .tc-product-right-side_container__F-G0M {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-product-right-side_container-md__yNHOz, .tc-product-right-side_container-sm__8OGmL, .tc-product-right-side_container__F-G0M {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-product-right-side_container-lg__JW5QW, .tc-product-right-side_container-md__yNHOz, .tc-product-right-side_container-sm__8OGmL, .tc-product-right-side_container__F-G0M {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-product-right-side_container-xl__ZVTpM, .tc-product-right-side_container-lg__JW5QW, .tc-product-right-side_container-md__yNHOz, .tc-product-right-side_container-sm__8OGmL, .tc-product-right-side_container__F-G0M {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-product-right-side_container-xxl__boJpZ, .tc-product-right-side_container-xl__ZVTpM, .tc-product-right-side_container-lg__JW5QW, .tc-product-right-side_container-md__yNHOz, .tc-product-right-side_container-sm__8OGmL, .tc-product-right-side_container__F-G0M {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-product-right-side_container-xxxl__LkyVj, .tc-product-right-side_container-xxl__boJpZ, .tc-product-right-side_container-xl__ZVTpM, .tc-product-right-side_container-lg__JW5QW, .tc-product-right-side_container-md__yNHOz, .tc-product-right-side_container-sm__8OGmL, .tc-product-right-side_container__F-G0M {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-product-right-side_container-xxxl2__baeNZ, .tc-product-right-side_container-xxxl__LkyVj, .tc-product-right-side_container-xxl__boJpZ, .tc-product-right-side_container-xl__ZVTpM, .tc-product-right-side_container-lg__JW5QW, .tc-product-right-side_container-md__yNHOz, .tc-product-right-side_container-sm__8OGmL, .tc-product-right-side_container__F-G0M {\n    max-width: 182rem;\n  }\n}\n.tc-product-right-side_rating__HnhAW {\n  margin-bottom: 1rem;\n}\n@media (min-width: 768px) {\n  .tc-product-right-side_rating__HnhAW {\n    margin-bottom: 2.5rem;\n  }\n}\n.tc-product-right-side_rating__stars__X5OJB {\n  position: relative;\n  display: inline-block;\n  font-size: 1.2rem;\n}\n@media (min-width: 768px) {\n  .tc-product-right-side_rating__stars__X5OJB {\n    font-size: 1.8rem;\n  }\n}\n.tc-product-right-side_rating__stars__X5OJB::before {\n  color: #e2e2e2;\n  content: \"☆☆☆☆☆\";\n}\n.tc-product-right-side_rating__stars-inner__9SDxH {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.tc-product-right-side_rating__stars-inner__9SDxH::before {\n  color: #ffe200;\n  content: \"★★★★★\";\n}\n.tc-product-right-side_rating__count__na9gd {\n  padding-left: 2rem;\n  color: #1b8158;\n  font-size: 1.2rem;\n  white-space: nowrap;\n  cursor: pointer;\n}\n@media (min-width: 768px) {\n  .tc-product-right-side_rating__count__na9gd {\n    font-size: 1.6rem;\n  }\n}\n\n.tc-product-right-side_product__price__bwtWU {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 3rem;\n}\n.tc-product-right-side_product__price-normal__KLAGp {\n  padding-right: 1.5rem;\n  color: #1b8158;\n  font-weight: 700;\n  font-size: 2.2rem;\n}\n.tc-product-right-side_product__price-sale__grazX {\n  padding-left: 1.5rem;\n  color: #acacac;\n  font-size: 2.2rem;\n  text-decoration: line-through;\n  border-left: 0.1rem solid #528d6f;\n}\n.tc-product-right-side_product__subsidy__yStKG {\n  font-weight: 500;\n}\n@media (max-width: 767.98px) {\n  .tc-product-right-side_product__subsidy__yStKG {\n    font-size: 1.4rem;\n  }\n}\n@media (max-width: 1199.98px) {\n  .tc-product-right-side_product__tabs__ZrJhU {\n    width: 100%;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-product-right-side_product__tabs__ZrJhU {\n    margin-left: 10rem;\n  }\n}\n@media (min-width: 768px) and (max-width: 1199.98px) {\n  .tc-product-right-side_product__tabs__ZrJhU {\n    margin-top: 2rem;\n  }\n}\n.tc-product-right-side_product__tabs__ZrJhU .MuiTabs-indicator {\n  background-color: transparent;\n}\n@media (max-width: 767.98px) {\n  .tc-product-right-side_product__tabs__ZrJhU .MuiTabs-flexContainer {\n    flex-direction: column;\n  }\n}\n.tc-product-right-side_product__tabs__ZrJhU .MuiButtonBase-root {\n  flex: auto;\n  height: 4.1rem;\n  min-height: 100%;\n  padding: 0 3rem;\n  color: #b2deba;\n  font-weight: bold;\n  font-size: 1.4rem;\n  font-family: \"Poppins\", verdana, sans-serif;\n  white-space: nowrap;\n  background-color: transparent;\n  border: none !important;\n}\n@media (max-width: 767.98px) {\n  .tc-product-right-side_product__tabs__ZrJhU .MuiButtonBase-root {\n    max-width: 100%;\n    border-radius: 2rem;\n  }\n  .tc-product-right-side_product__tabs__ZrJhU .MuiButtonBase-root:first-of-type {\n    margin-bottom: 1rem;\n  }\n  .tc-product-right-side_product__tabs__ZrJhU .MuiButtonBase-root::before {\n    position: absolute;\n    top: 50%;\n    left: 2rem;\n    width: 1.5rem;\n    height: 1.5rem;\n    border: 0.1rem solid #e2e2e2;\n    border-radius: 0.5rem;\n    transform: translateY(-50%);\n    transition: 0.5s;\n    content: \"\";\n    will-change: background;\n  }\n}\n@media (min-width: 768px) {\n  .tc-product-right-side_product__tabs__ZrJhU .MuiButtonBase-root {\n    height: 5.3rem;\n    font-size: 1.6rem;\n    border-radius: 4.8rem;\n  }\n}\n.tc-product-right-side_product__tabs__ZrJhU .MuiButtonBase-root.Mui-selected {\n  color: #1b8158;\n  background-color: #f7f7f7;\n}\n@media (max-width: 767.98px) {\n  .tc-product-right-side_product__tabs__ZrJhU .MuiButtonBase-root.Mui-selected::before {\n    background-color: #1b8158;\n    box-shadow: 0 0.1rem 0.6rem rgba(28, 144, 125, 0.2039215686);\n  }\n}\n.tc-product-right-side_product__tabs__ZrJhU .MuiButtonBase-root span.MuiTab-wrapper {\n  display: block;\n  width: auto;\n  margin-bottom: 0;\n  padding: 0;\n}\n.tc-product-right-side_product__size-label__XH7MR {\n  margin-bottom: 1rem;\n  font-weight: 500;\n}\n.tc-product-right-side_product-size-select__radio__OC8z- {\n  overflow: auto;\n}\n.tc-product-right-side_product-size-select__radio__OC8z- .MuiFormGroup-root {\n  display: flex;\n  flex-flow: row nowrap;\n  padding: 0.2rem;\n}\n.tc-product-right-side_product-size-select__radio__OC8z- .MuiFormControlLabel-label {\n  color: #5e6469;\n  font-weight: 500;\n  font-size: 1.6rem;\n  font-family: \"Poppins\", verdana, sans-serif;\n}\n.tc-product-right-side_product-size-select__radio__OC8z- .MuiSvgIcon-root,\n.tc-product-right-side_product-size-select__radio__OC8z- .MuiTouchRipple-root {\n  display: none;\n}\n.tc-product-right-side_product-size-select__radio__OC8z- .MuiFormControlLabel-root {\n  margin: 0;\n}\n.tc-product-right-side_product-size-select__radio__OC8z- .MuiIconButton-root:hover {\n  background: none !important;\n}\n.tc-product-right-side_product-size-select__radio__OC8z- .MuiButtonBase-root {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0.1rem solid #bdd8ca;\n  border-radius: 1rem;\n}\n.tc-product-right-side_product-size-select__radio__OC8z- .Mui-checked {\n  border-color: #1b8158;\n  box-shadow: 0 0 0 0.1rem #1b8158;\n}\n.tc-product-right-side_product-size-select__radio__OC8z- .Mui-checked ~ .MuiFormControlLabel-label {\n  color: #13220f;\n  font-weight: 700;\n}\n.tc-product-right-side_product-size-select__input__xXgua {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  width: 9.5rem;\n  height: 11rem;\n  margin-right: 1rem;\n  padding: 0.5rem;\n}\n@media (min-width: 768px) {\n  .tc-product-right-side_product-size-select__input__xXgua {\n    flex-direction: row;\n    width: 100%;\n    min-width: 14.5rem;\n    height: 7.4rem;\n  }\n}\n.tc-product-right-side_product-size-select__img__coi8L {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 6.4rem;\n  height: 6.4rem;\n}\n.tc-product-right-side_product-size-select__img__coi8L img {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.onSale .tc-product-right-side_product__price-normal__KLAGp {\n  color: #c23326;\n}\n\n.error {\n  margin-top: 0.5rem;\n  color: #d92f2f;\n  font-size: 1.5rem;\n}";
var productCss = {"container":"tc-product-right-side_container__F-G0M","container-fluid":"tc-product-right-side_container-fluid__oER5O","container-xxxl2":"tc-product-right-side_container-xxxl2__baeNZ","container-xxxl":"tc-product-right-side_container-xxxl__LkyVj","container-xxl":"tc-product-right-side_container-xxl__boJpZ","container-xl":"tc-product-right-side_container-xl__ZVTpM","container-lg":"tc-product-right-side_container-lg__JW5QW","container-md":"tc-product-right-side_container-md__yNHOz","container-sm":"tc-product-right-side_container-sm__8OGmL","rating":"tc-product-right-side_rating__HnhAW","rating__stars":"tc-product-right-side_rating__stars__X5OJB","rating__stars-inner":"tc-product-right-side_rating__stars-inner__9SDxH","rating__count":"tc-product-right-side_rating__count__na9gd","product__price":"tc-product-right-side_product__price__bwtWU","product__price-normal":"tc-product-right-side_product__price-normal__KLAGp","product__price-sale":"tc-product-right-side_product__price-sale__grazX","product__subsidy":"tc-product-right-side_product__subsidy__yStKG","product__tabs":"tc-product-right-side_product__tabs__ZrJhU","product__size-label":"tc-product-right-side_product__size-label__XH7MR","product-size-select__radio":"tc-product-right-side_product-size-select__radio__OC8z-","product-size-select__input":"tc-product-right-side_product-size-select__input__xXgua","product-size-select__img":"tc-product-right-side_product-size-select__img__coi8L"};
styleInject(css_248z$d);

var PriceLabel = function PriceLabel(_ref) {
  var brand = _ref.brand,
    price = _ref.price,
    on_sale = _ref.on_sale,
    old_price = _ref.old_price,
    _ref$self_served = _ref.self_served,
    self_served = _ref$self_served === void 0 ? false : _ref$self_served,
    subsidy = _ref.subsidy,
    translations = _ref.translations;
  var parsePriceValue = function parsePriceValue(priceString) {
    if (!priceString) return 0;
    return parseFloat(priceString.replace(/[^\d.-]/g, ''));
  };
  var currentPriceValue = parsePriceValue(price);
  var oldPriceValue = parsePriceValue(old_price);
  var shouldShowOldPrice = oldPriceValue > currentPriceValue;
  var productPriceClassName = "".concat(productCss.product__price, " mb-3 d-flex align-items-baseline ").concat(on_sale ? 'onSale' : '');
  var brandSubsidyMessage = translations.brand_subsidy.replace(':brand_name', brand);
  return /*#__PURE__*/React__default.createElement("div", {
    className: productPriceClassName
  }, /*#__PURE__*/React__default.createElement("span", {
    className: productCss['product__price-normal']
  }, price), on_sale && shouldShowOldPrice && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "".concat(productCss['product__price-sale'], " me-4 onSale")
  }, old_price), self_served && /*#__PURE__*/React__default.createElement("span", {
    className: "onSale fw-medium grey-text"
  }, "(", /*#__PURE__*/React__default.createElement("span", {
    className: productCss.product__subsidy
  }, subsidy), ' ', brandSubsidyMessage, ")")), !on_sale && shouldShowOldPrice && /*#__PURE__*/React__default.createElement("span", {
    className: "".concat(productCss['product__price-sale'], " me-4 onSale")
  }, old_price));
};
PriceLabel.propTypes = {
  brand: PropTypes.string,
  old_price: PropTypes.string,
  on_sale: PropTypes.bool,
  price: PropTypes.string,
  self_served: PropTypes.bool,
  subsidy: PropTypes.string,
  translations: PropTypes.object.isRequired
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (Object.prototype.hasOwnProperty.call(n, '__esModule')) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			var isInstance = false;
      try {
        isInstance = this instanceof a;
      } catch {}
			if (isInstance) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var lib$6 = {};

var Parser = {};

var Tokenizer = {};

var decode = {};

var decodeDataHtml = {};

var hasRequiredDecodeDataHtml;

function requireDecodeDataHtml () {
	if (hasRequiredDecodeDataHtml) return decodeDataHtml;
	hasRequiredDecodeDataHtml = 1;
	// Generated using scripts/write-decode-map.ts
	Object.defineProperty(decodeDataHtml, "__esModule", { value: true });
	decodeDataHtml.default = new Uint16Array(
	// prettier-ignore
	"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c"
	    .split("")
	    .map(function (c) { return c.charCodeAt(0); }));
	
	return decodeDataHtml;
}

var decodeDataXml = {};

var hasRequiredDecodeDataXml;

function requireDecodeDataXml () {
	if (hasRequiredDecodeDataXml) return decodeDataXml;
	hasRequiredDecodeDataXml = 1;
	// Generated using scripts/write-decode-map.ts
	Object.defineProperty(decodeDataXml, "__esModule", { value: true });
	decodeDataXml.default = new Uint16Array(
	// prettier-ignore
	"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022"
	    .split("")
	    .map(function (c) { return c.charCodeAt(0); }));
	
	return decodeDataXml;
}

var decode_codepoint = {};

var hasRequiredDecode_codepoint;

function requireDecode_codepoint () {
	if (hasRequiredDecode_codepoint) return decode_codepoint;
	hasRequiredDecode_codepoint = 1;
	(function (exports) {
		// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
		var _a;
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.replaceCodePoint = exports.fromCodePoint = void 0;
		var decodeMap = new Map([
		    [0, 65533],
		    // C1 Unicode control character reference replacements
		    [128, 8364],
		    [130, 8218],
		    [131, 402],
		    [132, 8222],
		    [133, 8230],
		    [134, 8224],
		    [135, 8225],
		    [136, 710],
		    [137, 8240],
		    [138, 352],
		    [139, 8249],
		    [140, 338],
		    [142, 381],
		    [145, 8216],
		    [146, 8217],
		    [147, 8220],
		    [148, 8221],
		    [149, 8226],
		    [150, 8211],
		    [151, 8212],
		    [152, 732],
		    [153, 8482],
		    [154, 353],
		    [155, 8250],
		    [156, 339],
		    [158, 382],
		    [159, 376],
		]);
		/**
		 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
		 */
		exports.fromCodePoint = 
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
		(_a = String.fromCodePoint) !== null && _a !== void 0 ? _a : function (codePoint) {
		    var output = "";
		    if (codePoint > 0xffff) {
		        codePoint -= 0x10000;
		        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
		        codePoint = 0xdc00 | (codePoint & 0x3ff);
		    }
		    output += String.fromCharCode(codePoint);
		    return output;
		};
		/**
		 * Replace the given code point with a replacement character if it is a
		 * surrogate or is outside the valid range. Otherwise return the code
		 * point unchanged.
		 */
		function replaceCodePoint(codePoint) {
		    var _a;
		    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
		        return 0xfffd;
		    }
		    return (_a = decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
		}
		exports.replaceCodePoint = replaceCodePoint;
		/**
		 * Replace the code point if relevant, then convert it to a string.
		 *
		 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
		 * @param codePoint The code point to decode.
		 * @returns The decoded code point.
		 */
		function decodeCodePoint(codePoint) {
		    return (0, exports.fromCodePoint)(replaceCodePoint(codePoint));
		}
		exports.default = decodeCodePoint;
		
	} (decode_codepoint));
	return decode_codepoint;
}

var hasRequiredDecode;

function requireDecode () {
	if (hasRequiredDecode) return decode;
	hasRequiredDecode = 1;
	(function (exports) {
		var __createBinding = (decode && decode.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __setModuleDefault = (decode && decode.__setModuleDefault) || (Object.create ? (function(o, v) {
		    Object.defineProperty(o, "default", { enumerable: true, value: v });
		}) : function(o, v) {
		    o["default"] = v;
		});
		var __importStar = (decode && decode.__importStar) || function (mod) {
		    if (mod && mod.__esModule) return mod;
		    var result = {};
		    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		    __setModuleDefault(result, mod);
		    return result;
		};
		var __importDefault = (decode && decode.__importDefault) || function (mod) {
		    return (mod && mod.__esModule) ? mod : { "default": mod };
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.decodeXML = exports.decodeHTMLStrict = exports.decodeHTMLAttribute = exports.decodeHTML = exports.determineBranch = exports.EntityDecoder = exports.DecodingMode = exports.BinTrieFlags = exports.fromCodePoint = exports.replaceCodePoint = exports.decodeCodePoint = exports.xmlDecodeTree = exports.htmlDecodeTree = void 0;
		var decode_data_html_js_1 = __importDefault(/*@__PURE__*/ requireDecodeDataHtml());
		exports.htmlDecodeTree = decode_data_html_js_1.default;
		var decode_data_xml_js_1 = __importDefault(/*@__PURE__*/ requireDecodeDataXml());
		exports.xmlDecodeTree = decode_data_xml_js_1.default;
		var decode_codepoint_js_1 = __importStar(/*@__PURE__*/ requireDecode_codepoint());
		exports.decodeCodePoint = decode_codepoint_js_1.default;
		var decode_codepoint_js_2 = /*@__PURE__*/ requireDecode_codepoint();
		Object.defineProperty(exports, "replaceCodePoint", { enumerable: true, get: function () { return decode_codepoint_js_2.replaceCodePoint; } });
		Object.defineProperty(exports, "fromCodePoint", { enumerable: true, get: function () { return decode_codepoint_js_2.fromCodePoint; } });
		var CharCodes;
		(function (CharCodes) {
		    CharCodes[CharCodes["NUM"] = 35] = "NUM";
		    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
		    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
		    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
		    CharCodes[CharCodes["NINE"] = 57] = "NINE";
		    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
		    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
		    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
		    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
		    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
		    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
		    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
		})(CharCodes || (CharCodes = {}));
		/** Bit that needs to be set to convert an upper case ASCII character to lower case */
		var TO_LOWER_BIT = 32;
		var BinTrieFlags;
		(function (BinTrieFlags) {
		    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
		    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
		    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
		})(BinTrieFlags = exports.BinTrieFlags || (exports.BinTrieFlags = {}));
		function isNumber(code) {
		    return code >= CharCodes.ZERO && code <= CharCodes.NINE;
		}
		function isHexadecimalCharacter(code) {
		    return ((code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_F) ||
		        (code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_F));
		}
		function isAsciiAlphaNumeric(code) {
		    return ((code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_Z) ||
		        (code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_Z) ||
		        isNumber(code));
		}
		/**
		 * Checks if the given character is a valid end character for an entity in an attribute.
		 *
		 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
		 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
		 */
		function isEntityInAttributeInvalidEnd(code) {
		    return code === CharCodes.EQUALS || isAsciiAlphaNumeric(code);
		}
		var EntityDecoderState;
		(function (EntityDecoderState) {
		    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
		    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
		    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
		    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
		    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
		})(EntityDecoderState || (EntityDecoderState = {}));
		var DecodingMode;
		(function (DecodingMode) {
		    /** Entities in text nodes that can end with any character. */
		    DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
		    /** Only allow entities terminated with a semicolon. */
		    DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
		    /** Entities in attributes have limitations on ending characters. */
		    DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
		})(DecodingMode = exports.DecodingMode || (exports.DecodingMode = {}));
		/**
		 * Token decoder with support of writing partial entities.
		 */
		var EntityDecoder = /** @class */ (function () {
		    function EntityDecoder(
		    /** The tree used to decode entities. */
		    decodeTree, 
		    /**
		     * The function that is called when a codepoint is decoded.
		     *
		     * For multi-byte named entities, this will be called multiple times,
		     * with the second codepoint, and the same `consumed` value.
		     *
		     * @param codepoint The decoded codepoint.
		     * @param consumed The number of bytes consumed by the decoder.
		     */
		    emitCodePoint, 
		    /** An object that is used to produce errors. */
		    errors) {
		        this.decodeTree = decodeTree;
		        this.emitCodePoint = emitCodePoint;
		        this.errors = errors;
		        /** The current state of the decoder. */
		        this.state = EntityDecoderState.EntityStart;
		        /** Characters that were consumed while parsing an entity. */
		        this.consumed = 1;
		        /**
		         * The result of the entity.
		         *
		         * Either the result index of a numeric entity, or the codepoint of a
		         * numeric entity.
		         */
		        this.result = 0;
		        /** The current index in the decode tree. */
		        this.treeIndex = 0;
		        /** The number of characters that were consumed in excess. */
		        this.excess = 1;
		        /** The mode in which the decoder is operating. */
		        this.decodeMode = DecodingMode.Strict;
		    }
		    /** Resets the instance to make it reusable. */
		    EntityDecoder.prototype.startEntity = function (decodeMode) {
		        this.decodeMode = decodeMode;
		        this.state = EntityDecoderState.EntityStart;
		        this.result = 0;
		        this.treeIndex = 0;
		        this.excess = 1;
		        this.consumed = 1;
		    };
		    /**
		     * Write an entity to the decoder. This can be called multiple times with partial entities.
		     * If the entity is incomplete, the decoder will return -1.
		     *
		     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
		     * entity is incomplete, and resume when the next string is written.
		     *
		     * @param string The string containing the entity (or a continuation of the entity).
		     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
		     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
		     */
		    EntityDecoder.prototype.write = function (str, offset) {
		        switch (this.state) {
		            case EntityDecoderState.EntityStart: {
		                if (str.charCodeAt(offset) === CharCodes.NUM) {
		                    this.state = EntityDecoderState.NumericStart;
		                    this.consumed += 1;
		                    return this.stateNumericStart(str, offset + 1);
		                }
		                this.state = EntityDecoderState.NamedEntity;
		                return this.stateNamedEntity(str, offset);
		            }
		            case EntityDecoderState.NumericStart: {
		                return this.stateNumericStart(str, offset);
		            }
		            case EntityDecoderState.NumericDecimal: {
		                return this.stateNumericDecimal(str, offset);
		            }
		            case EntityDecoderState.NumericHex: {
		                return this.stateNumericHex(str, offset);
		            }
		            case EntityDecoderState.NamedEntity: {
		                return this.stateNamedEntity(str, offset);
		            }
		        }
		    };
		    /**
		     * Switches between the numeric decimal and hexadecimal states.
		     *
		     * Equivalent to the `Numeric character reference state` in the HTML spec.
		     *
		     * @param str The string containing the entity (or a continuation of the entity).
		     * @param offset The current offset.
		     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
		     */
		    EntityDecoder.prototype.stateNumericStart = function (str, offset) {
		        if (offset >= str.length) {
		            return -1;
		        }
		        if ((str.charCodeAt(offset) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
		            this.state = EntityDecoderState.NumericHex;
		            this.consumed += 1;
		            return this.stateNumericHex(str, offset + 1);
		        }
		        this.state = EntityDecoderState.NumericDecimal;
		        return this.stateNumericDecimal(str, offset);
		    };
		    EntityDecoder.prototype.addToNumericResult = function (str, start, end, base) {
		        if (start !== end) {
		            var digitCount = end - start;
		            this.result =
		                this.result * Math.pow(base, digitCount) +
		                    parseInt(str.substr(start, digitCount), base);
		            this.consumed += digitCount;
		        }
		    };
		    /**
		     * Parses a hexadecimal numeric entity.
		     *
		     * Equivalent to the `Hexademical character reference state` in the HTML spec.
		     *
		     * @param str The string containing the entity (or a continuation of the entity).
		     * @param offset The current offset.
		     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
		     */
		    EntityDecoder.prototype.stateNumericHex = function (str, offset) {
		        var startIdx = offset;
		        while (offset < str.length) {
		            var char = str.charCodeAt(offset);
		            if (isNumber(char) || isHexadecimalCharacter(char)) {
		                offset += 1;
		            }
		            else {
		                this.addToNumericResult(str, startIdx, offset, 16);
		                return this.emitNumericEntity(char, 3);
		            }
		        }
		        this.addToNumericResult(str, startIdx, offset, 16);
		        return -1;
		    };
		    /**
		     * Parses a decimal numeric entity.
		     *
		     * Equivalent to the `Decimal character reference state` in the HTML spec.
		     *
		     * @param str The string containing the entity (or a continuation of the entity).
		     * @param offset The current offset.
		     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
		     */
		    EntityDecoder.prototype.stateNumericDecimal = function (str, offset) {
		        var startIdx = offset;
		        while (offset < str.length) {
		            var char = str.charCodeAt(offset);
		            if (isNumber(char)) {
		                offset += 1;
		            }
		            else {
		                this.addToNumericResult(str, startIdx, offset, 10);
		                return this.emitNumericEntity(char, 2);
		            }
		        }
		        this.addToNumericResult(str, startIdx, offset, 10);
		        return -1;
		    };
		    /**
		     * Validate and emit a numeric entity.
		     *
		     * Implements the logic from the `Hexademical character reference start
		     * state` and `Numeric character reference end state` in the HTML spec.
		     *
		     * @param lastCp The last code point of the entity. Used to see if the
		     *               entity was terminated with a semicolon.
		     * @param expectedLength The minimum number of characters that should be
		     *                       consumed. Used to validate that at least one digit
		     *                       was consumed.
		     * @returns The number of characters that were consumed.
		     */
		    EntityDecoder.prototype.emitNumericEntity = function (lastCp, expectedLength) {
		        var _a;
		        // Ensure we consumed at least one digit.
		        if (this.consumed <= expectedLength) {
		            (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
		            return 0;
		        }
		        // Figure out if this is a legit end of the entity
		        if (lastCp === CharCodes.SEMI) {
		            this.consumed += 1;
		        }
		        else if (this.decodeMode === DecodingMode.Strict) {
		            return 0;
		        }
		        this.emitCodePoint((0, decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
		        if (this.errors) {
		            if (lastCp !== CharCodes.SEMI) {
		                this.errors.missingSemicolonAfterCharacterReference();
		            }
		            this.errors.validateNumericCharacterReference(this.result);
		        }
		        return this.consumed;
		    };
		    /**
		     * Parses a named entity.
		     *
		     * Equivalent to the `Named character reference state` in the HTML spec.
		     *
		     * @param str The string containing the entity (or a continuation of the entity).
		     * @param offset The current offset.
		     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
		     */
		    EntityDecoder.prototype.stateNamedEntity = function (str, offset) {
		        var decodeTree = this.decodeTree;
		        var current = decodeTree[this.treeIndex];
		        // The mask is the number of bytes of the value, including the current byte.
		        var valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
		        for (; offset < str.length; offset++, this.excess++) {
		            var char = str.charCodeAt(offset);
		            this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
		            if (this.treeIndex < 0) {
		                return this.result === 0 ||
		                    // If we are parsing an attribute
		                    (this.decodeMode === DecodingMode.Attribute &&
		                        // We shouldn't have consumed any characters after the entity,
		                        (valueLength === 0 ||
		                            // And there should be no invalid characters.
		                            isEntityInAttributeInvalidEnd(char)))
		                    ? 0
		                    : this.emitNotTerminatedNamedEntity();
		            }
		            current = decodeTree[this.treeIndex];
		            valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
		            // If the branch is a value, store it and continue
		            if (valueLength !== 0) {
		                // If the entity is terminated by a semicolon, we are done.
		                if (char === CharCodes.SEMI) {
		                    return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
		                }
		                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
		                if (this.decodeMode !== DecodingMode.Strict) {
		                    this.result = this.treeIndex;
		                    this.consumed += this.excess;
		                    this.excess = 0;
		                }
		            }
		        }
		        return -1;
		    };
		    /**
		     * Emit a named entity that was not terminated with a semicolon.
		     *
		     * @returns The number of characters consumed.
		     */
		    EntityDecoder.prototype.emitNotTerminatedNamedEntity = function () {
		        var _a;
		        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
		        var valueLength = (decodeTree[result] & BinTrieFlags.VALUE_LENGTH) >> 14;
		        this.emitNamedEntityData(result, valueLength, this.consumed);
		        (_a = this.errors) === null || _a === void 0 ? void 0 : _a.missingSemicolonAfterCharacterReference();
		        return this.consumed;
		    };
		    /**
		     * Emit a named entity.
		     *
		     * @param result The index of the entity in the decode tree.
		     * @param valueLength The number of bytes in the entity.
		     * @param consumed The number of characters consumed.
		     *
		     * @returns The number of characters consumed.
		     */
		    EntityDecoder.prototype.emitNamedEntityData = function (result, valueLength, consumed) {
		        var decodeTree = this.decodeTree;
		        this.emitCodePoint(valueLength === 1
		            ? decodeTree[result] & ~BinTrieFlags.VALUE_LENGTH
		            : decodeTree[result + 1], consumed);
		        if (valueLength === 3) {
		            // For multi-byte values, we need to emit the second byte.
		            this.emitCodePoint(decodeTree[result + 2], consumed);
		        }
		        return consumed;
		    };
		    /**
		     * Signal to the parser that the end of the input was reached.
		     *
		     * Remaining data will be emitted and relevant errors will be produced.
		     *
		     * @returns The number of characters consumed.
		     */
		    EntityDecoder.prototype.end = function () {
		        var _a;
		        switch (this.state) {
		            case EntityDecoderState.NamedEntity: {
		                // Emit a named entity if we have one.
		                return this.result !== 0 &&
		                    (this.decodeMode !== DecodingMode.Attribute ||
		                        this.result === this.treeIndex)
		                    ? this.emitNotTerminatedNamedEntity()
		                    : 0;
		            }
		            // Otherwise, emit a numeric entity if we have one.
		            case EntityDecoderState.NumericDecimal: {
		                return this.emitNumericEntity(0, 2);
		            }
		            case EntityDecoderState.NumericHex: {
		                return this.emitNumericEntity(0, 3);
		            }
		            case EntityDecoderState.NumericStart: {
		                (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
		                return 0;
		            }
		            case EntityDecoderState.EntityStart: {
		                // Return 0 if we have no entity.
		                return 0;
		            }
		        }
		    };
		    return EntityDecoder;
		}());
		exports.EntityDecoder = EntityDecoder;
		/**
		 * Creates a function that decodes entities in a string.
		 *
		 * @param decodeTree The decode tree.
		 * @returns A function that decodes entities in a string.
		 */
		function getDecoder(decodeTree) {
		    var ret = "";
		    var decoder = new EntityDecoder(decodeTree, function (str) { return (ret += (0, decode_codepoint_js_1.fromCodePoint)(str)); });
		    return function decodeWithTrie(str, decodeMode) {
		        var lastIndex = 0;
		        var offset = 0;
		        while ((offset = str.indexOf("&", offset)) >= 0) {
		            ret += str.slice(lastIndex, offset);
		            decoder.startEntity(decodeMode);
		            var len = decoder.write(str, 
		            // Skip the "&"
		            offset + 1);
		            if (len < 0) {
		                lastIndex = offset + decoder.end();
		                break;
		            }
		            lastIndex = offset + len;
		            // If `len` is 0, skip the current `&` and continue.
		            offset = len === 0 ? lastIndex + 1 : lastIndex;
		        }
		        var result = ret + str.slice(lastIndex);
		        // Make sure we don't keep a reference to the final string.
		        ret = "";
		        return result;
		    };
		}
		/**
		 * Determines the branch of the current node that is taken given the current
		 * character. This function is used to traverse the trie.
		 *
		 * @param decodeTree The trie.
		 * @param current The current node.
		 * @param nodeIdx The index right after the current node and its value.
		 * @param char The current character.
		 * @returns The index of the next node, or -1 if no branch is taken.
		 */
		function determineBranch(decodeTree, current, nodeIdx, char) {
		    var branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
		    var jumpOffset = current & BinTrieFlags.JUMP_TABLE;
		    // Case 1: Single branch encoded in jump offset
		    if (branchCount === 0) {
		        return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
		    }
		    // Case 2: Multiple branches encoded in jump table
		    if (jumpOffset) {
		        var value = char - jumpOffset;
		        return value < 0 || value >= branchCount
		            ? -1
		            : decodeTree[nodeIdx + value] - 1;
		    }
		    // Case 3: Multiple branches encoded in dictionary
		    // Binary search for the character.
		    var lo = nodeIdx;
		    var hi = lo + branchCount - 1;
		    while (lo <= hi) {
		        var mid = (lo + hi) >>> 1;
		        var midVal = decodeTree[mid];
		        if (midVal < char) {
		            lo = mid + 1;
		        }
		        else if (midVal > char) {
		            hi = mid - 1;
		        }
		        else {
		            return decodeTree[mid + branchCount];
		        }
		    }
		    return -1;
		}
		exports.determineBranch = determineBranch;
		var htmlDecoder = getDecoder(decode_data_html_js_1.default);
		var xmlDecoder = getDecoder(decode_data_xml_js_1.default);
		/**
		 * Decodes an HTML string.
		 *
		 * @param str The string to decode.
		 * @param mode The decoding mode.
		 * @returns The decoded string.
		 */
		function decodeHTML(str, mode) {
		    if (mode === void 0) { mode = DecodingMode.Legacy; }
		    return htmlDecoder(str, mode);
		}
		exports.decodeHTML = decodeHTML;
		/**
		 * Decodes an HTML string in an attribute.
		 *
		 * @param str The string to decode.
		 * @returns The decoded string.
		 */
		function decodeHTMLAttribute(str) {
		    return htmlDecoder(str, DecodingMode.Attribute);
		}
		exports.decodeHTMLAttribute = decodeHTMLAttribute;
		/**
		 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
		 *
		 * @param str The string to decode.
		 * @returns The decoded string.
		 */
		function decodeHTMLStrict(str) {
		    return htmlDecoder(str, DecodingMode.Strict);
		}
		exports.decodeHTMLStrict = decodeHTMLStrict;
		/**
		 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
		 *
		 * @param str The string to decode.
		 * @returns The decoded string.
		 */
		function decodeXML(str) {
		    return xmlDecoder(str, DecodingMode.Strict);
		}
		exports.decodeXML = decodeXML;
		
	} (decode));
	return decode;
}

var hasRequiredTokenizer;

function requireTokenizer () {
	if (hasRequiredTokenizer) return Tokenizer;
	hasRequiredTokenizer = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.QuoteType = void 0;
		var decode_js_1 = /*@__PURE__*/ requireDecode();
		var CharCodes;
		(function (CharCodes) {
		    CharCodes[CharCodes["Tab"] = 9] = "Tab";
		    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
		    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
		    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
		    CharCodes[CharCodes["Space"] = 32] = "Space";
		    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
		    CharCodes[CharCodes["Number"] = 35] = "Number";
		    CharCodes[CharCodes["Amp"] = 38] = "Amp";
		    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
		    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
		    CharCodes[CharCodes["Dash"] = 45] = "Dash";
		    CharCodes[CharCodes["Slash"] = 47] = "Slash";
		    CharCodes[CharCodes["Zero"] = 48] = "Zero";
		    CharCodes[CharCodes["Nine"] = 57] = "Nine";
		    CharCodes[CharCodes["Semi"] = 59] = "Semi";
		    CharCodes[CharCodes["Lt"] = 60] = "Lt";
		    CharCodes[CharCodes["Eq"] = 61] = "Eq";
		    CharCodes[CharCodes["Gt"] = 62] = "Gt";
		    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
		    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
		    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
		    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
		    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
		    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
		    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
		    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
		    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
		})(CharCodes || (CharCodes = {}));
		/** All the states the tokenizer can be in. */
		var State;
		(function (State) {
		    State[State["Text"] = 1] = "Text";
		    State[State["BeforeTagName"] = 2] = "BeforeTagName";
		    State[State["InTagName"] = 3] = "InTagName";
		    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
		    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
		    State[State["InClosingTagName"] = 6] = "InClosingTagName";
		    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
		    // Attributes
		    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
		    State[State["InAttributeName"] = 9] = "InAttributeName";
		    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
		    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
		    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
		    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
		    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
		    // Declarations
		    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
		    State[State["InDeclaration"] = 16] = "InDeclaration";
		    // Processing instructions
		    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
		    // Comments & CDATA
		    State[State["BeforeComment"] = 18] = "BeforeComment";
		    State[State["CDATASequence"] = 19] = "CDATASequence";
		    State[State["InSpecialComment"] = 20] = "InSpecialComment";
		    State[State["InCommentLike"] = 21] = "InCommentLike";
		    // Special tags
		    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
		    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
		    State[State["InSpecialTag"] = 24] = "InSpecialTag";
		    State[State["BeforeEntity"] = 25] = "BeforeEntity";
		    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
		    State[State["InNamedEntity"] = 27] = "InNamedEntity";
		    State[State["InNumericEntity"] = 28] = "InNumericEntity";
		    State[State["InHexEntity"] = 29] = "InHexEntity";
		})(State || (State = {}));
		function isWhitespace(c) {
		    return (c === CharCodes.Space ||
		        c === CharCodes.NewLine ||
		        c === CharCodes.Tab ||
		        c === CharCodes.FormFeed ||
		        c === CharCodes.CarriageReturn);
		}
		function isEndOfTagSection(c) {
		    return c === CharCodes.Slash || c === CharCodes.Gt || isWhitespace(c);
		}
		function isNumber(c) {
		    return c >= CharCodes.Zero && c <= CharCodes.Nine;
		}
		function isASCIIAlpha(c) {
		    return ((c >= CharCodes.LowerA && c <= CharCodes.LowerZ) ||
		        (c >= CharCodes.UpperA && c <= CharCodes.UpperZ));
		}
		function isHexDigit(c) {
		    return ((c >= CharCodes.UpperA && c <= CharCodes.UpperF) ||
		        (c >= CharCodes.LowerA && c <= CharCodes.LowerF));
		}
		var QuoteType;
		(function (QuoteType) {
		    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
		    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
		    QuoteType[QuoteType["Single"] = 2] = "Single";
		    QuoteType[QuoteType["Double"] = 3] = "Double";
		})(QuoteType = exports.QuoteType || (exports.QuoteType = {}));
		/**
		 * Sequences used to match longer strings.
		 *
		 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
		 * sequences with an increased offset.
		 */
		var Sequences = {
		    Cdata: new Uint8Array([0x43, 0x44, 0x41, 0x54, 0x41, 0x5b]),
		    CdataEnd: new Uint8Array([0x5d, 0x5d, 0x3e]),
		    CommentEnd: new Uint8Array([0x2d, 0x2d, 0x3e]),
		    ScriptEnd: new Uint8Array([0x3c, 0x2f, 0x73, 0x63, 0x72, 0x69, 0x70, 0x74]),
		    StyleEnd: new Uint8Array([0x3c, 0x2f, 0x73, 0x74, 0x79, 0x6c, 0x65]),
		    TitleEnd: new Uint8Array([0x3c, 0x2f, 0x74, 0x69, 0x74, 0x6c, 0x65]), // `</title`
		};
		var Tokenizer = /** @class */ (function () {
		    function Tokenizer(_a, cbs) {
		        var _b = _a.xmlMode, xmlMode = _b === void 0 ? false : _b, _c = _a.decodeEntities, decodeEntities = _c === void 0 ? true : _c;
		        this.cbs = cbs;
		        /** The current state the tokenizer is in. */
		        this.state = State.Text;
		        /** The read buffer. */
		        this.buffer = "";
		        /** The beginning of the section that is currently being read. */
		        this.sectionStart = 0;
		        /** The index within the buffer that we are currently looking at. */
		        this.index = 0;
		        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */
		        this.baseState = State.Text;
		        /** For special parsing behavior inside of script and style tags. */
		        this.isSpecial = false;
		        /** Indicates whether the tokenizer has been paused. */
		        this.running = true;
		        /** The offset of the current buffer. */
		        this.offset = 0;
		        this.currentSequence = undefined;
		        this.sequenceIndex = 0;
		        this.trieIndex = 0;
		        this.trieCurrent = 0;
		        /** For named entities, the index of the value. For numeric entities, the code point. */
		        this.entityResult = 0;
		        this.entityExcess = 0;
		        this.xmlMode = xmlMode;
		        this.decodeEntities = decodeEntities;
		        this.entityTrie = xmlMode ? decode_js_1.xmlDecodeTree : decode_js_1.htmlDecodeTree;
		    }
		    Tokenizer.prototype.reset = function () {
		        this.state = State.Text;
		        this.buffer = "";
		        this.sectionStart = 0;
		        this.index = 0;
		        this.baseState = State.Text;
		        this.currentSequence = undefined;
		        this.running = true;
		        this.offset = 0;
		    };
		    Tokenizer.prototype.write = function (chunk) {
		        this.offset += this.buffer.length;
		        this.buffer = chunk;
		        this.parse();
		    };
		    Tokenizer.prototype.end = function () {
		        if (this.running)
		            this.finish();
		    };
		    Tokenizer.prototype.pause = function () {
		        this.running = false;
		    };
		    Tokenizer.prototype.resume = function () {
		        this.running = true;
		        if (this.index < this.buffer.length + this.offset) {
		            this.parse();
		        }
		    };
		    /**
		     * The current index within all of the written data.
		     */
		    Tokenizer.prototype.getIndex = function () {
		        return this.index;
		    };
		    /**
		     * The start of the current section.
		     */
		    Tokenizer.prototype.getSectionStart = function () {
		        return this.sectionStart;
		    };
		    Tokenizer.prototype.stateText = function (c) {
		        if (c === CharCodes.Lt ||
		            (!this.decodeEntities && this.fastForwardTo(CharCodes.Lt))) {
		            if (this.index > this.sectionStart) {
		                this.cbs.ontext(this.sectionStart, this.index);
		            }
		            this.state = State.BeforeTagName;
		            this.sectionStart = this.index;
		        }
		        else if (this.decodeEntities && c === CharCodes.Amp) {
		            this.state = State.BeforeEntity;
		        }
		    };
		    Tokenizer.prototype.stateSpecialStartSequence = function (c) {
		        var isEnd = this.sequenceIndex === this.currentSequence.length;
		        var isMatch = isEnd
		            ? // If we are at the end of the sequence, make sure the tag name has ended
		                isEndOfTagSection(c)
		            : // Otherwise, do a case-insensitive comparison
		                (c | 0x20) === this.currentSequence[this.sequenceIndex];
		        if (!isMatch) {
		            this.isSpecial = false;
		        }
		        else if (!isEnd) {
		            this.sequenceIndex++;
		            return;
		        }
		        this.sequenceIndex = 0;
		        this.state = State.InTagName;
		        this.stateInTagName(c);
		    };
		    /** Look for an end tag. For <title> tags, also decode entities. */
		    Tokenizer.prototype.stateInSpecialTag = function (c) {
		        if (this.sequenceIndex === this.currentSequence.length) {
		            if (c === CharCodes.Gt || isWhitespace(c)) {
		                var endOfText = this.index - this.currentSequence.length;
		                if (this.sectionStart < endOfText) {
		                    // Spoof the index so that reported locations match up.
		                    var actualIndex = this.index;
		                    this.index = endOfText;
		                    this.cbs.ontext(this.sectionStart, endOfText);
		                    this.index = actualIndex;
		                }
		                this.isSpecial = false;
		                this.sectionStart = endOfText + 2; // Skip over the `</`
		                this.stateInClosingTagName(c);
		                return; // We are done; skip the rest of the function.
		            }
		            this.sequenceIndex = 0;
		        }
		        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) {
		            this.sequenceIndex += 1;
		        }
		        else if (this.sequenceIndex === 0) {
		            if (this.currentSequence === Sequences.TitleEnd) {
		                // We have to parse entities in <title> tags.
		                if (this.decodeEntities && c === CharCodes.Amp) {
		                    this.state = State.BeforeEntity;
		                }
		            }
		            else if (this.fastForwardTo(CharCodes.Lt)) {
		                // Outside of <title> tags, we can fast-forward.
		                this.sequenceIndex = 1;
		            }
		        }
		        else {
		            // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
		            this.sequenceIndex = Number(c === CharCodes.Lt);
		        }
		    };
		    Tokenizer.prototype.stateCDATASequence = function (c) {
		        if (c === Sequences.Cdata[this.sequenceIndex]) {
		            if (++this.sequenceIndex === Sequences.Cdata.length) {
		                this.state = State.InCommentLike;
		                this.currentSequence = Sequences.CdataEnd;
		                this.sequenceIndex = 0;
		                this.sectionStart = this.index + 1;
		            }
		        }
		        else {
		            this.sequenceIndex = 0;
		            this.state = State.InDeclaration;
		            this.stateInDeclaration(c); // Reconsume the character
		        }
		    };
		    /**
		     * When we wait for one specific character, we can speed things up
		     * by skipping through the buffer until we find it.
		     *
		     * @returns Whether the character was found.
		     */
		    Tokenizer.prototype.fastForwardTo = function (c) {
		        while (++this.index < this.buffer.length + this.offset) {
		            if (this.buffer.charCodeAt(this.index - this.offset) === c) {
		                return true;
		            }
		        }
		        /*
		         * We increment the index at the end of the `parse` loop,
		         * so set it to `buffer.length - 1` here.
		         *
		         * TODO: Refactor `parse` to increment index before calling states.
		         */
		        this.index = this.buffer.length + this.offset - 1;
		        return false;
		    };
		    /**
		     * Comments and CDATA end with `-->` and `]]>`.
		     *
		     * Their common qualities are:
		     * - Their end sequences have a distinct character they start with.
		     * - That character is then repeated, so we have to check multiple repeats.
		     * - All characters but the start character of the sequence can be skipped.
		     */
		    Tokenizer.prototype.stateInCommentLike = function (c) {
		        if (c === this.currentSequence[this.sequenceIndex]) {
		            if (++this.sequenceIndex === this.currentSequence.length) {
		                if (this.currentSequence === Sequences.CdataEnd) {
		                    this.cbs.oncdata(this.sectionStart, this.index, 2);
		                }
		                else {
		                    this.cbs.oncomment(this.sectionStart, this.index, 2);
		                }
		                this.sequenceIndex = 0;
		                this.sectionStart = this.index + 1;
		                this.state = State.Text;
		            }
		        }
		        else if (this.sequenceIndex === 0) {
		            // Fast-forward to the first character of the sequence
		            if (this.fastForwardTo(this.currentSequence[0])) {
		                this.sequenceIndex = 1;
		            }
		        }
		        else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
		            // Allow long sequences, eg. --->, ]]]>
		            this.sequenceIndex = 0;
		        }
		    };
		    /**
		     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
		     *
		     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
		     * We allow anything that wouldn't end the tag.
		     */
		    Tokenizer.prototype.isTagStartChar = function (c) {
		        return this.xmlMode ? !isEndOfTagSection(c) : isASCIIAlpha(c);
		    };
		    Tokenizer.prototype.startSpecial = function (sequence, offset) {
		        this.isSpecial = true;
		        this.currentSequence = sequence;
		        this.sequenceIndex = offset;
		        this.state = State.SpecialStartSequence;
		    };
		    Tokenizer.prototype.stateBeforeTagName = function (c) {
		        if (c === CharCodes.ExclamationMark) {
		            this.state = State.BeforeDeclaration;
		            this.sectionStart = this.index + 1;
		        }
		        else if (c === CharCodes.Questionmark) {
		            this.state = State.InProcessingInstruction;
		            this.sectionStart = this.index + 1;
		        }
		        else if (this.isTagStartChar(c)) {
		            var lower = c | 0x20;
		            this.sectionStart = this.index;
		            if (!this.xmlMode && lower === Sequences.TitleEnd[2]) {
		                this.startSpecial(Sequences.TitleEnd, 3);
		            }
		            else {
		                this.state =
		                    !this.xmlMode && lower === Sequences.ScriptEnd[2]
		                        ? State.BeforeSpecialS
		                        : State.InTagName;
		            }
		        }
		        else if (c === CharCodes.Slash) {
		            this.state = State.BeforeClosingTagName;
		        }
		        else {
		            this.state = State.Text;
		            this.stateText(c);
		        }
		    };
		    Tokenizer.prototype.stateInTagName = function (c) {
		        if (isEndOfTagSection(c)) {
		            this.cbs.onopentagname(this.sectionStart, this.index);
		            this.sectionStart = -1;
		            this.state = State.BeforeAttributeName;
		            this.stateBeforeAttributeName(c);
		        }
		    };
		    Tokenizer.prototype.stateBeforeClosingTagName = function (c) {
		        if (isWhitespace(c)) ;
		        else if (c === CharCodes.Gt) {
		            this.state = State.Text;
		        }
		        else {
		            this.state = this.isTagStartChar(c)
		                ? State.InClosingTagName
		                : State.InSpecialComment;
		            this.sectionStart = this.index;
		        }
		    };
		    Tokenizer.prototype.stateInClosingTagName = function (c) {
		        if (c === CharCodes.Gt || isWhitespace(c)) {
		            this.cbs.onclosetag(this.sectionStart, this.index);
		            this.sectionStart = -1;
		            this.state = State.AfterClosingTagName;
		            this.stateAfterClosingTagName(c);
		        }
		    };
		    Tokenizer.prototype.stateAfterClosingTagName = function (c) {
		        // Skip everything until ">"
		        if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
		            this.state = State.Text;
		            this.baseState = State.Text;
		            this.sectionStart = this.index + 1;
		        }
		    };
		    Tokenizer.prototype.stateBeforeAttributeName = function (c) {
		        if (c === CharCodes.Gt) {
		            this.cbs.onopentagend(this.index);
		            if (this.isSpecial) {
		                this.state = State.InSpecialTag;
		                this.sequenceIndex = 0;
		            }
		            else {
		                this.state = State.Text;
		            }
		            this.baseState = this.state;
		            this.sectionStart = this.index + 1;
		        }
		        else if (c === CharCodes.Slash) {
		            this.state = State.InSelfClosingTag;
		        }
		        else if (!isWhitespace(c)) {
		            this.state = State.InAttributeName;
		            this.sectionStart = this.index;
		        }
		    };
		    Tokenizer.prototype.stateInSelfClosingTag = function (c) {
		        if (c === CharCodes.Gt) {
		            this.cbs.onselfclosingtag(this.index);
		            this.state = State.Text;
		            this.baseState = State.Text;
		            this.sectionStart = this.index + 1;
		            this.isSpecial = false; // Reset special state, in case of self-closing special tags
		        }
		        else if (!isWhitespace(c)) {
		            this.state = State.BeforeAttributeName;
		            this.stateBeforeAttributeName(c);
		        }
		    };
		    Tokenizer.prototype.stateInAttributeName = function (c) {
		        if (c === CharCodes.Eq || isEndOfTagSection(c)) {
		            this.cbs.onattribname(this.sectionStart, this.index);
		            this.sectionStart = -1;
		            this.state = State.AfterAttributeName;
		            this.stateAfterAttributeName(c);
		        }
		    };
		    Tokenizer.prototype.stateAfterAttributeName = function (c) {
		        if (c === CharCodes.Eq) {
		            this.state = State.BeforeAttributeValue;
		        }
		        else if (c === CharCodes.Slash || c === CharCodes.Gt) {
		            this.cbs.onattribend(QuoteType.NoValue, this.index);
		            this.state = State.BeforeAttributeName;
		            this.stateBeforeAttributeName(c);
		        }
		        else if (!isWhitespace(c)) {
		            this.cbs.onattribend(QuoteType.NoValue, this.index);
		            this.state = State.InAttributeName;
		            this.sectionStart = this.index;
		        }
		    };
		    Tokenizer.prototype.stateBeforeAttributeValue = function (c) {
		        if (c === CharCodes.DoubleQuote) {
		            this.state = State.InAttributeValueDq;
		            this.sectionStart = this.index + 1;
		        }
		        else if (c === CharCodes.SingleQuote) {
		            this.state = State.InAttributeValueSq;
		            this.sectionStart = this.index + 1;
		        }
		        else if (!isWhitespace(c)) {
		            this.sectionStart = this.index;
		            this.state = State.InAttributeValueNq;
		            this.stateInAttributeValueNoQuotes(c); // Reconsume token
		        }
		    };
		    Tokenizer.prototype.handleInAttributeValue = function (c, quote) {
		        if (c === quote ||
		            (!this.decodeEntities && this.fastForwardTo(quote))) {
		            this.cbs.onattribdata(this.sectionStart, this.index);
		            this.sectionStart = -1;
		            this.cbs.onattribend(quote === CharCodes.DoubleQuote
		                ? QuoteType.Double
		                : QuoteType.Single, this.index);
		            this.state = State.BeforeAttributeName;
		        }
		        else if (this.decodeEntities && c === CharCodes.Amp) {
		            this.baseState = this.state;
		            this.state = State.BeforeEntity;
		        }
		    };
		    Tokenizer.prototype.stateInAttributeValueDoubleQuotes = function (c) {
		        this.handleInAttributeValue(c, CharCodes.DoubleQuote);
		    };
		    Tokenizer.prototype.stateInAttributeValueSingleQuotes = function (c) {
		        this.handleInAttributeValue(c, CharCodes.SingleQuote);
		    };
		    Tokenizer.prototype.stateInAttributeValueNoQuotes = function (c) {
		        if (isWhitespace(c) || c === CharCodes.Gt) {
		            this.cbs.onattribdata(this.sectionStart, this.index);
		            this.sectionStart = -1;
		            this.cbs.onattribend(QuoteType.Unquoted, this.index);
		            this.state = State.BeforeAttributeName;
		            this.stateBeforeAttributeName(c);
		        }
		        else if (this.decodeEntities && c === CharCodes.Amp) {
		            this.baseState = this.state;
		            this.state = State.BeforeEntity;
		        }
		    };
		    Tokenizer.prototype.stateBeforeDeclaration = function (c) {
		        if (c === CharCodes.OpeningSquareBracket) {
		            this.state = State.CDATASequence;
		            this.sequenceIndex = 0;
		        }
		        else {
		            this.state =
		                c === CharCodes.Dash
		                    ? State.BeforeComment
		                    : State.InDeclaration;
		        }
		    };
		    Tokenizer.prototype.stateInDeclaration = function (c) {
		        if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
		            this.cbs.ondeclaration(this.sectionStart, this.index);
		            this.state = State.Text;
		            this.sectionStart = this.index + 1;
		        }
		    };
		    Tokenizer.prototype.stateInProcessingInstruction = function (c) {
		        if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
		            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
		            this.state = State.Text;
		            this.sectionStart = this.index + 1;
		        }
		    };
		    Tokenizer.prototype.stateBeforeComment = function (c) {
		        if (c === CharCodes.Dash) {
		            this.state = State.InCommentLike;
		            this.currentSequence = Sequences.CommentEnd;
		            // Allow short comments (eg. <!-->)
		            this.sequenceIndex = 2;
		            this.sectionStart = this.index + 1;
		        }
		        else {
		            this.state = State.InDeclaration;
		        }
		    };
		    Tokenizer.prototype.stateInSpecialComment = function (c) {
		        if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
		            this.cbs.oncomment(this.sectionStart, this.index, 0);
		            this.state = State.Text;
		            this.sectionStart = this.index + 1;
		        }
		    };
		    Tokenizer.prototype.stateBeforeSpecialS = function (c) {
		        var lower = c | 0x20;
		        if (lower === Sequences.ScriptEnd[3]) {
		            this.startSpecial(Sequences.ScriptEnd, 4);
		        }
		        else if (lower === Sequences.StyleEnd[3]) {
		            this.startSpecial(Sequences.StyleEnd, 4);
		        }
		        else {
		            this.state = State.InTagName;
		            this.stateInTagName(c); // Consume the token again
		        }
		    };
		    Tokenizer.prototype.stateBeforeEntity = function (c) {
		        // Start excess with 1 to include the '&'
		        this.entityExcess = 1;
		        this.entityResult = 0;
		        if (c === CharCodes.Number) {
		            this.state = State.BeforeNumericEntity;
		        }
		        else if (c === CharCodes.Amp) ;
		        else {
		            this.trieIndex = 0;
		            this.trieCurrent = this.entityTrie[0];
		            this.state = State.InNamedEntity;
		            this.stateInNamedEntity(c);
		        }
		    };
		    Tokenizer.prototype.stateInNamedEntity = function (c) {
		        this.entityExcess += 1;
		        this.trieIndex = (0, decode_js_1.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
		        if (this.trieIndex < 0) {
		            this.emitNamedEntity();
		            this.index--;
		            return;
		        }
		        this.trieCurrent = this.entityTrie[this.trieIndex];
		        var masked = this.trieCurrent & decode_js_1.BinTrieFlags.VALUE_LENGTH;
		        // If the branch is a value, store it and continue
		        if (masked) {
		            // The mask is the number of bytes of the value, including the current byte.
		            var valueLength = (masked >> 14) - 1;
		            // If we have a legacy entity while parsing strictly, just skip the number of bytes
		            if (!this.allowLegacyEntity() && c !== CharCodes.Semi) {
		                this.trieIndex += valueLength;
		            }
		            else {
		                // Add 1 as we have already incremented the excess
		                var entityStart = this.index - this.entityExcess + 1;
		                if (entityStart > this.sectionStart) {
		                    this.emitPartial(this.sectionStart, entityStart);
		                }
		                // If this is a surrogate pair, consume the next two bytes
		                this.entityResult = this.trieIndex;
		                this.trieIndex += valueLength;
		                this.entityExcess = 0;
		                this.sectionStart = this.index + 1;
		                if (valueLength === 0) {
		                    this.emitNamedEntity();
		                }
		            }
		        }
		    };
		    Tokenizer.prototype.emitNamedEntity = function () {
		        this.state = this.baseState;
		        if (this.entityResult === 0) {
		            return;
		        }
		        var valueLength = (this.entityTrie[this.entityResult] & decode_js_1.BinTrieFlags.VALUE_LENGTH) >>
		            14;
		        switch (valueLength) {
		            case 1: {
		                this.emitCodePoint(this.entityTrie[this.entityResult] &
		                    ~decode_js_1.BinTrieFlags.VALUE_LENGTH);
		                break;
		            }
		            case 2: {
		                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
		                break;
		            }
		            case 3: {
		                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
		                this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
		            }
		        }
		    };
		    Tokenizer.prototype.stateBeforeNumericEntity = function (c) {
		        if ((c | 0x20) === CharCodes.LowerX) {
		            this.entityExcess++;
		            this.state = State.InHexEntity;
		        }
		        else {
		            this.state = State.InNumericEntity;
		            this.stateInNumericEntity(c);
		        }
		    };
		    Tokenizer.prototype.emitNumericEntity = function (strict) {
		        var entityStart = this.index - this.entityExcess - 1;
		        var numberStart = entityStart + 2 + Number(this.state === State.InHexEntity);
		        if (numberStart !== this.index) {
		            // Emit leading data if any
		            if (entityStart > this.sectionStart) {
		                this.emitPartial(this.sectionStart, entityStart);
		            }
		            this.sectionStart = this.index + Number(strict);
		            this.emitCodePoint((0, decode_js_1.replaceCodePoint)(this.entityResult));
		        }
		        this.state = this.baseState;
		    };
		    Tokenizer.prototype.stateInNumericEntity = function (c) {
		        if (c === CharCodes.Semi) {
		            this.emitNumericEntity(true);
		        }
		        else if (isNumber(c)) {
		            this.entityResult = this.entityResult * 10 + (c - CharCodes.Zero);
		            this.entityExcess++;
		        }
		        else {
		            if (this.allowLegacyEntity()) {
		                this.emitNumericEntity(false);
		            }
		            else {
		                this.state = this.baseState;
		            }
		            this.index--;
		        }
		    };
		    Tokenizer.prototype.stateInHexEntity = function (c) {
		        if (c === CharCodes.Semi) {
		            this.emitNumericEntity(true);
		        }
		        else if (isNumber(c)) {
		            this.entityResult = this.entityResult * 16 + (c - CharCodes.Zero);
		            this.entityExcess++;
		        }
		        else if (isHexDigit(c)) {
		            this.entityResult =
		                this.entityResult * 16 + ((c | 0x20) - CharCodes.LowerA + 10);
		            this.entityExcess++;
		        }
		        else {
		            if (this.allowLegacyEntity()) {
		                this.emitNumericEntity(false);
		            }
		            else {
		                this.state = this.baseState;
		            }
		            this.index--;
		        }
		    };
		    Tokenizer.prototype.allowLegacyEntity = function () {
		        return (!this.xmlMode &&
		            (this.baseState === State.Text ||
		                this.baseState === State.InSpecialTag));
		    };
		    /**
		     * Remove data that has already been consumed from the buffer.
		     */
		    Tokenizer.prototype.cleanup = function () {
		        // If we are inside of text or attributes, emit what we already have.
		        if (this.running && this.sectionStart !== this.index) {
		            if (this.state === State.Text ||
		                (this.state === State.InSpecialTag && this.sequenceIndex === 0)) {
		                this.cbs.ontext(this.sectionStart, this.index);
		                this.sectionStart = this.index;
		            }
		            else if (this.state === State.InAttributeValueDq ||
		                this.state === State.InAttributeValueSq ||
		                this.state === State.InAttributeValueNq) {
		                this.cbs.onattribdata(this.sectionStart, this.index);
		                this.sectionStart = this.index;
		            }
		        }
		    };
		    Tokenizer.prototype.shouldContinue = function () {
		        return this.index < this.buffer.length + this.offset && this.running;
		    };
		    /**
		     * Iterates through the buffer, calling the function corresponding to the current state.
		     *
		     * States that are more likely to be hit are higher up, as a performance improvement.
		     */
		    Tokenizer.prototype.parse = function () {
		        while (this.shouldContinue()) {
		            var c = this.buffer.charCodeAt(this.index - this.offset);
		            switch (this.state) {
		                case State.Text: {
		                    this.stateText(c);
		                    break;
		                }
		                case State.SpecialStartSequence: {
		                    this.stateSpecialStartSequence(c);
		                    break;
		                }
		                case State.InSpecialTag: {
		                    this.stateInSpecialTag(c);
		                    break;
		                }
		                case State.CDATASequence: {
		                    this.stateCDATASequence(c);
		                    break;
		                }
		                case State.InAttributeValueDq: {
		                    this.stateInAttributeValueDoubleQuotes(c);
		                    break;
		                }
		                case State.InAttributeName: {
		                    this.stateInAttributeName(c);
		                    break;
		                }
		                case State.InCommentLike: {
		                    this.stateInCommentLike(c);
		                    break;
		                }
		                case State.InSpecialComment: {
		                    this.stateInSpecialComment(c);
		                    break;
		                }
		                case State.BeforeAttributeName: {
		                    this.stateBeforeAttributeName(c);
		                    break;
		                }
		                case State.InTagName: {
		                    this.stateInTagName(c);
		                    break;
		                }
		                case State.InClosingTagName: {
		                    this.stateInClosingTagName(c);
		                    break;
		                }
		                case State.BeforeTagName: {
		                    this.stateBeforeTagName(c);
		                    break;
		                }
		                case State.AfterAttributeName: {
		                    this.stateAfterAttributeName(c);
		                    break;
		                }
		                case State.InAttributeValueSq: {
		                    this.stateInAttributeValueSingleQuotes(c);
		                    break;
		                }
		                case State.BeforeAttributeValue: {
		                    this.stateBeforeAttributeValue(c);
		                    break;
		                }
		                case State.BeforeClosingTagName: {
		                    this.stateBeforeClosingTagName(c);
		                    break;
		                }
		                case State.AfterClosingTagName: {
		                    this.stateAfterClosingTagName(c);
		                    break;
		                }
		                case State.BeforeSpecialS: {
		                    this.stateBeforeSpecialS(c);
		                    break;
		                }
		                case State.InAttributeValueNq: {
		                    this.stateInAttributeValueNoQuotes(c);
		                    break;
		                }
		                case State.InSelfClosingTag: {
		                    this.stateInSelfClosingTag(c);
		                    break;
		                }
		                case State.InDeclaration: {
		                    this.stateInDeclaration(c);
		                    break;
		                }
		                case State.BeforeDeclaration: {
		                    this.stateBeforeDeclaration(c);
		                    break;
		                }
		                case State.BeforeComment: {
		                    this.stateBeforeComment(c);
		                    break;
		                }
		                case State.InProcessingInstruction: {
		                    this.stateInProcessingInstruction(c);
		                    break;
		                }
		                case State.InNamedEntity: {
		                    this.stateInNamedEntity(c);
		                    break;
		                }
		                case State.BeforeEntity: {
		                    this.stateBeforeEntity(c);
		                    break;
		                }
		                case State.InHexEntity: {
		                    this.stateInHexEntity(c);
		                    break;
		                }
		                case State.InNumericEntity: {
		                    this.stateInNumericEntity(c);
		                    break;
		                }
		                default: {
		                    // `this._state === State.BeforeNumericEntity`
		                    this.stateBeforeNumericEntity(c);
		                }
		            }
		            this.index++;
		        }
		        this.cleanup();
		    };
		    Tokenizer.prototype.finish = function () {
		        if (this.state === State.InNamedEntity) {
		            this.emitNamedEntity();
		        }
		        // If there is remaining data, emit it in a reasonable way
		        if (this.sectionStart < this.index) {
		            this.handleTrailingData();
		        }
		        this.cbs.onend();
		    };
		    /** Handle any trailing data. */
		    Tokenizer.prototype.handleTrailingData = function () {
		        var endIndex = this.buffer.length + this.offset;
		        if (this.state === State.InCommentLike) {
		            if (this.currentSequence === Sequences.CdataEnd) {
		                this.cbs.oncdata(this.sectionStart, endIndex, 0);
		            }
		            else {
		                this.cbs.oncomment(this.sectionStart, endIndex, 0);
		            }
		        }
		        else if (this.state === State.InNumericEntity &&
		            this.allowLegacyEntity()) {
		            this.emitNumericEntity(false);
		            // All trailing data will have been consumed
		        }
		        else if (this.state === State.InHexEntity &&
		            this.allowLegacyEntity()) {
		            this.emitNumericEntity(false);
		            // All trailing data will have been consumed
		        }
		        else if (this.state === State.InTagName ||
		            this.state === State.BeforeAttributeName ||
		            this.state === State.BeforeAttributeValue ||
		            this.state === State.AfterAttributeName ||
		            this.state === State.InAttributeName ||
		            this.state === State.InAttributeValueSq ||
		            this.state === State.InAttributeValueDq ||
		            this.state === State.InAttributeValueNq ||
		            this.state === State.InClosingTagName) ;
		        else {
		            this.cbs.ontext(this.sectionStart, endIndex);
		        }
		    };
		    Tokenizer.prototype.emitPartial = function (start, endIndex) {
		        if (this.baseState !== State.Text &&
		            this.baseState !== State.InSpecialTag) {
		            this.cbs.onattribdata(start, endIndex);
		        }
		        else {
		            this.cbs.ontext(start, endIndex);
		        }
		    };
		    Tokenizer.prototype.emitCodePoint = function (cp) {
		        if (this.baseState !== State.Text &&
		            this.baseState !== State.InSpecialTag) {
		            this.cbs.onattribentity(cp);
		        }
		        else {
		            this.cbs.ontextentity(cp);
		        }
		    };
		    return Tokenizer;
		}());
		exports.default = Tokenizer;
		
	} (Tokenizer));
	return Tokenizer;
}

var hasRequiredParser$1;

function requireParser$1 () {
	if (hasRequiredParser$1) return Parser;
	hasRequiredParser$1 = 1;
	var __createBinding = (Parser && Parser.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (Parser && Parser.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (Parser && Parser.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	Object.defineProperty(Parser, "__esModule", { value: true });
	Parser.Parser = void 0;
	var Tokenizer_js_1 = __importStar(/*@__PURE__*/ requireTokenizer());
	var decode_js_1 = /*@__PURE__*/ requireDecode();
	var formTags = new Set([
	    "input",
	    "option",
	    "optgroup",
	    "select",
	    "button",
	    "datalist",
	    "textarea",
	]);
	var pTag = new Set(["p"]);
	var tableSectionTags = new Set(["thead", "tbody"]);
	var ddtTags = new Set(["dd", "dt"]);
	var rtpTags = new Set(["rt", "rp"]);
	var openImpliesClose = new Map([
	    ["tr", new Set(["tr", "th", "td"])],
	    ["th", new Set(["th"])],
	    ["td", new Set(["thead", "th", "td"])],
	    ["body", new Set(["head", "link", "script"])],
	    ["li", new Set(["li"])],
	    ["p", pTag],
	    ["h1", pTag],
	    ["h2", pTag],
	    ["h3", pTag],
	    ["h4", pTag],
	    ["h5", pTag],
	    ["h6", pTag],
	    ["select", formTags],
	    ["input", formTags],
	    ["output", formTags],
	    ["button", formTags],
	    ["datalist", formTags],
	    ["textarea", formTags],
	    ["option", new Set(["option"])],
	    ["optgroup", new Set(["optgroup", "option"])],
	    ["dd", ddtTags],
	    ["dt", ddtTags],
	    ["address", pTag],
	    ["article", pTag],
	    ["aside", pTag],
	    ["blockquote", pTag],
	    ["details", pTag],
	    ["div", pTag],
	    ["dl", pTag],
	    ["fieldset", pTag],
	    ["figcaption", pTag],
	    ["figure", pTag],
	    ["footer", pTag],
	    ["form", pTag],
	    ["header", pTag],
	    ["hr", pTag],
	    ["main", pTag],
	    ["nav", pTag],
	    ["ol", pTag],
	    ["pre", pTag],
	    ["section", pTag],
	    ["table", pTag],
	    ["ul", pTag],
	    ["rt", rtpTags],
	    ["rp", rtpTags],
	    ["tbody", tableSectionTags],
	    ["tfoot", tableSectionTags],
	]);
	var voidElements = new Set([
	    "area",
	    "base",
	    "basefont",
	    "br",
	    "col",
	    "command",
	    "embed",
	    "frame",
	    "hr",
	    "img",
	    "input",
	    "isindex",
	    "keygen",
	    "link",
	    "meta",
	    "param",
	    "source",
	    "track",
	    "wbr",
	]);
	var foreignContextElements = new Set(["math", "svg"]);
	var htmlIntegrationElements = new Set([
	    "mi",
	    "mo",
	    "mn",
	    "ms",
	    "mtext",
	    "annotation-xml",
	    "foreignobject",
	    "desc",
	    "title",
	]);
	var reNameEnd = /\s|\//;
	var Parser$1 = /** @class */ (function () {
	    function Parser(cbs, options) {
	        if (options === void 0) { options = {}; }
	        var _a, _b, _c, _d, _e;
	        this.options = options;
	        /** The start index of the last event. */
	        this.startIndex = 0;
	        /** The end index of the last event. */
	        this.endIndex = 0;
	        /**
	         * Store the start index of the current open tag,
	         * so we can update the start index for attributes.
	         */
	        this.openTagStart = 0;
	        this.tagname = "";
	        this.attribname = "";
	        this.attribvalue = "";
	        this.attribs = null;
	        this.stack = [];
	        this.foreignContext = [];
	        this.buffers = [];
	        this.bufferOffset = 0;
	        /** The index of the last written buffer. Used when resuming after a `pause()`. */
	        this.writeIndex = 0;
	        /** Indicates whether the parser has finished running / `.end` has been called. */
	        this.ended = false;
	        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
	        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
	        this.lowerCaseAttributeNames =
	            (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
	        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_js_1.default)(this.options, this);
	        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
	    }
	    // Tokenizer event handlers
	    /** @internal */
	    Parser.prototype.ontext = function (start, endIndex) {
	        var _a, _b;
	        var data = this.getSlice(start, endIndex);
	        this.endIndex = endIndex - 1;
	        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data);
	        this.startIndex = endIndex;
	    };
	    /** @internal */
	    Parser.prototype.ontextentity = function (cp) {
	        var _a, _b;
	        /*
	         * Entities can be emitted on the character, or directly after.
	         * We use the section start here to get accurate indices.
	         */
	        var index = this.tokenizer.getSectionStart();
	        this.endIndex = index - 1;
	        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, (0, decode_js_1.fromCodePoint)(cp));
	        this.startIndex = index;
	    };
	    Parser.prototype.isVoidElement = function (name) {
	        return !this.options.xmlMode && voidElements.has(name);
	    };
	    /** @internal */
	    Parser.prototype.onopentagname = function (start, endIndex) {
	        this.endIndex = endIndex;
	        var name = this.getSlice(start, endIndex);
	        if (this.lowerCaseTagNames) {
	            name = name.toLowerCase();
	        }
	        this.emitOpenTag(name);
	    };
	    Parser.prototype.emitOpenTag = function (name) {
	        var _a, _b, _c, _d;
	        this.openTagStart = this.startIndex;
	        this.tagname = name;
	        var impliesClose = !this.options.xmlMode && openImpliesClose.get(name);
	        if (impliesClose) {
	            while (this.stack.length > 0 &&
	                impliesClose.has(this.stack[this.stack.length - 1])) {
	                var element = this.stack.pop();
	                (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, element, true);
	            }
	        }
	        if (!this.isVoidElement(name)) {
	            this.stack.push(name);
	            if (foreignContextElements.has(name)) {
	                this.foreignContext.push(true);
	            }
	            else if (htmlIntegrationElements.has(name)) {
	                this.foreignContext.push(false);
	            }
	        }
	        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name);
	        if (this.cbs.onopentag)
	            this.attribs = {};
	    };
	    Parser.prototype.endOpenTag = function (isImplied) {
	        var _a, _b;
	        this.startIndex = this.openTagStart;
	        if (this.attribs) {
	            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs, isImplied);
	            this.attribs = null;
	        }
	        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
	            this.cbs.onclosetag(this.tagname, true);
	        }
	        this.tagname = "";
	    };
	    /** @internal */
	    Parser.prototype.onopentagend = function (endIndex) {
	        this.endIndex = endIndex;
	        this.endOpenTag(false);
	        // Set `startIndex` for next node
	        this.startIndex = endIndex + 1;
	    };
	    /** @internal */
	    Parser.prototype.onclosetag = function (start, endIndex) {
	        var _a, _b, _c, _d, _e, _f;
	        this.endIndex = endIndex;
	        var name = this.getSlice(start, endIndex);
	        if (this.lowerCaseTagNames) {
	            name = name.toLowerCase();
	        }
	        if (foreignContextElements.has(name) ||
	            htmlIntegrationElements.has(name)) {
	            this.foreignContext.pop();
	        }
	        if (!this.isVoidElement(name)) {
	            var pos = this.stack.lastIndexOf(name);
	            if (pos !== -1) {
	                if (this.cbs.onclosetag) {
	                    var count = this.stack.length - pos;
	                    while (count--) {
	                        // We know the stack has sufficient elements.
	                        this.cbs.onclosetag(this.stack.pop(), count !== 0);
	                    }
	                }
	                else
	                    this.stack.length = pos;
	            }
	            else if (!this.options.xmlMode && name === "p") {
	                // Implicit open before close
	                this.emitOpenTag("p");
	                this.closeCurrentTag(true);
	            }
	        }
	        else if (!this.options.xmlMode && name === "br") {
	            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
	            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, "br");
	            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 ? void 0 : _d.call(_c, "br", {}, true);
	            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e, "br", false);
	        }
	        // Set `startIndex` for next node
	        this.startIndex = endIndex + 1;
	    };
	    /** @internal */
	    Parser.prototype.onselfclosingtag = function (endIndex) {
	        this.endIndex = endIndex;
	        if (this.options.xmlMode ||
	            this.options.recognizeSelfClosing ||
	            this.foreignContext[this.foreignContext.length - 1]) {
	            this.closeCurrentTag(false);
	            // Set `startIndex` for next node
	            this.startIndex = endIndex + 1;
	        }
	        else {
	            // Ignore the fact that the tag is self-closing.
	            this.onopentagend(endIndex);
	        }
	    };
	    Parser.prototype.closeCurrentTag = function (isOpenImplied) {
	        var _a, _b;
	        var name = this.tagname;
	        this.endOpenTag(isOpenImplied);
	        // Self-closing tags will be on the top of the stack
	        if (this.stack[this.stack.length - 1] === name) {
	            // If the opening tag isn't implied, the closing tag has to be implied.
	            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name, !isOpenImplied);
	            this.stack.pop();
	        }
	    };
	    /** @internal */
	    Parser.prototype.onattribname = function (start, endIndex) {
	        this.startIndex = start;
	        var name = this.getSlice(start, endIndex);
	        this.attribname = this.lowerCaseAttributeNames
	            ? name.toLowerCase()
	            : name;
	    };
	    /** @internal */
	    Parser.prototype.onattribdata = function (start, endIndex) {
	        this.attribvalue += this.getSlice(start, endIndex);
	    };
	    /** @internal */
	    Parser.prototype.onattribentity = function (cp) {
	        this.attribvalue += (0, decode_js_1.fromCodePoint)(cp);
	    };
	    /** @internal */
	    Parser.prototype.onattribend = function (quote, endIndex) {
	        var _a, _b;
	        this.endIndex = endIndex;
	        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote === Tokenizer_js_1.QuoteType.Double
	            ? '"'
	            : quote === Tokenizer_js_1.QuoteType.Single
	                ? "'"
	                : quote === Tokenizer_js_1.QuoteType.NoValue
	                    ? undefined
	                    : null);
	        if (this.attribs &&
	            !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
	            this.attribs[this.attribname] = this.attribvalue;
	        }
	        this.attribvalue = "";
	    };
	    Parser.prototype.getInstructionName = function (value) {
	        var index = value.search(reNameEnd);
	        var name = index < 0 ? value : value.substr(0, index);
	        if (this.lowerCaseTagNames) {
	            name = name.toLowerCase();
	        }
	        return name;
	    };
	    /** @internal */
	    Parser.prototype.ondeclaration = function (start, endIndex) {
	        this.endIndex = endIndex;
	        var value = this.getSlice(start, endIndex);
	        if (this.cbs.onprocessinginstruction) {
	            var name = this.getInstructionName(value);
	            this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
	        }
	        // Set `startIndex` for next node
	        this.startIndex = endIndex + 1;
	    };
	    /** @internal */
	    Parser.prototype.onprocessinginstruction = function (start, endIndex) {
	        this.endIndex = endIndex;
	        var value = this.getSlice(start, endIndex);
	        if (this.cbs.onprocessinginstruction) {
	            var name = this.getInstructionName(value);
	            this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
	        }
	        // Set `startIndex` for next node
	        this.startIndex = endIndex + 1;
	    };
	    /** @internal */
	    Parser.prototype.oncomment = function (start, endIndex, offset) {
	        var _a, _b, _c, _d;
	        this.endIndex = endIndex;
	        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, this.getSlice(start, endIndex - offset));
	        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
	        // Set `startIndex` for next node
	        this.startIndex = endIndex + 1;
	    };
	    /** @internal */
	    Parser.prototype.oncdata = function (start, endIndex, offset) {
	        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
	        this.endIndex = endIndex;
	        var value = this.getSlice(start, endIndex - offset);
	        if (this.options.xmlMode || this.options.recognizeCDATA) {
	            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
	            (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
	            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
	        }
	        else {
	            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, "[CDATA[".concat(value, "]]"));
	            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
	        }
	        // Set `startIndex` for next node
	        this.startIndex = endIndex + 1;
	    };
	    /** @internal */
	    Parser.prototype.onend = function () {
	        var _a, _b;
	        if (this.cbs.onclosetag) {
	            // Set the end index for all remaining tags
	            this.endIndex = this.startIndex;
	            for (var index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true))
	                ;
	        }
	        (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
	    };
	    /**
	     * Resets the parser to a blank state, ready to parse a new HTML document
	     */
	    Parser.prototype.reset = function () {
	        var _a, _b, _c, _d;
	        (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
	        this.tokenizer.reset();
	        this.tagname = "";
	        this.attribname = "";
	        this.attribs = null;
	        this.stack.length = 0;
	        this.startIndex = 0;
	        this.endIndex = 0;
	        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
	        this.buffers.length = 0;
	        this.bufferOffset = 0;
	        this.writeIndex = 0;
	        this.ended = false;
	    };
	    /**
	     * Resets the parser, then parses a complete document and
	     * pushes it to the handler.
	     *
	     * @param data Document to parse.
	     */
	    Parser.prototype.parseComplete = function (data) {
	        this.reset();
	        this.end(data);
	    };
	    Parser.prototype.getSlice = function (start, end) {
	        while (start - this.bufferOffset >= this.buffers[0].length) {
	            this.shiftBuffer();
	        }
	        var slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
	        while (end - this.bufferOffset > this.buffers[0].length) {
	            this.shiftBuffer();
	            slice += this.buffers[0].slice(0, end - this.bufferOffset);
	        }
	        return slice;
	    };
	    Parser.prototype.shiftBuffer = function () {
	        this.bufferOffset += this.buffers[0].length;
	        this.writeIndex--;
	        this.buffers.shift();
	    };
	    /**
	     * Parses a chunk of data and calls the corresponding callbacks.
	     *
	     * @param chunk Chunk to parse.
	     */
	    Parser.prototype.write = function (chunk) {
	        var _a, _b;
	        if (this.ended) {
	            (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".write() after done!"));
	            return;
	        }
	        this.buffers.push(chunk);
	        if (this.tokenizer.running) {
	            this.tokenizer.write(chunk);
	            this.writeIndex++;
	        }
	    };
	    /**
	     * Parses the end of the buffer and clears the stack, calls onend.
	     *
	     * @param chunk Optional final chunk to parse.
	     */
	    Parser.prototype.end = function (chunk) {
	        var _a, _b;
	        if (this.ended) {
	            (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".end() after done!"));
	            return;
	        }
	        if (chunk)
	            this.write(chunk);
	        this.ended = true;
	        this.tokenizer.end();
	    };
	    /**
	     * Pauses parsing. The parser won't emit events until `resume` is called.
	     */
	    Parser.prototype.pause = function () {
	        this.tokenizer.pause();
	    };
	    /**
	     * Resumes parsing after `pause` was called.
	     */
	    Parser.prototype.resume = function () {
	        this.tokenizer.resume();
	        while (this.tokenizer.running &&
	            this.writeIndex < this.buffers.length) {
	            this.tokenizer.write(this.buffers[this.writeIndex++]);
	        }
	        if (this.ended)
	            this.tokenizer.end();
	    };
	    /**
	     * Alias of `write`, for backwards compatibility.
	     *
	     * @param chunk Chunk to parse.
	     * @deprecated
	     */
	    Parser.prototype.parseChunk = function (chunk) {
	        this.write(chunk);
	    };
	    /**
	     * Alias of `end`, for backwards compatibility.
	     *
	     * @param chunk Optional final chunk to parse.
	     * @deprecated
	     */
	    Parser.prototype.done = function (chunk) {
	        this.end(chunk);
	    };
	    return Parser;
	}());
	Parser.Parser = Parser$1;
	
	return Parser;
}

var lib$5 = {};

var lib$4 = {};

var hasRequiredLib$6;

function requireLib$6 () {
	if (hasRequiredLib$6) return lib$4;
	hasRequiredLib$6 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
		/** Types of elements found in htmlparser2's DOM */
		var ElementType;
		(function (ElementType) {
		    /** Type for the root element of a document */
		    ElementType["Root"] = "root";
		    /** Type for Text */
		    ElementType["Text"] = "text";
		    /** Type for <? ... ?> */
		    ElementType["Directive"] = "directive";
		    /** Type for <!-- ... --> */
		    ElementType["Comment"] = "comment";
		    /** Type for <script> tags */
		    ElementType["Script"] = "script";
		    /** Type for <style> tags */
		    ElementType["Style"] = "style";
		    /** Type for Any tag */
		    ElementType["Tag"] = "tag";
		    /** Type for <![CDATA[ ... ]]> */
		    ElementType["CDATA"] = "cdata";
		    /** Type for <!doctype ...> */
		    ElementType["Doctype"] = "doctype";
		})(ElementType = exports.ElementType || (exports.ElementType = {}));
		/**
		 * Tests whether an element is a tag or not.
		 *
		 * @param elem Element to test
		 */
		function isTag(elem) {
		    return (elem.type === ElementType.Tag ||
		        elem.type === ElementType.Script ||
		        elem.type === ElementType.Style);
		}
		exports.isTag = isTag;
		// Exports for backwards compatibility
		/** Type for the root element of a document */
		exports.Root = ElementType.Root;
		/** Type for Text */
		exports.Text = ElementType.Text;
		/** Type for <? ... ?> */
		exports.Directive = ElementType.Directive;
		/** Type for <!-- ... --> */
		exports.Comment = ElementType.Comment;
		/** Type for <script> tags */
		exports.Script = ElementType.Script;
		/** Type for <style> tags */
		exports.Style = ElementType.Style;
		/** Type for Any tag */
		exports.Tag = ElementType.Tag;
		/** Type for <![CDATA[ ... ]]> */
		exports.CDATA = ElementType.CDATA;
		/** Type for <!doctype ...> */
		exports.Doctype = ElementType.Doctype; 
	} (lib$4));
	return lib$4;
}

var node$1 = {};

var hasRequiredNode$1;

function requireNode$1 () {
	if (hasRequiredNode$1) return node$1;
	hasRequiredNode$1 = 1;
	var __extends = (node$1 && node$1.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (node$1 && node$1.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(node$1, "__esModule", { value: true });
	node$1.cloneNode = node$1.hasChildren = node$1.isDocument = node$1.isDirective = node$1.isComment = node$1.isText = node$1.isCDATA = node$1.isTag = node$1.Element = node$1.Document = node$1.CDATA = node$1.NodeWithChildren = node$1.ProcessingInstruction = node$1.Comment = node$1.Text = node$1.DataNode = node$1.Node = void 0;
	var domelementtype_1 = /*@__PURE__*/ requireLib$6();
	/**
	 * This object will be used as the prototype for Nodes when creating a
	 * DOM-Level-1-compliant structure.
	 */
	var Node = /** @class */ (function () {
	    function Node() {
	        /** Parent of the node */
	        this.parent = null;
	        /** Previous sibling */
	        this.prev = null;
	        /** Next sibling */
	        this.next = null;
	        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
	        this.startIndex = null;
	        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
	        this.endIndex = null;
	    }
	    Object.defineProperty(Node.prototype, "parentNode", {
	        // Read-write aliases for properties
	        /**
	         * Same as {@link parent}.
	         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
	         */
	        get: function () {
	            return this.parent;
	        },
	        set: function (parent) {
	            this.parent = parent;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Node.prototype, "previousSibling", {
	        /**
	         * Same as {@link prev}.
	         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
	         */
	        get: function () {
	            return this.prev;
	        },
	        set: function (prev) {
	            this.prev = prev;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Node.prototype, "nextSibling", {
	        /**
	         * Same as {@link next}.
	         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
	         */
	        get: function () {
	            return this.next;
	        },
	        set: function (next) {
	            this.next = next;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Clone this node, and optionally its children.
	     *
	     * @param recursive Clone child nodes as well.
	     * @returns A clone of the node.
	     */
	    Node.prototype.cloneNode = function (recursive) {
	        if (recursive === void 0) { recursive = false; }
	        return cloneNode(this, recursive);
	    };
	    return Node;
	}());
	node$1.Node = Node;
	/**
	 * A node that contains some data.
	 */
	var DataNode = /** @class */ (function (_super) {
	    __extends(DataNode, _super);
	    /**
	     * @param data The content of the data node
	     */
	    function DataNode(data) {
	        var _this = _super.call(this) || this;
	        _this.data = data;
	        return _this;
	    }
	    Object.defineProperty(DataNode.prototype, "nodeValue", {
	        /**
	         * Same as {@link data}.
	         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
	         */
	        get: function () {
	            return this.data;
	        },
	        set: function (data) {
	            this.data = data;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return DataNode;
	}(Node));
	node$1.DataNode = DataNode;
	/**
	 * Text within the document.
	 */
	var Text = /** @class */ (function (_super) {
	    __extends(Text, _super);
	    function Text() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.type = domelementtype_1.ElementType.Text;
	        return _this;
	    }
	    Object.defineProperty(Text.prototype, "nodeType", {
	        get: function () {
	            return 3;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Text;
	}(DataNode));
	node$1.Text = Text;
	/**
	 * Comments within the document.
	 */
	var Comment = /** @class */ (function (_super) {
	    __extends(Comment, _super);
	    function Comment() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.type = domelementtype_1.ElementType.Comment;
	        return _this;
	    }
	    Object.defineProperty(Comment.prototype, "nodeType", {
	        get: function () {
	            return 8;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Comment;
	}(DataNode));
	node$1.Comment = Comment;
	/**
	 * Processing instructions, including doc types.
	 */
	var ProcessingInstruction = /** @class */ (function (_super) {
	    __extends(ProcessingInstruction, _super);
	    function ProcessingInstruction(name, data) {
	        var _this = _super.call(this, data) || this;
	        _this.name = name;
	        _this.type = domelementtype_1.ElementType.Directive;
	        return _this;
	    }
	    Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
	        get: function () {
	            return 1;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return ProcessingInstruction;
	}(DataNode));
	node$1.ProcessingInstruction = ProcessingInstruction;
	/**
	 * A `Node` that can have children.
	 */
	var NodeWithChildren = /** @class */ (function (_super) {
	    __extends(NodeWithChildren, _super);
	    /**
	     * @param children Children of the node. Only certain node types can have children.
	     */
	    function NodeWithChildren(children) {
	        var _this = _super.call(this) || this;
	        _this.children = children;
	        return _this;
	    }
	    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
	        // Aliases
	        /** First child of the node. */
	        get: function () {
	            var _a;
	            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
	        /** Last child of the node. */
	        get: function () {
	            return this.children.length > 0
	                ? this.children[this.children.length - 1]
	                : null;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
	        /**
	         * Same as {@link children}.
	         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
	         */
	        get: function () {
	            return this.children;
	        },
	        set: function (children) {
	            this.children = children;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return NodeWithChildren;
	}(Node));
	node$1.NodeWithChildren = NodeWithChildren;
	var CDATA = /** @class */ (function (_super) {
	    __extends(CDATA, _super);
	    function CDATA() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.type = domelementtype_1.ElementType.CDATA;
	        return _this;
	    }
	    Object.defineProperty(CDATA.prototype, "nodeType", {
	        get: function () {
	            return 4;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return CDATA;
	}(NodeWithChildren));
	node$1.CDATA = CDATA;
	/**
	 * The root node of the document.
	 */
	var Document = /** @class */ (function (_super) {
	    __extends(Document, _super);
	    function Document() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.type = domelementtype_1.ElementType.Root;
	        return _this;
	    }
	    Object.defineProperty(Document.prototype, "nodeType", {
	        get: function () {
	            return 9;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Document;
	}(NodeWithChildren));
	node$1.Document = Document;
	/**
	 * An element within the DOM.
	 */
	var Element = /** @class */ (function (_super) {
	    __extends(Element, _super);
	    /**
	     * @param name Name of the tag, eg. `div`, `span`.
	     * @param attribs Object mapping attribute names to attribute values.
	     * @param children Children of the node.
	     */
	    function Element(name, attribs, children, type) {
	        if (children === void 0) { children = []; }
	        if (type === void 0) { type = name === "script"
	            ? domelementtype_1.ElementType.Script
	            : name === "style"
	                ? domelementtype_1.ElementType.Style
	                : domelementtype_1.ElementType.Tag; }
	        var _this = _super.call(this, children) || this;
	        _this.name = name;
	        _this.attribs = attribs;
	        _this.type = type;
	        return _this;
	    }
	    Object.defineProperty(Element.prototype, "nodeType", {
	        get: function () {
	            return 1;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Element.prototype, "tagName", {
	        // DOM Level 1 aliases
	        /**
	         * Same as {@link name}.
	         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
	         */
	        get: function () {
	            return this.name;
	        },
	        set: function (name) {
	            this.name = name;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Element.prototype, "attributes", {
	        get: function () {
	            var _this = this;
	            return Object.keys(this.attribs).map(function (name) {
	                var _a, _b;
	                return ({
	                    name: name,
	                    value: _this.attribs[name],
	                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
	                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
	                });
	            });
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Element;
	}(NodeWithChildren));
	node$1.Element = Element;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node is a `Element`, `false` otherwise.
	 */
	function isTag(node) {
	    return (0, domelementtype_1.isTag)(node);
	}
	node$1.isTag = isTag;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
	 */
	function isCDATA(node) {
	    return node.type === domelementtype_1.ElementType.CDATA;
	}
	node$1.isCDATA = isCDATA;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node has the type `Text`, `false` otherwise.
	 */
	function isText(node) {
	    return node.type === domelementtype_1.ElementType.Text;
	}
	node$1.isText = isText;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node has the type `Comment`, `false` otherwise.
	 */
	function isComment(node) {
	    return node.type === domelementtype_1.ElementType.Comment;
	}
	node$1.isComment = isComment;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
	 */
	function isDirective(node) {
	    return node.type === domelementtype_1.ElementType.Directive;
	}
	node$1.isDirective = isDirective;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
	 */
	function isDocument(node) {
	    return node.type === domelementtype_1.ElementType.Root;
	}
	node$1.isDocument = isDocument;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node has children, `false` otherwise.
	 */
	function hasChildren(node) {
	    return Object.prototype.hasOwnProperty.call(node, "children");
	}
	node$1.hasChildren = hasChildren;
	/**
	 * Clone a node, and optionally its children.
	 *
	 * @param recursive Clone child nodes as well.
	 * @returns A clone of the node.
	 */
	function cloneNode(node, recursive) {
	    if (recursive === void 0) { recursive = false; }
	    var result;
	    if (isText(node)) {
	        result = new Text(node.data);
	    }
	    else if (isComment(node)) {
	        result = new Comment(node.data);
	    }
	    else if (isTag(node)) {
	        var children = recursive ? cloneChildren(node.children) : [];
	        var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
	        children.forEach(function (child) { return (child.parent = clone_1); });
	        if (node.namespace != null) {
	            clone_1.namespace = node.namespace;
	        }
	        if (node["x-attribsNamespace"]) {
	            clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
	        }
	        if (node["x-attribsPrefix"]) {
	            clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
	        }
	        result = clone_1;
	    }
	    else if (isCDATA(node)) {
	        var children = recursive ? cloneChildren(node.children) : [];
	        var clone_2 = new CDATA(children);
	        children.forEach(function (child) { return (child.parent = clone_2); });
	        result = clone_2;
	    }
	    else if (isDocument(node)) {
	        var children = recursive ? cloneChildren(node.children) : [];
	        var clone_3 = new Document(children);
	        children.forEach(function (child) { return (child.parent = clone_3); });
	        if (node["x-mode"]) {
	            clone_3["x-mode"] = node["x-mode"];
	        }
	        result = clone_3;
	    }
	    else if (isDirective(node)) {
	        var instruction = new ProcessingInstruction(node.name, node.data);
	        if (node["x-name"] != null) {
	            instruction["x-name"] = node["x-name"];
	            instruction["x-publicId"] = node["x-publicId"];
	            instruction["x-systemId"] = node["x-systemId"];
	        }
	        result = instruction;
	    }
	    else {
	        throw new Error("Not implemented yet: ".concat(node.type));
	    }
	    result.startIndex = node.startIndex;
	    result.endIndex = node.endIndex;
	    if (node.sourceCodeLocation != null) {
	        result.sourceCodeLocation = node.sourceCodeLocation;
	    }
	    return result;
	}
	node$1.cloneNode = cloneNode;
	function cloneChildren(childs) {
	    var children = childs.map(function (child) { return cloneNode(child, true); });
	    for (var i = 1; i < children.length; i++) {
	        children[i].prev = children[i - 1];
	        children[i - 1].next = children[i];
	    }
	    return children;
	}
	return node$1;
}

var hasRequiredLib$5;

function requireLib$5 () {
	if (hasRequiredLib$5) return lib$5;
	hasRequiredLib$5 = 1;
	(function (exports) {
		var __createBinding = (lib$5 && lib$5.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (lib$5 && lib$5.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.DomHandler = void 0;
		var domelementtype_1 = /*@__PURE__*/ requireLib$6();
		var node_js_1 = /*@__PURE__*/ requireNode$1();
		__exportStar(/*@__PURE__*/ requireNode$1(), exports);
		// Default options
		var defaultOpts = {
		    withStartIndices: false,
		    withEndIndices: false,
		    xmlMode: false,
		};
		var DomHandler = /** @class */ (function () {
		    /**
		     * @param callback Called once parsing has completed.
		     * @param options Settings for the handler.
		     * @param elementCB Callback whenever a tag is closed.
		     */
		    function DomHandler(callback, options, elementCB) {
		        /** The elements of the DOM */
		        this.dom = [];
		        /** The root element for the DOM */
		        this.root = new node_js_1.Document(this.dom);
		        /** Indicated whether parsing has been completed. */
		        this.done = false;
		        /** Stack of open tags. */
		        this.tagStack = [this.root];
		        /** A data node that is still being written to. */
		        this.lastNode = null;
		        /** Reference to the parser instance. Used for location information. */
		        this.parser = null;
		        // Make it possible to skip arguments, for backwards-compatibility
		        if (typeof options === "function") {
		            elementCB = options;
		            options = defaultOpts;
		        }
		        if (typeof callback === "object") {
		            options = callback;
		            callback = undefined;
		        }
		        this.callback = callback !== null && callback !== void 0 ? callback : null;
		        this.options = options !== null && options !== void 0 ? options : defaultOpts;
		        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
		    }
		    DomHandler.prototype.onparserinit = function (parser) {
		        this.parser = parser;
		    };
		    // Resets the handler back to starting state
		    DomHandler.prototype.onreset = function () {
		        this.dom = [];
		        this.root = new node_js_1.Document(this.dom);
		        this.done = false;
		        this.tagStack = [this.root];
		        this.lastNode = null;
		        this.parser = null;
		    };
		    // Signals the handler that parsing is done
		    DomHandler.prototype.onend = function () {
		        if (this.done)
		            return;
		        this.done = true;
		        this.parser = null;
		        this.handleCallback(null);
		    };
		    DomHandler.prototype.onerror = function (error) {
		        this.handleCallback(error);
		    };
		    DomHandler.prototype.onclosetag = function () {
		        this.lastNode = null;
		        var elem = this.tagStack.pop();
		        if (this.options.withEndIndices) {
		            elem.endIndex = this.parser.endIndex;
		        }
		        if (this.elementCB)
		            this.elementCB(elem);
		    };
		    DomHandler.prototype.onopentag = function (name, attribs) {
		        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
		        var element = new node_js_1.Element(name, attribs, undefined, type);
		        this.addNode(element);
		        this.tagStack.push(element);
		    };
		    DomHandler.prototype.ontext = function (data) {
		        var lastNode = this.lastNode;
		        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
		            lastNode.data += data;
		            if (this.options.withEndIndices) {
		                lastNode.endIndex = this.parser.endIndex;
		            }
		        }
		        else {
		            var node = new node_js_1.Text(data);
		            this.addNode(node);
		            this.lastNode = node;
		        }
		    };
		    DomHandler.prototype.oncomment = function (data) {
		        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
		            this.lastNode.data += data;
		            return;
		        }
		        var node = new node_js_1.Comment(data);
		        this.addNode(node);
		        this.lastNode = node;
		    };
		    DomHandler.prototype.oncommentend = function () {
		        this.lastNode = null;
		    };
		    DomHandler.prototype.oncdatastart = function () {
		        var text = new node_js_1.Text("");
		        var node = new node_js_1.CDATA([text]);
		        this.addNode(node);
		        text.parent = node;
		        this.lastNode = text;
		    };
		    DomHandler.prototype.oncdataend = function () {
		        this.lastNode = null;
		    };
		    DomHandler.prototype.onprocessinginstruction = function (name, data) {
		        var node = new node_js_1.ProcessingInstruction(name, data);
		        this.addNode(node);
		    };
		    DomHandler.prototype.handleCallback = function (error) {
		        if (typeof this.callback === "function") {
		            this.callback(error, this.dom);
		        }
		        else if (error) {
		            throw error;
		        }
		    };
		    DomHandler.prototype.addNode = function (node) {
		        var parent = this.tagStack[this.tagStack.length - 1];
		        var previousSibling = parent.children[parent.children.length - 1];
		        if (this.options.withStartIndices) {
		            node.startIndex = this.parser.startIndex;
		        }
		        if (this.options.withEndIndices) {
		            node.endIndex = this.parser.endIndex;
		        }
		        parent.children.push(node);
		        if (previousSibling) {
		            node.prev = previousSibling;
		            previousSibling.next = node;
		        }
		        node.parent = parent;
		        this.lastNode = null;
		    };
		    return DomHandler;
		}());
		exports.DomHandler = DomHandler;
		exports.default = DomHandler; 
	} (lib$5));
	return lib$5;
}

var lib$3 = {};

var stringify$1 = {};

var lib$2 = {};

var lib$1 = {};

var encode$1 = {};

var encodeHtml = {};

var hasRequiredEncodeHtml;

function requireEncodeHtml () {
	if (hasRequiredEncodeHtml) return encodeHtml;
	hasRequiredEncodeHtml = 1;
	// Generated using scripts/write-encode-map.ts
	Object.defineProperty(encodeHtml, "__esModule", { value: true });
	function restoreDiff(arr) {
	    for (var i = 1; i < arr.length; i++) {
	        arr[i][0] += arr[i - 1][0] + 1;
	    }
	    return arr;
	}
	// prettier-ignore
	encodeHtml.default = new Map(/* #__PURE__ */ restoreDiff([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* #__PURE__ */ restoreDiff([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* #__PURE__ */ restoreDiff([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* #__PURE__ */ restoreDiff([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
	
	return encodeHtml;
}

var _escape = {};

var hasRequired_escape;

function require_escape () {
	if (hasRequired_escape) return _escape;
	hasRequired_escape = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.getCodePoint = exports.xmlReplacer = void 0;
		exports.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
		var xmlCodeMap = new Map([
		    [34, "&quot;"],
		    [38, "&amp;"],
		    [39, "&apos;"],
		    [60, "&lt;"],
		    [62, "&gt;"],
		]);
		// For compatibility with node < 4, we wrap `codePointAt`
		exports.getCodePoint = 
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		String.prototype.codePointAt != null
		    ? function (str, index) { return str.codePointAt(index); }
		    : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
		        function (c, index) {
		            return (c.charCodeAt(index) & 0xfc00) === 0xd800
		                ? (c.charCodeAt(index) - 0xd800) * 0x400 +
		                    c.charCodeAt(index + 1) -
		                    0xdc00 +
		                    0x10000
		                : c.charCodeAt(index);
		        };
		/**
		 * Encodes all non-ASCII characters, as well as characters not valid in XML
		 * documents using XML entities.
		 *
		 * If a character has no equivalent entity, a
		 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
		 */
		function encodeXML(str) {
		    var ret = "";
		    var lastIdx = 0;
		    var match;
		    while ((match = exports.xmlReplacer.exec(str)) !== null) {
		        var i = match.index;
		        var char = str.charCodeAt(i);
		        var next = xmlCodeMap.get(char);
		        if (next !== undefined) {
		            ret += str.substring(lastIdx, i) + next;
		            lastIdx = i + 1;
		        }
		        else {
		            ret += "".concat(str.substring(lastIdx, i), "&#x").concat((0, exports.getCodePoint)(str, i).toString(16), ";");
		            // Increase by 1 if we have a surrogate pair
		            lastIdx = exports.xmlReplacer.lastIndex += Number((char & 0xfc00) === 0xd800);
		        }
		    }
		    return ret + str.substr(lastIdx);
		}
		exports.encodeXML = encodeXML;
		/**
		 * Encodes all non-ASCII characters, as well as characters not valid in XML
		 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
		 *
		 * Have a look at `escapeUTF8` if you want a more concise output at the expense
		 * of reduced transportability.
		 *
		 * @param data String to escape.
		 */
		exports.escape = encodeXML;
		/**
		 * Creates a function that escapes all characters matched by the given regular
		 * expression using the given map of characters to escape to their entities.
		 *
		 * @param regex Regular expression to match characters to escape.
		 * @param map Map of characters to escape to their entities.
		 *
		 * @returns Function that escapes all characters matched by the given regular
		 * expression using the given map of characters to escape to their entities.
		 */
		function getEscaper(regex, map) {
		    return function escape(data) {
		        var match;
		        var lastIdx = 0;
		        var result = "";
		        while ((match = regex.exec(data))) {
		            if (lastIdx !== match.index) {
		                result += data.substring(lastIdx, match.index);
		            }
		            // We know that this character will be in the map.
		            result += map.get(match[0].charCodeAt(0));
		            // Every match will be of length 1
		            lastIdx = match.index + 1;
		        }
		        return result + data.substring(lastIdx);
		    };
		}
		/**
		 * Encodes all characters not valid in XML documents using XML entities.
		 *
		 * Note that the output will be character-set dependent.
		 *
		 * @param data String to escape.
		 */
		exports.escapeUTF8 = getEscaper(/[&<>'"]/g, xmlCodeMap);
		/**
		 * Encodes all characters that have to be escaped in HTML attributes,
		 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
		 *
		 * @param data String to escape.
		 */
		exports.escapeAttribute = getEscaper(/["&\u00A0]/g, new Map([
		    [34, "&quot;"],
		    [38, "&amp;"],
		    [160, "&nbsp;"],
		]));
		/**
		 * Encodes all characters that have to be escaped in HTML text,
		 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
		 *
		 * @param data String to escape.
		 */
		exports.escapeText = getEscaper(/[&<>\u00A0]/g, new Map([
		    [38, "&amp;"],
		    [60, "&lt;"],
		    [62, "&gt;"],
		    [160, "&nbsp;"],
		]));
		
	} (_escape));
	return _escape;
}

var hasRequiredEncode;

function requireEncode () {
	if (hasRequiredEncode) return encode$1;
	hasRequiredEncode = 1;
	var __importDefault = (encode$1 && encode$1.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(encode$1, "__esModule", { value: true });
	encode$1.encodeNonAsciiHTML = encode$1.encodeHTML = void 0;
	var encode_html_js_1 = __importDefault(/*@__PURE__*/ requireEncodeHtml());
	var escape_js_1 = /*@__PURE__*/ require_escape();
	var htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
	/**
	 * Encodes all characters in the input using HTML entities. This includes
	 * characters that are valid ASCII characters in HTML documents, such as `#`.
	 *
	 * To get a more compact output, consider using the `encodeNonAsciiHTML`
	 * function, which will only encode characters that are not valid in HTML
	 * documents, as well as non-ASCII characters.
	 *
	 * If a character has no equivalent entity, a numeric hexadecimal reference
	 * (eg. `&#xfc;`) will be used.
	 */
	function encodeHTML(data) {
	    return encodeHTMLTrieRe(htmlReplacer, data);
	}
	encode$1.encodeHTML = encodeHTML;
	/**
	 * Encodes all non-ASCII characters, as well as characters not valid in HTML
	 * documents using HTML entities. This function will not encode characters that
	 * are valid in HTML documents, such as `#`.
	 *
	 * If a character has no equivalent entity, a numeric hexadecimal reference
	 * (eg. `&#xfc;`) will be used.
	 */
	function encodeNonAsciiHTML(data) {
	    return encodeHTMLTrieRe(escape_js_1.xmlReplacer, data);
	}
	encode$1.encodeNonAsciiHTML = encodeNonAsciiHTML;
	function encodeHTMLTrieRe(regExp, str) {
	    var ret = "";
	    var lastIdx = 0;
	    var match;
	    while ((match = regExp.exec(str)) !== null) {
	        var i = match.index;
	        ret += str.substring(lastIdx, i);
	        var char = str.charCodeAt(i);
	        var next = encode_html_js_1.default.get(char);
	        if (typeof next === "object") {
	            // We are in a branch. Try to match the next char.
	            if (i + 1 < str.length) {
	                var nextChar = str.charCodeAt(i + 1);
	                var value = typeof next.n === "number"
	                    ? next.n === nextChar
	                        ? next.o
	                        : undefined
	                    : next.n.get(nextChar);
	                if (value !== undefined) {
	                    ret += value;
	                    lastIdx = regExp.lastIndex += 1;
	                    continue;
	                }
	            }
	            next = next.v;
	        }
	        // We might have a tree node without a value; skip and use a numeric entity.
	        if (next !== undefined) {
	            ret += next;
	            lastIdx = i + 1;
	        }
	        else {
	            var cp = (0, escape_js_1.getCodePoint)(str, i);
	            ret += "&#x".concat(cp.toString(16), ";");
	            // Increase by 1 if we have a surrogate pair
	            lastIdx = regExp.lastIndex += Number(cp !== char);
	        }
	    }
	    return ret + str.substr(lastIdx);
	}
	
	return encode$1;
}

var hasRequiredLib$4;

function requireLib$4 () {
	if (hasRequiredLib$4) return lib$1;
	hasRequiredLib$4 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLAttribute = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.DecodingMode = exports.EntityDecoder = exports.encodeHTML5 = exports.encodeHTML4 = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = exports.EncodingMode = exports.EntityLevel = void 0;
		var decode_js_1 = /*@__PURE__*/ requireDecode();
		var encode_js_1 = /*@__PURE__*/ requireEncode();
		var escape_js_1 = /*@__PURE__*/ require_escape();
		/** The level of entities to support. */
		var EntityLevel;
		(function (EntityLevel) {
		    /** Support only XML entities. */
		    EntityLevel[EntityLevel["XML"] = 0] = "XML";
		    /** Support HTML entities, which are a superset of XML entities. */
		    EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
		})(EntityLevel = exports.EntityLevel || (exports.EntityLevel = {}));
		var EncodingMode;
		(function (EncodingMode) {
		    /**
		     * The output is UTF-8 encoded. Only characters that need escaping within
		     * XML will be escaped.
		     */
		    EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
		    /**
		     * The output consists only of ASCII characters. Characters that need
		     * escaping within HTML, and characters that aren't ASCII characters will
		     * be escaped.
		     */
		    EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
		    /**
		     * Encode all characters that have an equivalent entity, as well as all
		     * characters that are not ASCII characters.
		     */
		    EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
		    /**
		     * Encode all characters that have to be escaped in HTML attributes,
		     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
		     */
		    EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
		    /**
		     * Encode all characters that have to be escaped in HTML text,
		     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
		     */
		    EncodingMode[EncodingMode["Text"] = 4] = "Text";
		})(EncodingMode = exports.EncodingMode || (exports.EncodingMode = {}));
		/**
		 * Decodes a string with entities.
		 *
		 * @param data String to decode.
		 * @param options Decoding options.
		 */
		function decode(data, options) {
		    if (options === void 0) { options = EntityLevel.XML; }
		    var level = typeof options === "number" ? options : options.level;
		    if (level === EntityLevel.HTML) {
		        var mode = typeof options === "object" ? options.mode : undefined;
		        return (0, decode_js_1.decodeHTML)(data, mode);
		    }
		    return (0, decode_js_1.decodeXML)(data);
		}
		exports.decode = decode;
		/**
		 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
		 *
		 * @param data String to decode.
		 * @param options Decoding options.
		 * @deprecated Use `decode` with the `mode` set to `Strict`.
		 */
		function decodeStrict(data, options) {
		    var _a;
		    if (options === void 0) { options = EntityLevel.XML; }
		    var opts = typeof options === "number" ? { level: options } : options;
		    (_a = opts.mode) !== null && _a !== void 0 ? _a : (opts.mode = decode_js_1.DecodingMode.Strict);
		    return decode(data, opts);
		}
		exports.decodeStrict = decodeStrict;
		/**
		 * Encodes a string with entities.
		 *
		 * @param data String to encode.
		 * @param options Encoding options.
		 */
		function encode(data, options) {
		    if (options === void 0) { options = EntityLevel.XML; }
		    var opts = typeof options === "number" ? { level: options } : options;
		    // Mode `UTF8` just escapes XML entities
		    if (opts.mode === EncodingMode.UTF8)
		        return (0, escape_js_1.escapeUTF8)(data);
		    if (opts.mode === EncodingMode.Attribute)
		        return (0, escape_js_1.escapeAttribute)(data);
		    if (opts.mode === EncodingMode.Text)
		        return (0, escape_js_1.escapeText)(data);
		    if (opts.level === EntityLevel.HTML) {
		        if (opts.mode === EncodingMode.ASCII) {
		            return (0, encode_js_1.encodeNonAsciiHTML)(data);
		        }
		        return (0, encode_js_1.encodeHTML)(data);
		    }
		    // ASCII and Extensive are equivalent
		    return (0, escape_js_1.encodeXML)(data);
		}
		exports.encode = encode;
		var escape_js_2 = /*@__PURE__*/ require_escape();
		Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function () { return escape_js_2.encodeXML; } });
		Object.defineProperty(exports, "escape", { enumerable: true, get: function () { return escape_js_2.escape; } });
		Object.defineProperty(exports, "escapeUTF8", { enumerable: true, get: function () { return escape_js_2.escapeUTF8; } });
		Object.defineProperty(exports, "escapeAttribute", { enumerable: true, get: function () { return escape_js_2.escapeAttribute; } });
		Object.defineProperty(exports, "escapeText", { enumerable: true, get: function () { return escape_js_2.escapeText; } });
		var encode_js_2 = /*@__PURE__*/ requireEncode();
		Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function () { return encode_js_2.encodeHTML; } });
		Object.defineProperty(exports, "encodeNonAsciiHTML", { enumerable: true, get: function () { return encode_js_2.encodeNonAsciiHTML; } });
		// Legacy aliases (deprecated)
		Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function () { return encode_js_2.encodeHTML; } });
		Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function () { return encode_js_2.encodeHTML; } });
		var decode_js_2 = /*@__PURE__*/ requireDecode();
		Object.defineProperty(exports, "EntityDecoder", { enumerable: true, get: function () { return decode_js_2.EntityDecoder; } });
		Object.defineProperty(exports, "DecodingMode", { enumerable: true, get: function () { return decode_js_2.DecodingMode; } });
		Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function () { return decode_js_2.decodeXML; } });
		Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function () { return decode_js_2.decodeHTML; } });
		Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function () { return decode_js_2.decodeHTMLStrict; } });
		Object.defineProperty(exports, "decodeHTMLAttribute", { enumerable: true, get: function () { return decode_js_2.decodeHTMLAttribute; } });
		// Legacy aliases (deprecated)
		Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function () { return decode_js_2.decodeHTML; } });
		Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function () { return decode_js_2.decodeHTML; } });
		Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function () { return decode_js_2.decodeHTMLStrict; } });
		Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function () { return decode_js_2.decodeHTMLStrict; } });
		Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function () { return decode_js_2.decodeXML; } });
		
	} (lib$1));
	return lib$1;
}

var foreignNames = {};

var hasRequiredForeignNames;

function requireForeignNames () {
	if (hasRequiredForeignNames) return foreignNames;
	hasRequiredForeignNames = 1;
	Object.defineProperty(foreignNames, "__esModule", { value: true });
	foreignNames.attributeNames = foreignNames.elementNames = void 0;
	foreignNames.elementNames = new Map([
	    "altGlyph",
	    "altGlyphDef",
	    "altGlyphItem",
	    "animateColor",
	    "animateMotion",
	    "animateTransform",
	    "clipPath",
	    "feBlend",
	    "feColorMatrix",
	    "feComponentTransfer",
	    "feComposite",
	    "feConvolveMatrix",
	    "feDiffuseLighting",
	    "feDisplacementMap",
	    "feDistantLight",
	    "feDropShadow",
	    "feFlood",
	    "feFuncA",
	    "feFuncB",
	    "feFuncG",
	    "feFuncR",
	    "feGaussianBlur",
	    "feImage",
	    "feMerge",
	    "feMergeNode",
	    "feMorphology",
	    "feOffset",
	    "fePointLight",
	    "feSpecularLighting",
	    "feSpotLight",
	    "feTile",
	    "feTurbulence",
	    "foreignObject",
	    "glyphRef",
	    "linearGradient",
	    "radialGradient",
	    "textPath",
	].map(function (val) { return [val.toLowerCase(), val]; }));
	foreignNames.attributeNames = new Map([
	    "definitionURL",
	    "attributeName",
	    "attributeType",
	    "baseFrequency",
	    "baseProfile",
	    "calcMode",
	    "clipPathUnits",
	    "diffuseConstant",
	    "edgeMode",
	    "filterUnits",
	    "glyphRef",
	    "gradientTransform",
	    "gradientUnits",
	    "kernelMatrix",
	    "kernelUnitLength",
	    "keyPoints",
	    "keySplines",
	    "keyTimes",
	    "lengthAdjust",
	    "limitingConeAngle",
	    "markerHeight",
	    "markerUnits",
	    "markerWidth",
	    "maskContentUnits",
	    "maskUnits",
	    "numOctaves",
	    "pathLength",
	    "patternContentUnits",
	    "patternTransform",
	    "patternUnits",
	    "pointsAtX",
	    "pointsAtY",
	    "pointsAtZ",
	    "preserveAlpha",
	    "preserveAspectRatio",
	    "primitiveUnits",
	    "refX",
	    "refY",
	    "repeatCount",
	    "repeatDur",
	    "requiredExtensions",
	    "requiredFeatures",
	    "specularConstant",
	    "specularExponent",
	    "spreadMethod",
	    "startOffset",
	    "stdDeviation",
	    "stitchTiles",
	    "surfaceScale",
	    "systemLanguage",
	    "tableValues",
	    "targetX",
	    "targetY",
	    "textLength",
	    "viewBox",
	    "viewTarget",
	    "xChannelSelector",
	    "yChannelSelector",
	    "zoomAndPan",
	].map(function (val) { return [val.toLowerCase(), val]; }));
	return foreignNames;
}

var hasRequiredLib$3;

function requireLib$3 () {
	if (hasRequiredLib$3) return lib$2;
	hasRequiredLib$3 = 1;
	var __assign = (lib$2 && lib$2.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __createBinding = (lib$2 && lib$2.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (lib$2 && lib$2.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (lib$2 && lib$2.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	Object.defineProperty(lib$2, "__esModule", { value: true });
	lib$2.render = void 0;
	/*
	 * Module dependencies
	 */
	var ElementType = __importStar(/*@__PURE__*/ requireLib$6());
	var entities_1 = /*@__PURE__*/ requireLib$4();
	/**
	 * Mixed-case SVG and MathML tags & attributes
	 * recognized by the HTML parser.
	 *
	 * @see https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
	 */
	var foreignNames_js_1 = /*@__PURE__*/ requireForeignNames();
	var unencodedElements = new Set([
	    "style",
	    "script",
	    "xmp",
	    "iframe",
	    "noembed",
	    "noframes",
	    "plaintext",
	    "noscript",
	]);
	function replaceQuotes(value) {
	    return value.replace(/"/g, "&quot;");
	}
	/**
	 * Format attributes
	 */
	function formatAttributes(attributes, opts) {
	    var _a;
	    if (!attributes)
	        return;
	    var encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false
	        ? replaceQuotes
	        : opts.xmlMode || opts.encodeEntities !== "utf8"
	            ? entities_1.encodeXML
	            : entities_1.escapeAttribute;
	    return Object.keys(attributes)
	        .map(function (key) {
	        var _a, _b;
	        var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
	        if (opts.xmlMode === "foreign") {
	            /* Fix up mixed-case attribute names */
	            key = (_b = foreignNames_js_1.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
	        }
	        if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
	            return key;
	        }
	        return "".concat(key, "=\"").concat(encode(value), "\"");
	    })
	        .join(" ");
	}
	/**
	 * Self-enclosing tags
	 */
	var singleTag = new Set([
	    "area",
	    "base",
	    "basefont",
	    "br",
	    "col",
	    "command",
	    "embed",
	    "frame",
	    "hr",
	    "img",
	    "input",
	    "isindex",
	    "keygen",
	    "link",
	    "meta",
	    "param",
	    "source",
	    "track",
	    "wbr",
	]);
	/**
	 * Renders a DOM node or an array of DOM nodes to a string.
	 *
	 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
	 *
	 * @param node Node to be rendered.
	 * @param options Changes serialization behavior
	 */
	function render(node, options) {
	    if (options === void 0) { options = {}; }
	    var nodes = "length" in node ? node : [node];
	    var output = "";
	    for (var i = 0; i < nodes.length; i++) {
	        output += renderNode(nodes[i], options);
	    }
	    return output;
	}
	lib$2.render = render;
	lib$2.default = render;
	function renderNode(node, options) {
	    switch (node.type) {
	        case ElementType.Root:
	            return render(node.children, options);
	        // @ts-expect-error We don't use `Doctype` yet
	        case ElementType.Doctype:
	        case ElementType.Directive:
	            return renderDirective(node);
	        case ElementType.Comment:
	            return renderComment(node);
	        case ElementType.CDATA:
	            return renderCdata(node);
	        case ElementType.Script:
	        case ElementType.Style:
	        case ElementType.Tag:
	            return renderTag(node, options);
	        case ElementType.Text:
	            return renderText(node, options);
	    }
	}
	var foreignModeIntegrationPoints = new Set([
	    "mi",
	    "mo",
	    "mn",
	    "ms",
	    "mtext",
	    "annotation-xml",
	    "foreignObject",
	    "desc",
	    "title",
	]);
	var foreignElements = new Set(["svg", "math"]);
	function renderTag(elem, opts) {
	    var _a;
	    // Handle SVG / MathML in HTML
	    if (opts.xmlMode === "foreign") {
	        /* Fix up mixed-case element names */
	        elem.name = (_a = foreignNames_js_1.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
	        /* Exit foreign mode at integration points */
	        if (elem.parent &&
	            foreignModeIntegrationPoints.has(elem.parent.name)) {
	            opts = __assign(__assign({}, opts), { xmlMode: false });
	        }
	    }
	    if (!opts.xmlMode && foreignElements.has(elem.name)) {
	        opts = __assign(__assign({}, opts), { xmlMode: "foreign" });
	    }
	    var tag = "<".concat(elem.name);
	    var attribs = formatAttributes(elem.attribs, opts);
	    if (attribs) {
	        tag += " ".concat(attribs);
	    }
	    if (elem.children.length === 0 &&
	        (opts.xmlMode
	            ? // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
	                opts.selfClosingTags !== false
	            : // User explicitly asked for self-closing tags, even in HTML mode
	                opts.selfClosingTags && singleTag.has(elem.name))) {
	        if (!opts.xmlMode)
	            tag += " ";
	        tag += "/>";
	    }
	    else {
	        tag += ">";
	        if (elem.children.length > 0) {
	            tag += render(elem.children, opts);
	        }
	        if (opts.xmlMode || !singleTag.has(elem.name)) {
	            tag += "</".concat(elem.name, ">");
	        }
	    }
	    return tag;
	}
	function renderDirective(elem) {
	    return "<".concat(elem.data, ">");
	}
	function renderText(elem, opts) {
	    var _a;
	    var data = elem.data || "";
	    // If entities weren't decoded, no need to encode them back
	    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false &&
	        !(!opts.xmlMode &&
	            elem.parent &&
	            unencodedElements.has(elem.parent.name))) {
	        data =
	            opts.xmlMode || opts.encodeEntities !== "utf8"
	                ? (0, entities_1.encodeXML)(data)
	                : (0, entities_1.escapeText)(data);
	    }
	    return data;
	}
	function renderCdata(elem) {
	    return "<![CDATA[".concat(elem.children[0].data, "]]>");
	}
	function renderComment(elem) {
	    return "<!--".concat(elem.data, "-->");
	}
	return lib$2;
}

var hasRequiredStringify$1;

function requireStringify$1 () {
	if (hasRequiredStringify$1) return stringify$1;
	hasRequiredStringify$1 = 1;
	var __importDefault = (stringify$1 && stringify$1.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(stringify$1, "__esModule", { value: true });
	stringify$1.getOuterHTML = getOuterHTML;
	stringify$1.getInnerHTML = getInnerHTML;
	stringify$1.getText = getText;
	stringify$1.textContent = textContent;
	stringify$1.innerText = innerText;
	var domhandler_1 = /*@__PURE__*/ requireLib$5();
	var dom_serializer_1 = __importDefault(/*@__PURE__*/ requireLib$3());
	var domelementtype_1 = /*@__PURE__*/ requireLib$6();
	/**
	 * @category Stringify
	 * @deprecated Use the `dom-serializer` module directly.
	 * @param node Node to get the outer HTML of.
	 * @param options Options for serialization.
	 * @returns `node`'s outer HTML.
	 */
	function getOuterHTML(node, options) {
	    return (0, dom_serializer_1.default)(node, options);
	}
	/**
	 * @category Stringify
	 * @deprecated Use the `dom-serializer` module directly.
	 * @param node Node to get the inner HTML of.
	 * @param options Options for serialization.
	 * @returns `node`'s inner HTML.
	 */
	function getInnerHTML(node, options) {
	    return (0, domhandler_1.hasChildren)(node)
	        ? node.children.map(function (node) { return getOuterHTML(node, options); }).join("")
	        : "";
	}
	/**
	 * Get a node's inner text. Same as `textContent`, but inserts newlines for `<br>` tags. Ignores comments.
	 *
	 * @category Stringify
	 * @deprecated Use `textContent` instead.
	 * @param node Node to get the inner text of.
	 * @returns `node`'s inner text.
	 */
	function getText(node) {
	    if (Array.isArray(node))
	        return node.map(getText).join("");
	    if ((0, domhandler_1.isTag)(node))
	        return node.name === "br" ? "\n" : getText(node.children);
	    if ((0, domhandler_1.isCDATA)(node))
	        return getText(node.children);
	    if ((0, domhandler_1.isText)(node))
	        return node.data;
	    return "";
	}
	/**
	 * Get a node's text content. Ignores comments.
	 *
	 * @category Stringify
	 * @param node Node to get the text content of.
	 * @returns `node`'s text content.
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
	 */
	function textContent(node) {
	    if (Array.isArray(node))
	        return node.map(textContent).join("");
	    if ((0, domhandler_1.hasChildren)(node) && !(0, domhandler_1.isComment)(node)) {
	        return textContent(node.children);
	    }
	    if ((0, domhandler_1.isText)(node))
	        return node.data;
	    return "";
	}
	/**
	 * Get a node's inner text, ignoring `<script>` and `<style>` tags. Ignores comments.
	 *
	 * @category Stringify
	 * @param node Node to get the inner text of.
	 * @returns `node`'s inner text.
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText}
	 */
	function innerText(node) {
	    if (Array.isArray(node))
	        return node.map(innerText).join("");
	    if ((0, domhandler_1.hasChildren)(node) && (node.type === domelementtype_1.ElementType.Tag || (0, domhandler_1.isCDATA)(node))) {
	        return innerText(node.children);
	    }
	    if ((0, domhandler_1.isText)(node))
	        return node.data;
	    return "";
	}
	
	return stringify$1;
}

var traversal = {};

var hasRequiredTraversal;

function requireTraversal () {
	if (hasRequiredTraversal) return traversal;
	hasRequiredTraversal = 1;
	Object.defineProperty(traversal, "__esModule", { value: true });
	traversal.getChildren = getChildren;
	traversal.getParent = getParent;
	traversal.getSiblings = getSiblings;
	traversal.getAttributeValue = getAttributeValue;
	traversal.hasAttrib = hasAttrib;
	traversal.getName = getName;
	traversal.nextElementSibling = nextElementSibling;
	traversal.prevElementSibling = prevElementSibling;
	var domhandler_1 = /*@__PURE__*/ requireLib$5();
	/**
	 * Get a node's children.
	 *
	 * @category Traversal
	 * @param elem Node to get the children of.
	 * @returns `elem`'s children, or an empty array.
	 */
	function getChildren(elem) {
	    return (0, domhandler_1.hasChildren)(elem) ? elem.children : [];
	}
	/**
	 * Get a node's parent.
	 *
	 * @category Traversal
	 * @param elem Node to get the parent of.
	 * @returns `elem`'s parent node, or `null` if `elem` is a root node.
	 */
	function getParent(elem) {
	    return elem.parent || null;
	}
	/**
	 * Gets an elements siblings, including the element itself.
	 *
	 * Attempts to get the children through the element's parent first. If we don't
	 * have a parent (the element is a root node), we walk the element's `prev` &
	 * `next` to get all remaining nodes.
	 *
	 * @category Traversal
	 * @param elem Element to get the siblings of.
	 * @returns `elem`'s siblings, including `elem`.
	 */
	function getSiblings(elem) {
	    var _a, _b;
	    var parent = getParent(elem);
	    if (parent != null)
	        return getChildren(parent);
	    var siblings = [elem];
	    var prev = elem.prev, next = elem.next;
	    while (prev != null) {
	        siblings.unshift(prev);
	        (_a = prev, prev = _a.prev);
	    }
	    while (next != null) {
	        siblings.push(next);
	        (_b = next, next = _b.next);
	    }
	    return siblings;
	}
	/**
	 * Gets an attribute from an element.
	 *
	 * @category Traversal
	 * @param elem Element to check.
	 * @param name Attribute name to retrieve.
	 * @returns The element's attribute value, or `undefined`.
	 */
	function getAttributeValue(elem, name) {
	    var _a;
	    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
	}
	/**
	 * Checks whether an element has an attribute.
	 *
	 * @category Traversal
	 * @param elem Element to check.
	 * @param name Attribute name to look for.
	 * @returns Returns whether `elem` has the attribute `name`.
	 */
	function hasAttrib(elem, name) {
	    return (elem.attribs != null &&
	        Object.prototype.hasOwnProperty.call(elem.attribs, name) &&
	        elem.attribs[name] != null);
	}
	/**
	 * Get the tag name of an element.
	 *
	 * @category Traversal
	 * @param elem The element to get the name for.
	 * @returns The tag name of `elem`.
	 */
	function getName(elem) {
	    return elem.name;
	}
	/**
	 * Returns the next element sibling of a node.
	 *
	 * @category Traversal
	 * @param elem The element to get the next sibling of.
	 * @returns `elem`'s next sibling that is a tag, or `null` if there is no next
	 * sibling.
	 */
	function nextElementSibling(elem) {
	    var _a;
	    var next = elem.next;
	    while (next !== null && !(0, domhandler_1.isTag)(next))
	        (_a = next, next = _a.next);
	    return next;
	}
	/**
	 * Returns the previous element sibling of a node.
	 *
	 * @category Traversal
	 * @param elem The element to get the previous sibling of.
	 * @returns `elem`'s previous sibling that is a tag, or `null` if there is no
	 * previous sibling.
	 */
	function prevElementSibling(elem) {
	    var _a;
	    var prev = elem.prev;
	    while (prev !== null && !(0, domhandler_1.isTag)(prev))
	        (_a = prev, prev = _a.prev);
	    return prev;
	}
	
	return traversal;
}

var manipulation = {};

var hasRequiredManipulation;

function requireManipulation () {
	if (hasRequiredManipulation) return manipulation;
	hasRequiredManipulation = 1;
	Object.defineProperty(manipulation, "__esModule", { value: true });
	manipulation.removeElement = removeElement;
	manipulation.replaceElement = replaceElement;
	manipulation.appendChild = appendChild;
	manipulation.append = append;
	manipulation.prependChild = prependChild;
	manipulation.prepend = prepend;
	/**
	 * Remove an element from the dom
	 *
	 * @category Manipulation
	 * @param elem The element to be removed
	 */
	function removeElement(elem) {
	    if (elem.prev)
	        elem.prev.next = elem.next;
	    if (elem.next)
	        elem.next.prev = elem.prev;
	    if (elem.parent) {
	        var childs = elem.parent.children;
	        var childsIndex = childs.lastIndexOf(elem);
	        if (childsIndex >= 0) {
	            childs.splice(childsIndex, 1);
	        }
	    }
	    elem.next = null;
	    elem.prev = null;
	    elem.parent = null;
	}
	/**
	 * Replace an element in the dom
	 *
	 * @category Manipulation
	 * @param elem The element to be replaced
	 * @param replacement The element to be added
	 */
	function replaceElement(elem, replacement) {
	    var prev = (replacement.prev = elem.prev);
	    if (prev) {
	        prev.next = replacement;
	    }
	    var next = (replacement.next = elem.next);
	    if (next) {
	        next.prev = replacement;
	    }
	    var parent = (replacement.parent = elem.parent);
	    if (parent) {
	        var childs = parent.children;
	        childs[childs.lastIndexOf(elem)] = replacement;
	        elem.parent = null;
	    }
	}
	/**
	 * Append a child to an element.
	 *
	 * @category Manipulation
	 * @param parent The element to append to.
	 * @param child The element to be added as a child.
	 */
	function appendChild(parent, child) {
	    removeElement(child);
	    child.next = null;
	    child.parent = parent;
	    if (parent.children.push(child) > 1) {
	        var sibling = parent.children[parent.children.length - 2];
	        sibling.next = child;
	        child.prev = sibling;
	    }
	    else {
	        child.prev = null;
	    }
	}
	/**
	 * Append an element after another.
	 *
	 * @category Manipulation
	 * @param elem The element to append after.
	 * @param next The element be added.
	 */
	function append(elem, next) {
	    removeElement(next);
	    var parent = elem.parent;
	    var currNext = elem.next;
	    next.next = currNext;
	    next.prev = elem;
	    elem.next = next;
	    next.parent = parent;
	    if (currNext) {
	        currNext.prev = next;
	        if (parent) {
	            var childs = parent.children;
	            childs.splice(childs.lastIndexOf(currNext), 0, next);
	        }
	    }
	    else if (parent) {
	        parent.children.push(next);
	    }
	}
	/**
	 * Prepend a child to an element.
	 *
	 * @category Manipulation
	 * @param parent The element to prepend before.
	 * @param child The element to be added as a child.
	 */
	function prependChild(parent, child) {
	    removeElement(child);
	    child.parent = parent;
	    child.prev = null;
	    if (parent.children.unshift(child) !== 1) {
	        var sibling = parent.children[1];
	        sibling.prev = child;
	        child.next = sibling;
	    }
	    else {
	        child.next = null;
	    }
	}
	/**
	 * Prepend an element before another.
	 *
	 * @category Manipulation
	 * @param elem The element to prepend before.
	 * @param prev The element be added.
	 */
	function prepend(elem, prev) {
	    removeElement(prev);
	    var parent = elem.parent;
	    if (parent) {
	        var childs = parent.children;
	        childs.splice(childs.indexOf(elem), 0, prev);
	    }
	    if (elem.prev) {
	        elem.prev.next = prev;
	    }
	    prev.parent = parent;
	    prev.prev = elem.prev;
	    prev.next = elem;
	    elem.prev = prev;
	}
	
	return manipulation;
}

var querying = {};

var hasRequiredQuerying;

function requireQuerying () {
	if (hasRequiredQuerying) return querying;
	hasRequiredQuerying = 1;
	Object.defineProperty(querying, "__esModule", { value: true });
	querying.filter = filter;
	querying.find = find;
	querying.findOneChild = findOneChild;
	querying.findOne = findOne;
	querying.existsOne = existsOne;
	querying.findAll = findAll;
	var domhandler_1 = /*@__PURE__*/ requireLib$5();
	/**
	 * Search a node and its children for nodes passing a test function. If `node` is not an array, it will be wrapped in one.
	 *
	 * @category Querying
	 * @param test Function to test nodes on.
	 * @param node Node to search. Will be included in the result set if it matches.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 * @returns All nodes passing `test`.
	 */
	function filter(test, node, recurse, limit) {
	    if (recurse === void 0) { recurse = true; }
	    if (limit === void 0) { limit = Infinity; }
	    return find(test, Array.isArray(node) ? node : [node], recurse, limit);
	}
	/**
	 * Search an array of nodes and their children for nodes passing a test function.
	 *
	 * @category Querying
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 * @returns All nodes passing `test`.
	 */
	function find(test, nodes, recurse, limit) {
	    var result = [];
	    /** Stack of the arrays we are looking at. */
	    var nodeStack = [Array.isArray(nodes) ? nodes : [nodes]];
	    /** Stack of the indices within the arrays. */
	    var indexStack = [0];
	    for (;;) {
	        // First, check if the current array has any more elements to look at.
	        if (indexStack[0] >= nodeStack[0].length) {
	            // If we have no more arrays to look at, we are done.
	            if (indexStack.length === 1) {
	                return result;
	            }
	            // Otherwise, remove the current array from the stack.
	            nodeStack.shift();
	            indexStack.shift();
	            // Loop back to the start to continue with the next array.
	            continue;
	        }
	        var elem = nodeStack[0][indexStack[0]++];
	        if (test(elem)) {
	            result.push(elem);
	            if (--limit <= 0)
	                return result;
	        }
	        if (recurse && (0, domhandler_1.hasChildren)(elem) && elem.children.length > 0) {
	            /*
	             * Add the children to the stack. We are depth-first, so this is
	             * the next array we look at.
	             */
	            indexStack.unshift(0);
	            nodeStack.unshift(elem.children);
	        }
	    }
	}
	/**
	 * Finds the first element inside of an array that matches a test function. This is an alias for `Array.prototype.find`.
	 *
	 * @category Querying
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @returns The first node in the array that passes `test`.
	 * @deprecated Use `Array.prototype.find` directly.
	 */
	function findOneChild(test, nodes) {
	    return nodes.find(test);
	}
	/**
	 * Finds one element in a tree that passes a test.
	 *
	 * @category Querying
	 * @param test Function to test nodes on.
	 * @param nodes Node or array of nodes to search.
	 * @param recurse Also consider child nodes.
	 * @returns The first node that passes `test`.
	 */
	function findOne(test, nodes, recurse) {
	    if (recurse === void 0) { recurse = true; }
	    var searchedNodes = Array.isArray(nodes) ? nodes : [nodes];
	    for (var i = 0; i < searchedNodes.length; i++) {
	        var node = searchedNodes[i];
	        if ((0, domhandler_1.isTag)(node) && test(node)) {
	            return node;
	        }
	        if (recurse && (0, domhandler_1.hasChildren)(node) && node.children.length > 0) {
	            var found = findOne(test, node.children, true);
	            if (found)
	                return found;
	        }
	    }
	    return null;
	}
	/**
	 * Checks if a tree of nodes contains at least one node passing a test.
	 *
	 * @category Querying
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @returns Whether a tree of nodes contains at least one node passing the test.
	 */
	function existsOne(test, nodes) {
	    return (Array.isArray(nodes) ? nodes : [nodes]).some(function (node) {
	        return ((0, domhandler_1.isTag)(node) && test(node)) ||
	            ((0, domhandler_1.hasChildren)(node) && existsOne(test, node.children));
	    });
	}
	/**
	 * Search an array of nodes and their children for elements passing a test function.
	 *
	 * Same as `find`, but limited to elements and with less options, leading to reduced complexity.
	 *
	 * @category Querying
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @returns All nodes passing `test`.
	 */
	function findAll(test, nodes) {
	    var result = [];
	    var nodeStack = [Array.isArray(nodes) ? nodes : [nodes]];
	    var indexStack = [0];
	    for (;;) {
	        if (indexStack[0] >= nodeStack[0].length) {
	            if (nodeStack.length === 1) {
	                return result;
	            }
	            // Otherwise, remove the current array from the stack.
	            nodeStack.shift();
	            indexStack.shift();
	            // Loop back to the start to continue with the next array.
	            continue;
	        }
	        var elem = nodeStack[0][indexStack[0]++];
	        if ((0, domhandler_1.isTag)(elem) && test(elem))
	            result.push(elem);
	        if ((0, domhandler_1.hasChildren)(elem) && elem.children.length > 0) {
	            indexStack.unshift(0);
	            nodeStack.unshift(elem.children);
	        }
	    }
	}
	
	return querying;
}

var legacy = {};

var hasRequiredLegacy;

function requireLegacy () {
	if (hasRequiredLegacy) return legacy;
	hasRequiredLegacy = 1;
	Object.defineProperty(legacy, "__esModule", { value: true });
	legacy.testElement = testElement;
	legacy.getElements = getElements;
	legacy.getElementById = getElementById;
	legacy.getElementsByTagName = getElementsByTagName;
	legacy.getElementsByClassName = getElementsByClassName;
	legacy.getElementsByTagType = getElementsByTagType;
	var domhandler_1 = /*@__PURE__*/ requireLib$5();
	var querying_js_1 = /*@__PURE__*/ requireQuerying();
	/**
	 * A map of functions to check nodes against.
	 */
	var Checks = {
	    tag_name: function (name) {
	        if (typeof name === "function") {
	            return function (elem) { return (0, domhandler_1.isTag)(elem) && name(elem.name); };
	        }
	        else if (name === "*") {
	            return domhandler_1.isTag;
	        }
	        return function (elem) { return (0, domhandler_1.isTag)(elem) && elem.name === name; };
	    },
	    tag_type: function (type) {
	        if (typeof type === "function") {
	            return function (elem) { return type(elem.type); };
	        }
	        return function (elem) { return elem.type === type; };
	    },
	    tag_contains: function (data) {
	        if (typeof data === "function") {
	            return function (elem) { return (0, domhandler_1.isText)(elem) && data(elem.data); };
	        }
	        return function (elem) { return (0, domhandler_1.isText)(elem) && elem.data === data; };
	    },
	};
	/**
	 * Returns a function to check whether a node has an attribute with a particular
	 * value.
	 *
	 * @param attrib Attribute to check.
	 * @param value Attribute value to look for.
	 * @returns A function to check whether the a node has an attribute with a
	 *   particular value.
	 */
	function getAttribCheck(attrib, value) {
	    if (typeof value === "function") {
	        return function (elem) { return (0, domhandler_1.isTag)(elem) && value(elem.attribs[attrib]); };
	    }
	    return function (elem) { return (0, domhandler_1.isTag)(elem) && elem.attribs[attrib] === value; };
	}
	/**
	 * Returns a function that returns `true` if either of the input functions
	 * returns `true` for a node.
	 *
	 * @param a First function to combine.
	 * @param b Second function to combine.
	 * @returns A function taking a node and returning `true` if either of the input
	 *   functions returns `true` for the node.
	 */
	function combineFuncs(a, b) {
	    return function (elem) { return a(elem) || b(elem); };
	}
	/**
	 * Returns a function that executes all checks in `options` and returns `true`
	 * if any of them match a node.
	 *
	 * @param options An object describing nodes to look for.
	 * @returns A function that executes all checks in `options` and returns `true`
	 *   if any of them match a node.
	 */
	function compileTest(options) {
	    var funcs = Object.keys(options).map(function (key) {
	        var value = options[key];
	        return Object.prototype.hasOwnProperty.call(Checks, key)
	            ? Checks[key](value)
	            : getAttribCheck(key, value);
	    });
	    return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
	}
	/**
	 * Checks whether a node matches the description in `options`.
	 *
	 * @category Legacy Query Functions
	 * @param options An object describing nodes to look for.
	 * @param node The element to test.
	 * @returns Whether the element matches the description in `options`.
	 */
	function testElement(options, node) {
	    var test = compileTest(options);
	    return test ? test(node) : true;
	}
	/**
	 * Returns all nodes that match `options`.
	 *
	 * @category Legacy Query Functions
	 * @param options An object describing nodes to look for.
	 * @param nodes Nodes to search through.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 * @returns All nodes that match `options`.
	 */
	function getElements(options, nodes, recurse, limit) {
	    if (limit === void 0) { limit = Infinity; }
	    var test = compileTest(options);
	    return test ? (0, querying_js_1.filter)(test, nodes, recurse, limit) : [];
	}
	/**
	 * Returns the node with the supplied ID.
	 *
	 * @category Legacy Query Functions
	 * @param id The unique ID attribute value to look for.
	 * @param nodes Nodes to search through.
	 * @param recurse Also consider child nodes.
	 * @returns The node with the supplied ID.
	 */
	function getElementById(id, nodes, recurse) {
	    if (recurse === void 0) { recurse = true; }
	    if (!Array.isArray(nodes))
	        nodes = [nodes];
	    return (0, querying_js_1.findOne)(getAttribCheck("id", id), nodes, recurse);
	}
	/**
	 * Returns all nodes with the supplied `tagName`.
	 *
	 * @category Legacy Query Functions
	 * @param tagName Tag name to search for.
	 * @param nodes Nodes to search through.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 * @returns All nodes with the supplied `tagName`.
	 */
	function getElementsByTagName(tagName, nodes, recurse, limit) {
	    if (recurse === void 0) { recurse = true; }
	    if (limit === void 0) { limit = Infinity; }
	    return (0, querying_js_1.filter)(Checks["tag_name"](tagName), nodes, recurse, limit);
	}
	/**
	 * Returns all nodes with the supplied `className`.
	 *
	 * @category Legacy Query Functions
	 * @param className Class name to search for.
	 * @param nodes Nodes to search through.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 * @returns All nodes with the supplied `className`.
	 */
	function getElementsByClassName(className, nodes, recurse, limit) {
	    if (recurse === void 0) { recurse = true; }
	    if (limit === void 0) { limit = Infinity; }
	    return (0, querying_js_1.filter)(getAttribCheck("class", className), nodes, recurse, limit);
	}
	/**
	 * Returns all nodes with the supplied `type`.
	 *
	 * @category Legacy Query Functions
	 * @param type Element type to look for.
	 * @param nodes Nodes to search through.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 * @returns All nodes with the supplied `type`.
	 */
	function getElementsByTagType(type, nodes, recurse, limit) {
	    if (recurse === void 0) { recurse = true; }
	    if (limit === void 0) { limit = Infinity; }
	    return (0, querying_js_1.filter)(Checks["tag_type"](type), nodes, recurse, limit);
	}
	
	return legacy;
}

var helpers = {};

var hasRequiredHelpers;

function requireHelpers () {
	if (hasRequiredHelpers) return helpers;
	hasRequiredHelpers = 1;
	Object.defineProperty(helpers, "__esModule", { value: true });
	helpers.DocumentPosition = void 0;
	helpers.removeSubsets = removeSubsets;
	helpers.compareDocumentPosition = compareDocumentPosition;
	helpers.uniqueSort = uniqueSort;
	var domhandler_1 = /*@__PURE__*/ requireLib$5();
	/**
	 * Given an array of nodes, remove any member that is contained by another
	 * member.
	 *
	 * @category Helpers
	 * @param nodes Nodes to filter.
	 * @returns Remaining nodes that aren't contained by other nodes.
	 */
	function removeSubsets(nodes) {
	    var idx = nodes.length;
	    /*
	     * Check if each node (or one of its ancestors) is already contained in the
	     * array.
	     */
	    while (--idx >= 0) {
	        var node = nodes[idx];
	        /*
	         * Remove the node if it is not unique.
	         * We are going through the array from the end, so we only
	         * have to check nodes that preceed the node under consideration in the array.
	         */
	        if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
	            nodes.splice(idx, 1);
	            continue;
	        }
	        for (var ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
	            if (nodes.includes(ancestor)) {
	                nodes.splice(idx, 1);
	                break;
	            }
	        }
	    }
	    return nodes;
	}
	/**
	 * @category Helpers
	 * @see {@link http://dom.spec.whatwg.org/#dom-node-comparedocumentposition}
	 */
	var DocumentPosition;
	(function (DocumentPosition) {
	    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
	    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
	    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
	    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
	    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
	})(DocumentPosition || (helpers.DocumentPosition = DocumentPosition = {}));
	/**
	 * Compare the position of one node against another node in any other document,
	 * returning a bitmask with the values from {@link DocumentPosition}.
	 *
	 * Document order:
	 * > There is an ordering, document order, defined on all the nodes in the
	 * > document corresponding to the order in which the first character of the
	 * > XML representation of each node occurs in the XML representation of the
	 * > document after expansion of general entities. Thus, the document element
	 * > node will be the first node. Element nodes occur before their children.
	 * > Thus, document order orders element nodes in order of the occurrence of
	 * > their start-tag in the XML (after expansion of entities). The attribute
	 * > nodes of an element occur after the element and before its children. The
	 * > relative order of attribute nodes is implementation-dependent.
	 *
	 * Source:
	 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	 *
	 * @category Helpers
	 * @param nodeA The first node to use in the comparison
	 * @param nodeB The second node to use in the comparison
	 * @returns A bitmask describing the input nodes' relative position.
	 *
	 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	 * a description of these values.
	 */
	function compareDocumentPosition(nodeA, nodeB) {
	    var aParents = [];
	    var bParents = [];
	    if (nodeA === nodeB) {
	        return 0;
	    }
	    var current = (0, domhandler_1.hasChildren)(nodeA) ? nodeA : nodeA.parent;
	    while (current) {
	        aParents.unshift(current);
	        current = current.parent;
	    }
	    current = (0, domhandler_1.hasChildren)(nodeB) ? nodeB : nodeB.parent;
	    while (current) {
	        bParents.unshift(current);
	        current = current.parent;
	    }
	    var maxIdx = Math.min(aParents.length, bParents.length);
	    var idx = 0;
	    while (idx < maxIdx && aParents[idx] === bParents[idx]) {
	        idx++;
	    }
	    if (idx === 0) {
	        return DocumentPosition.DISCONNECTED;
	    }
	    var sharedParent = aParents[idx - 1];
	    var siblings = sharedParent.children;
	    var aSibling = aParents[idx];
	    var bSibling = bParents[idx];
	    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
	        if (sharedParent === nodeB) {
	            return DocumentPosition.FOLLOWING | DocumentPosition.CONTAINED_BY;
	        }
	        return DocumentPosition.FOLLOWING;
	    }
	    if (sharedParent === nodeA) {
	        return DocumentPosition.PRECEDING | DocumentPosition.CONTAINS;
	    }
	    return DocumentPosition.PRECEDING;
	}
	/**
	 * Sort an array of nodes based on their relative position in the document,
	 * removing any duplicate nodes. If the array contains nodes that do not belong
	 * to the same document, sort order is unspecified.
	 *
	 * @category Helpers
	 * @param nodes Array of DOM nodes.
	 * @returns Collection of unique nodes, sorted in document order.
	 */
	function uniqueSort(nodes) {
	    nodes = nodes.filter(function (node, i, arr) { return !arr.includes(node, i + 1); });
	    nodes.sort(function (a, b) {
	        var relative = compareDocumentPosition(a, b);
	        if (relative & DocumentPosition.PRECEDING) {
	            return -1;
	        }
	        else if (relative & DocumentPosition.FOLLOWING) {
	            return 1;
	        }
	        return 0;
	    });
	    return nodes;
	}
	
	return helpers;
}

var feeds = {};

var hasRequiredFeeds;

function requireFeeds () {
	if (hasRequiredFeeds) return feeds;
	hasRequiredFeeds = 1;
	Object.defineProperty(feeds, "__esModule", { value: true });
	feeds.getFeed = getFeed;
	var stringify_js_1 = /*@__PURE__*/ requireStringify$1();
	var legacy_js_1 = /*@__PURE__*/ requireLegacy();
	/**
	 * Get the feed object from the root of a DOM tree.
	 *
	 * @category Feeds
	 * @param doc - The DOM to to extract the feed from.
	 * @returns The feed.
	 */
	function getFeed(doc) {
	    var feedRoot = getOneElement(isValidFeed, doc);
	    return !feedRoot
	        ? null
	        : feedRoot.name === "feed"
	            ? getAtomFeed(feedRoot)
	            : getRssFeed(feedRoot);
	}
	/**
	 * Parse an Atom feed.
	 *
	 * @param feedRoot The root of the feed.
	 * @returns The parsed feed.
	 */
	function getAtomFeed(feedRoot) {
	    var _a;
	    var childs = feedRoot.children;
	    var feed = {
	        type: "atom",
	        items: (0, legacy_js_1.getElementsByTagName)("entry", childs).map(function (item) {
	            var _a;
	            var children = item.children;
	            var entry = { media: getMediaElements(children) };
	            addConditionally(entry, "id", "id", children);
	            addConditionally(entry, "title", "title", children);
	            var href = (_a = getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
	            if (href) {
	                entry.link = href;
	            }
	            var description = fetch("summary", children) || fetch("content", children);
	            if (description) {
	                entry.description = description;
	            }
	            var pubDate = fetch("updated", children);
	            if (pubDate) {
	                entry.pubDate = new Date(pubDate);
	            }
	            return entry;
	        }),
	    };
	    addConditionally(feed, "id", "id", childs);
	    addConditionally(feed, "title", "title", childs);
	    var href = (_a = getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
	    if (href) {
	        feed.link = href;
	    }
	    addConditionally(feed, "description", "subtitle", childs);
	    var updated = fetch("updated", childs);
	    if (updated) {
	        feed.updated = new Date(updated);
	    }
	    addConditionally(feed, "author", "email", childs, true);
	    return feed;
	}
	/**
	 * Parse a RSS feed.
	 *
	 * @param feedRoot The root of the feed.
	 * @returns The parsed feed.
	 */
	function getRssFeed(feedRoot) {
	    var _a, _b;
	    var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
	    var feed = {
	        type: feedRoot.name.substr(0, 3),
	        id: "",
	        items: (0, legacy_js_1.getElementsByTagName)("item", feedRoot.children).map(function (item) {
	            var children = item.children;
	            var entry = { media: getMediaElements(children) };
	            addConditionally(entry, "id", "guid", children);
	            addConditionally(entry, "title", "title", children);
	            addConditionally(entry, "link", "link", children);
	            addConditionally(entry, "description", "description", children);
	            var pubDate = fetch("pubDate", children) || fetch("dc:date", children);
	            if (pubDate)
	                entry.pubDate = new Date(pubDate);
	            return entry;
	        }),
	    };
	    addConditionally(feed, "title", "title", childs);
	    addConditionally(feed, "link", "link", childs);
	    addConditionally(feed, "description", "description", childs);
	    var updated = fetch("lastBuildDate", childs);
	    if (updated) {
	        feed.updated = new Date(updated);
	    }
	    addConditionally(feed, "author", "managingEditor", childs, true);
	    return feed;
	}
	var MEDIA_KEYS_STRING = ["url", "type", "lang"];
	var MEDIA_KEYS_INT = [
	    "fileSize",
	    "bitrate",
	    "framerate",
	    "samplingrate",
	    "channels",
	    "duration",
	    "height",
	    "width",
	];
	/**
	 * Get all media elements of a feed item.
	 *
	 * @param where Nodes to search in.
	 * @returns Media elements.
	 */
	function getMediaElements(where) {
	    return (0, legacy_js_1.getElementsByTagName)("media:content", where).map(function (elem) {
	        var attribs = elem.attribs;
	        var media = {
	            medium: attribs["medium"],
	            isDefault: !!attribs["isDefault"],
	        };
	        for (var _i = 0, MEDIA_KEYS_STRING_1 = MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++) {
	            var attrib = MEDIA_KEYS_STRING_1[_i];
	            if (attribs[attrib]) {
	                media[attrib] = attribs[attrib];
	            }
	        }
	        for (var _a = 0, MEDIA_KEYS_INT_1 = MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++) {
	            var attrib = MEDIA_KEYS_INT_1[_a];
	            if (attribs[attrib]) {
	                media[attrib] = parseInt(attribs[attrib], 10);
	            }
	        }
	        if (attribs["expression"]) {
	            media.expression = attribs["expression"];
	        }
	        return media;
	    });
	}
	/**
	 * Get one element by tag name.
	 *
	 * @param tagName Tag name to look for
	 * @param node Node to search in
	 * @returns The element or null
	 */
	function getOneElement(tagName, node) {
	    return (0, legacy_js_1.getElementsByTagName)(tagName, node, true, 1)[0];
	}
	/**
	 * Get the text content of an element with a certain tag name.
	 *
	 * @param tagName Tag name to look for.
	 * @param where Node to search in.
	 * @param recurse Whether to recurse into child nodes.
	 * @returns The text content of the element.
	 */
	function fetch(tagName, where, recurse) {
	    if (recurse === void 0) { recurse = false; }
	    return (0, stringify_js_1.textContent)((0, legacy_js_1.getElementsByTagName)(tagName, where, recurse, 1)).trim();
	}
	/**
	 * Adds a property to an object if it has a value.
	 *
	 * @param obj Object to be extended
	 * @param prop Property name
	 * @param tagName Tag name that contains the conditionally added property
	 * @param where Element to search for the property
	 * @param recurse Whether to recurse into child nodes.
	 */
	function addConditionally(obj, prop, tagName, where, recurse) {
	    if (recurse === void 0) { recurse = false; }
	    var val = fetch(tagName, where, recurse);
	    if (val)
	        obj[prop] = val;
	}
	/**
	 * Checks if an element is a feed root node.
	 *
	 * @param value The name of the element to check.
	 * @returns Whether an element is a feed root node.
	 */
	function isValidFeed(value) {
	    return value === "rss" || value === "feed" || value === "rdf:RDF";
	}
	
	return feeds;
}

var hasRequiredLib$2;

function requireLib$2 () {
	if (hasRequiredLib$2) return lib$3;
	hasRequiredLib$2 = 1;
	(function (exports) {
		var __createBinding = (lib$3 && lib$3.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (lib$3 && lib$3.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.hasChildren = exports.isDocument = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = void 0;
		__exportStar(/*@__PURE__*/ requireStringify$1(), exports);
		__exportStar(/*@__PURE__*/ requireTraversal(), exports);
		__exportStar(/*@__PURE__*/ requireManipulation(), exports);
		__exportStar(/*@__PURE__*/ requireQuerying(), exports);
		__exportStar(/*@__PURE__*/ requireLegacy(), exports);
		__exportStar(/*@__PURE__*/ requireHelpers(), exports);
		__exportStar(/*@__PURE__*/ requireFeeds(), exports);
		/** @deprecated Use these methods from `domhandler` directly. */
		var domhandler_1 = /*@__PURE__*/ requireLib$5();
		Object.defineProperty(exports, "isTag", { enumerable: true, get: function () { return domhandler_1.isTag; } });
		Object.defineProperty(exports, "isCDATA", { enumerable: true, get: function () { return domhandler_1.isCDATA; } });
		Object.defineProperty(exports, "isText", { enumerable: true, get: function () { return domhandler_1.isText; } });
		Object.defineProperty(exports, "isComment", { enumerable: true, get: function () { return domhandler_1.isComment; } });
		Object.defineProperty(exports, "isDocument", { enumerable: true, get: function () { return domhandler_1.isDocument; } });
		Object.defineProperty(exports, "hasChildren", { enumerable: true, get: function () { return domhandler_1.hasChildren; } });
		
	} (lib$3));
	return lib$3;
}

var hasRequiredLib$1;

function requireLib$1 () {
	if (hasRequiredLib$1) return lib$6;
	hasRequiredLib$1 = 1;
	(function (exports) {
		var __createBinding = (lib$6 && lib$6.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __setModuleDefault = (lib$6 && lib$6.__setModuleDefault) || (Object.create ? (function(o, v) {
		    Object.defineProperty(o, "default", { enumerable: true, value: v });
		}) : function(o, v) {
		    o["default"] = v;
		});
		var __importStar = (lib$6 && lib$6.__importStar) || function (mod) {
		    if (mod && mod.__esModule) return mod;
		    var result = {};
		    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		    __setModuleDefault(result, mod);
		    return result;
		};
		var __importDefault = (lib$6 && lib$6.__importDefault) || function (mod) {
		    return (mod && mod.__esModule) ? mod : { "default": mod };
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.DomUtils = exports.parseFeed = exports.getFeed = exports.ElementType = exports.Tokenizer = exports.createDomStream = exports.parseDOM = exports.parseDocument = exports.DefaultHandler = exports.DomHandler = exports.Parser = void 0;
		var Parser_js_1 = /*@__PURE__*/ requireParser$1();
		var Parser_js_2 = /*@__PURE__*/ requireParser$1();
		Object.defineProperty(exports, "Parser", { enumerable: true, get: function () { return Parser_js_2.Parser; } });
		var domhandler_1 = /*@__PURE__*/ requireLib$5();
		var domhandler_2 = /*@__PURE__*/ requireLib$5();
		Object.defineProperty(exports, "DomHandler", { enumerable: true, get: function () { return domhandler_2.DomHandler; } });
		// Old name for DomHandler
		Object.defineProperty(exports, "DefaultHandler", { enumerable: true, get: function () { return domhandler_2.DomHandler; } });
		// Helper methods
		/**
		 * Parses the data, returns the resulting document.
		 *
		 * @param data The data that should be parsed.
		 * @param options Optional options for the parser and DOM builder.
		 */
		function parseDocument(data, options) {
		    var handler = new domhandler_1.DomHandler(undefined, options);
		    new Parser_js_1.Parser(handler, options).end(data);
		    return handler.root;
		}
		exports.parseDocument = parseDocument;
		/**
		 * Parses data, returns an array of the root nodes.
		 *
		 * Note that the root nodes still have a `Document` node as their parent.
		 * Use `parseDocument` to get the `Document` node instead.
		 *
		 * @param data The data that should be parsed.
		 * @param options Optional options for the parser and DOM builder.
		 * @deprecated Use `parseDocument` instead.
		 */
		function parseDOM(data, options) {
		    return parseDocument(data, options).children;
		}
		exports.parseDOM = parseDOM;
		/**
		 * Creates a parser instance, with an attached DOM handler.
		 *
		 * @param callback A callback that will be called once parsing has been completed.
		 * @param options Optional options for the parser and DOM builder.
		 * @param elementCallback An optional callback that will be called every time a tag has been completed inside of the DOM.
		 */
		function createDomStream(callback, options, elementCallback) {
		    var handler = new domhandler_1.DomHandler(callback, options, elementCallback);
		    return new Parser_js_1.Parser(handler, options);
		}
		exports.createDomStream = createDomStream;
		var Tokenizer_js_1 = /*@__PURE__*/ requireTokenizer();
		Object.defineProperty(exports, "Tokenizer", { enumerable: true, get: function () { return __importDefault(Tokenizer_js_1).default; } });
		/*
		 * All of the following exports exist for backwards-compatibility.
		 * They should probably be removed eventually.
		 */
		exports.ElementType = __importStar(/*@__PURE__*/ requireLib$6());
		var domutils_1 = /*@__PURE__*/ requireLib$2();
		var domutils_2 = /*@__PURE__*/ requireLib$2();
		Object.defineProperty(exports, "getFeed", { enumerable: true, get: function () { return domutils_2.getFeed; } });
		var parseFeedDefaultOptions = { xmlMode: true };
		/**
		 * Parse a feed.
		 *
		 * @param feed The feed that should be parsed, as a string.
		 * @param options Optionally, options for parsing. When using this, you should set `xmlMode` to `true`.
		 */
		function parseFeed(feed, options) {
		    if (options === void 0) { options = parseFeedDefaultOptions; }
		    return (0, domutils_1.getFeed)(parseDOM(feed, options));
		}
		exports.parseFeed = parseFeed;
		exports.DomUtils = __importStar(/*@__PURE__*/ requireLib$2());
		
	} (lib$6));
	return lib$6;
}

var escapeStringRegexp;
var hasRequiredEscapeStringRegexp;

function requireEscapeStringRegexp () {
	if (hasRequiredEscapeStringRegexp) return escapeStringRegexp;
	hasRequiredEscapeStringRegexp = 1;

	escapeStringRegexp = string => {
		if (typeof string !== 'string') {
			throw new TypeError('Expected a string');
		}

		// Escape characters with special meaning either inside or outside character sets.
		// Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
		return string
			.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
			.replace(/-/g, '\\x2d');
	};
	return escapeStringRegexp;
}

var isPlainObject = {};

var hasRequiredIsPlainObject;

function requireIsPlainObject () {
	if (hasRequiredIsPlainObject) return isPlainObject;
	hasRequiredIsPlainObject = 1;

	Object.defineProperty(isPlainObject, '__esModule', { value: true });

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */

	function isObject(o) {
	  return Object.prototype.toString.call(o) === '[object Object]';
	}

	function isPlainObject$1(o) {
	  var ctor,prot;

	  if (isObject(o) === false) return false;

	  // If has modified constructor
	  ctor = o.constructor;
	  if (ctor === undefined) return true;

	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObject(prot) === false) return false;

	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }

	  // Most likely a plain Object
	  return true;
	}

	isPlainObject.isPlainObject = isPlainObject$1;
	return isPlainObject;
}

var cjs;
var hasRequiredCjs;

function requireCjs () {
	if (hasRequiredCjs) return cjs;
	hasRequiredCjs = 1;

	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};

	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}

	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);

		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}

	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}

	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}

	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}

	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}

	function getMergeFunction(key, options) {
		if (!options.customMerge) {
			return deepmerge
		}
		var customMerge = options.customMerge(key);
		return typeof customMerge === 'function' ? customMerge : deepmerge
	}

	function getEnumerableOwnPropertySymbols(target) {
		return Object.getOwnPropertySymbols
			? Object.getOwnPropertySymbols(target).filter(function(symbol) {
				return Object.propertyIsEnumerable.call(target, symbol)
			})
			: []
	}

	function getKeys(target) {
		return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	}

	function propertyIsOnObject(object, property) {
		try {
			return property in object
		} catch(_) {
			return false
		}
	}

	// Protects from prototype poisoning and unexpected merging up the prototype chain.
	function propertyIsUnsafe(target, key) {
		return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
			&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
				&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
	}

	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			getKeys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		getKeys(source).forEach(function(key) {
			if (propertyIsUnsafe(target, key)) {
				return
			}

			if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
				destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
			} else {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			}
		});
		return destination
	}

	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;
		// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
		// implementations can use it. The caller may not replace it.
		options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}

	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}

		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};

	var deepmerge_1 = deepmerge;

	cjs = deepmerge_1;
	return cjs;
}

var parseSrcset$1 = {exports: {}};

/**
 * Srcset Parser
 *
 * By Alex Bell |  MIT License
 *
 * JS Parser for the string value that appears in markup <img srcset="here">
 *
 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
 *
 * Based super duper closely on the reference algorithm at:
 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
 *
 * Most comments are copied in directly from the spec
 * (except for comments in parens).
 */
var parseSrcset = parseSrcset$1.exports;

var hasRequiredParseSrcset;

function requireParseSrcset () {
	if (hasRequiredParseSrcset) return parseSrcset$1.exports;
	hasRequiredParseSrcset = 1;
	(function (module) {
		(function (root, factory) {
			if (module.exports) {
				// Node. Does not work with strict CommonJS, but
				// only CommonJS-like environments that support module.exports,
				// like Node.
				module.exports = factory();
			} else {
				// Browser globals (root is window)
				root.parseSrcset = factory();
			}
		}(parseSrcset, function () {

			// 1. Let input be the value passed to this algorithm.
			return function (input) {

				// UTILITY FUNCTIONS

				// Manual is faster than RegEx
				// http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
				// http://jsperf.com/whitespace-character/5
				function isSpace(c) {
					return (c === "\u0020" || // space
					c === "\u0009" || // horizontal tab
					c === "\u000A" || // new line
					c === "\u000C" || // form feed
					c === "\u000D");  // carriage return
				}

				function collectCharacters(regEx) {
					var chars,
						match = regEx.exec(input.substring(pos));
					if (match) {
						chars = match[ 0 ];
						pos += chars.length;
						return chars;
					}
				}

				var inputLength = input.length,

					// (Don't use \s, to avoid matching non-breaking space)
					regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
					regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
					regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
					regexTrailingCommas = /[,]+$/,
					regexNonNegativeInteger = /^\d+$/,

					// ( Positive or negative or unsigned integers or decimals, without or without exponents.
					// Must include at least one digit.
					// According to spec tests any decimal point must be followed by a digit.
					// No leading plus sign is allowed.)
					// https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
					regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,

					url,
					descriptors,
					currentDescriptor,
					state,
					c,

					// 2. Let position be a pointer into input, initially pointing at the start
					//    of the string.
					pos = 0,

					// 3. Let candidates be an initially empty source set.
					candidates = [];

				// 4. Splitting loop: Collect a sequence of characters that are space
				//    characters or U+002C COMMA characters. If any U+002C COMMA characters
				//    were collected, that is a parse error.
				while (true) {
					collectCharacters(regexLeadingCommasOrSpaces);

					// 5. If position is past the end of input, return candidates and abort these steps.
					if (pos >= inputLength) {
						return candidates; // (we're done, this is the sole return path)
					}

					// 6. Collect a sequence of characters that are not space characters,
					//    and let that be url.
					url = collectCharacters(regexLeadingNotSpaces);

					// 7. Let descriptors be a new empty list.
					descriptors = [];

					// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
					//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
					//         more than one character, that is a parse error.
					if (url.slice(-1) === ",") {
						url = url.replace(regexTrailingCommas, "");
						// (Jump ahead to step 9 to skip tokenization and just push the candidate).
						parseDescriptors();

						//	Otherwise, follow these substeps:
					} else {
						tokenize();
					} // (close else of step 8)

					// 16. Return to the step labeled splitting loop.
				} // (Close of big while loop.)

				/**
				 * Tokenizes descriptor properties prior to parsing
				 * Returns undefined.
				 */
				function tokenize() {

					// 8.1. Descriptor tokeniser: Skip whitespace
					collectCharacters(regexLeadingSpaces);

					// 8.2. Let current descriptor be the empty string.
					currentDescriptor = "";

					// 8.3. Let state be in descriptor.
					state = "in descriptor";

					while (true) {

						// 8.4. Let c be the character at position.
						c = input.charAt(pos);

						//  Do the following depending on the value of state.
						//  For the purpose of this step, "EOF" is a special character representing
						//  that position is past the end of input.

						// In descriptor
						if (state === "in descriptor") {
							// Do the following, depending on the value of c:

							// Space character
							// If current descriptor is not empty, append current descriptor to
							// descriptors and let current descriptor be the empty string.
							// Set state to after descriptor.
							if (isSpace(c)) {
								if (currentDescriptor) {
									descriptors.push(currentDescriptor);
									currentDescriptor = "";
									state = "after descriptor";
								}

								// U+002C COMMA (,)
								// Advance position to the next character in input. If current descriptor
								// is not empty, append current descriptor to descriptors. Jump to the step
								// labeled descriptor parser.
							} else if (c === ",") {
								pos += 1;
								if (currentDescriptor) {
									descriptors.push(currentDescriptor);
								}
								parseDescriptors();
								return;

								// U+0028 LEFT PARENTHESIS (()
								// Append c to current descriptor. Set state to in parens.
							} else if (c === "\u0028") {
								currentDescriptor = currentDescriptor + c;
								state = "in parens";

								// EOF
								// If current descriptor is not empty, append current descriptor to
								// descriptors. Jump to the step labeled descriptor parser.
							} else if (c === "") {
								if (currentDescriptor) {
									descriptors.push(currentDescriptor);
								}
								parseDescriptors();
								return;

								// Anything else
								// Append c to current descriptor.
							} else {
								currentDescriptor = currentDescriptor + c;
							}
							// (end "in descriptor"

							// In parens
						} else if (state === "in parens") {

							// U+0029 RIGHT PARENTHESIS ())
							// Append c to current descriptor. Set state to in descriptor.
							if (c === ")") {
								currentDescriptor = currentDescriptor + c;
								state = "in descriptor";

								// EOF
								// Append current descriptor to descriptors. Jump to the step labeled
								// descriptor parser.
							} else if (c === "") {
								descriptors.push(currentDescriptor);
								parseDescriptors();
								return;

								// Anything else
								// Append c to current descriptor.
							} else {
								currentDescriptor = currentDescriptor + c;
							}

							// After descriptor
						} else if (state === "after descriptor") {

							// Do the following, depending on the value of c:
							// Space character: Stay in this state.
							if (isSpace(c)) ; else if (c === "") {
								parseDescriptors();
								return;

								// Anything else
								// Set state to in descriptor. Set position to the previous character in input.
							} else {
								state = "in descriptor";
								pos -= 1;

							}
						}

						// Advance position to the next character in input.
						pos += 1;

						// Repeat this step.
					} // (close while true loop)
				}

				/**
				 * Adds descriptor properties to a candidate, pushes to the candidates array
				 * @return undefined
				 */
				// Declared outside of the while loop so that it's only created once.
				function parseDescriptors() {

					// 9. Descriptor parser: Let error be no.
					var pError = false,

						// 10. Let width be absent.
						// 11. Let density be absent.
						// 12. Let future-compat-h be absent. (We're implementing it now as h)
						w, d, h, i,
						candidate = {},
						desc, lastChar, value, intVal, floatVal;

					// 13. For each descriptor in descriptors, run the appropriate set of steps
					// from the following list:
					for (i = 0 ; i < descriptors.length; i++) {
						desc = descriptors[ i ];

						lastChar = desc[ desc.length - 1 ];
						value = desc.substring(0, desc.length - 1);
						intVal = parseInt(value, 10);
						floatVal = parseFloat(value);

						// If the descriptor consists of a valid non-negative integer followed by
						// a U+0077 LATIN SMALL LETTER W character
						if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {

							// If width and density are not both absent, then let error be yes.
							if (w || d) {pError = true;}

							// Apply the rules for parsing non-negative integers to the descriptor.
							// If the result is zero, let error be yes.
							// Otherwise, let width be the result.
							if (intVal === 0) {pError = true;} else {w = intVal;}

							// If the descriptor consists of a valid floating-point number followed by
							// a U+0078 LATIN SMALL LETTER X character
						} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {

							// If width, density and future-compat-h are not all absent, then let error
							// be yes.
							if (w || d || h) {pError = true;}

							// Apply the rules for parsing floating-point number values to the descriptor.
							// If the result is less than zero, let error be yes. Otherwise, let density
							// be the result.
							if (floatVal < 0) {pError = true;} else {d = floatVal;}

							// If the descriptor consists of a valid non-negative integer followed by
							// a U+0068 LATIN SMALL LETTER H character
						} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {

							// If height and density are not both absent, then let error be yes.
							if (h || d) {pError = true;}

							// Apply the rules for parsing non-negative integers to the descriptor.
							// If the result is zero, let error be yes. Otherwise, let future-compat-h
							// be the result.
							if (intVal === 0) {pError = true;} else {h = intVal;}

							// Anything else, Let error be yes.
						} else {pError = true;}
					} // (close step 13 for loop)

					// 15. If error is still no, then append a new image source to candidates whose
					// URL is url, associated with a width width if not absent and a pixel
					// density density if not absent. Otherwise, there is a parse error.
					if (!pError) {
						candidate.url = url;
						if (w) { candidate.w = w;}
						if (d) { candidate.d = d;}
						if (h) { candidate.h = h;}
						candidates.push(candidate);
					} else if (console && console.log) {
						console.log("Invalid srcset descriptor found in '" +
							input + "' at '" + desc + "'.");
					}
				} // (close parseDescriptors fn)

			}
		})); 
	} (parseSrcset$1));
	return parseSrcset$1.exports;
}

var picocolors_browser = {exports: {}};

var hasRequiredPicocolors_browser;

function requirePicocolors_browser () {
	if (hasRequiredPicocolors_browser) return picocolors_browser.exports;
	hasRequiredPicocolors_browser = 1;
	var x=String;
	var create=function() {return {isColorSupported:false,reset:x,bold:x,dim:x,italic:x,underline:x,inverse:x,hidden:x,strikethrough:x,black:x,red:x,green:x,yellow:x,blue:x,magenta:x,cyan:x,white:x,gray:x,bgBlack:x,bgRed:x,bgGreen:x,bgYellow:x,bgBlue:x,bgMagenta:x,bgCyan:x,bgWhite:x,blackBright:x,redBright:x,greenBright:x,yellowBright:x,blueBright:x,magentaBright:x,cyanBright:x,whiteBright:x,bgBlackBright:x,bgRedBright:x,bgGreenBright:x,bgYellowBright:x,bgBlueBright:x,bgMagentaBright:x,bgCyanBright:x,bgWhiteBright:x}};
	picocolors_browser.exports=create();
	picocolors_browser.exports.createColors = create;
	return picocolors_browser.exports;
}

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: _nodeResolve_empty
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

var cssSyntaxError;
var hasRequiredCssSyntaxError;

function requireCssSyntaxError () {
	if (hasRequiredCssSyntaxError) return cssSyntaxError;
	hasRequiredCssSyntaxError = 1;

	let pico = /*@__PURE__*/ requirePicocolors_browser();

	let terminalHighlight = require$$1;

	class CssSyntaxError extends Error {
	  constructor(message, line, column, source, file, plugin) {
	    super(message);
	    this.name = 'CssSyntaxError';
	    this.reason = message;

	    if (file) {
	      this.file = file;
	    }
	    if (source) {
	      this.source = source;
	    }
	    if (plugin) {
	      this.plugin = plugin;
	    }
	    if (typeof line !== 'undefined' && typeof column !== 'undefined') {
	      if (typeof line === 'number') {
	        this.line = line;
	        this.column = column;
	      } else {
	        this.line = line.line;
	        this.column = line.column;
	        this.endLine = column.line;
	        this.endColumn = column.column;
	      }
	    }

	    this.setMessage();

	    if (Error.captureStackTrace) {
	      Error.captureStackTrace(this, CssSyntaxError);
	    }
	  }

	  setMessage() {
	    this.message = this.plugin ? this.plugin + ': ' : '';
	    this.message += this.file ? this.file : '<css input>';
	    if (typeof this.line !== 'undefined') {
	      this.message += ':' + this.line + ':' + this.column;
	    }
	    this.message += ': ' + this.reason;
	  }

	  showSourceCode(color) {
	    if (!this.source) return ''

	    let css = this.source;
	    if (color == null) color = pico.isColorSupported;

	    let aside = text => text;
	    let mark = text => text;
	    let highlight = text => text;
	    if (color) {
	      let { bold, gray, red } = pico.createColors(true);
	      mark = text => bold(red(text));
	      aside = text => gray(text);
	      if (terminalHighlight) {
	        highlight = text => terminalHighlight(text);
	      }
	    }

	    let lines = css.split(/\r?\n/);
	    let start = Math.max(this.line - 3, 0);
	    let end = Math.min(this.line + 2, lines.length);
	    let maxWidth = String(end).length;

	    return lines
	      .slice(start, end)
	      .map((line, index) => {
	        let number = start + 1 + index;
	        let gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';
	        if (number === this.line) {
	          if (line.length > 160) {
	            let padding = 20;
	            let subLineStart = Math.max(0, this.column - padding);
	            let subLineEnd = Math.max(
	              this.column + padding,
	              this.endColumn + padding
	            );
	            let subLine = line.slice(subLineStart, subLineEnd);

	            let spacing =
	              aside(gutter.replace(/\d/g, ' ')) +
	              line
	                .slice(0, Math.min(this.column - 1, padding - 1))
	                .replace(/[^\t]/g, ' ');

	            return (
	              mark('>') +
	              aside(gutter) +
	              highlight(subLine) +
	              '\n ' +
	              spacing +
	              mark('^')
	            )
	          }

	          let spacing =
	            aside(gutter.replace(/\d/g, ' ')) +
	            line.slice(0, this.column - 1).replace(/[^\t]/g, ' ');

	          return (
	            mark('>') +
	            aside(gutter) +
	            highlight(line) +
	            '\n ' +
	            spacing +
	            mark('^')
	          )
	        }

	        return ' ' + aside(gutter) + highlight(line)
	      })
	      .join('\n')
	  }

	  toString() {
	    let code = this.showSourceCode();
	    if (code) {
	      code = '\n\n' + code + '\n';
	    }
	    return this.name + ': ' + this.message + code
	  }
	}

	cssSyntaxError = CssSyntaxError;
	CssSyntaxError.default = CssSyntaxError;
	return cssSyntaxError;
}

var stringifier;
var hasRequiredStringifier;

function requireStringifier () {
	if (hasRequiredStringifier) return stringifier;
	hasRequiredStringifier = 1;

	const DEFAULT_RAW = {
	  after: '\n',
	  beforeClose: '\n',
	  beforeComment: '\n',
	  beforeDecl: '\n',
	  beforeOpen: ' ',
	  beforeRule: '\n',
	  colon: ': ',
	  commentLeft: ' ',
	  commentRight: ' ',
	  emptyBody: '',
	  indent: '    ',
	  semicolon: false
	};

	function capitalize(str) {
	  return str[0].toUpperCase() + str.slice(1)
	}

	class Stringifier {
	  constructor(builder) {
	    this.builder = builder;
	  }

	  atrule(node, semicolon) {
	    let name = '@' + node.name;
	    let params = node.params ? this.rawValue(node, 'params') : '';

	    if (typeof node.raws.afterName !== 'undefined') {
	      name += node.raws.afterName;
	    } else if (params) {
	      name += ' ';
	    }

	    if (node.nodes) {
	      this.block(node, name + params);
	    } else {
	      let end = (node.raws.between || '') + (semicolon ? ';' : '');
	      this.builder(name + params + end, node);
	    }
	  }

	  beforeAfter(node, detect) {
	    let value;
	    if (node.type === 'decl') {
	      value = this.raw(node, null, 'beforeDecl');
	    } else if (node.type === 'comment') {
	      value = this.raw(node, null, 'beforeComment');
	    } else if (detect === 'before') {
	      value = this.raw(node, null, 'beforeRule');
	    } else {
	      value = this.raw(node, null, 'beforeClose');
	    }

	    let buf = node.parent;
	    let depth = 0;
	    while (buf && buf.type !== 'root') {
	      depth += 1;
	      buf = buf.parent;
	    }

	    if (value.includes('\n')) {
	      let indent = this.raw(node, null, 'indent');
	      if (indent.length) {
	        for (let step = 0; step < depth; step++) value += indent;
	      }
	    }

	    return value
	  }

	  block(node, start) {
	    let between = this.raw(node, 'between', 'beforeOpen');
	    this.builder(start + between + '{', node, 'start');

	    let after;
	    if (node.nodes && node.nodes.length) {
	      this.body(node);
	      after = this.raw(node, 'after');
	    } else {
	      after = this.raw(node, 'after', 'emptyBody');
	    }

	    if (after) this.builder(after);
	    this.builder('}', node, 'end');
	  }

	  body(node) {
	    let last = node.nodes.length - 1;
	    while (last > 0) {
	      if (node.nodes[last].type !== 'comment') break
	      last -= 1;
	    }

	    let semicolon = this.raw(node, 'semicolon');
	    for (let i = 0; i < node.nodes.length; i++) {
	      let child = node.nodes[i];
	      let before = this.raw(child, 'before');
	      if (before) this.builder(before);
	      this.stringify(child, last !== i || semicolon);
	    }
	  }

	  comment(node) {
	    let left = this.raw(node, 'left', 'commentLeft');
	    let right = this.raw(node, 'right', 'commentRight');
	    this.builder('/*' + left + node.text + right + '*/', node);
	  }

	  decl(node, semicolon) {
	    let between = this.raw(node, 'between', 'colon');
	    let string = node.prop + between + this.rawValue(node, 'value');

	    if (node.important) {
	      string += node.raws.important || ' !important';
	    }

	    if (semicolon) string += ';';
	    this.builder(string, node);
	  }

	  document(node) {
	    this.body(node);
	  }

	  raw(node, own, detect) {
	    let value;
	    if (!detect) detect = own;

	    // Already had
	    if (own) {
	      value = node.raws[own];
	      if (typeof value !== 'undefined') return value
	    }

	    let parent = node.parent;

	    if (detect === 'before') {
	      // Hack for first rule in CSS
	      if (!parent || (parent.type === 'root' && parent.first === node)) {
	        return ''
	      }

	      // `root` nodes in `document` should use only their own raws
	      if (parent && parent.type === 'document') {
	        return ''
	      }
	    }

	    // Floating child without parent
	    if (!parent) return DEFAULT_RAW[detect]

	    // Detect style by other nodes
	    let root = node.root();
	    if (!root.rawCache) root.rawCache = {};
	    if (typeof root.rawCache[detect] !== 'undefined') {
	      return root.rawCache[detect]
	    }

	    if (detect === 'before' || detect === 'after') {
	      return this.beforeAfter(node, detect)
	    } else {
	      let method = 'raw' + capitalize(detect);
	      if (this[method]) {
	        value = this[method](root, node);
	      } else {
	        root.walk(i => {
	          value = i.raws[own];
	          if (typeof value !== 'undefined') return false
	        });
	      }
	    }

	    if (typeof value === 'undefined') value = DEFAULT_RAW[detect];

	    root.rawCache[detect] = value;
	    return value
	  }

	  rawBeforeClose(root) {
	    let value;
	    root.walk(i => {
	      if (i.nodes && i.nodes.length > 0) {
	        if (typeof i.raws.after !== 'undefined') {
	          value = i.raws.after;
	          if (value.includes('\n')) {
	            value = value.replace(/[^\n]+$/, '');
	          }
	          return false
	        }
	      }
	    });
	    if (value) value = value.replace(/\S/g, '');
	    return value
	  }

	  rawBeforeComment(root, node) {
	    let value;
	    root.walkComments(i => {
	      if (typeof i.raws.before !== 'undefined') {
	        value = i.raws.before;
	        if (value.includes('\n')) {
	          value = value.replace(/[^\n]+$/, '');
	        }
	        return false
	      }
	    });
	    if (typeof value === 'undefined') {
	      value = this.raw(node, null, 'beforeDecl');
	    } else if (value) {
	      value = value.replace(/\S/g, '');
	    }
	    return value
	  }

	  rawBeforeDecl(root, node) {
	    let value;
	    root.walkDecls(i => {
	      if (typeof i.raws.before !== 'undefined') {
	        value = i.raws.before;
	        if (value.includes('\n')) {
	          value = value.replace(/[^\n]+$/, '');
	        }
	        return false
	      }
	    });
	    if (typeof value === 'undefined') {
	      value = this.raw(node, null, 'beforeRule');
	    } else if (value) {
	      value = value.replace(/\S/g, '');
	    }
	    return value
	  }

	  rawBeforeOpen(root) {
	    let value;
	    root.walk(i => {
	      if (i.type !== 'decl') {
	        value = i.raws.between;
	        if (typeof value !== 'undefined') return false
	      }
	    });
	    return value
	  }

	  rawBeforeRule(root) {
	    let value;
	    root.walk(i => {
	      if (i.nodes && (i.parent !== root || root.first !== i)) {
	        if (typeof i.raws.before !== 'undefined') {
	          value = i.raws.before;
	          if (value.includes('\n')) {
	            value = value.replace(/[^\n]+$/, '');
	          }
	          return false
	        }
	      }
	    });
	    if (value) value = value.replace(/\S/g, '');
	    return value
	  }

	  rawColon(root) {
	    let value;
	    root.walkDecls(i => {
	      if (typeof i.raws.between !== 'undefined') {
	        value = i.raws.between.replace(/[^\s:]/g, '');
	        return false
	      }
	    });
	    return value
	  }

	  rawEmptyBody(root) {
	    let value;
	    root.walk(i => {
	      if (i.nodes && i.nodes.length === 0) {
	        value = i.raws.after;
	        if (typeof value !== 'undefined') return false
	      }
	    });
	    return value
	  }

	  rawIndent(root) {
	    if (root.raws.indent) return root.raws.indent
	    let value;
	    root.walk(i => {
	      let p = i.parent;
	      if (p && p !== root && p.parent && p.parent === root) {
	        if (typeof i.raws.before !== 'undefined') {
	          let parts = i.raws.before.split('\n');
	          value = parts[parts.length - 1];
	          value = value.replace(/\S/g, '');
	          return false
	        }
	      }
	    });
	    return value
	  }

	  rawSemicolon(root) {
	    let value;
	    root.walk(i => {
	      if (i.nodes && i.nodes.length && i.last.type === 'decl') {
	        value = i.raws.semicolon;
	        if (typeof value !== 'undefined') return false
	      }
	    });
	    return value
	  }

	  rawValue(node, prop) {
	    let value = node[prop];
	    let raw = node.raws[prop];
	    if (raw && raw.value === value) {
	      return raw.raw
	    }

	    return value
	  }

	  root(node) {
	    this.body(node);
	    if (node.raws.after) this.builder(node.raws.after);
	  }

	  rule(node) {
	    this.block(node, this.rawValue(node, 'selector'));
	    if (node.raws.ownSemicolon) {
	      this.builder(node.raws.ownSemicolon, node, 'end');
	    }
	  }

	  stringify(node, semicolon) {
	    /* c8 ignore start */
	    if (!this[node.type]) {
	      throw new Error(
	        'Unknown AST node type ' +
	          node.type +
	          '. ' +
	          'Maybe you need to change PostCSS stringifier.'
	      )
	    }
	    /* c8 ignore stop */
	    this[node.type](node, semicolon);
	  }
	}

	stringifier = Stringifier;
	Stringifier.default = Stringifier;
	return stringifier;
}

var stringify_1;
var hasRequiredStringify;

function requireStringify () {
	if (hasRequiredStringify) return stringify_1;
	hasRequiredStringify = 1;

	let Stringifier = requireStringifier();

	function stringify(node, builder) {
	  let str = new Stringifier(builder);
	  str.stringify(node);
	}

	stringify_1 = stringify;
	stringify.default = stringify;
	return stringify_1;
}

var symbols = {};

var hasRequiredSymbols;

function requireSymbols () {
	if (hasRequiredSymbols) return symbols;
	hasRequiredSymbols = 1;

	symbols.isClean = Symbol('isClean');

	symbols.my = Symbol('my');
	return symbols;
}

var node;
var hasRequiredNode;

function requireNode () {
	if (hasRequiredNode) return node;
	hasRequiredNode = 1;

	let CssSyntaxError = requireCssSyntaxError();
	let Stringifier = requireStringifier();
	let stringify = requireStringify();
	let { isClean, my } = requireSymbols();

	function cloneNode(obj, parent) {
	  let cloned = new obj.constructor();

	  for (let i in obj) {
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) {
	      /* c8 ignore next 2 */
	      continue
	    }
	    if (i === 'proxyCache') continue
	    let value = obj[i];
	    let type = typeof value;

	    if (i === 'parent' && type === 'object') {
	      if (parent) cloned[i] = parent;
	    } else if (i === 'source') {
	      cloned[i] = value;
	    } else if (Array.isArray(value)) {
	      cloned[i] = value.map(j => cloneNode(j, cloned));
	    } else {
	      if (type === 'object' && value !== null) value = cloneNode(value);
	      cloned[i] = value;
	    }
	  }

	  return cloned
	}

	function sourceOffset(inputCSS, position) {
	  // Not all custom syntaxes support `offset` in `source.start` and `source.end`
	  if (position && typeof position.offset !== 'undefined') {
	    return position.offset
	  }

	  let column = 1;
	  let line = 1;
	  let offset = 0;

	  for (let i = 0; i < inputCSS.length; i++) {
	    if (line === position.line && column === position.column) {
	      offset = i;
	      break
	    }

	    if (inputCSS[i] === '\n') {
	      column = 1;
	      line += 1;
	    } else {
	      column += 1;
	    }
	  }

	  return offset
	}

	class Node {
	  get proxyOf() {
	    return this
	  }

	  constructor(defaults = {}) {
	    this.raws = {};
	    this[isClean] = false;
	    this[my] = true;

	    for (let name in defaults) {
	      if (name === 'nodes') {
	        this.nodes = [];
	        for (let node of defaults[name]) {
	          if (typeof node.clone === 'function') {
	            this.append(node.clone());
	          } else {
	            this.append(node);
	          }
	        }
	      } else {
	        this[name] = defaults[name];
	      }
	    }
	  }

	  addToError(error) {
	    error.postcssNode = this;
	    if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
	      let s = this.source;
	      error.stack = error.stack.replace(
	        /\n\s{4}at /,
	        `$&${s.input.from}:${s.start.line}:${s.start.column}$&`
	      );
	    }
	    return error
	  }

	  after(add) {
	    this.parent.insertAfter(this, add);
	    return this
	  }

	  assign(overrides = {}) {
	    for (let name in overrides) {
	      this[name] = overrides[name];
	    }
	    return this
	  }

	  before(add) {
	    this.parent.insertBefore(this, add);
	    return this
	  }

	  cleanRaws(keepBetween) {
	    delete this.raws.before;
	    delete this.raws.after;
	    if (!keepBetween) delete this.raws.between;
	  }

	  clone(overrides = {}) {
	    let cloned = cloneNode(this);
	    for (let name in overrides) {
	      cloned[name] = overrides[name];
	    }
	    return cloned
	  }

	  cloneAfter(overrides = {}) {
	    let cloned = this.clone(overrides);
	    this.parent.insertAfter(this, cloned);
	    return cloned
	  }

	  cloneBefore(overrides = {}) {
	    let cloned = this.clone(overrides);
	    this.parent.insertBefore(this, cloned);
	    return cloned
	  }

	  error(message, opts = {}) {
	    if (this.source) {
	      let { end, start } = this.rangeBy(opts);
	      return this.source.input.error(
	        message,
	        { column: start.column, line: start.line },
	        { column: end.column, line: end.line },
	        opts
	      )
	    }
	    return new CssSyntaxError(message)
	  }

	  getProxyProcessor() {
	    return {
	      get(node, prop) {
	        if (prop === 'proxyOf') {
	          return node
	        } else if (prop === 'root') {
	          return () => node.root().toProxy()
	        } else {
	          return node[prop]
	        }
	      },

	      set(node, prop, value) {
	        if (node[prop] === value) return true
	        node[prop] = value;
	        if (
	          prop === 'prop' ||
	          prop === 'value' ||
	          prop === 'name' ||
	          prop === 'params' ||
	          prop === 'important' ||
	          /* c8 ignore next */
	          prop === 'text'
	        ) {
	          node.markDirty();
	        }
	        return true
	      }
	    }
	  }

	  /* c8 ignore next 3 */
	  markClean() {
	    this[isClean] = true;
	  }

	  markDirty() {
	    if (this[isClean]) {
	      this[isClean] = false;
	      let next = this;
	      while ((next = next.parent)) {
	        next[isClean] = false;
	      }
	    }
	  }

	  next() {
	    if (!this.parent) return undefined
	    let index = this.parent.index(this);
	    return this.parent.nodes[index + 1]
	  }

	  positionBy(opts = {}) {
	    let pos = this.source.start;
	    if (opts.index) {
	      pos = this.positionInside(opts.index);
	    } else if (opts.word) {
	      let inputString =
	        'document' in this.source.input
	          ? this.source.input.document
	          : this.source.input.css;
	      let stringRepresentation = inputString.slice(
	        sourceOffset(inputString, this.source.start),
	        sourceOffset(inputString, this.source.end)
	      );
	      let index = stringRepresentation.indexOf(opts.word);
	      if (index !== -1) pos = this.positionInside(index);
	    }
	    return pos
	  }

	  positionInside(index) {
	    let column = this.source.start.column;
	    let line = this.source.start.line;
	    let inputString =
	      'document' in this.source.input
	        ? this.source.input.document
	        : this.source.input.css;
	    let offset = sourceOffset(inputString, this.source.start);
	    let end = offset + index;

	    for (let i = offset; i < end; i++) {
	      if (inputString[i] === '\n') {
	        column = 1;
	        line += 1;
	      } else {
	        column += 1;
	      }
	    }

	    return { column, line, offset: end }
	  }

	  prev() {
	    if (!this.parent) return undefined
	    let index = this.parent.index(this);
	    return this.parent.nodes[index - 1]
	  }

	  rangeBy(opts = {}) {
	    let inputString =
	      'document' in this.source.input
	        ? this.source.input.document
	        : this.source.input.css;
	    let start = {
	      column: this.source.start.column,
	      line: this.source.start.line,
	      offset: sourceOffset(inputString, this.source.start)
	    };
	    let end = this.source.end
	      ? {
	          column: this.source.end.column + 1,
	          line: this.source.end.line,
	          offset:
	            typeof this.source.end.offset === 'number'
	              ? // `source.end.offset` is exclusive, so we don't need to add 1
	                this.source.end.offset
	              : // Since line/column in this.source.end is inclusive,
	                // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
	                // So, we add 1 to convert it to exclusive.
	                sourceOffset(inputString, this.source.end) + 1
	        }
	      : {
	          column: start.column + 1,
	          line: start.line,
	          offset: start.offset + 1
	        };

	    if (opts.word) {
	      let stringRepresentation = inputString.slice(
	        sourceOffset(inputString, this.source.start),
	        sourceOffset(inputString, this.source.end)
	      );
	      let index = stringRepresentation.indexOf(opts.word);
	      if (index !== -1) {
	        start = this.positionInside(index);
	        end = this.positionInside(index + opts.word.length);
	      }
	    } else {
	      if (opts.start) {
	        start = {
	          column: opts.start.column,
	          line: opts.start.line,
	          offset: sourceOffset(inputString, opts.start)
	        };
	      } else if (opts.index) {
	        start = this.positionInside(opts.index);
	      }

	      if (opts.end) {
	        end = {
	          column: opts.end.column,
	          line: opts.end.line,
	          offset: sourceOffset(inputString, opts.end)
	        };
	      } else if (typeof opts.endIndex === 'number') {
	        end = this.positionInside(opts.endIndex);
	      } else if (opts.index) {
	        end = this.positionInside(opts.index + 1);
	      }
	    }

	    if (
	      end.line < start.line ||
	      (end.line === start.line && end.column <= start.column)
	    ) {
	      end = {
	        column: start.column + 1,
	        line: start.line,
	        offset: start.offset + 1
	      };
	    }

	    return { end, start }
	  }

	  raw(prop, defaultType) {
	    let str = new Stringifier();
	    return str.raw(this, prop, defaultType)
	  }

	  remove() {
	    if (this.parent) {
	      this.parent.removeChild(this);
	    }
	    this.parent = undefined;
	    return this
	  }

	  replaceWith(...nodes) {
	    if (this.parent) {
	      let bookmark = this;
	      let foundSelf = false;
	      for (let node of nodes) {
	        if (node === this) {
	          foundSelf = true;
	        } else if (foundSelf) {
	          this.parent.insertAfter(bookmark, node);
	          bookmark = node;
	        } else {
	          this.parent.insertBefore(bookmark, node);
	        }
	      }

	      if (!foundSelf) {
	        this.remove();
	      }
	    }

	    return this
	  }

	  root() {
	    let result = this;
	    while (result.parent && result.parent.type !== 'document') {
	      result = result.parent;
	    }
	    return result
	  }

	  toJSON(_, inputs) {
	    let fixed = {};
	    let emitInputs = inputs == null;
	    inputs = inputs || new Map();
	    let inputsNextIndex = 0;

	    for (let name in this) {
	      if (!Object.prototype.hasOwnProperty.call(this, name)) {
	        /* c8 ignore next 2 */
	        continue
	      }
	      if (name === 'parent' || name === 'proxyCache') continue
	      let value = this[name];

	      if (Array.isArray(value)) {
	        fixed[name] = value.map(i => {
	          if (typeof i === 'object' && i.toJSON) {
	            return i.toJSON(null, inputs)
	          } else {
	            return i
	          }
	        });
	      } else if (typeof value === 'object' && value.toJSON) {
	        fixed[name] = value.toJSON(null, inputs);
	      } else if (name === 'source') {
	        if (value == null) continue
	        let inputId = inputs.get(value.input);
	        if (inputId == null) {
	          inputId = inputsNextIndex;
	          inputs.set(value.input, inputsNextIndex);
	          inputsNextIndex++;
	        }
	        fixed[name] = {
	          end: value.end,
	          inputId,
	          start: value.start
	        };
	      } else {
	        fixed[name] = value;
	      }
	    }

	    if (emitInputs) {
	      fixed.inputs = [...inputs.keys()].map(input => input.toJSON());
	    }

	    return fixed
	  }

	  toProxy() {
	    if (!this.proxyCache) {
	      this.proxyCache = new Proxy(this, this.getProxyProcessor());
	    }
	    return this.proxyCache
	  }

	  toString(stringifier = stringify) {
	    if (stringifier.stringify) stringifier = stringifier.stringify;
	    let result = '';
	    stringifier(this, i => {
	      result += i;
	    });
	    return result
	  }

	  warn(result, text, opts = {}) {
	    let data = { node: this };
	    for (let i in opts) data[i] = opts[i];
	    return result.warn(text, data)
	  }
	}

	node = Node;
	Node.default = Node;
	return node;
}

var comment;
var hasRequiredComment;

function requireComment () {
	if (hasRequiredComment) return comment;
	hasRequiredComment = 1;

	let Node = requireNode();

	class Comment extends Node {
	  constructor(defaults) {
	    super(defaults);
	    this.type = 'comment';
	  }
	}

	comment = Comment;
	Comment.default = Comment;
	return comment;
}

var declaration;
var hasRequiredDeclaration;

function requireDeclaration () {
	if (hasRequiredDeclaration) return declaration;
	hasRequiredDeclaration = 1;

	let Node = requireNode();

	class Declaration extends Node {
	  get variable() {
	    return this.prop.startsWith('--') || this.prop[0] === '$'
	  }

	  constructor(defaults) {
	    if (
	      defaults &&
	      typeof defaults.value !== 'undefined' &&
	      typeof defaults.value !== 'string'
	    ) {
	      defaults = { ...defaults, value: String(defaults.value) };
	    }
	    super(defaults);
	    this.type = 'decl';
	  }
	}

	declaration = Declaration;
	Declaration.default = Declaration;
	return declaration;
}

var container;
var hasRequiredContainer;

function requireContainer () {
	if (hasRequiredContainer) return container;
	hasRequiredContainer = 1;

	let Comment = requireComment();
	let Declaration = requireDeclaration();
	let Node = requireNode();
	let { isClean, my } = requireSymbols();

	let AtRule, parse, Root, Rule;

	function cleanSource(nodes) {
	  return nodes.map(i => {
	    if (i.nodes) i.nodes = cleanSource(i.nodes);
	    delete i.source;
	    return i
	  })
	}

	function markTreeDirty(node) {
	  node[isClean] = false;
	  if (node.proxyOf.nodes) {
	    for (let i of node.proxyOf.nodes) {
	      markTreeDirty(i);
	    }
	  }
	}

	class Container extends Node {
	  get first() {
	    if (!this.proxyOf.nodes) return undefined
	    return this.proxyOf.nodes[0]
	  }

	  get last() {
	    if (!this.proxyOf.nodes) return undefined
	    return this.proxyOf.nodes[this.proxyOf.nodes.length - 1]
	  }

	  append(...children) {
	    for (let child of children) {
	      let nodes = this.normalize(child, this.last);
	      for (let node of nodes) this.proxyOf.nodes.push(node);
	    }

	    this.markDirty();

	    return this
	  }

	  cleanRaws(keepBetween) {
	    super.cleanRaws(keepBetween);
	    if (this.nodes) {
	      for (let node of this.nodes) node.cleanRaws(keepBetween);
	    }
	  }

	  each(callback) {
	    if (!this.proxyOf.nodes) return undefined
	    let iterator = this.getIterator();

	    let index, result;
	    while (this.indexes[iterator] < this.proxyOf.nodes.length) {
	      index = this.indexes[iterator];
	      result = callback(this.proxyOf.nodes[index], index);
	      if (result === false) break

	      this.indexes[iterator] += 1;
	    }

	    delete this.indexes[iterator];
	    return result
	  }

	  every(condition) {
	    return this.nodes.every(condition)
	  }

	  getIterator() {
	    if (!this.lastEach) this.lastEach = 0;
	    if (!this.indexes) this.indexes = {};

	    this.lastEach += 1;
	    let iterator = this.lastEach;
	    this.indexes[iterator] = 0;

	    return iterator
	  }

	  getProxyProcessor() {
	    return {
	      get(node, prop) {
	        if (prop === 'proxyOf') {
	          return node
	        } else if (!node[prop]) {
	          return node[prop]
	        } else if (
	          prop === 'each' ||
	          (typeof prop === 'string' && prop.startsWith('walk'))
	        ) {
	          return (...args) => {
	            return node[prop](
	              ...args.map(i => {
	                if (typeof i === 'function') {
	                  return (child, index) => i(child.toProxy(), index)
	                } else {
	                  return i
	                }
	              })
	            )
	          }
	        } else if (prop === 'every' || prop === 'some') {
	          return cb => {
	            return node[prop]((child, ...other) =>
	              cb(child.toProxy(), ...other)
	            )
	          }
	        } else if (prop === 'root') {
	          return () => node.root().toProxy()
	        } else if (prop === 'nodes') {
	          return node.nodes.map(i => i.toProxy())
	        } else if (prop === 'first' || prop === 'last') {
	          return node[prop].toProxy()
	        } else {
	          return node[prop]
	        }
	      },

	      set(node, prop, value) {
	        if (node[prop] === value) return true
	        node[prop] = value;
	        if (prop === 'name' || prop === 'params' || prop === 'selector') {
	          node.markDirty();
	        }
	        return true
	      }
	    }
	  }

	  index(child) {
	    if (typeof child === 'number') return child
	    if (child.proxyOf) child = child.proxyOf;
	    return this.proxyOf.nodes.indexOf(child)
	  }

	  insertAfter(exist, add) {
	    let existIndex = this.index(exist);
	    let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
	    existIndex = this.index(exist);
	    for (let node of nodes) this.proxyOf.nodes.splice(existIndex + 1, 0, node);

	    let index;
	    for (let id in this.indexes) {
	      index = this.indexes[id];
	      if (existIndex < index) {
	        this.indexes[id] = index + nodes.length;
	      }
	    }

	    this.markDirty();

	    return this
	  }

	  insertBefore(exist, add) {
	    let existIndex = this.index(exist);
	    let type = existIndex === 0 ? 'prepend' : false;
	    let nodes = this.normalize(
	      add,
	      this.proxyOf.nodes[existIndex],
	      type
	    ).reverse();
	    existIndex = this.index(exist);
	    for (let node of nodes) this.proxyOf.nodes.splice(existIndex, 0, node);

	    let index;
	    for (let id in this.indexes) {
	      index = this.indexes[id];
	      if (existIndex <= index) {
	        this.indexes[id] = index + nodes.length;
	      }
	    }

	    this.markDirty();

	    return this
	  }

	  normalize(nodes, sample) {
	    if (typeof nodes === 'string') {
	      nodes = cleanSource(parse(nodes).nodes);
	    } else if (typeof nodes === 'undefined') {
	      nodes = [];
	    } else if (Array.isArray(nodes)) {
	      nodes = nodes.slice(0);
	      for (let i of nodes) {
	        if (i.parent) i.parent.removeChild(i, 'ignore');
	      }
	    } else if (nodes.type === 'root' && this.type !== 'document') {
	      nodes = nodes.nodes.slice(0);
	      for (let i of nodes) {
	        if (i.parent) i.parent.removeChild(i, 'ignore');
	      }
	    } else if (nodes.type) {
	      nodes = [nodes];
	    } else if (nodes.prop) {
	      if (typeof nodes.value === 'undefined') {
	        throw new Error('Value field is missed in node creation')
	      } else if (typeof nodes.value !== 'string') {
	        nodes.value = String(nodes.value);
	      }
	      nodes = [new Declaration(nodes)];
	    } else if (nodes.selector || nodes.selectors) {
	      nodes = [new Rule(nodes)];
	    } else if (nodes.name) {
	      nodes = [new AtRule(nodes)];
	    } else if (nodes.text) {
	      nodes = [new Comment(nodes)];
	    } else {
	      throw new Error('Unknown node type in node creation')
	    }

	    let processed = nodes.map(i => {
	      /* c8 ignore next */
	      if (!i[my]) Container.rebuild(i);
	      i = i.proxyOf;
	      if (i.parent) i.parent.removeChild(i);
	      if (i[isClean]) markTreeDirty(i);

	      if (!i.raws) i.raws = {};
	      if (typeof i.raws.before === 'undefined') {
	        if (sample && typeof sample.raws.before !== 'undefined') {
	          i.raws.before = sample.raws.before.replace(/\S/g, '');
	        }
	      }
	      i.parent = this.proxyOf;
	      return i
	    });

	    return processed
	  }

	  prepend(...children) {
	    children = children.reverse();
	    for (let child of children) {
	      let nodes = this.normalize(child, this.first, 'prepend').reverse();
	      for (let node of nodes) this.proxyOf.nodes.unshift(node);
	      for (let id in this.indexes) {
	        this.indexes[id] = this.indexes[id] + nodes.length;
	      }
	    }

	    this.markDirty();

	    return this
	  }

	  push(child) {
	    child.parent = this;
	    this.proxyOf.nodes.push(child);
	    return this
	  }

	  removeAll() {
	    for (let node of this.proxyOf.nodes) node.parent = undefined;
	    this.proxyOf.nodes = [];

	    this.markDirty();

	    return this
	  }

	  removeChild(child) {
	    child = this.index(child);
	    this.proxyOf.nodes[child].parent = undefined;
	    this.proxyOf.nodes.splice(child, 1);

	    let index;
	    for (let id in this.indexes) {
	      index = this.indexes[id];
	      if (index >= child) {
	        this.indexes[id] = index - 1;
	      }
	    }

	    this.markDirty();

	    return this
	  }

	  replaceValues(pattern, opts, callback) {
	    if (!callback) {
	      callback = opts;
	      opts = {};
	    }

	    this.walkDecls(decl => {
	      if (opts.props && !opts.props.includes(decl.prop)) return
	      if (opts.fast && !decl.value.includes(opts.fast)) return

	      decl.value = decl.value.replace(pattern, callback);
	    });

	    this.markDirty();

	    return this
	  }

	  some(condition) {
	    return this.nodes.some(condition)
	  }

	  walk(callback) {
	    return this.each((child, i) => {
	      let result;
	      try {
	        result = callback(child, i);
	      } catch (e) {
	        throw child.addToError(e)
	      }
	      if (result !== false && child.walk) {
	        result = child.walk(callback);
	      }

	      return result
	    })
	  }

	  walkAtRules(name, callback) {
	    if (!callback) {
	      callback = name;
	      return this.walk((child, i) => {
	        if (child.type === 'atrule') {
	          return callback(child, i)
	        }
	      })
	    }
	    if (name instanceof RegExp) {
	      return this.walk((child, i) => {
	        if (child.type === 'atrule' && name.test(child.name)) {
	          return callback(child, i)
	        }
	      })
	    }
	    return this.walk((child, i) => {
	      if (child.type === 'atrule' && child.name === name) {
	        return callback(child, i)
	      }
	    })
	  }

	  walkComments(callback) {
	    return this.walk((child, i) => {
	      if (child.type === 'comment') {
	        return callback(child, i)
	      }
	    })
	  }

	  walkDecls(prop, callback) {
	    if (!callback) {
	      callback = prop;
	      return this.walk((child, i) => {
	        if (child.type === 'decl') {
	          return callback(child, i)
	        }
	      })
	    }
	    if (prop instanceof RegExp) {
	      return this.walk((child, i) => {
	        if (child.type === 'decl' && prop.test(child.prop)) {
	          return callback(child, i)
	        }
	      })
	    }
	    return this.walk((child, i) => {
	      if (child.type === 'decl' && child.prop === prop) {
	        return callback(child, i)
	      }
	    })
	  }

	  walkRules(selector, callback) {
	    if (!callback) {
	      callback = selector;

	      return this.walk((child, i) => {
	        if (child.type === 'rule') {
	          return callback(child, i)
	        }
	      })
	    }
	    if (selector instanceof RegExp) {
	      return this.walk((child, i) => {
	        if (child.type === 'rule' && selector.test(child.selector)) {
	          return callback(child, i)
	        }
	      })
	    }
	    return this.walk((child, i) => {
	      if (child.type === 'rule' && child.selector === selector) {
	        return callback(child, i)
	      }
	    })
	  }
	}

	Container.registerParse = dependant => {
	  parse = dependant;
	};

	Container.registerRule = dependant => {
	  Rule = dependant;
	};

	Container.registerAtRule = dependant => {
	  AtRule = dependant;
	};

	Container.registerRoot = dependant => {
	  Root = dependant;
	};

	container = Container;
	Container.default = Container;

	/* c8 ignore start */
	Container.rebuild = node => {
	  if (node.type === 'atrule') {
	    Object.setPrototypeOf(node, AtRule.prototype);
	  } else if (node.type === 'rule') {
	    Object.setPrototypeOf(node, Rule.prototype);
	  } else if (node.type === 'decl') {
	    Object.setPrototypeOf(node, Declaration.prototype);
	  } else if (node.type === 'comment') {
	    Object.setPrototypeOf(node, Comment.prototype);
	  } else if (node.type === 'root') {
	    Object.setPrototypeOf(node, Root.prototype);
	  }

	  node[my] = true;

	  if (node.nodes) {
	    node.nodes.forEach(child => {
	      Container.rebuild(child);
	    });
	  }
	};
	/* c8 ignore stop */
	return container;
}

var atRule;
var hasRequiredAtRule;

function requireAtRule () {
	if (hasRequiredAtRule) return atRule;
	hasRequiredAtRule = 1;

	let Container = requireContainer();

	class AtRule extends Container {
	  constructor(defaults) {
	    super(defaults);
	    this.type = 'atrule';
	  }

	  append(...children) {
	    if (!this.proxyOf.nodes) this.nodes = [];
	    return super.append(...children)
	  }

	  prepend(...children) {
	    if (!this.proxyOf.nodes) this.nodes = [];
	    return super.prepend(...children)
	  }
	}

	atRule = AtRule;
	AtRule.default = AtRule;

	Container.registerAtRule(AtRule);
	return atRule;
}

var document$1;
var hasRequiredDocument;

function requireDocument () {
	if (hasRequiredDocument) return document$1;
	hasRequiredDocument = 1;

	let Container = requireContainer();

	let LazyResult, Processor;

	class Document extends Container {
	  constructor(defaults) {
	    // type needs to be passed to super, otherwise child roots won't be normalized correctly
	    super({ type: 'document', ...defaults });

	    if (!this.nodes) {
	      this.nodes = [];
	    }
	  }

	  toResult(opts = {}) {
	    let lazy = new LazyResult(new Processor(), this, opts);

	    return lazy.stringify()
	  }
	}

	Document.registerLazyResult = dependant => {
	  LazyResult = dependant;
	};

	Document.registerProcessor = dependant => {
	  Processor = dependant;
	};

	document$1 = Document;
	Document.default = Document;
	return document$1;
}

var nonSecure;
var hasRequiredNonSecure;

function requireNonSecure () {
	if (hasRequiredNonSecure) return nonSecure;
	hasRequiredNonSecure = 1;
	// This alphabet uses `A-Za-z0-9_-` symbols.
	// The order of characters is optimized for better gzip and brotli compression.
	// References to the same file (works both for gzip and brotli):
	// `'use`, `andom`, and `rict'`
	// References to the brotli default dictionary:
	// `-26T`, `1983`, `40px`, `75px`, `bush`, `jack`, `mind`, `very`, and `wolf`
	let urlAlphabet =
	  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

	let customAlphabet = (alphabet, defaultSize = 21) => {
	  return (size = defaultSize) => {
	    let id = '';
	    // A compact alternative for `for (var i = 0; i < step; i++)`.
	    let i = size | 0;
	    while (i--) {
	      // `| 0` is more compact and faster than `Math.floor()`.
	      id += alphabet[(Math.random() * alphabet.length) | 0];
	    }
	    return id
	  }
	};

	let nanoid = (size = 21) => {
	  let id = '';
	  // A compact alternative for `for (var i = 0; i < step; i++)`.
	  let i = size | 0;
	  while (i--) {
	    // `| 0` is more compact and faster than `Math.floor()`.
	    id += urlAlphabet[(Math.random() * 64) | 0];
	  }
	  return id
	};

	nonSecure = { nanoid, customAlphabet };
	return nonSecure;
}

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
function resolve() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : '/';

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
}
// path.normalize(path)
// posix version
function normalize(path) {
  var isPathAbsolute = isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isPathAbsolute).join('/');

  if (!path && !isPathAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isPathAbsolute ? '/' : '') + path;
}
// posix version
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
function join() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
}


// path.relative(from, to)
// posix version
function relative(from, to) {
  from = resolve(from).substr(1);
  to = resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

var sep = '/';
var delimiter$1 = ':';

function dirname(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
}

function basename(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
}


function extname(path) {
  return splitPath(path)[3];
}
var _polyfillNode_path = {
  extname: extname,
  basename: basename,
  dirname: dirname,
  sep: sep,
  delimiter: delimiter$1,
  relative: relative,
  join: join,
  isAbsolute: isAbsolute,
  normalize: normalize,
  resolve: resolve
};
function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b' ?
    function (str, start, len) { return str.substr(start, len) } :
    function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

var _polyfillNode_path$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  basename: basename,
  default: _polyfillNode_path,
  delimiter: delimiter$1,
  dirname: dirname,
  extname: extname,
  isAbsolute: isAbsolute,
  join: join,
  normalize: normalize,
  relative: relative,
  resolve: resolve,
  sep: sep
});

var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_path$1);

/*! https://mths.be/punycode v1.4.1 by @mathias */


/** Highest positive signed 32-bit float value */
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

/** Bootstring parameters */
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\x20-\x7E]/; // unprintable ASCII chars + non-ASCII chars
var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

/** Error messages */
var errors = {
  'overflow': 'Overflow: input needs wider integers to process',
  'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
  'invalid-input': 'Invalid input'
};

/** Convenience shortcuts */
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/*--------------------------------------------------------------------------*/

/**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */
function error(type) {
  throw new RangeError(errors[type]);
}

/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */
function map$1(array, fn) {
  var length = array.length;
  var result = [];
  while (length--) {
    result[length] = fn(array[length]);
  }
  return result;
}

/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */
function mapDomain(string, fn) {
  var parts = string.split('@');
  var result = '';
  if (parts.length > 1) {
    // In email addresses, only the domain name should be punycoded. Leave
    // the local part (i.e. everything up to `@`) intact.
    result = parts[0] + '@';
    string = parts[1];
  }
  // Avoid `split(regex)` for IE8 compatibility. See #17.
  string = string.replace(regexSeparators, '\x2E');
  var labels = string.split('.');
  var encoded = map$1(labels, fn).join('.');
  return result + encoded;
}

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */
function ucs2decode(string) {
  var output = [],
    counter = 0,
    length = string.length,
    value,
    extra;
  while (counter < length) {
    value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // high surrogate, and there is a next character
      extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // low surrogate
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // unmatched surrogate; only append this code unit, in case the next
        // code unit is the high surrogate of a surrogate pair
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
}

/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */
function digitToBasic(digit, flag) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
}

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */
function adapt(delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  for ( /* no initialization */ ; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
}

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */
function encode(input) {
  var n,
    delta,
    handledCPCount,
    basicLength,
    bias,
    j,
    m,
    q,
    k,
    t,
    currentValue,
    output = [],
    /** `inputLength` will hold the number of code points in `input`. */
    inputLength,
    /** Cached calculation results */
    handledCPCountPlusOne,
    baseMinusT,
    qMinusT;

  // Convert the input in UCS-2 to Unicode
  input = ucs2decode(input);

  // Cache the length
  inputLength = input.length;

  // Initialize the state
  n = initialN;
  delta = 0;
  bias = initialBias;

  // Handle the basic code points
  for (j = 0; j < inputLength; ++j) {
    currentValue = input[j];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  handledCPCount = basicLength = output.length;

  // `handledCPCount` is the number of code points that have been handled;
  // `basicLength` is the number of basic code points.

  // Finish the basic string - if it is not empty - with a delimiter
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {

    // All non-basic code points < n have been handled already. Find the next
    // larger one:
    for (m = maxInt, j = 0; j < inputLength; ++j) {
      currentValue = input[j];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
    // but guard against overflow
    handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      error('overflow');
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (j = 0; j < inputLength; ++j) {
      currentValue = input[j];

      if (currentValue < n && ++delta > maxInt) {
        error('overflow');
      }

      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer
        for (q = delta, k = base; /* no condition */ ; k += base) {
          t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) {
            break;
          }
          qMinusT = q - t;
          baseMinusT = base - t;
          output.push(
            stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
          );
          q = floor(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q, 0)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;

  }
  return output.join('');
}

/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */
function toASCII(input) {
  return mapDomain(input, function(string) {
    return regexNonASCII.test(string) ?
      'xn--' + encode(string) :
      string;
  });
}

function isNull(arg) {
  return arg === null;
}

function isNullOrUndefined(arg) {
  return arg == null;
}

function isString(arg) {
  return typeof arg === 'string';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.


// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};
function stringifyPrimitive(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
}

function stringify (obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
}
function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

function parse$1(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
}

// WHATWG API
const URL$1 = global$2.URL;
const URLSearchParams$1 = global$2.URLSearchParams;
var _polyfillNode_url = {
  parse: urlParse,
  resolve: urlResolve,
  resolveObject: urlResolveObject,
  fileURLToPath: urlFileURLToPath,
  format: urlFormat,
  Url: Url,

  // WHATWG API
  URL: URL$1,
  URLSearchParams: URLSearchParams$1,  
};
function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,

  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

  // RFC 2396: characters reserved for delimiting URLs.
  // We actually just auto-escape these.
  delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

  // RFC 2396: characters not allowed for various reasons.
  unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  // Characters that are never ever allowed in a hostname.
  // Note that any invalid chars are also handled, but these
  // are the ones that are *expected* to be seen, so we fast-path
  // them.
  nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
  hostEndingChars = ['/', '?', '#'],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    'javascript': true,
    'javascript:': true
  },
  // protocols that never have a hostname.
  hostlessProtocol = {
    'javascript': true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  };

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  return parse(this, url, parseQueryString, slashesDenoteHost);
};

function parse(self, url, parseQueryString, slashesDenoteHost) {
  if (!isString(url)) {
    throw new TypeError('Parameter \'url\' must be a string, not ' + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
    splitter =
    (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
    uSplit = url.split(splitter),
    slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      self.path = rest;
      self.href = rest;
      self.pathname = simplePath[1];
      if (simplePath[2]) {
        self.search = simplePath[2];
        if (parseQueryString) {
          self.query = parse$1(self.search.substr(1));
        } else {
          self.query = self.search.substr(1);
        }
      } else if (parseQueryString) {
        self.search = '';
        self.query = {};
      }
      return self;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    self.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      self.slashes = true;
    }
  }
  var i, hec, l, p;
  if (!hostlessProtocol[proto] &&
    (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (i = 0; i < hostEndingChars.length; i++) {
      hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      self.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (i = 0; i < nonHostChars.length; i++) {
      hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    self.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    parseHost(self);

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    self.hostname = self.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = self.hostname[0] === '[' &&
      self.hostname[self.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = self.hostname.split(/\./);
      for (i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            self.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (self.hostname.length > hostnameMaxLen) {
      self.hostname = '';
    } else {
      // hostnames are always lower case.
      self.hostname = self.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      self.hostname = toASCII(self.hostname);
    }

    p = self.port ? ':' + self.port : '';
    var h = self.hostname || '';
    self.host = h + p;
    self.href += self.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      self.hostname = self.hostname.substr(1, self.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    self.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    self.search = rest.substr(qm);
    self.query = rest.substr(qm + 1);
    if (parseQueryString) {
      self.query = parse$1(self.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    self.search = '';
    self.query = {};
  }
  if (rest) self.pathname = rest;
  if (slashedProtocol[lowerProto] &&
    self.hostname && !self.pathname) {
    self.pathname = '/';
  }

  //to support http.request
  if (self.pathname || self.search) {
    p = self.pathname || '';
    var s = self.search || '';
    self.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  self.href = format(self);
  return self;
}

function urlFileURLToPath(path) {
  if (typeof path === 'string')
    path = new Url().parse(path);
  else if (!(path instanceof Url))
    throw new TypeError('The "path" argument must be of type string or an instance of URL. Received type ' + (typeof path) + String(path));
  if (path.protocol !== 'file:')
    throw new TypeError('The URL must be of scheme file');
  return getPathFromURLPosix(path);
}

function getPathFromURLPosix(url) {
  const pathname = url.pathname;
  for (let n = 0; n < pathname.length; n++) {
    if (pathname[n] === '%') {
      const third = pathname.codePointAt(n + 2) | 0x20;
      if (pathname[n + 1] === '2' && third === 102) {
        throw new TypeError(
          'must not include encoded / characters'
        );
      }
    }
  }
  return decodeURIComponent(pathname);
}

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (isString(obj)) obj = parse({}, obj);
  return format(obj);
}

function format(self) {
  var auth = self.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = self.protocol || '',
    pathname = self.pathname || '',
    hash = self.hash || '',
    host = false,
    query = '';

  if (self.host) {
    host = auth + self.host;
  } else if (self.hostname) {
    host = auth + (self.hostname.indexOf(':') === -1 ?
      self.hostname :
      '[' + this.hostname + ']');
    if (self.port) {
      host += ':' + self.port;
    }
  }

  if (self.query &&
    isObject(self.query) &&
    Object.keys(self.query).length) {
    query = stringify(self.query);
  }

  var search = self.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (self.slashes ||
    (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
}

Url.prototype.format = function() {
  return format(this);
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
      result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }
  var relPath;
  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
    isRelAbs = (
      relative.host ||
      relative.pathname && relative.pathname.charAt(0) === '/'
    ),
    mustEndAbs = (isRelAbs || isSourceAbs ||
      (result.host && relative.pathname)),
    removeAllDots = mustEndAbs,
    srcPath = result.pathname && result.pathname.split('/') || [],
    psychotic = result.protocol && !slashedProtocol[result.protocol];
  relPath = relative.pathname && relative.pathname.split('/') || [];
  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }
  var authInHost;
  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
      relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      authInHost = result.host && result.host.indexOf('@') > 0 ?
        result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!isNull(result.pathname) || !isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
        (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
    (result.host || relative.host || srcPath.length > 1) &&
    (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
    (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
    (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
      srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    authInHost = result.host && result.host.indexOf('@') > 0 ?
      result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!isNull(result.pathname) || !isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
      (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  return parseHost(this);
};

function parseHost(self) {
  var host = self.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      self.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) self.hostname = host;
}

var _polyfillNode_url$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  URL: URL$1,
  URLSearchParams: URLSearchParams$1,
  Url: Url,
  default: _polyfillNode_url,
  fileURLToPath: urlFileURLToPath,
  format: urlFormat,
  parse: urlParse,
  resolve: urlResolve,
  resolveObject: urlResolveObject
});

var require$$2 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_url$1);

var _polyfillNode_fs = {};

var _polyfillNode_fs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: _polyfillNode_fs
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_fs$1);

var previousMap;
var hasRequiredPreviousMap;

function requirePreviousMap () {
	if (hasRequiredPreviousMap) return previousMap;
	hasRequiredPreviousMap = 1;

	let { existsSync, readFileSync } = require$$0;
	let { dirname, join } = require$$0$1;
	let { SourceMapConsumer, SourceMapGenerator } = require$$1;

	function fromBase64(str) {
	  if (Buffer) {
	    return Buffer.from(str, 'base64').toString()
	  } else {
	    /* c8 ignore next 2 */
	    return window.atob(str)
	  }
	}

	class PreviousMap {
	  constructor(css, opts) {
	    if (opts.map === false) return
	    this.loadAnnotation(css);
	    this.inline = this.startWith(this.annotation, 'data:');

	    let prev = opts.map ? opts.map.prev : undefined;
	    let text = this.loadMap(opts.from, prev);
	    if (!this.mapFile && opts.from) {
	      this.mapFile = opts.from;
	    }
	    if (this.mapFile) this.root = dirname(this.mapFile);
	    if (text) this.text = text;
	  }

	  consumer() {
	    if (!this.consumerCache) {
	      this.consumerCache = new SourceMapConsumer(this.text);
	    }
	    return this.consumerCache
	  }

	  decodeInline(text) {
	    let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
	    let baseUri = /^data:application\/json;base64,/;
	    let charsetUri = /^data:application\/json;charset=utf-?8,/;
	    let uri = /^data:application\/json,/;

	    let uriMatch = text.match(charsetUri) || text.match(uri);
	    if (uriMatch) {
	      return decodeURIComponent(text.substr(uriMatch[0].length))
	    }

	    let baseUriMatch = text.match(baseCharsetUri) || text.match(baseUri);
	    if (baseUriMatch) {
	      return fromBase64(text.substr(baseUriMatch[0].length))
	    }

	    let encoding = text.match(/data:application\/json;([^,]+),/)[1];
	    throw new Error('Unsupported source map encoding ' + encoding)
	  }

	  getAnnotationURL(sourceMapString) {
	    return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, '').trim()
	  }

	  isMap(map) {
	    if (typeof map !== 'object') return false
	    return (
	      typeof map.mappings === 'string' ||
	      typeof map._mappings === 'string' ||
	      Array.isArray(map.sections)
	    )
	  }

	  loadAnnotation(css) {
	    let comments = css.match(/\/\*\s*# sourceMappingURL=/g);
	    if (!comments) return

	    // sourceMappingURLs from comments, strings, etc.
	    let start = css.lastIndexOf(comments.pop());
	    let end = css.indexOf('*/', start);

	    if (start > -1 && end > -1) {
	      // Locate the last sourceMappingURL to avoid pickin
	      this.annotation = this.getAnnotationURL(css.substring(start, end));
	    }
	  }

	  loadFile(path) {
	    this.root = dirname(path);
	    if (existsSync(path)) {
	      this.mapFile = path;
	      return readFileSync(path, 'utf-8').toString().trim()
	    }
	  }

	  loadMap(file, prev) {
	    if (prev === false) return false

	    if (prev) {
	      if (typeof prev === 'string') {
	        return prev
	      } else if (typeof prev === 'function') {
	        let prevPath = prev(file);
	        if (prevPath) {
	          let map = this.loadFile(prevPath);
	          if (!map) {
	            throw new Error(
	              'Unable to load previous source map: ' + prevPath.toString()
	            )
	          }
	          return map
	        }
	      } else if (prev instanceof SourceMapConsumer) {
	        return SourceMapGenerator.fromSourceMap(prev).toString()
	      } else if (prev instanceof SourceMapGenerator) {
	        return prev.toString()
	      } else if (this.isMap(prev)) {
	        return JSON.stringify(prev)
	      } else {
	        throw new Error(
	          'Unsupported previous source map format: ' + prev.toString()
	        )
	      }
	    } else if (this.inline) {
	      return this.decodeInline(this.annotation)
	    } else if (this.annotation) {
	      let map = this.annotation;
	      if (file) map = join(dirname(file), map);
	      return this.loadFile(map)
	    }
	  }

	  startWith(string, start) {
	    if (!string) return false
	    return string.substr(0, start.length) === start
	  }

	  withContent() {
	    return !!(
	      this.consumer().sourcesContent &&
	      this.consumer().sourcesContent.length > 0
	    )
	  }
	}

	previousMap = PreviousMap;
	PreviousMap.default = PreviousMap;
	return previousMap;
}

var input;
var hasRequiredInput;

function requireInput () {
	if (hasRequiredInput) return input;
	hasRequiredInput = 1;

	let { nanoid } = /*@__PURE__*/ requireNonSecure();
	let { isAbsolute, resolve } = require$$0$1;
	let { SourceMapConsumer, SourceMapGenerator } = require$$1;
	let { fileURLToPath, pathToFileURL } = require$$2;

	let CssSyntaxError = requireCssSyntaxError();
	let PreviousMap = requirePreviousMap();
	let terminalHighlight = require$$1;

	let lineToIndexCache = Symbol('lineToIndexCache');

	let sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
	let pathAvailable = Boolean(resolve && isAbsolute);

	function getLineToIndex(input) {
	  if (input[lineToIndexCache]) return input[lineToIndexCache]
	  let lines = input.css.split('\n');
	  let lineToIndex = new Array(lines.length);
	  let prevIndex = 0;

	  for (let i = 0, l = lines.length; i < l; i++) {
	    lineToIndex[i] = prevIndex;
	    prevIndex += lines[i].length + 1;
	  }

	  input[lineToIndexCache] = lineToIndex;
	  return lineToIndex
	}

	class Input {
	  get from() {
	    return this.file || this.id
	  }

	  constructor(css, opts = {}) {
	    if (
	      css === null ||
	      typeof css === 'undefined' ||
	      (typeof css === 'object' && !css.toString)
	    ) {
	      throw new Error(`PostCSS received ${css} instead of CSS string`)
	    }

	    this.css = css.toString();

	    if (this.css[0] === '\uFEFF' || this.css[0] === '\uFFFE') {
	      this.hasBOM = true;
	      this.css = this.css.slice(1);
	    } else {
	      this.hasBOM = false;
	    }

	    this.document = this.css;
	    if (opts.document) this.document = opts.document.toString();

	    if (opts.from) {
	      if (
	        !pathAvailable ||
	        /^\w+:\/\//.test(opts.from) ||
	        isAbsolute(opts.from)
	      ) {
	        this.file = opts.from;
	      } else {
	        this.file = resolve(opts.from);
	      }
	    }

	    if (pathAvailable && sourceMapAvailable) {
	      let map = new PreviousMap(this.css, opts);
	      if (map.text) {
	        this.map = map;
	        let file = map.consumer().file;
	        if (!this.file && file) this.file = this.mapResolve(file);
	      }
	    }

	    if (!this.file) {
	      this.id = '<input css ' + nanoid(6) + '>';
	    }
	    if (this.map) this.map.file = this.from;
	  }

	  error(message, line, column, opts = {}) {
	    let endColumn, endLine, endOffset, offset, result;

	    if (line && typeof line === 'object') {
	      let start = line;
	      let end = column;
	      if (typeof start.offset === 'number') {
	        offset = start.offset;
	        let pos = this.fromOffset(offset);
	        line = pos.line;
	        column = pos.col;
	      } else {
	        line = start.line;
	        column = start.column;
	        offset = this.fromLineAndColumn(line, column);
	      }
	      if (typeof end.offset === 'number') {
	        endOffset = end.offset;
	        let pos = this.fromOffset(endOffset);
	        endLine = pos.line;
	        endColumn = pos.col;
	      } else {
	        endLine = end.line;
	        endColumn = end.column;
	        endOffset = this.fromLineAndColumn(end.line, end.column);
	      }
	    } else if (!column) {
	      offset = line;
	      let pos = this.fromOffset(offset);
	      line = pos.line;
	      column = pos.col;
	    } else {
	      offset = this.fromLineAndColumn(line, column);
	    }

	    let origin = this.origin(line, column, endLine, endColumn);
	    if (origin) {
	      result = new CssSyntaxError(
	        message,
	        origin.endLine === undefined
	          ? origin.line
	          : { column: origin.column, line: origin.line },
	        origin.endLine === undefined
	          ? origin.column
	          : { column: origin.endColumn, line: origin.endLine },
	        origin.source,
	        origin.file,
	        opts.plugin
	      );
	    } else {
	      result = new CssSyntaxError(
	        message,
	        endLine === undefined ? line : { column, line },
	        endLine === undefined ? column : { column: endColumn, line: endLine },
	        this.css,
	        this.file,
	        opts.plugin
	      );
	    }

	    result.input = { column, endColumn, endLine, endOffset, line, offset, source: this.css };
	    if (this.file) {
	      if (pathToFileURL) {
	        result.input.url = pathToFileURL(this.file).toString();
	      }
	      result.input.file = this.file;
	    }

	    return result
	  }

	  fromLineAndColumn(line, column) {
	    let lineToIndex = getLineToIndex(this);
	    let index = lineToIndex[line - 1];
	    return index + column - 1
	  }

	  fromOffset(offset) {
	    let lineToIndex = getLineToIndex(this);
	    let lastLine = lineToIndex[lineToIndex.length - 1];

	    let min = 0;
	    if (offset >= lastLine) {
	      min = lineToIndex.length - 1;
	    } else {
	      let max = lineToIndex.length - 2;
	      let mid;
	      while (min < max) {
	        mid = min + ((max - min) >> 1);
	        if (offset < lineToIndex[mid]) {
	          max = mid - 1;
	        } else if (offset >= lineToIndex[mid + 1]) {
	          min = mid + 1;
	        } else {
	          min = mid;
	          break
	        }
	      }
	    }
	    return {
	      col: offset - lineToIndex[min] + 1,
	      line: min + 1
	    }
	  }

	  mapResolve(file) {
	    if (/^\w+:\/\//.test(file)) {
	      return file
	    }
	    return resolve(this.map.consumer().sourceRoot || this.map.root || '.', file)
	  }

	  origin(line, column, endLine, endColumn) {
	    if (!this.map) return false
	    let consumer = this.map.consumer();

	    let from = consumer.originalPositionFor({ column, line });
	    if (!from.source) return false

	    let to;
	    if (typeof endLine === 'number') {
	      to = consumer.originalPositionFor({ column: endColumn, line: endLine });
	    }

	    let fromUrl;

	    if (isAbsolute(from.source)) {
	      fromUrl = pathToFileURL(from.source);
	    } else {
	      fromUrl = new URL(
	        from.source,
	        this.map.consumer().sourceRoot || pathToFileURL(this.map.mapFile)
	      );
	    }

	    let result = {
	      column: from.column,
	      endColumn: to && to.column,
	      endLine: to && to.line,
	      line: from.line,
	      url: fromUrl.toString()
	    };

	    if (fromUrl.protocol === 'file:') {
	      if (fileURLToPath) {
	        result.file = fileURLToPath(fromUrl);
	      } else {
	        /* c8 ignore next 2 */
	        throw new Error(`file: protocol is not available in this PostCSS build`)
	      }
	    }

	    let source = consumer.sourceContentFor(from.source);
	    if (source) result.source = source;

	    return result
	  }

	  toJSON() {
	    let json = {};
	    for (let name of ['hasBOM', 'css', 'file', 'id']) {
	      if (this[name] != null) {
	        json[name] = this[name];
	      }
	    }
	    if (this.map) {
	      json.map = { ...this.map };
	      if (json.map.consumerCache) {
	        json.map.consumerCache = undefined;
	      }
	    }
	    return json
	  }
	}

	input = Input;
	Input.default = Input;

	if (terminalHighlight && terminalHighlight.registerInput) {
	  terminalHighlight.registerInput(Input);
	}
	return input;
}

var root;
var hasRequiredRoot;

function requireRoot () {
	if (hasRequiredRoot) return root;
	hasRequiredRoot = 1;

	let Container = requireContainer();

	let LazyResult, Processor;

	class Root extends Container {
	  constructor(defaults) {
	    super(defaults);
	    this.type = 'root';
	    if (!this.nodes) this.nodes = [];
	  }

	  normalize(child, sample, type) {
	    let nodes = super.normalize(child);

	    if (sample) {
	      if (type === 'prepend') {
	        if (this.nodes.length > 1) {
	          sample.raws.before = this.nodes[1].raws.before;
	        } else {
	          delete sample.raws.before;
	        }
	      } else if (this.first !== sample) {
	        for (let node of nodes) {
	          node.raws.before = sample.raws.before;
	        }
	      }
	    }

	    return nodes
	  }

	  removeChild(child, ignore) {
	    let index = this.index(child);

	    if (!ignore && index === 0 && this.nodes.length > 1) {
	      this.nodes[1].raws.before = this.nodes[index].raws.before;
	    }

	    return super.removeChild(child)
	  }

	  toResult(opts = {}) {
	    let lazy = new LazyResult(new Processor(), this, opts);
	    return lazy.stringify()
	  }
	}

	Root.registerLazyResult = dependant => {
	  LazyResult = dependant;
	};

	Root.registerProcessor = dependant => {
	  Processor = dependant;
	};

	root = Root;
	Root.default = Root;

	Container.registerRoot(Root);
	return root;
}

var list_1;
var hasRequiredList;

function requireList () {
	if (hasRequiredList) return list_1;
	hasRequiredList = 1;

	let list = {
	  comma(string) {
	    return list.split(string, [','], true)
	  },

	  space(string) {
	    let spaces = [' ', '\n', '\t'];
	    return list.split(string, spaces)
	  },

	  split(string, separators, last) {
	    let array = [];
	    let current = '';
	    let split = false;

	    let func = 0;
	    let inQuote = false;
	    let prevQuote = '';
	    let escape = false;

	    for (let letter of string) {
	      if (escape) {
	        escape = false;
	      } else if (letter === '\\') {
	        escape = true;
	      } else if (inQuote) {
	        if (letter === prevQuote) {
	          inQuote = false;
	        }
	      } else if (letter === '"' || letter === "'") {
	        inQuote = true;
	        prevQuote = letter;
	      } else if (letter === '(') {
	        func += 1;
	      } else if (letter === ')') {
	        if (func > 0) func -= 1;
	      } else if (func === 0) {
	        if (separators.includes(letter)) split = true;
	      }

	      if (split) {
	        if (current !== '') array.push(current.trim());
	        current = '';
	        split = false;
	      } else {
	        current += letter;
	      }
	    }

	    if (last || current !== '') array.push(current.trim());
	    return array
	  }
	};

	list_1 = list;
	list.default = list;
	return list_1;
}

var rule;
var hasRequiredRule;

function requireRule () {
	if (hasRequiredRule) return rule;
	hasRequiredRule = 1;

	let Container = requireContainer();
	let list = requireList();

	class Rule extends Container {
	  get selectors() {
	    return list.comma(this.selector)
	  }

	  set selectors(values) {
	    let match = this.selector ? this.selector.match(/,\s*/) : null;
	    let sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
	    this.selector = values.join(sep);
	  }

	  constructor(defaults) {
	    super(defaults);
	    this.type = 'rule';
	    if (!this.nodes) this.nodes = [];
	  }
	}

	rule = Rule;
	Rule.default = Rule;

	Container.registerRule(Rule);
	return rule;
}

var fromJSON_1;
var hasRequiredFromJSON;

function requireFromJSON () {
	if (hasRequiredFromJSON) return fromJSON_1;
	hasRequiredFromJSON = 1;

	let AtRule = requireAtRule();
	let Comment = requireComment();
	let Declaration = requireDeclaration();
	let Input = requireInput();
	let PreviousMap = requirePreviousMap();
	let Root = requireRoot();
	let Rule = requireRule();

	function fromJSON(json, inputs) {
	  if (Array.isArray(json)) return json.map(n => fromJSON(n))

	  let { inputs: ownInputs, ...defaults } = json;
	  if (ownInputs) {
	    inputs = [];
	    for (let input of ownInputs) {
	      let inputHydrated = { ...input, __proto__: Input.prototype };
	      if (inputHydrated.map) {
	        inputHydrated.map = {
	          ...inputHydrated.map,
	          __proto__: PreviousMap.prototype
	        };
	      }
	      inputs.push(inputHydrated);
	    }
	  }
	  if (defaults.nodes) {
	    defaults.nodes = json.nodes.map(n => fromJSON(n, inputs));
	  }
	  if (defaults.source) {
	    let { inputId, ...source } = defaults.source;
	    defaults.source = source;
	    if (inputId != null) {
	      defaults.source.input = inputs[inputId];
	    }
	  }
	  if (defaults.type === 'root') {
	    return new Root(defaults)
	  } else if (defaults.type === 'decl') {
	    return new Declaration(defaults)
	  } else if (defaults.type === 'rule') {
	    return new Rule(defaults)
	  } else if (defaults.type === 'comment') {
	    return new Comment(defaults)
	  } else if (defaults.type === 'atrule') {
	    return new AtRule(defaults)
	  } else {
	    throw new Error('Unknown node type: ' + json.type)
	  }
	}

	fromJSON_1 = fromJSON;
	fromJSON.default = fromJSON;
	return fromJSON_1;
}

var mapGenerator;
var hasRequiredMapGenerator;

function requireMapGenerator () {
	if (hasRequiredMapGenerator) return mapGenerator;
	hasRequiredMapGenerator = 1;

	let { dirname, relative, resolve, sep } = require$$0$1;
	let { SourceMapConsumer, SourceMapGenerator } = require$$1;
	let { pathToFileURL } = require$$2;

	let Input = requireInput();

	let sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
	let pathAvailable = Boolean(dirname && resolve && relative && sep);

	class MapGenerator {
	  constructor(stringify, root, opts, cssString) {
	    this.stringify = stringify;
	    this.mapOpts = opts.map || {};
	    this.root = root;
	    this.opts = opts;
	    this.css = cssString;
	    this.originalCSS = cssString;
	    this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;

	    this.memoizedFileURLs = new Map();
	    this.memoizedPaths = new Map();
	    this.memoizedURLs = new Map();
	  }

	  addAnnotation() {
	    let content;

	    if (this.isInline()) {
	      content =
	        'data:application/json;base64,' + this.toBase64(this.map.toString());
	    } else if (typeof this.mapOpts.annotation === 'string') {
	      content = this.mapOpts.annotation;
	    } else if (typeof this.mapOpts.annotation === 'function') {
	      content = this.mapOpts.annotation(this.opts.to, this.root);
	    } else {
	      content = this.outputFile() + '.map';
	    }
	    let eol = '\n';
	    if (this.css.includes('\r\n')) eol = '\r\n';

	    this.css += eol + '/*# sourceMappingURL=' + content + ' */';
	  }

	  applyPrevMaps() {
	    for (let prev of this.previous()) {
	      let from = this.toUrl(this.path(prev.file));
	      let root = prev.root || dirname(prev.file);
	      let map;

	      if (this.mapOpts.sourcesContent === false) {
	        map = new SourceMapConsumer(prev.text);
	        if (map.sourcesContent) {
	          map.sourcesContent = null;
	        }
	      } else {
	        map = prev.consumer();
	      }

	      this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
	    }
	  }

	  clearAnnotation() {
	    if (this.mapOpts.annotation === false) return

	    if (this.root) {
	      let node;
	      for (let i = this.root.nodes.length - 1; i >= 0; i--) {
	        node = this.root.nodes[i];
	        if (node.type !== 'comment') continue
	        if (node.text.startsWith('# sourceMappingURL=')) {
	          this.root.removeChild(i);
	        }
	      }
	    } else if (this.css) {
	      this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, '');
	    }
	  }

	  generate() {
	    this.clearAnnotation();
	    if (pathAvailable && sourceMapAvailable && this.isMap()) {
	      return this.generateMap()
	    } else {
	      let result = '';
	      this.stringify(this.root, i => {
	        result += i;
	      });
	      return [result]
	    }
	  }

	  generateMap() {
	    if (this.root) {
	      this.generateString();
	    } else if (this.previous().length === 1) {
	      let prev = this.previous()[0].consumer();
	      prev.file = this.outputFile();
	      this.map = SourceMapGenerator.fromSourceMap(prev, {
	        ignoreInvalidMapping: true
	      });
	    } else {
	      this.map = new SourceMapGenerator({
	        file: this.outputFile(),
	        ignoreInvalidMapping: true
	      });
	      this.map.addMapping({
	        generated: { column: 0, line: 1 },
	        original: { column: 0, line: 1 },
	        source: this.opts.from
	          ? this.toUrl(this.path(this.opts.from))
	          : '<no source>'
	      });
	    }

	    if (this.isSourcesContent()) this.setSourcesContent();
	    if (this.root && this.previous().length > 0) this.applyPrevMaps();
	    if (this.isAnnotation()) this.addAnnotation();

	    if (this.isInline()) {
	      return [this.css]
	    } else {
	      return [this.css, this.map]
	    }
	  }

	  generateString() {
	    this.css = '';
	    this.map = new SourceMapGenerator({
	      file: this.outputFile(),
	      ignoreInvalidMapping: true
	    });

	    let line = 1;
	    let column = 1;

	    let noSource = '<no source>';
	    let mapping = {
	      generated: { column: 0, line: 0 },
	      original: { column: 0, line: 0 },
	      source: ''
	    };

	    let last, lines;
	    this.stringify(this.root, (str, node, type) => {
	      this.css += str;

	      if (node && type !== 'end') {
	        mapping.generated.line = line;
	        mapping.generated.column = column - 1;
	        if (node.source && node.source.start) {
	          mapping.source = this.sourcePath(node);
	          mapping.original.line = node.source.start.line;
	          mapping.original.column = node.source.start.column - 1;
	          this.map.addMapping(mapping);
	        } else {
	          mapping.source = noSource;
	          mapping.original.line = 1;
	          mapping.original.column = 0;
	          this.map.addMapping(mapping);
	        }
	      }

	      lines = str.match(/\n/g);
	      if (lines) {
	        line += lines.length;
	        last = str.lastIndexOf('\n');
	        column = str.length - last;
	      } else {
	        column += str.length;
	      }

	      if (node && type !== 'start') {
	        let p = node.parent || { raws: {} };
	        let childless =
	          node.type === 'decl' || (node.type === 'atrule' && !node.nodes);
	        if (!childless || node !== p.last || p.raws.semicolon) {
	          if (node.source && node.source.end) {
	            mapping.source = this.sourcePath(node);
	            mapping.original.line = node.source.end.line;
	            mapping.original.column = node.source.end.column - 1;
	            mapping.generated.line = line;
	            mapping.generated.column = column - 2;
	            this.map.addMapping(mapping);
	          } else {
	            mapping.source = noSource;
	            mapping.original.line = 1;
	            mapping.original.column = 0;
	            mapping.generated.line = line;
	            mapping.generated.column = column - 1;
	            this.map.addMapping(mapping);
	          }
	        }
	      }
	    });
	  }

	  isAnnotation() {
	    if (this.isInline()) {
	      return true
	    }
	    if (typeof this.mapOpts.annotation !== 'undefined') {
	      return this.mapOpts.annotation
	    }
	    if (this.previous().length) {
	      return this.previous().some(i => i.annotation)
	    }
	    return true
	  }

	  isInline() {
	    if (typeof this.mapOpts.inline !== 'undefined') {
	      return this.mapOpts.inline
	    }

	    let annotation = this.mapOpts.annotation;
	    if (typeof annotation !== 'undefined' && annotation !== true) {
	      return false
	    }

	    if (this.previous().length) {
	      return this.previous().some(i => i.inline)
	    }
	    return true
	  }

	  isMap() {
	    if (typeof this.opts.map !== 'undefined') {
	      return !!this.opts.map
	    }
	    return this.previous().length > 0
	  }

	  isSourcesContent() {
	    if (typeof this.mapOpts.sourcesContent !== 'undefined') {
	      return this.mapOpts.sourcesContent
	    }
	    if (this.previous().length) {
	      return this.previous().some(i => i.withContent())
	    }
	    return true
	  }

	  outputFile() {
	    if (this.opts.to) {
	      return this.path(this.opts.to)
	    } else if (this.opts.from) {
	      return this.path(this.opts.from)
	    } else {
	      return 'to.css'
	    }
	  }

	  path(file) {
	    if (this.mapOpts.absolute) return file
	    if (file.charCodeAt(0) === 60 /* `<` */) return file
	    if (/^\w+:\/\//.test(file)) return file
	    let cached = this.memoizedPaths.get(file);
	    if (cached) return cached

	    let from = this.opts.to ? dirname(this.opts.to) : '.';

	    if (typeof this.mapOpts.annotation === 'string') {
	      from = dirname(resolve(from, this.mapOpts.annotation));
	    }

	    let path = relative(from, file);
	    this.memoizedPaths.set(file, path);

	    return path
	  }

	  previous() {
	    if (!this.previousMaps) {
	      this.previousMaps = [];
	      if (this.root) {
	        this.root.walk(node => {
	          if (node.source && node.source.input.map) {
	            let map = node.source.input.map;
	            if (!this.previousMaps.includes(map)) {
	              this.previousMaps.push(map);
	            }
	          }
	        });
	      } else {
	        let input = new Input(this.originalCSS, this.opts);
	        if (input.map) this.previousMaps.push(input.map);
	      }
	    }

	    return this.previousMaps
	  }

	  setSourcesContent() {
	    let already = {};
	    if (this.root) {
	      this.root.walk(node => {
	        if (node.source) {
	          let from = node.source.input.from;
	          if (from && !already[from]) {
	            already[from] = true;
	            let fromUrl = this.usesFileUrls
	              ? this.toFileUrl(from)
	              : this.toUrl(this.path(from));
	            this.map.setSourceContent(fromUrl, node.source.input.css);
	          }
	        }
	      });
	    } else if (this.css) {
	      let from = this.opts.from
	        ? this.toUrl(this.path(this.opts.from))
	        : '<no source>';
	      this.map.setSourceContent(from, this.css);
	    }
	  }

	  sourcePath(node) {
	    if (this.mapOpts.from) {
	      return this.toUrl(this.mapOpts.from)
	    } else if (this.usesFileUrls) {
	      return this.toFileUrl(node.source.input.from)
	    } else {
	      return this.toUrl(this.path(node.source.input.from))
	    }
	  }

	  toBase64(str) {
	    if (Buffer) {
	      return Buffer.from(str).toString('base64')
	    } else {
	      return window.btoa(unescape(encodeURIComponent(str)))
	    }
	  }

	  toFileUrl(path) {
	    let cached = this.memoizedFileURLs.get(path);
	    if (cached) return cached

	    if (pathToFileURL) {
	      let fileURL = pathToFileURL(path).toString();
	      this.memoizedFileURLs.set(path, fileURL);

	      return fileURL
	    } else {
	      throw new Error(
	        '`map.absolute` option is not available in this PostCSS build'
	      )
	    }
	  }

	  toUrl(path) {
	    let cached = this.memoizedURLs.get(path);
	    if (cached) return cached

	    if (sep === '\\') {
	      path = path.replace(/\\/g, '/');
	    }

	    let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
	    this.memoizedURLs.set(path, url);

	    return url
	  }
	}

	mapGenerator = MapGenerator;
	return mapGenerator;
}

var tokenize;
var hasRequiredTokenize;

function requireTokenize () {
	if (hasRequiredTokenize) return tokenize;
	hasRequiredTokenize = 1;

	const SINGLE_QUOTE = "'".charCodeAt(0);
	const DOUBLE_QUOTE = '"'.charCodeAt(0);
	const BACKSLASH = '\\'.charCodeAt(0);
	const SLASH = '/'.charCodeAt(0);
	const NEWLINE = '\n'.charCodeAt(0);
	const SPACE = ' '.charCodeAt(0);
	const FEED = '\f'.charCodeAt(0);
	const TAB = '\t'.charCodeAt(0);
	const CR = '\r'.charCodeAt(0);
	const OPEN_SQUARE = '['.charCodeAt(0);
	const CLOSE_SQUARE = ']'.charCodeAt(0);
	const OPEN_PARENTHESES = '('.charCodeAt(0);
	const CLOSE_PARENTHESES = ')'.charCodeAt(0);
	const OPEN_CURLY = '{'.charCodeAt(0);
	const CLOSE_CURLY = '}'.charCodeAt(0);
	const SEMICOLON = ';'.charCodeAt(0);
	const ASTERISK = '*'.charCodeAt(0);
	const COLON = ':'.charCodeAt(0);
	const AT = '@'.charCodeAt(0);

	const RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
	const RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
	const RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
	const RE_HEX_ESCAPE = /[\da-f]/i;

	tokenize = function tokenizer(input, options = {}) {
	  let css = input.css.valueOf();
	  let ignore = options.ignoreErrors;

	  let code, content, escape, next, quote;
	  let currentToken, escaped, escapePos, n, prev;

	  let length = css.length;
	  let pos = 0;
	  let buffer = [];
	  let returned = [];

	  function position() {
	    return pos
	  }

	  function unclosed(what) {
	    throw input.error('Unclosed ' + what, pos)
	  }

	  function endOfFile() {
	    return returned.length === 0 && pos >= length
	  }

	  function nextToken(opts) {
	    if (returned.length) return returned.pop()
	    if (pos >= length) return

	    let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;

	    code = css.charCodeAt(pos);

	    switch (code) {
	      case NEWLINE:
	      case SPACE:
	      case TAB:
	      case CR:
	      case FEED: {
	        next = pos;
	        do {
	          next += 1;
	          code = css.charCodeAt(next);
	        } while (
	          code === SPACE ||
	          code === NEWLINE ||
	          code === TAB ||
	          code === CR ||
	          code === FEED
	        )

	        currentToken = ['space', css.slice(pos, next)];
	        pos = next - 1;
	        break
	      }

	      case OPEN_SQUARE:
	      case CLOSE_SQUARE:
	      case OPEN_CURLY:
	      case CLOSE_CURLY:
	      case COLON:
	      case SEMICOLON:
	      case CLOSE_PARENTHESES: {
	        let controlChar = String.fromCharCode(code);
	        currentToken = [controlChar, controlChar, pos];
	        break
	      }

	      case OPEN_PARENTHESES: {
	        prev = buffer.length ? buffer.pop()[1] : '';
	        n = css.charCodeAt(pos + 1);
	        if (
	          prev === 'url' &&
	          n !== SINGLE_QUOTE &&
	          n !== DOUBLE_QUOTE &&
	          n !== SPACE &&
	          n !== NEWLINE &&
	          n !== TAB &&
	          n !== FEED &&
	          n !== CR
	        ) {
	          next = pos;
	          do {
	            escaped = false;
	            next = css.indexOf(')', next + 1);
	            if (next === -1) {
	              if (ignore || ignoreUnclosed) {
	                next = pos;
	                break
	              } else {
	                unclosed('bracket');
	              }
	            }
	            escapePos = next;
	            while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
	              escapePos -= 1;
	              escaped = !escaped;
	            }
	          } while (escaped)

	          currentToken = ['brackets', css.slice(pos, next + 1), pos, next];

	          pos = next;
	        } else {
	          next = css.indexOf(')', pos + 1);
	          content = css.slice(pos, next + 1);

	          if (next === -1 || RE_BAD_BRACKET.test(content)) {
	            currentToken = ['(', '(', pos];
	          } else {
	            currentToken = ['brackets', content, pos, next];
	            pos = next;
	          }
	        }

	        break
	      }

	      case SINGLE_QUOTE:
	      case DOUBLE_QUOTE: {
	        quote = code === SINGLE_QUOTE ? "'" : '"';
	        next = pos;
	        do {
	          escaped = false;
	          next = css.indexOf(quote, next + 1);
	          if (next === -1) {
	            if (ignore || ignoreUnclosed) {
	              next = pos + 1;
	              break
	            } else {
	              unclosed('string');
	            }
	          }
	          escapePos = next;
	          while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
	            escapePos -= 1;
	            escaped = !escaped;
	          }
	        } while (escaped)

	        currentToken = ['string', css.slice(pos, next + 1), pos, next];
	        pos = next;
	        break
	      }

	      case AT: {
	        RE_AT_END.lastIndex = pos + 1;
	        RE_AT_END.test(css);
	        if (RE_AT_END.lastIndex === 0) {
	          next = css.length - 1;
	        } else {
	          next = RE_AT_END.lastIndex - 2;
	        }

	        currentToken = ['at-word', css.slice(pos, next + 1), pos, next];

	        pos = next;
	        break
	      }

	      case BACKSLASH: {
	        next = pos;
	        escape = true;
	        while (css.charCodeAt(next + 1) === BACKSLASH) {
	          next += 1;
	          escape = !escape;
	        }
	        code = css.charCodeAt(next + 1);
	        if (
	          escape &&
	          code !== SLASH &&
	          code !== SPACE &&
	          code !== NEWLINE &&
	          code !== TAB &&
	          code !== CR &&
	          code !== FEED
	        ) {
	          next += 1;
	          if (RE_HEX_ESCAPE.test(css.charAt(next))) {
	            while (RE_HEX_ESCAPE.test(css.charAt(next + 1))) {
	              next += 1;
	            }
	            if (css.charCodeAt(next + 1) === SPACE) {
	              next += 1;
	            }
	          }
	        }

	        currentToken = ['word', css.slice(pos, next + 1), pos, next];

	        pos = next;
	        break
	      }

	      default: {
	        if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
	          next = css.indexOf('*/', pos + 2) + 1;
	          if (next === 0) {
	            if (ignore || ignoreUnclosed) {
	              next = css.length;
	            } else {
	              unclosed('comment');
	            }
	          }

	          currentToken = ['comment', css.slice(pos, next + 1), pos, next];
	          pos = next;
	        } else {
	          RE_WORD_END.lastIndex = pos + 1;
	          RE_WORD_END.test(css);
	          if (RE_WORD_END.lastIndex === 0) {
	            next = css.length - 1;
	          } else {
	            next = RE_WORD_END.lastIndex - 2;
	          }

	          currentToken = ['word', css.slice(pos, next + 1), pos, next];
	          buffer.push(currentToken);
	          pos = next;
	        }

	        break
	      }
	    }

	    pos++;
	    return currentToken
	  }

	  function back(token) {
	    returned.push(token);
	  }

	  return {
	    back,
	    endOfFile,
	    nextToken,
	    position
	  }
	};
	return tokenize;
}

var parser;
var hasRequiredParser;

function requireParser () {
	if (hasRequiredParser) return parser;
	hasRequiredParser = 1;

	let AtRule = requireAtRule();
	let Comment = requireComment();
	let Declaration = requireDeclaration();
	let Root = requireRoot();
	let Rule = requireRule();
	let tokenizer = requireTokenize();

	const SAFE_COMMENT_NEIGHBOR = {
	  empty: true,
	  space: true
	};

	function findLastWithPosition(tokens) {
	  for (let i = tokens.length - 1; i >= 0; i--) {
	    let token = tokens[i];
	    let pos = token[3] || token[2];
	    if (pos) return pos
	  }
	}

	class Parser {
	  constructor(input) {
	    this.input = input;

	    this.root = new Root();
	    this.current = this.root;
	    this.spaces = '';
	    this.semicolon = false;

	    this.createTokenizer();
	    this.root.source = { input, start: { column: 1, line: 1, offset: 0 } };
	  }

	  atrule(token) {
	    let node = new AtRule();
	    node.name = token[1].slice(1);
	    if (node.name === '') {
	      this.unnamedAtrule(node, token);
	    }
	    this.init(node, token[2]);

	    let type;
	    let prev;
	    let shift;
	    let last = false;
	    let open = false;
	    let params = [];
	    let brackets = [];

	    while (!this.tokenizer.endOfFile()) {
	      token = this.tokenizer.nextToken();
	      type = token[0];

	      if (type === '(' || type === '[') {
	        brackets.push(type === '(' ? ')' : ']');
	      } else if (type === '{' && brackets.length > 0) {
	        brackets.push('}');
	      } else if (type === brackets[brackets.length - 1]) {
	        brackets.pop();
	      }

	      if (brackets.length === 0) {
	        if (type === ';') {
	          node.source.end = this.getPosition(token[2]);
	          node.source.end.offset++;
	          this.semicolon = true;
	          break
	        } else if (type === '{') {
	          open = true;
	          break
	        } else if (type === '}') {
	          if (params.length > 0) {
	            shift = params.length - 1;
	            prev = params[shift];
	            while (prev && prev[0] === 'space') {
	              prev = params[--shift];
	            }
	            if (prev) {
	              node.source.end = this.getPosition(prev[3] || prev[2]);
	              node.source.end.offset++;
	            }
	          }
	          this.end(token);
	          break
	        } else {
	          params.push(token);
	        }
	      } else {
	        params.push(token);
	      }

	      if (this.tokenizer.endOfFile()) {
	        last = true;
	        break
	      }
	    }

	    node.raws.between = this.spacesAndCommentsFromEnd(params);
	    if (params.length) {
	      node.raws.afterName = this.spacesAndCommentsFromStart(params);
	      this.raw(node, 'params', params);
	      if (last) {
	        token = params[params.length - 1];
	        node.source.end = this.getPosition(token[3] || token[2]);
	        node.source.end.offset++;
	        this.spaces = node.raws.between;
	        node.raws.between = '';
	      }
	    } else {
	      node.raws.afterName = '';
	      node.params = '';
	    }

	    if (open) {
	      node.nodes = [];
	      this.current = node;
	    }
	  }

	  checkMissedSemicolon(tokens) {
	    let colon = this.colon(tokens);
	    if (colon === false) return

	    let founded = 0;
	    let token;
	    for (let j = colon - 1; j >= 0; j--) {
	      token = tokens[j];
	      if (token[0] !== 'space') {
	        founded += 1;
	        if (founded === 2) break
	      }
	    }
	    // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
	    // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
	    // And because we need it after that one we do +1 to get the next one.
	    throw this.input.error(
	      'Missed semicolon',
	      token[0] === 'word' ? token[3] + 1 : token[2]
	    )
	  }

	  colon(tokens) {
	    let brackets = 0;
	    let prev, token, type;
	    for (let [i, element] of tokens.entries()) {
	      token = element;
	      type = token[0];

	      if (type === '(') {
	        brackets += 1;
	      }
	      if (type === ')') {
	        brackets -= 1;
	      }
	      if (brackets === 0 && type === ':') {
	        if (!prev) {
	          this.doubleColon(token);
	        } else if (prev[0] === 'word' && prev[1] === 'progid') {
	          continue
	        } else {
	          return i
	        }
	      }

	      prev = token;
	    }
	    return false
	  }

	  comment(token) {
	    let node = new Comment();
	    this.init(node, token[2]);
	    node.source.end = this.getPosition(token[3] || token[2]);
	    node.source.end.offset++;

	    let text = token[1].slice(2, -2);
	    if (/^\s*$/.test(text)) {
	      node.text = '';
	      node.raws.left = text;
	      node.raws.right = '';
	    } else {
	      let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
	      node.text = match[2];
	      node.raws.left = match[1];
	      node.raws.right = match[3];
	    }
	  }

	  createTokenizer() {
	    this.tokenizer = tokenizer(this.input);
	  }

	  decl(tokens, customProperty) {
	    let node = new Declaration();
	    this.init(node, tokens[0][2]);

	    let last = tokens[tokens.length - 1];
	    if (last[0] === ';') {
	      this.semicolon = true;
	      tokens.pop();
	    }

	    node.source.end = this.getPosition(
	      last[3] || last[2] || findLastWithPosition(tokens)
	    );
	    node.source.end.offset++;

	    while (tokens[0][0] !== 'word') {
	      if (tokens.length === 1) this.unknownWord(tokens);
	      node.raws.before += tokens.shift()[1];
	    }
	    node.source.start = this.getPosition(tokens[0][2]);

	    node.prop = '';
	    while (tokens.length) {
	      let type = tokens[0][0];
	      if (type === ':' || type === 'space' || type === 'comment') {
	        break
	      }
	      node.prop += tokens.shift()[1];
	    }

	    node.raws.between = '';

	    let token;
	    while (tokens.length) {
	      token = tokens.shift();

	      if (token[0] === ':') {
	        node.raws.between += token[1];
	        break
	      } else {
	        if (token[0] === 'word' && /\w/.test(token[1])) {
	          this.unknownWord([token]);
	        }
	        node.raws.between += token[1];
	      }
	    }

	    if (node.prop[0] === '_' || node.prop[0] === '*') {
	      node.raws.before += node.prop[0];
	      node.prop = node.prop.slice(1);
	    }

	    let firstSpaces = [];
	    let next;
	    while (tokens.length) {
	      next = tokens[0][0];
	      if (next !== 'space' && next !== 'comment') break
	      firstSpaces.push(tokens.shift());
	    }

	    this.precheckMissedSemicolon(tokens);

	    for (let i = tokens.length - 1; i >= 0; i--) {
	      token = tokens[i];
	      if (token[1].toLowerCase() === '!important') {
	        node.important = true;
	        let string = this.stringFrom(tokens, i);
	        string = this.spacesFromEnd(tokens) + string;
	        if (string !== ' !important') node.raws.important = string;
	        break
	      } else if (token[1].toLowerCase() === 'important') {
	        let cache = tokens.slice(0);
	        let str = '';
	        for (let j = i; j > 0; j--) {
	          let type = cache[j][0];
	          if (str.trim().startsWith('!') && type !== 'space') {
	            break
	          }
	          str = cache.pop()[1] + str;
	        }
	        if (str.trim().startsWith('!')) {
	          node.important = true;
	          node.raws.important = str;
	          tokens = cache;
	        }
	      }

	      if (token[0] !== 'space' && token[0] !== 'comment') {
	        break
	      }
	    }

	    let hasWord = tokens.some(i => i[0] !== 'space' && i[0] !== 'comment');

	    if (hasWord) {
	      node.raws.between += firstSpaces.map(i => i[1]).join('');
	      firstSpaces = [];
	    }
	    this.raw(node, 'value', firstSpaces.concat(tokens), customProperty);

	    if (node.value.includes(':') && !customProperty) {
	      this.checkMissedSemicolon(tokens);
	    }
	  }

	  doubleColon(token) {
	    throw this.input.error(
	      'Double colon',
	      { offset: token[2] },
	      { offset: token[2] + token[1].length }
	    )
	  }

	  emptyRule(token) {
	    let node = new Rule();
	    this.init(node, token[2]);
	    node.selector = '';
	    node.raws.between = '';
	    this.current = node;
	  }

	  end(token) {
	    if (this.current.nodes && this.current.nodes.length) {
	      this.current.raws.semicolon = this.semicolon;
	    }
	    this.semicolon = false;

	    this.current.raws.after = (this.current.raws.after || '') + this.spaces;
	    this.spaces = '';

	    if (this.current.parent) {
	      this.current.source.end = this.getPosition(token[2]);
	      this.current.source.end.offset++;
	      this.current = this.current.parent;
	    } else {
	      this.unexpectedClose(token);
	    }
	  }

	  endFile() {
	    if (this.current.parent) this.unclosedBlock();
	    if (this.current.nodes && this.current.nodes.length) {
	      this.current.raws.semicolon = this.semicolon;
	    }
	    this.current.raws.after = (this.current.raws.after || '') + this.spaces;
	    this.root.source.end = this.getPosition(this.tokenizer.position());
	  }

	  freeSemicolon(token) {
	    this.spaces += token[1];
	    if (this.current.nodes) {
	      let prev = this.current.nodes[this.current.nodes.length - 1];
	      if (prev && prev.type === 'rule' && !prev.raws.ownSemicolon) {
	        prev.raws.ownSemicolon = this.spaces;
	        this.spaces = '';
	        prev.source.end = this.getPosition(token[2]);
	        prev.source.end.offset += prev.raws.ownSemicolon.length;
	      }
	    }
	  }

	  // Helpers

	  getPosition(offset) {
	    let pos = this.input.fromOffset(offset);
	    return {
	      column: pos.col,
	      line: pos.line,
	      offset
	    }
	  }

	  init(node, offset) {
	    this.current.push(node);
	    node.source = {
	      input: this.input,
	      start: this.getPosition(offset)
	    };
	    node.raws.before = this.spaces;
	    this.spaces = '';
	    if (node.type !== 'comment') this.semicolon = false;
	  }

	  other(start) {
	    let end = false;
	    let type = null;
	    let colon = false;
	    let bracket = null;
	    let brackets = [];
	    let customProperty = start[1].startsWith('--');

	    let tokens = [];
	    let token = start;
	    while (token) {
	      type = token[0];
	      tokens.push(token);

	      if (type === '(' || type === '[') {
	        if (!bracket) bracket = token;
	        brackets.push(type === '(' ? ')' : ']');
	      } else if (customProperty && colon && type === '{') {
	        if (!bracket) bracket = token;
	        brackets.push('}');
	      } else if (brackets.length === 0) {
	        if (type === ';') {
	          if (colon) {
	            this.decl(tokens, customProperty);
	            return
	          } else {
	            break
	          }
	        } else if (type === '{') {
	          this.rule(tokens);
	          return
	        } else if (type === '}') {
	          this.tokenizer.back(tokens.pop());
	          end = true;
	          break
	        } else if (type === ':') {
	          colon = true;
	        }
	      } else if (type === brackets[brackets.length - 1]) {
	        brackets.pop();
	        if (brackets.length === 0) bracket = null;
	      }

	      token = this.tokenizer.nextToken();
	    }

	    if (this.tokenizer.endOfFile()) end = true;
	    if (brackets.length > 0) this.unclosedBracket(bracket);

	    if (end && colon) {
	      if (!customProperty) {
	        while (tokens.length) {
	          token = tokens[tokens.length - 1][0];
	          if (token !== 'space' && token !== 'comment') break
	          this.tokenizer.back(tokens.pop());
	        }
	      }
	      this.decl(tokens, customProperty);
	    } else {
	      this.unknownWord(tokens);
	    }
	  }

	  parse() {
	    let token;
	    while (!this.tokenizer.endOfFile()) {
	      token = this.tokenizer.nextToken();

	      switch (token[0]) {
	        case 'space':
	          this.spaces += token[1];
	          break

	        case ';':
	          this.freeSemicolon(token);
	          break

	        case '}':
	          this.end(token);
	          break

	        case 'comment':
	          this.comment(token);
	          break

	        case 'at-word':
	          this.atrule(token);
	          break

	        case '{':
	          this.emptyRule(token);
	          break

	        default:
	          this.other(token);
	          break
	      }
	    }
	    this.endFile();
	  }

	  precheckMissedSemicolon(/* tokens */) {
	    // Hook for Safe Parser
	  }

	  raw(node, prop, tokens, customProperty) {
	    let token, type;
	    let length = tokens.length;
	    let value = '';
	    let clean = true;
	    let next, prev;

	    for (let i = 0; i < length; i += 1) {
	      token = tokens[i];
	      type = token[0];
	      if (type === 'space' && i === length - 1 && !customProperty) {
	        clean = false;
	      } else if (type === 'comment') {
	        prev = tokens[i - 1] ? tokens[i - 1][0] : 'empty';
	        next = tokens[i + 1] ? tokens[i + 1][0] : 'empty';
	        if (!SAFE_COMMENT_NEIGHBOR[prev] && !SAFE_COMMENT_NEIGHBOR[next]) {
	          if (value.slice(-1) === ',') {
	            clean = false;
	          } else {
	            value += token[1];
	          }
	        } else {
	          clean = false;
	        }
	      } else {
	        value += token[1];
	      }
	    }
	    if (!clean) {
	      let raw = tokens.reduce((all, i) => all + i[1], '');
	      node.raws[prop] = { raw, value };
	    }
	    node[prop] = value;
	  }

	  rule(tokens) {
	    tokens.pop();

	    let node = new Rule();
	    this.init(node, tokens[0][2]);

	    node.raws.between = this.spacesAndCommentsFromEnd(tokens);
	    this.raw(node, 'selector', tokens);
	    this.current = node;
	  }

	  spacesAndCommentsFromEnd(tokens) {
	    let lastTokenType;
	    let spaces = '';
	    while (tokens.length) {
	      lastTokenType = tokens[tokens.length - 1][0];
	      if (lastTokenType !== 'space' && lastTokenType !== 'comment') break
	      spaces = tokens.pop()[1] + spaces;
	    }
	    return spaces
	  }

	  // Errors

	  spacesAndCommentsFromStart(tokens) {
	    let next;
	    let spaces = '';
	    while (tokens.length) {
	      next = tokens[0][0];
	      if (next !== 'space' && next !== 'comment') break
	      spaces += tokens.shift()[1];
	    }
	    return spaces
	  }

	  spacesFromEnd(tokens) {
	    let lastTokenType;
	    let spaces = '';
	    while (tokens.length) {
	      lastTokenType = tokens[tokens.length - 1][0];
	      if (lastTokenType !== 'space') break
	      spaces = tokens.pop()[1] + spaces;
	    }
	    return spaces
	  }

	  stringFrom(tokens, from) {
	    let result = '';
	    for (let i = from; i < tokens.length; i++) {
	      result += tokens[i][1];
	    }
	    tokens.splice(from, tokens.length - from);
	    return result
	  }

	  unclosedBlock() {
	    let pos = this.current.source.start;
	    throw this.input.error('Unclosed block', pos.line, pos.column)
	  }

	  unclosedBracket(bracket) {
	    throw this.input.error(
	      'Unclosed bracket',
	      { offset: bracket[2] },
	      { offset: bracket[2] + 1 }
	    )
	  }

	  unexpectedClose(token) {
	    throw this.input.error(
	      'Unexpected }',
	      { offset: token[2] },
	      { offset: token[2] + 1 }
	    )
	  }

	  unknownWord(tokens) {
	    throw this.input.error(
	      'Unknown word ' + tokens[0][1],
	      { offset: tokens[0][2] },
	      { offset: tokens[0][2] + tokens[0][1].length }
	    )
	  }

	  unnamedAtrule(node, token) {
	    throw this.input.error(
	      'At-rule without name',
	      { offset: token[2] },
	      { offset: token[2] + token[1].length }
	    )
	  }
	}

	parser = Parser;
	return parser;
}

var parse_1;
var hasRequiredParse;

function requireParse () {
	if (hasRequiredParse) return parse_1;
	hasRequiredParse = 1;

	let Container = requireContainer();
	let Input = requireInput();
	let Parser = requireParser();

	function parse(css, opts) {
	  let input = new Input(css, opts);
	  let parser = new Parser(input);
	  try {
	    parser.parse();
	  } catch (e) {
	    if (browser$1.env.NODE_ENV !== 'production') {
	      if (e.name === 'CssSyntaxError' && opts && opts.from) {
	        if (/\.scss$/i.test(opts.from)) {
	          e.message +=
	            '\nYou tried to parse SCSS with ' +
	            'the standard CSS parser; ' +
	            'try again with the postcss-scss parser';
	        } else if (/\.sass/i.test(opts.from)) {
	          e.message +=
	            '\nYou tried to parse Sass with ' +
	            'the standard CSS parser; ' +
	            'try again with the postcss-sass parser';
	        } else if (/\.less$/i.test(opts.from)) {
	          e.message +=
	            '\nYou tried to parse Less with ' +
	            'the standard CSS parser; ' +
	            'try again with the postcss-less parser';
	        }
	      }
	    }
	    throw e
	  }

	  return parser.root
	}

	parse_1 = parse;
	parse.default = parse;

	Container.registerParse(parse);
	return parse_1;
}

var warning;
var hasRequiredWarning;

function requireWarning () {
	if (hasRequiredWarning) return warning;
	hasRequiredWarning = 1;

	class Warning {
	  constructor(text, opts = {}) {
	    this.type = 'warning';
	    this.text = text;

	    if (opts.node && opts.node.source) {
	      let range = opts.node.rangeBy(opts);
	      this.line = range.start.line;
	      this.column = range.start.column;
	      this.endLine = range.end.line;
	      this.endColumn = range.end.column;
	    }

	    for (let opt in opts) this[opt] = opts[opt];
	  }

	  toString() {
	    if (this.node) {
	      return this.node.error(this.text, {
	        index: this.index,
	        plugin: this.plugin,
	        word: this.word
	      }).message
	    }

	    if (this.plugin) {
	      return this.plugin + ': ' + this.text
	    }

	    return this.text
	  }
	}

	warning = Warning;
	Warning.default = Warning;
	return warning;
}

var result;
var hasRequiredResult;

function requireResult () {
	if (hasRequiredResult) return result;
	hasRequiredResult = 1;

	let Warning = requireWarning();

	class Result {
	  get content() {
	    return this.css
	  }

	  constructor(processor, root, opts) {
	    this.processor = processor;
	    this.messages = [];
	    this.root = root;
	    this.opts = opts;
	    this.css = '';
	    this.map = undefined;
	  }

	  toString() {
	    return this.css
	  }

	  warn(text, opts = {}) {
	    if (!opts.plugin) {
	      if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
	        opts.plugin = this.lastPlugin.postcssPlugin;
	      }
	    }

	    let warning = new Warning(text, opts);
	    this.messages.push(warning);

	    return warning
	  }

	  warnings() {
	    return this.messages.filter(i => i.type === 'warning')
	  }
	}

	result = Result;
	Result.default = Result;
	return result;
}

/* eslint-disable no-console */

var warnOnce;
var hasRequiredWarnOnce;

function requireWarnOnce () {
	if (hasRequiredWarnOnce) return warnOnce;
	hasRequiredWarnOnce = 1;

	let printed = {};

	warnOnce = function warnOnce(message) {
	  if (printed[message]) return
	  printed[message] = true;

	  if (typeof console !== 'undefined' && console.warn) {
	    console.warn(message);
	  }
	};
	return warnOnce;
}

var lazyResult;
var hasRequiredLazyResult;

function requireLazyResult () {
	if (hasRequiredLazyResult) return lazyResult;
	hasRequiredLazyResult = 1;

	let Container = requireContainer();
	let Document = requireDocument();
	let MapGenerator = requireMapGenerator();
	let parse = requireParse();
	let Result = requireResult();
	let Root = requireRoot();
	let stringify = requireStringify();
	let { isClean, my } = requireSymbols();
	let warnOnce = requireWarnOnce();

	const TYPE_TO_CLASS_NAME = {
	  atrule: 'AtRule',
	  comment: 'Comment',
	  decl: 'Declaration',
	  document: 'Document',
	  root: 'Root',
	  rule: 'Rule'
	};

	const PLUGIN_PROPS = {
	  AtRule: true,
	  AtRuleExit: true,
	  Comment: true,
	  CommentExit: true,
	  Declaration: true,
	  DeclarationExit: true,
	  Document: true,
	  DocumentExit: true,
	  Once: true,
	  OnceExit: true,
	  postcssPlugin: true,
	  prepare: true,
	  Root: true,
	  RootExit: true,
	  Rule: true,
	  RuleExit: true
	};

	const NOT_VISITORS = {
	  Once: true,
	  postcssPlugin: true,
	  prepare: true
	};

	const CHILDREN = 0;

	function isPromise(obj) {
	  return typeof obj === 'object' && typeof obj.then === 'function'
	}

	function getEvents(node) {
	  let key = false;
	  let type = TYPE_TO_CLASS_NAME[node.type];
	  if (node.type === 'decl') {
	    key = node.prop.toLowerCase();
	  } else if (node.type === 'atrule') {
	    key = node.name.toLowerCase();
	  }

	  if (key && node.append) {
	    return [
	      type,
	      type + '-' + key,
	      CHILDREN,
	      type + 'Exit',
	      type + 'Exit-' + key
	    ]
	  } else if (key) {
	    return [type, type + '-' + key, type + 'Exit', type + 'Exit-' + key]
	  } else if (node.append) {
	    return [type, CHILDREN, type + 'Exit']
	  } else {
	    return [type, type + 'Exit']
	  }
	}

	function toStack(node) {
	  let events;
	  if (node.type === 'document') {
	    events = ['Document', CHILDREN, 'DocumentExit'];
	  } else if (node.type === 'root') {
	    events = ['Root', CHILDREN, 'RootExit'];
	  } else {
	    events = getEvents(node);
	  }

	  return {
	    eventIndex: 0,
	    events,
	    iterator: 0,
	    node,
	    visitorIndex: 0,
	    visitors: []
	  }
	}

	function cleanMarks(node) {
	  node[isClean] = false;
	  if (node.nodes) node.nodes.forEach(i => cleanMarks(i));
	  return node
	}

	let postcss = {};

	class LazyResult {
	  get content() {
	    return this.stringify().content
	  }

	  get css() {
	    return this.stringify().css
	  }

	  get map() {
	    return this.stringify().map
	  }

	  get messages() {
	    return this.sync().messages
	  }

	  get opts() {
	    return this.result.opts
	  }

	  get processor() {
	    return this.result.processor
	  }

	  get root() {
	    return this.sync().root
	  }

	  get [Symbol.toStringTag]() {
	    return 'LazyResult'
	  }

	  constructor(processor, css, opts) {
	    this.stringified = false;
	    this.processed = false;

	    let root;
	    if (
	      typeof css === 'object' &&
	      css !== null &&
	      (css.type === 'root' || css.type === 'document')
	    ) {
	      root = cleanMarks(css);
	    } else if (css instanceof LazyResult || css instanceof Result) {
	      root = cleanMarks(css.root);
	      if (css.map) {
	        if (typeof opts.map === 'undefined') opts.map = {};
	        if (!opts.map.inline) opts.map.inline = false;
	        opts.map.prev = css.map;
	      }
	    } else {
	      let parser = parse;
	      if (opts.syntax) parser = opts.syntax.parse;
	      if (opts.parser) parser = opts.parser;
	      if (parser.parse) parser = parser.parse;

	      try {
	        root = parser(css, opts);
	      } catch (error) {
	        this.processed = true;
	        this.error = error;
	      }

	      if (root && !root[my]) {
	        /* c8 ignore next 2 */
	        Container.rebuild(root);
	      }
	    }

	    this.result = new Result(processor, root, opts);
	    this.helpers = { ...postcss, postcss, result: this.result };
	    this.plugins = this.processor.plugins.map(plugin => {
	      if (typeof plugin === 'object' && plugin.prepare) {
	        return { ...plugin, ...plugin.prepare(this.result) }
	      } else {
	        return plugin
	      }
	    });
	  }

	  async() {
	    if (this.error) return Promise.reject(this.error)
	    if (this.processed) return Promise.resolve(this.result)
	    if (!this.processing) {
	      this.processing = this.runAsync();
	    }
	    return this.processing
	  }

	  catch(onRejected) {
	    return this.async().catch(onRejected)
	  }

	  finally(onFinally) {
	    return this.async().then(onFinally, onFinally)
	  }

	  getAsyncError() {
	    throw new Error('Use process(css).then(cb) to work with async plugins')
	  }

	  handleError(error, node) {
	    let plugin = this.result.lastPlugin;
	    try {
	      if (node) node.addToError(error);
	      this.error = error;
	      if (error.name === 'CssSyntaxError' && !error.plugin) {
	        error.plugin = plugin.postcssPlugin;
	        error.setMessage();
	      } else if (plugin.postcssVersion) {
	        if (browser$1.env.NODE_ENV !== 'production') {
	          let pluginName = plugin.postcssPlugin;
	          let pluginVer = plugin.postcssVersion;
	          let runtimeVer = this.result.processor.version;
	          let a = pluginVer.split('.');
	          let b = runtimeVer.split('.');

	          if (a[0] !== b[0] || parseInt(a[1]) > parseInt(b[1])) {
	            // eslint-disable-next-line no-console
	            console.error(
	              'Unknown error from PostCSS plugin. Your current PostCSS ' +
	                'version is ' +
	                runtimeVer +
	                ', but ' +
	                pluginName +
	                ' uses ' +
	                pluginVer +
	                '. Perhaps this is the source of the error below.'
	            );
	          }
	        }
	      }
	    } catch (err) {
	      /* c8 ignore next 3 */
	      // eslint-disable-next-line no-console
	      if (console && console.error) console.error(err);
	    }
	    return error
	  }

	  prepareVisitors() {
	    this.listeners = {};
	    let add = (plugin, type, cb) => {
	      if (!this.listeners[type]) this.listeners[type] = [];
	      this.listeners[type].push([plugin, cb]);
	    };
	    for (let plugin of this.plugins) {
	      if (typeof plugin === 'object') {
	        for (let event in plugin) {
	          if (!PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) {
	            throw new Error(
	              `Unknown event ${event} in ${plugin.postcssPlugin}. ` +
	                `Try to update PostCSS (${this.processor.version} now).`
	            )
	          }
	          if (!NOT_VISITORS[event]) {
	            if (typeof plugin[event] === 'object') {
	              for (let filter in plugin[event]) {
	                if (filter === '*') {
	                  add(plugin, event, plugin[event][filter]);
	                } else {
	                  add(
	                    plugin,
	                    event + '-' + filter.toLowerCase(),
	                    plugin[event][filter]
	                  );
	                }
	              }
	            } else if (typeof plugin[event] === 'function') {
	              add(plugin, event, plugin[event]);
	            }
	          }
	        }
	      }
	    }
	    this.hasListener = Object.keys(this.listeners).length > 0;
	  }

	  async runAsync() {
	    this.plugin = 0;
	    for (let i = 0; i < this.plugins.length; i++) {
	      let plugin = this.plugins[i];
	      let promise = this.runOnRoot(plugin);
	      if (isPromise(promise)) {
	        try {
	          await promise;
	        } catch (error) {
	          throw this.handleError(error)
	        }
	      }
	    }

	    this.prepareVisitors();
	    if (this.hasListener) {
	      let root = this.result.root;
	      while (!root[isClean]) {
	        root[isClean] = true;
	        let stack = [toStack(root)];
	        while (stack.length > 0) {
	          let promise = this.visitTick(stack);
	          if (isPromise(promise)) {
	            try {
	              await promise;
	            } catch (e) {
	              let node = stack[stack.length - 1].node;
	              throw this.handleError(e, node)
	            }
	          }
	        }
	      }

	      if (this.listeners.OnceExit) {
	        for (let [plugin, visitor] of this.listeners.OnceExit) {
	          this.result.lastPlugin = plugin;
	          try {
	            if (root.type === 'document') {
	              let roots = root.nodes.map(subRoot =>
	                visitor(subRoot, this.helpers)
	              );

	              await Promise.all(roots);
	            } else {
	              await visitor(root, this.helpers);
	            }
	          } catch (e) {
	            throw this.handleError(e)
	          }
	        }
	      }
	    }

	    this.processed = true;
	    return this.stringify()
	  }

	  runOnRoot(plugin) {
	    this.result.lastPlugin = plugin;
	    try {
	      if (typeof plugin === 'object' && plugin.Once) {
	        if (this.result.root.type === 'document') {
	          let roots = this.result.root.nodes.map(root =>
	            plugin.Once(root, this.helpers)
	          );

	          if (isPromise(roots[0])) {
	            return Promise.all(roots)
	          }

	          return roots
	        }

	        return plugin.Once(this.result.root, this.helpers)
	      } else if (typeof plugin === 'function') {
	        return plugin(this.result.root, this.result)
	      }
	    } catch (error) {
	      throw this.handleError(error)
	    }
	  }

	  stringify() {
	    if (this.error) throw this.error
	    if (this.stringified) return this.result
	    this.stringified = true;

	    this.sync();

	    let opts = this.result.opts;
	    let str = stringify;
	    if (opts.syntax) str = opts.syntax.stringify;
	    if (opts.stringifier) str = opts.stringifier;
	    if (str.stringify) str = str.stringify;

	    let map = new MapGenerator(str, this.result.root, this.result.opts);
	    let data = map.generate();
	    this.result.css = data[0];
	    this.result.map = data[1];

	    return this.result
	  }

	  sync() {
	    if (this.error) throw this.error
	    if (this.processed) return this.result
	    this.processed = true;

	    if (this.processing) {
	      throw this.getAsyncError()
	    }

	    for (let plugin of this.plugins) {
	      let promise = this.runOnRoot(plugin);
	      if (isPromise(promise)) {
	        throw this.getAsyncError()
	      }
	    }

	    this.prepareVisitors();
	    if (this.hasListener) {
	      let root = this.result.root;
	      while (!root[isClean]) {
	        root[isClean] = true;
	        this.walkSync(root);
	      }
	      if (this.listeners.OnceExit) {
	        if (root.type === 'document') {
	          for (let subRoot of root.nodes) {
	            this.visitSync(this.listeners.OnceExit, subRoot);
	          }
	        } else {
	          this.visitSync(this.listeners.OnceExit, root);
	        }
	      }
	    }

	    return this.result
	  }

	  then(onFulfilled, onRejected) {
	    if (browser$1.env.NODE_ENV !== 'production') {
	      if (!('from' in this.opts)) {
	        warnOnce(
	          'Without `from` option PostCSS could generate wrong source map ' +
	            'and will not find Browserslist config. Set it to CSS file path ' +
	            'or to `undefined` to prevent this warning.'
	        );
	      }
	    }
	    return this.async().then(onFulfilled, onRejected)
	  }

	  toString() {
	    return this.css
	  }

	  visitSync(visitors, node) {
	    for (let [plugin, visitor] of visitors) {
	      this.result.lastPlugin = plugin;
	      let promise;
	      try {
	        promise = visitor(node, this.helpers);
	      } catch (e) {
	        throw this.handleError(e, node.proxyOf)
	      }
	      if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
	        return true
	      }
	      if (isPromise(promise)) {
	        throw this.getAsyncError()
	      }
	    }
	  }

	  visitTick(stack) {
	    let visit = stack[stack.length - 1];
	    let { node, visitors } = visit;

	    if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
	      stack.pop();
	      return
	    }

	    if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
	      let [plugin, visitor] = visitors[visit.visitorIndex];
	      visit.visitorIndex += 1;
	      if (visit.visitorIndex === visitors.length) {
	        visit.visitors = [];
	        visit.visitorIndex = 0;
	      }
	      this.result.lastPlugin = plugin;
	      try {
	        return visitor(node.toProxy(), this.helpers)
	      } catch (e) {
	        throw this.handleError(e, node)
	      }
	    }

	    if (visit.iterator !== 0) {
	      let iterator = visit.iterator;
	      let child;
	      while ((child = node.nodes[node.indexes[iterator]])) {
	        node.indexes[iterator] += 1;
	        if (!child[isClean]) {
	          child[isClean] = true;
	          stack.push(toStack(child));
	          return
	        }
	      }
	      visit.iterator = 0;
	      delete node.indexes[iterator];
	    }

	    let events = visit.events;
	    while (visit.eventIndex < events.length) {
	      let event = events[visit.eventIndex];
	      visit.eventIndex += 1;
	      if (event === CHILDREN) {
	        if (node.nodes && node.nodes.length) {
	          node[isClean] = true;
	          visit.iterator = node.getIterator();
	        }
	        return
	      } else if (this.listeners[event]) {
	        visit.visitors = this.listeners[event];
	        return
	      }
	    }
	    stack.pop();
	  }

	  walkSync(node) {
	    node[isClean] = true;
	    let events = getEvents(node);
	    for (let event of events) {
	      if (event === CHILDREN) {
	        if (node.nodes) {
	          node.each(child => {
	            if (!child[isClean]) this.walkSync(child);
	          });
	        }
	      } else {
	        let visitors = this.listeners[event];
	        if (visitors) {
	          if (this.visitSync(visitors, node.toProxy())) return
	        }
	      }
	    }
	  }

	  warnings() {
	    return this.sync().warnings()
	  }
	}

	LazyResult.registerPostcss = dependant => {
	  postcss = dependant;
	};

	lazyResult = LazyResult;
	LazyResult.default = LazyResult;

	Root.registerLazyResult(LazyResult);
	Document.registerLazyResult(LazyResult);
	return lazyResult;
}

var noWorkResult;
var hasRequiredNoWorkResult;

function requireNoWorkResult () {
	if (hasRequiredNoWorkResult) return noWorkResult;
	hasRequiredNoWorkResult = 1;

	let MapGenerator = requireMapGenerator();
	let parse = requireParse();
	const Result = requireResult();
	let stringify = requireStringify();
	let warnOnce = requireWarnOnce();

	class NoWorkResult {
	  get content() {
	    return this.result.css
	  }

	  get css() {
	    return this.result.css
	  }

	  get map() {
	    return this.result.map
	  }

	  get messages() {
	    return []
	  }

	  get opts() {
	    return this.result.opts
	  }

	  get processor() {
	    return this.result.processor
	  }

	  get root() {
	    if (this._root) {
	      return this._root
	    }

	    let root;
	    let parser = parse;

	    try {
	      root = parser(this._css, this._opts);
	    } catch (error) {
	      this.error = error;
	    }

	    if (this.error) {
	      throw this.error
	    } else {
	      this._root = root;
	      return root
	    }
	  }

	  get [Symbol.toStringTag]() {
	    return 'NoWorkResult'
	  }

	  constructor(processor, css, opts) {
	    css = css.toString();
	    this.stringified = false;

	    this._processor = processor;
	    this._css = css;
	    this._opts = opts;
	    this._map = undefined;
	    let root;

	    let str = stringify;
	    this.result = new Result(this._processor, root, this._opts);
	    this.result.css = css;

	    let self = this;
	    Object.defineProperty(this.result, 'root', {
	      get() {
	        return self.root
	      }
	    });

	    let map = new MapGenerator(str, root, this._opts, css);
	    if (map.isMap()) {
	      let [generatedCSS, generatedMap] = map.generate();
	      if (generatedCSS) {
	        this.result.css = generatedCSS;
	      }
	      if (generatedMap) {
	        this.result.map = generatedMap;
	      }
	    } else {
	      map.clearAnnotation();
	      this.result.css = map.css;
	    }
	  }

	  async() {
	    if (this.error) return Promise.reject(this.error)
	    return Promise.resolve(this.result)
	  }

	  catch(onRejected) {
	    return this.async().catch(onRejected)
	  }

	  finally(onFinally) {
	    return this.async().then(onFinally, onFinally)
	  }

	  sync() {
	    if (this.error) throw this.error
	    return this.result
	  }

	  then(onFulfilled, onRejected) {
	    if (browser$1.env.NODE_ENV !== 'production') {
	      if (!('from' in this._opts)) {
	        warnOnce(
	          'Without `from` option PostCSS could generate wrong source map ' +
	            'and will not find Browserslist config. Set it to CSS file path ' +
	            'or to `undefined` to prevent this warning.'
	        );
	      }
	    }

	    return this.async().then(onFulfilled, onRejected)
	  }

	  toString() {
	    return this._css
	  }

	  warnings() {
	    return []
	  }
	}

	noWorkResult = NoWorkResult;
	NoWorkResult.default = NoWorkResult;
	return noWorkResult;
}

var processor;
var hasRequiredProcessor;

function requireProcessor () {
	if (hasRequiredProcessor) return processor;
	hasRequiredProcessor = 1;

	let Document = requireDocument();
	let LazyResult = requireLazyResult();
	let NoWorkResult = requireNoWorkResult();
	let Root = requireRoot();

	class Processor {
	  constructor(plugins = []) {
	    this.version = '8.5.6';
	    this.plugins = this.normalize(plugins);
	  }

	  normalize(plugins) {
	    let normalized = [];
	    for (let i of plugins) {
	      if (i.postcss === true) {
	        i = i();
	      } else if (i.postcss) {
	        i = i.postcss;
	      }

	      if (typeof i === 'object' && Array.isArray(i.plugins)) {
	        normalized = normalized.concat(i.plugins);
	      } else if (typeof i === 'object' && i.postcssPlugin) {
	        normalized.push(i);
	      } else if (typeof i === 'function') {
	        normalized.push(i);
	      } else if (typeof i === 'object' && (i.parse || i.stringify)) {
	        if (browser$1.env.NODE_ENV !== 'production') {
	          throw new Error(
	            'PostCSS syntaxes cannot be used as plugins. Instead, please use ' +
	              'one of the syntax/parser/stringifier options as outlined ' +
	              'in your PostCSS runner documentation.'
	          )
	        }
	      } else {
	        throw new Error(i + ' is not a PostCSS plugin')
	      }
	    }
	    return normalized
	  }

	  process(css, opts = {}) {
	    if (
	      !this.plugins.length &&
	      !opts.parser &&
	      !opts.stringifier &&
	      !opts.syntax
	    ) {
	      return new NoWorkResult(this, css, opts)
	    } else {
	      return new LazyResult(this, css, opts)
	    }
	  }

	  use(plugin) {
	    this.plugins = this.plugins.concat(this.normalize([plugin]));
	    return this
	  }
	}

	processor = Processor;
	Processor.default = Processor;

	Root.registerProcessor(Processor);
	Document.registerProcessor(Processor);
	return processor;
}

var postcss_1;
var hasRequiredPostcss;

function requirePostcss () {
	if (hasRequiredPostcss) return postcss_1;
	hasRequiredPostcss = 1;

	let AtRule = requireAtRule();
	let Comment = requireComment();
	let Container = requireContainer();
	let CssSyntaxError = requireCssSyntaxError();
	let Declaration = requireDeclaration();
	let Document = requireDocument();
	let fromJSON = requireFromJSON();
	let Input = requireInput();
	let LazyResult = requireLazyResult();
	let list = requireList();
	let Node = requireNode();
	let parse = requireParse();
	let Processor = requireProcessor();
	let Result = requireResult();
	let Root = requireRoot();
	let Rule = requireRule();
	let stringify = requireStringify();
	let Warning = requireWarning();

	function postcss(...plugins) {
	  if (plugins.length === 1 && Array.isArray(plugins[0])) {
	    plugins = plugins[0];
	  }
	  return new Processor(plugins)
	}

	postcss.plugin = function plugin(name, initializer) {
	  let warningPrinted = false;
	  function creator(...args) {
	    // eslint-disable-next-line no-console
	    if (console && console.warn && !warningPrinted) {
	      warningPrinted = true;
	      // eslint-disable-next-line no-console
	      console.warn(
	        name +
	          ': postcss.plugin was deprecated. Migration guide:\n' +
	          'https://evilmartians.com/chronicles/postcss-8-plugin-migration'
	      );
	      if (browser$1.env.LANG && browser$1.env.LANG.startsWith('cn')) {
	        /* c8 ignore next 7 */
	        // eslint-disable-next-line no-console
	        console.warn(
	          name +
	            ': 里面 postcss.plugin 被弃用. 迁移指南:\n' +
	            'https://www.w3ctech.com/topic/2226'
	        );
	      }
	    }
	    let transformer = initializer(...args);
	    transformer.postcssPlugin = name;
	    transformer.postcssVersion = new Processor().version;
	    return transformer
	  }

	  let cache;
	  Object.defineProperty(creator, 'postcss', {
	    get() {
	      if (!cache) cache = creator();
	      return cache
	    }
	  });

	  creator.process = function (css, processOpts, pluginOpts) {
	    return postcss([creator(pluginOpts)]).process(css, processOpts)
	  };

	  return creator
	};

	postcss.stringify = stringify;
	postcss.parse = parse;
	postcss.fromJSON = fromJSON;
	postcss.list = list;

	postcss.comment = defaults => new Comment(defaults);
	postcss.atRule = defaults => new AtRule(defaults);
	postcss.decl = defaults => new Declaration(defaults);
	postcss.rule = defaults => new Rule(defaults);
	postcss.root = defaults => new Root(defaults);
	postcss.document = defaults => new Document(defaults);

	postcss.CssSyntaxError = CssSyntaxError;
	postcss.Declaration = Declaration;
	postcss.Container = Container;
	postcss.Processor = Processor;
	postcss.Document = Document;
	postcss.Comment = Comment;
	postcss.Warning = Warning;
	postcss.AtRule = AtRule;
	postcss.Result = Result;
	postcss.Input = Input;
	postcss.Rule = Rule;
	postcss.Root = Root;
	postcss.Node = Node;

	LazyResult.registerPostcss(postcss);

	postcss_1 = postcss;
	postcss.default = postcss;
	return postcss_1;
}

var sanitizeHtml_1;
var hasRequiredSanitizeHtml;

function requireSanitizeHtml () {
	if (hasRequiredSanitizeHtml) return sanitizeHtml_1;
	hasRequiredSanitizeHtml = 1;
	const htmlparser = /*@__PURE__*/ requireLib$1();
	const escapeStringRegexp = requireEscapeStringRegexp();
	const { isPlainObject } = requireIsPlainObject();
	const deepmerge = requireCjs();
	const parseSrcset = requireParseSrcset();
	const { parse: postcssParse } = requirePostcss();
	// Tags that can conceivably represent stand-alone media.
	const mediaTags = [
	  'img', 'audio', 'video', 'picture', 'svg',
	  'object', 'map', 'iframe', 'embed'
	];
	// Tags that are inherently vulnerable to being used in XSS attacks.
	const vulnerableTags = [ 'script', 'style' ];

	function each(obj, cb) {
	  if (obj) {
	    Object.keys(obj).forEach(function (key) {
	      cb(obj[key], key);
	    });
	  }
	}

	// Avoid false positives with .__proto__, .hasOwnProperty, etc.
	function has(obj, key) {
	  return ({}).hasOwnProperty.call(obj, key);
	}

	// Returns those elements of `a` for which `cb(a)` returns truthy
	function filter(a, cb) {
	  const n = [];
	  each(a, function(v) {
	    if (cb(v)) {
	      n.push(v);
	    }
	  });
	  return n;
	}

	function isEmptyObject(obj) {
	  for (const key in obj) {
	    if (has(obj, key)) {
	      return false;
	    }
	  }
	  return true;
	}

	function stringifySrcset(parsedSrcset) {
	  return parsedSrcset.map(function(part) {
	    if (!part.url) {
	      throw new Error('URL missing');
	    }

	    return (
	      part.url +
	      (part.w ? ` ${part.w}w` : '') +
	      (part.h ? ` ${part.h}h` : '') +
	      (part.d ? ` ${part.d}x` : '')
	    );
	  }).join(', ');
	}

	sanitizeHtml_1 = sanitizeHtml;

	// A valid attribute name.
	// We use a tolerant definition based on the set of strings defined by
	// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
	// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
	// The characters accepted are ones which can be appended to the attribute
	// name buffer without triggering a parse error:
	//   * unexpected-equals-sign-before-attribute-name
	//   * unexpected-null-character
	//   * unexpected-character-in-attribute-name
	// We exclude the empty string because it's impossible to get to the after
	// attribute name state with an empty attribute name buffer.
	const VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;

	// Ignore the _recursing flag; it's there for recursive
	// invocation as a guard against this exploit:
	// https://github.com/fb55/htmlparser2/issues/105

	function sanitizeHtml(html, options, _recursing) {
	  if (html == null) {
	    return '';
	  }
	  if (typeof html === 'number') {
	    html = html.toString();
	  }

	  let result = '';
	  // Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.
	  let tempResult = '';

	  function Frame(tag, attribs) {
	    const that = this;
	    this.tag = tag;
	    this.attribs = attribs || {};
	    this.tagPosition = result.length;
	    this.text = ''; // Node inner text
	    this.openingTagLength = 0;
	    this.mediaChildren = [];

	    this.updateParentNodeText = function() {
	      if (stack.length) {
	        const parentFrame = stack[stack.length - 1];
	        parentFrame.text += that.text;
	      }
	    };

	    this.updateParentNodeMediaChildren = function() {
	      if (stack.length && mediaTags.includes(this.tag)) {
	        const parentFrame = stack[stack.length - 1];
	        parentFrame.mediaChildren.push(this.tag);
	      }
	    };
	  }

	  options = Object.assign({}, sanitizeHtml.defaults, options);
	  options.parser = Object.assign({}, htmlParserDefaults, options.parser);

	  const tagAllowed = function (name) {
	    return options.allowedTags === false || (options.allowedTags || []).indexOf(name) > -1;
	  };

	  // vulnerableTags
	  vulnerableTags.forEach(function (tag) {
	    if (tagAllowed(tag) && !options.allowVulnerableTags) {
	      console.warn(`\n\n⚠️ Your \`allowedTags\` option includes, \`${tag}\`, which is inherently\nvulnerable to XSS attacks. Please remove it from \`allowedTags\`.\nOr, to disable this warning, add the \`allowVulnerableTags\` option\nand ensure you are accounting for this risk.\n\n`);
	    }
	  });

	  // Tags that contain something other than HTML, or where discarding
	  // the text when the tag is disallowed makes sense for other reasons.
	  // If we are not allowing these tags, we should drop their content too.
	  // For other tags you would drop the tag but keep its content.
	  const nonTextTagsArray = options.nonTextTags || [
	    'script',
	    'style',
	    'textarea',
	    'option'
	  ];
	  let allowedAttributesMap;
	  let allowedAttributesGlobMap;
	  if (options.allowedAttributes) {
	    allowedAttributesMap = {};
	    allowedAttributesGlobMap = {};
	    each(options.allowedAttributes, function(attributes, tag) {
	      allowedAttributesMap[tag] = [];
	      const globRegex = [];
	      attributes.forEach(function(obj) {
	        if (typeof obj === 'string' && obj.indexOf('*') >= 0) {
	          globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, '.*'));
	        } else {
	          allowedAttributesMap[tag].push(obj);
	        }
	      });
	      if (globRegex.length) {
	        allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
	      }
	    });
	  }
	  const allowedClassesMap = {};
	  const allowedClassesGlobMap = {};
	  const allowedClassesRegexMap = {};
	  each(options.allowedClasses, function(classes, tag) {
	    // Implicitly allows the class attribute
	    if (allowedAttributesMap) {
	      if (!has(allowedAttributesMap, tag)) {
	        allowedAttributesMap[tag] = [];
	      }
	      allowedAttributesMap[tag].push('class');
	    }

	    allowedClassesMap[tag] = classes;

	    if (Array.isArray(classes)) {
	      const globRegex = [];
	      allowedClassesMap[tag] = [];
	      allowedClassesRegexMap[tag] = [];
	      classes.forEach(function(obj) {
	        if (typeof obj === 'string' && obj.indexOf('*') >= 0) {
	          globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, '.*'));
	        } else if (obj instanceof RegExp) {
	          allowedClassesRegexMap[tag].push(obj);
	        } else {
	          allowedClassesMap[tag].push(obj);
	        }
	      });
	      if (globRegex.length) {
	        allowedClassesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
	      }
	    }
	  });

	  const transformTagsMap = {};
	  let transformTagsAll;
	  each(options.transformTags, function(transform, tag) {
	    let transFun;
	    if (typeof transform === 'function') {
	      transFun = transform;
	    } else if (typeof transform === 'string') {
	      transFun = sanitizeHtml.simpleTransform(transform);
	    }
	    if (tag === '*') {
	      transformTagsAll = transFun;
	    } else {
	      transformTagsMap[tag] = transFun;
	    }
	  });

	  let depth;
	  let stack;
	  let skipMap;
	  let transformMap;
	  let skipText;
	  let skipTextDepth;
	  let addedText = false;

	  initializeState();

	  const parser = new htmlparser.Parser({
	    onopentag: function(name, attribs) {
	      if (options.onOpenTag) {
	        options.onOpenTag(name, attribs);
	      }

	      // If `enforceHtmlBoundary` is `true` and this has found the opening
	      // `html` tag, reset the state.
	      if (options.enforceHtmlBoundary && name === 'html') {
	        initializeState();
	      }

	      if (skipText) {
	        skipTextDepth++;
	        return;
	      }
	      const frame = new Frame(name, attribs);
	      stack.push(frame);

	      let skip = false;
	      const hasText = !!frame.text;
	      let transformedTag;
	      if (has(transformTagsMap, name)) {
	        transformedTag = transformTagsMap[name](name, attribs);

	        frame.attribs = attribs = transformedTag.attribs;

	        if (transformedTag.text !== undefined) {
	          frame.innerText = transformedTag.text;
	        }

	        if (name !== transformedTag.tagName) {
	          frame.name = name = transformedTag.tagName;
	          transformMap[depth] = transformedTag.tagName;
	        }
	      }
	      if (transformTagsAll) {
	        transformedTag = transformTagsAll(name, attribs);

	        frame.attribs = attribs = transformedTag.attribs;
	        if (name !== transformedTag.tagName) {
	          frame.name = name = transformedTag.tagName;
	          transformMap[depth] = transformedTag.tagName;
	        }
	      }

	      if (!tagAllowed(name) || (options.disallowedTagsMode === 'recursiveEscape' && !isEmptyObject(skipMap)) || (options.nestingLimit != null && depth >= options.nestingLimit)) {
	        skip = true;
	        skipMap[depth] = true;
	        if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
	          if (nonTextTagsArray.indexOf(name) !== -1) {
	            skipText = true;
	            skipTextDepth = 1;
	          }
	        }
	      }
	      depth++;
	      if (skip) {
	        if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
	          // We want the contents but not this tag
	          if (frame.innerText && !hasText) {
	            const escaped = escapeHtml(frame.innerText);
	            if (options.textFilter) {
	              result += options.textFilter(escaped, name);
	            } else {
	              result += escaped;
	            }
	            addedText = true;
	          }
	          return;
	        }
	        tempResult = result;
	        result = '';
	      }
	      result += '<' + name;

	      if (name === 'script') {
	        if (options.allowedScriptHostnames || options.allowedScriptDomains) {
	          frame.innerText = '';
	        }
	      }

	      const isBeingEscaped = skip && (options.disallowedTagsMode === 'escape' || options.disallowedTagsMode === 'recursiveEscape');
	      const shouldPreserveEscapedAttributes = isBeingEscaped && options.preserveEscapedAttributes;

	      if (shouldPreserveEscapedAttributes) {
	        each(attribs, function(value, a) {
	          result += ' ' + a + '="' + escapeHtml((value || ''), true) + '"';
	        });
	      } else if (!allowedAttributesMap || has(allowedAttributesMap, name) || allowedAttributesMap['*']) {
	        each(attribs, function(value, a) {
	          if (!VALID_HTML_ATTRIBUTE_NAME.test(a)) {
	            // This prevents part of an attribute name in the output from being
	            // interpreted as the end of an attribute, or end of a tag.
	            delete frame.attribs[a];
	            return;
	          }
	          // If the value is empty, check if the attribute is in the allowedEmptyAttributes array.
	          // If it is not in the allowedEmptyAttributes array, and it is a known non-boolean attribute, delete it
	          // List taken from https://html.spec.whatwg.org/multipage/indices.html#attributes-3
	          if (value === '' && (!options.allowedEmptyAttributes.includes(a)) &&
	            (options.nonBooleanAttributes.includes(a) || options.nonBooleanAttributes.includes('*'))) {
	            delete frame.attribs[a];
	            return;
	          }
	          // check allowedAttributesMap for the element and attribute and modify the value
	          // as necessary if there are specific values defined.
	          let passedAllowedAttributesMapCheck = false;
	          if (!allowedAttributesMap ||
	            (has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1) ||
	            (allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1) ||
	            (has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a)) ||
	            (allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a))) {
	            passedAllowedAttributesMapCheck = true;
	          } else if (allowedAttributesMap && allowedAttributesMap[name]) {
	            for (const o of allowedAttributesMap[name]) {
	              if (isPlainObject(o) && o.name && (o.name === a)) {
	                passedAllowedAttributesMapCheck = true;
	                let newValue = '';
	                if (o.multiple === true) {
	                  // verify the values that are allowed
	                  const splitStrArray = value.split(' ');
	                  for (const s of splitStrArray) {
	                    if (o.values.indexOf(s) !== -1) {
	                      if (newValue === '') {
	                        newValue = s;
	                      } else {
	                        newValue += ' ' + s;
	                      }
	                    }
	                  }
	                } else if (o.values.indexOf(value) >= 0) {
	                  // verified an allowed value matches the entire attribute value
	                  newValue = value;
	                }
	                value = newValue;
	              }
	            }
	          }
	          if (passedAllowedAttributesMapCheck) {
	            if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
	              if (naughtyHref(name, value)) {
	                delete frame.attribs[a];
	                return;
	              }
	            }

	            if (name === 'script' && a === 'src') {

	              let allowed = true;

	              try {
	                const parsed = parseUrl(value);

	                if (options.allowedScriptHostnames || options.allowedScriptDomains) {
	                  const allowedHostname = (options.allowedScriptHostnames || []).find(function (hostname) {
	                    return hostname === parsed.url.hostname;
	                  });
	                  const allowedDomain = (options.allowedScriptDomains || []).find(function(domain) {
	                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
	                  });
	                  allowed = allowedHostname || allowedDomain;
	                }
	              } catch (e) {
	                allowed = false;
	              }

	              if (!allowed) {
	                delete frame.attribs[a];
	                return;
	              }
	            }

	            if (name === 'iframe' && a === 'src') {
	              let allowed = true;
	              try {
	                const parsed = parseUrl(value);

	                if (parsed.isRelativeUrl) {
	                  // default value of allowIframeRelativeUrls is true
	                  // unless allowedIframeHostnames or allowedIframeDomains specified
	                  allowed = has(options, 'allowIframeRelativeUrls')
	                    ? options.allowIframeRelativeUrls
	                    : (!options.allowedIframeHostnames && !options.allowedIframeDomains);
	                } else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
	                  const allowedHostname = (options.allowedIframeHostnames || []).find(function (hostname) {
	                    return hostname === parsed.url.hostname;
	                  });
	                  const allowedDomain = (options.allowedIframeDomains || []).find(function(domain) {
	                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
	                  });
	                  allowed = allowedHostname || allowedDomain;
	                }
	              } catch (e) {
	                // Unparseable iframe src
	                allowed = false;
	              }
	              if (!allowed) {
	                delete frame.attribs[a];
	                return;
	              }
	            }
	            if (a === 'srcset') {
	              try {
	                let parsed = parseSrcset(value);
	                parsed.forEach(function(value) {
	                  if (naughtyHref('srcset', value.url)) {
	                    value.evil = true;
	                  }
	                });
	                parsed = filter(parsed, function(v) {
	                  return !v.evil;
	                });
	                if (!parsed.length) {
	                  delete frame.attribs[a];
	                  return;
	                } else {
	                  value = stringifySrcset(filter(parsed, function(v) {
	                    return !v.evil;
	                  }));
	                  frame.attribs[a] = value;
	                }
	              } catch (e) {
	                // Unparseable srcset
	                delete frame.attribs[a];
	                return;
	              }
	            }
	            if (a === 'class') {
	              const allowedSpecificClasses = allowedClassesMap[name];
	              const allowedWildcardClasses = allowedClassesMap['*'];
	              const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
	              const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
	              const allowedWildcardClassesRegex = allowedClassesRegexMap['*'];
	              const allowedWildcardClassesGlob = allowedClassesGlobMap['*'];
	              const allowedClassesGlobs = [
	                allowedSpecificClassesGlob,
	                allowedWildcardClassesGlob
	              ]
	                .concat(allowedSpecificClassesRegex, allowedWildcardClassesRegex)
	                .filter(function (t) {
	                  return t;
	                });
	              if (allowedSpecificClasses && allowedWildcardClasses) {
	                value = filterClasses(value, deepmerge(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
	              } else {
	                value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
	              }
	              if (!value.length) {
	                delete frame.attribs[a];
	                return;
	              }
	            }
	            if (a === 'style') {
	              if (options.parseStyleAttributes) {
	                try {
	                  const abstractSyntaxTree = postcssParse(name + ' {' + value + '}', { map: false });
	                  const filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);

	                  value = stringifyStyleAttributes(filteredAST);

	                  if (value.length === 0) {
	                    delete frame.attribs[a];
	                    return;
	                  }
	                } catch (e) {
	                  if (typeof window !== 'undefined') {
	                    console.warn('Failed to parse "' + name + ' {' + value + '}' + '", If you\'re running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547');
	                  }
	                  delete frame.attribs[a];
	                  return;
	                }
	              } else if (options.allowedStyles) {
	                throw new Error('allowedStyles option cannot be used together with parseStyleAttributes: false.');
	              }
	            }
	            result += ' ' + a;
	            if (value && value.length) {
	              result += '="' + escapeHtml(value, true) + '"';
	            } else if (options.allowedEmptyAttributes.includes(a)) {
	              result += '=""';
	            }
	          } else {
	            delete frame.attribs[a];
	          }
	        });
	      }
	      if (options.selfClosing.indexOf(name) !== -1) {
	        result += ' />';
	      } else {
	        result += '>';
	        if (frame.innerText && !hasText && !options.textFilter) {
	          result += escapeHtml(frame.innerText);
	          addedText = true;
	        }
	      }
	      if (skip) {
	        result = tempResult + escapeHtml(result);
	        tempResult = '';
	      }
	      frame.openingTagLength = result.length - frame.tagPosition;
	    },
	    ontext: function(text) {
	      if (skipText) {
	        return;
	      }
	      const lastFrame = stack[stack.length - 1];
	      let tag;

	      if (lastFrame) {
	        tag = lastFrame.tag;
	        // If inner text was set by transform function then let's use it
	        text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
	      }

	      if (options.disallowedTagsMode === 'completelyDiscard' && !tagAllowed(tag)) {
	        text = '';
	      } else if ((options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') && ((tag === 'script') || (tag === 'style'))) {
	        // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
	        // script tags is, by definition, game over for XSS protection, so if that's
	        // your concern, don't allow them. The same is essentially true for style tags
	        // which have their own collection of XSS vectors.
	        result += text;
	      } else if (!addedText) {
	        const escaped = escapeHtml(text, false);
	        if (options.textFilter) {
	          result += options.textFilter(escaped, tag);
	        } else {
	          result += escaped;
	        }
	      }
	      if (stack.length) {
	        const frame = stack[stack.length - 1];
	        frame.text += text;
	      }
	    },
	    onclosetag: function(name, isImplied) {
	      if (options.onCloseTag) {
	        options.onCloseTag(name, isImplied);
	      }

	      if (skipText) {
	        skipTextDepth--;
	        if (!skipTextDepth) {
	          skipText = false;
	        } else {
	          return;
	        }
	      }

	      const frame = stack.pop();
	      if (!frame) {
	        // Do not crash on bad markup
	        return;
	      }

	      if (frame.tag !== name) {
	        // Another case of bad markup.
	        // Push to stack, so that it will be used in future closing tags.
	        stack.push(frame);
	        return;
	      }

	      skipText = options.enforceHtmlBoundary ? name === 'html' : false;
	      depth--;
	      const skip = skipMap[depth];
	      if (skip) {
	        delete skipMap[depth];
	        if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
	          frame.updateParentNodeText();
	          return;
	        }
	        tempResult = result;
	        result = '';
	      }

	      if (transformMap[depth]) {
	        name = transformMap[depth];
	        delete transformMap[depth];
	      }

	      if (options.exclusiveFilter) {
	        const filterResult = options.exclusiveFilter(frame);
	        if (filterResult === 'excludeTag') {
	          if (skip) {
	            // no longer escaping the tag since it's not added at all
	            result = tempResult;
	            tempResult = '';
	          }
	          // remove the opening tag from the result
	          result = result.substring(0, frame.tagPosition) + result.substring(frame.tagPosition + frame.openingTagLength);
	          return;
	        } else if (filterResult) {
	          result = result.substring(0, frame.tagPosition);
	          return;
	        }
	      }

	      frame.updateParentNodeMediaChildren();
	      frame.updateParentNodeText();

	      if (
	        // Already output />
	        options.selfClosing.indexOf(name) !== -1 ||
	        // Escaped tag, closing tag is implied
	        (isImplied && !tagAllowed(name) && [ 'escape', 'recursiveEscape' ].indexOf(options.disallowedTagsMode) >= 0)
	      ) {
	        if (skip) {
	          result = tempResult;
	          tempResult = '';
	        }
	        return;
	      }

	      result += '</' + name + '>';
	      if (skip) {
	        result = tempResult + escapeHtml(result);
	        tempResult = '';
	      }
	      addedText = false;
	    }
	  }, options.parser);
	  parser.write(html);
	  parser.end();

	  return result;

	  function initializeState() {
	    result = '';
	    depth = 0;
	    stack = [];
	    skipMap = {};
	    transformMap = {};
	    skipText = false;
	    skipTextDepth = 0;
	  }

	  function escapeHtml(s, quote) {
	    if (typeof (s) !== 'string') {
	      s = s + '';
	    }
	    if (options.parser.decodeEntities) {
	      s = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	      if (quote) {
	        s = s.replace(/"/g, '&quot;');
	      }
	    }
	    // TODO: this is inadequate because it will pass `&0;`. This approach
	    // will not work, each & must be considered with regard to whether it
	    // is followed by a 100% syntactically valid entity or not, and escaped
	    // if it is not. If this bothers you, don't set parser.decodeEntities
	    // to false. (The default is true.)
	    s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, '&amp;') // Match ampersands not part of existing HTML entity
	      .replace(/</g, '&lt;')
	      .replace(/>/g, '&gt;');
	    if (quote) {
	      s = s.replace(/"/g, '&quot;');
	    }
	    return s;
	  }

	  function naughtyHref(name, href) {
	    // Browsers ignore character codes of 32 (space) and below in a surprising
	    // number of situations. Start reading here:
	    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
	    // eslint-disable-next-line no-control-regex
	    href = href.replace(/[\x00-\x20]+/g, '');
	    // Clobber any comments in URLs, which the browser might
	    // interpret inside an XML data island, allowing
	    // a javascript: URL to be snuck through
	    while (true) {
	      const firstIndex = href.indexOf('<!--');
	      if (firstIndex === -1) {
	        break;
	      }
	      const lastIndex = href.indexOf('-->', firstIndex + 4);
	      if (lastIndex === -1) {
	        break;
	      }
	      href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
	    }
	    // Case insensitive so we don't get faked out by JAVASCRIPT #1
	    // Allow more characters after the first so we don't get faked
	    // out by certain schemes browsers accept
	    const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
	    if (!matches) {
	      // Protocol-relative URL starting with any combination of '/' and '\'
	      if (href.match(/^[/\\]{2}/)) {
	        return !options.allowProtocolRelative;
	      }

	      // No scheme
	      return false;
	    }
	    const scheme = matches[1].toLowerCase();

	    if (has(options.allowedSchemesByTag, name)) {
	      return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
	    }

	    return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
	  }

	  function parseUrl(value) {
	    value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, '$1//');
	    if (value.startsWith('relative:')) {
	      // An attempt to exploit our workaround for base URLs being
	      // mandatory for relative URL validation in the WHATWG
	      // URL parser, reject it
	      throw new Error('relative: exploit attempt');
	    }
	    // naughtyHref is in charge of whether protocol relative URLs
	    // are cool. Here we are concerned just with allowed hostnames and
	    // whether to allow relative URLs.
	    //
	    // Build a placeholder "base URL" against which any reasonable
	    // relative URL may be parsed successfully
	    let base = 'relative://relative-site';
	    for (let i = 0; (i < 100); i++) {
	      base += `/${i}`;
	    }

	    const parsed = new URL(value, base);

	    const isRelativeUrl = parsed && parsed.hostname === 'relative-site' && parsed.protocol === 'relative:';
	    return {
	      isRelativeUrl,
	      url: parsed
	    };
	  }
	  /**
	   * Filters user input css properties by allowlisted regex attributes.
	   * Modifies the abstractSyntaxTree object.
	   *
	   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
	   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
	   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
	   * @return {object}                    - The modified tree.
	   */
	  function filterCss(abstractSyntaxTree, allowedStyles) {
	    if (!allowedStyles) {
	      return abstractSyntaxTree;
	    }

	    const astRules = abstractSyntaxTree.nodes[0];
	    let selectedRule;

	    // Merge global and tag-specific styles into new AST.
	    if (allowedStyles[astRules.selector] && allowedStyles['*']) {
	      selectedRule = deepmerge(
	        allowedStyles[astRules.selector],
	        allowedStyles['*']
	      );
	    } else {
	      selectedRule = allowedStyles[astRules.selector] || allowedStyles['*'];
	    }

	    if (selectedRule) {
	      abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
	    }

	    return abstractSyntaxTree;
	  }

	  /**
	   * Extracts the style attributes from an AbstractSyntaxTree and formats those
	   * values in the inline style attribute format.
	   *
	   * @param  {AbstractSyntaxTree} filteredAST
	   * @return {string}             - Example: "color:yellow;text-align:center !important;font-family:helvetica;"
	   */
	  function stringifyStyleAttributes(filteredAST) {
	    return filteredAST.nodes[0].nodes
	      .reduce(function(extractedAttributes, attrObject) {
	        extractedAttributes.push(
	          `${attrObject.prop}:${attrObject.value}${attrObject.important ? ' !important' : ''}`
	        );
	        return extractedAttributes;
	      }, [])
	      .join(';');
	  }

	  /**
	    * Filters the existing attributes for the given property. Discards any attributes
	    * which don't match the allowlist.
	    *
	    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
	    * @param  {array} allowedDeclarationsList   - List of declarations which pass the allowlist.
	    * @param  {object} attributeObject          - Object representing the current css property.
	    * @property {string} attributeObject.type   - Typically 'declaration'.
	    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
	    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
	    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
	    */
	  function filterDeclarations(selectedRule) {
	    return function (allowedDeclarationsList, attributeObject) {
	      // If this property is allowlisted...
	      if (has(selectedRule, attributeObject.prop)) {
	        const matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
	          return regularExpression.test(attributeObject.value);
	        });

	        if (matchesRegex) {
	          allowedDeclarationsList.push(attributeObject);
	        }
	      }
	      return allowedDeclarationsList;
	    };
	  }

	  function filterClasses(classes, allowed, allowedGlobs) {
	    if (!allowed) {
	      // The class attribute is allowed without filtering on this tag
	      return classes;
	    }
	    classes = classes.split(/\s+/);
	    return classes.filter(function(clss) {
	      return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
	        return glob.test(clss);
	      });
	    }).join(' ');
	  }
	}

	// Defaults are accessible to you so that you can use them as a starting point
	// programmatically if you wish

	const htmlParserDefaults = {
	  decodeEntities: true
	};
	sanitizeHtml.defaults = {
	  allowedTags: [
	    // Sections derived from MDN element categories and limited to the more
	    // benign categories.
	    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
	    // Content sectioning
	    'address', 'article', 'aside', 'footer', 'header',
	    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hgroup',
	    'main', 'nav', 'section',
	    // Text content
	    'blockquote', 'dd', 'div', 'dl', 'dt', 'figcaption', 'figure',
	    'hr', 'li', 'menu', 'ol', 'p', 'pre', 'ul',
	    // Inline text semantics
	    'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn',
	    'em', 'i', 'kbd', 'mark', 'q',
	    'rb', 'rp', 'rt', 'rtc', 'ruby',
	    's', 'samp', 'small', 'span', 'strong', 'sub', 'sup', 'time', 'u', 'var', 'wbr',
	    // Table content
	    'caption', 'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th',
	    'thead', 'tr'
	  ],
	  // Tags that cannot be boolean
	  nonBooleanAttributes: [
	    'abbr', 'accept', 'accept-charset', 'accesskey', 'action',
	    'allow', 'alt', 'as', 'autocapitalize', 'autocomplete',
	    'blocking', 'charset', 'cite', 'class', 'color', 'cols',
	    'colspan', 'content', 'contenteditable', 'coords', 'crossorigin',
	    'data', 'datetime', 'decoding', 'dir', 'dirname', 'download',
	    'draggable', 'enctype', 'enterkeyhint', 'fetchpriority', 'for',
	    'form', 'formaction', 'formenctype', 'formmethod', 'formtarget',
	    'headers', 'height', 'hidden', 'high', 'href', 'hreflang',
	    'http-equiv', 'id', 'imagesizes', 'imagesrcset', 'inputmode',
	    'integrity', 'is', 'itemid', 'itemprop', 'itemref', 'itemtype',
	    'kind', 'label', 'lang', 'list', 'loading', 'low', 'max',
	    'maxlength', 'media', 'method', 'min', 'minlength', 'name',
	    'nonce', 'optimum', 'pattern', 'ping', 'placeholder', 'popover',
	    'popovertarget', 'popovertargetaction', 'poster', 'preload',
	    'referrerpolicy', 'rel', 'rows', 'rowspan', 'sandbox', 'scope',
	    'shape', 'size', 'sizes', 'slot', 'span', 'spellcheck', 'src',
	    'srcdoc', 'srclang', 'srcset', 'start', 'step', 'style',
	    'tabindex', 'target', 'title', 'translate', 'type', 'usemap',
	    'value', 'width', 'wrap',
	    // Event handlers
	    'onauxclick', 'onafterprint', 'onbeforematch', 'onbeforeprint',
	    'onbeforeunload', 'onbeforetoggle', 'onblur', 'oncancel',
	    'oncanplay', 'oncanplaythrough', 'onchange', 'onclick', 'onclose',
	    'oncontextlost', 'oncontextmenu', 'oncontextrestored', 'oncopy',
	    'oncuechange', 'oncut', 'ondblclick', 'ondrag', 'ondragend',
	    'ondragenter', 'ondragleave', 'ondragover', 'ondragstart',
	    'ondrop', 'ondurationchange', 'onemptied', 'onended',
	    'onerror', 'onfocus', 'onformdata', 'onhashchange', 'oninput',
	    'oninvalid', 'onkeydown', 'onkeypress', 'onkeyup',
	    'onlanguagechange', 'onload', 'onloadeddata', 'onloadedmetadata',
	    'onloadstart', 'onmessage', 'onmessageerror', 'onmousedown',
	    'onmouseenter', 'onmouseleave', 'onmousemove', 'onmouseout',
	    'onmouseover', 'onmouseup', 'onoffline', 'ononline', 'onpagehide',
	    'onpageshow', 'onpaste', 'onpause', 'onplay', 'onplaying',
	    'onpopstate', 'onprogress', 'onratechange', 'onreset', 'onresize',
	    'onrejectionhandled', 'onscroll', 'onscrollend',
	    'onsecuritypolicyviolation', 'onseeked', 'onseeking', 'onselect',
	    'onslotchange', 'onstalled', 'onstorage', 'onsubmit', 'onsuspend',
	    'ontimeupdate', 'ontoggle', 'onunhandledrejection', 'onunload',
	    'onvolumechange', 'onwaiting', 'onwheel'
	  ],
	  disallowedTagsMode: 'discard',
	  allowedAttributes: {
	    a: [ 'href', 'name', 'target' ],
	    // We don't currently allow img itself by default, but
	    // these attributes would make sense if we did.
	    img: [ 'src', 'srcset', 'alt', 'title', 'width', 'height', 'loading' ]
	  },
	  allowedEmptyAttributes: [
	    'alt'
	  ],
	  // Lots of these won't come up by default because we don't allow them
	  selfClosing: [ 'img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta' ],
	  // URL schemes we permit
	  allowedSchemes: [ 'http', 'https', 'ftp', 'mailto', 'tel' ],
	  allowedSchemesByTag: {},
	  allowedSchemesAppliedToAttributes: [ 'href', 'src', 'cite' ],
	  allowProtocolRelative: true,
	  enforceHtmlBoundary: false,
	  parseStyleAttributes: true,
	  preserveEscapedAttributes: false
	};

	sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
	  merge = (merge === undefined) ? true : merge;
	  newAttribs = newAttribs || {};

	  return function(tagName, attribs) {
	    let attrib;
	    if (merge) {
	      for (attrib in newAttribs) {
	        attribs[attrib] = newAttribs[attrib];
	      }
	    } else {
	      attribs = newAttribs;
	    }

	    return {
	      tagName: newTagName,
	      attribs: attribs
	    };
	  };
	};
	return sanitizeHtml_1;
}

var sanitizeHtmlExports = /*@__PURE__*/ requireSanitizeHtml();
var sanitizeHtml = /*@__PURE__*/getDefaultExportFromCjs(sanitizeHtmlExports);

var defaultOptions = {
  allowedAttributes: {
    a: ['href'],
    img: ['src', 'alt']
  },
  allowedTags: ['a', 'b', 'br', 'div', 'em', 'i', 'img', 'li', 'ol', 'p', 'span', 'strong', 'table', 'td', 'tr', 'ul']
};
var sanitize = function sanitize(dirty, options) {
  return {
    __html: sanitizeHtml(dirty, options = _objectSpread2(_objectSpread2({}, defaultOptions), options))
  };
};
var SanitizeHTML = function SanitizeHTML(_ref) {
  var html = _ref.html,
    options = _ref.options,
    className = _ref.className;
  var divClassName = "".concat(className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: divClassName,
    dangerouslySetInnerHTML: sanitize(html, options)
  });
};
SanitizeHTML.propTypes = {
  className: PropTypes.string,
  html: PropTypes.string,
  options: PropTypes.object
};

var lib = {};

var slider = {};

var innerSlider = {};

var initialState = {};

var hasRequiredInitialState;

function requireInitialState () {
	if (hasRequiredInitialState) return initialState;
	hasRequiredInitialState = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;
		var initialState = {
		  animating: false,
		  autoplaying: null,
		  currentDirection: 0,
		  currentLeft: null,
		  currentSlide: 0,
		  direction: 1,
		  dragging: false,
		  edgeDragged: false,
		  initialized: false,
		  lazyLoadedList: [],
		  listHeight: null,
		  listWidth: null,
		  scrolling: false,
		  slideCount: null,
		  slideHeight: null,
		  slideWidth: null,
		  swipeLeft: null,
		  swiped: false,
		  // used by swipeEvent. differentites between touch and swipe.
		  swiping: false,
		  touchObject: {
		    startX: 0,
		    startY: 0,
		    curX: 0,
		    curY: 0
		  },
		  trackStyle: {},
		  trackWidth: 0,
		  targetSlide: 0
		};
		exports["default"] = initialState; 
	} (initialState));
	return initialState;
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

var lodash_debounce;
var hasRequiredLodash_debounce;

function requireLodash_debounce () {
	if (hasRequiredLodash_debounce) return lodash_debounce;
	hasRequiredLodash_debounce = 1;
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;

	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';

	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;

	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;

	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;

	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;

	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};

	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;

	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }

	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;

	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }

	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }

	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;

	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }

	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;

	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }

	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }

	  function trailingEdge(time) {
	    timerId = undefined;

	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }

	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }

	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }

	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);

	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;

	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}

	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}

	lodash_debounce = debounce;
	return lodash_debounce;
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

var hasRequiredClassnames;

function requireClassnames () {
	if (hasRequiredClassnames) return classnames.exports;
	hasRequiredClassnames = 1;
	(function (module) {
		/* global define */

		(function () {

			var hasOwn = {}.hasOwnProperty;

			function classNames () {
				var classes = '';

				for (var i = 0; i < arguments.length; i++) {
					var arg = arguments[i];
					if (arg) {
						classes = appendClass(classes, parseValue(arg));
					}
				}

				return classes;
			}

			function parseValue (arg) {
				if (typeof arg === 'string' || typeof arg === 'number') {
					return arg;
				}

				if (typeof arg !== 'object') {
					return '';
				}

				if (Array.isArray(arg)) {
					return classNames.apply(null, arg);
				}

				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					return arg.toString();
				}

				var classes = '';

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes = appendClass(classes, key);
					}
				}

				return classes;
			}

			function appendClass (value, newClass) {
				if (!newClass) {
					return value;
				}
			
				if (value) {
					return value + ' ' + newClass;
				}
			
				return value + newClass;
			}

			if (module.exports) {
				classNames.default = classNames;
				module.exports = classNames;
			} else {
				window.classNames = classNames;
			}
		}()); 
	} (classnames));
	return classnames.exports;
}

var innerSliderUtils = {};

var defaultProps = {};

var hasRequiredDefaultProps;

function requireDefaultProps () {
	if (hasRequiredDefaultProps) return defaultProps;
	hasRequiredDefaultProps = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;
		var _react = _interopRequireDefault(React__default);
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
		var defaultProps = {
		  accessibility: true,
		  adaptiveHeight: false,
		  afterChange: null,
		  appendDots: function appendDots(dots) {
		    return /*#__PURE__*/_react["default"].createElement("ul", {
		      style: {
		        display: "block"
		      }
		    }, dots);
		  },
		  arrows: true,
		  autoplay: false,
		  autoplaySpeed: 3000,
		  beforeChange: null,
		  centerMode: false,
		  centerPadding: "50px",
		  className: "",
		  cssEase: "ease",
		  customPaging: function customPaging(i) {
		    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
		  },
		  dots: false,
		  dotsClass: "slick-dots",
		  draggable: true,
		  easing: "linear",
		  edgeFriction: 0.35,
		  fade: false,
		  focusOnSelect: false,
		  infinite: true,
		  initialSlide: 0,
		  lazyLoad: null,
		  nextArrow: null,
		  onEdge: null,
		  onInit: null,
		  onLazyLoadError: null,
		  onReInit: null,
		  pauseOnDotsHover: false,
		  pauseOnFocus: false,
		  pauseOnHover: true,
		  prevArrow: null,
		  responsive: null,
		  rows: 1,
		  rtl: false,
		  slide: "div",
		  slidesPerRow: 1,
		  slidesToScroll: 1,
		  slidesToShow: 1,
		  speed: 500,
		  swipe: true,
		  swipeEvent: null,
		  swipeToSlide: false,
		  touchMove: true,
		  touchThreshold: 5,
		  useCSS: true,
		  useTransform: true,
		  variableWidth: false,
		  vertical: false,
		  waitForAnimate: true,
		  asNavFor: null,
		  unslick: false
		};
		exports["default"] = defaultProps; 
	} (defaultProps));
	return defaultProps;
}

var hasRequiredInnerSliderUtils;

function requireInnerSliderUtils () {
	if (hasRequiredInnerSliderUtils) return innerSliderUtils;
	hasRequiredInnerSliderUtils = 1;

	Object.defineProperty(innerSliderUtils, "__esModule", {
	  value: true
	});
	innerSliderUtils.checkSpecKeys = innerSliderUtils.checkNavigable = innerSliderUtils.changeSlide = innerSliderUtils.canUseDOM = innerSliderUtils.canGoNext = void 0;
	innerSliderUtils.clamp = clamp;
	innerSliderUtils.extractObject = void 0;
	innerSliderUtils.filterSettings = filterSettings;
	innerSliderUtils.validSettings = innerSliderUtils.swipeStart = innerSliderUtils.swipeMove = innerSliderUtils.swipeEnd = innerSliderUtils.slidesOnRight = innerSliderUtils.slidesOnLeft = innerSliderUtils.slideHandler = innerSliderUtils.siblingDirection = innerSliderUtils.safePreventDefault = innerSliderUtils.lazyStartIndex = innerSliderUtils.lazySlidesOnRight = innerSliderUtils.lazySlidesOnLeft = innerSliderUtils.lazyEndIndex = innerSliderUtils.keyHandler = innerSliderUtils.initializedState = innerSliderUtils.getWidth = innerSliderUtils.getTrackLeft = innerSliderUtils.getTrackCSS = innerSliderUtils.getTrackAnimateCSS = innerSliderUtils.getTotalSlides = innerSliderUtils.getSwipeDirection = innerSliderUtils.getSlideCount = innerSliderUtils.getRequiredLazySlides = innerSliderUtils.getPreClones = innerSliderUtils.getPostClones = innerSliderUtils.getOnDemandLazySlides = innerSliderUtils.getNavigableIndexes = innerSliderUtils.getHeight = void 0;
	var _react = _interopRequireDefault(React__default);
	var _defaultProps = _interopRequireDefault(requireDefaultProps());
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
	function clamp(number, lowerBound, upperBound) {
	  return Math.max(lowerBound, Math.min(number, upperBound));
	}
	var safePreventDefault = innerSliderUtils.safePreventDefault = function safePreventDefault(event) {
	  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];
	  if (!passiveEvents.includes(event._reactName)) {
	    event.preventDefault();
	  }
	};
	var getOnDemandLazySlides = innerSliderUtils.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	  return onDemandSlides;
	};

	// return list of slides that need to be present
	innerSliderUtils.getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	  return requiredSlides;
	};

	// startIndex that needs to be present
	var lazyStartIndex = innerSliderUtils.lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	var lazyEndIndex = innerSliderUtils.lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	var lazySlidesOnLeft = innerSliderUtils.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	var lazySlidesOnRight = innerSliderUtils.lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	};

	// get width of an element
	var getWidth = innerSliderUtils.getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	var getHeight = innerSliderUtils.getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	var getSwipeDirection = innerSliderUtils.getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	  return "vertical";
	};

	// whether or not we can go next
	var canGoNext = innerSliderUtils.canGoNext = function canGoNext(spec) {
	  var canGo = true;
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	  return canGo;
	};

	// given an object and a list of keys, return new object with given keys
	innerSliderUtils.extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	};

	// get initialized state
	innerSliderUtils.initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react["default"].Children.count(spec.children);
	  var listNode = spec.listRef;
	  var listWidth = Math.ceil(getWidth(listNode));
	  var trackNode = spec.trackRef && spec.trackRef.node;
	  var trackWidth = Math.ceil(getWidth(trackNode));
	  var slideWidth;
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
	    currentSlide: currentSlide,
	    lazyLoadedList: lazyLoadedList
	  }));
	  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	  return state;
	};
	innerSliderUtils.slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	    animating = spec.animating,
	    fade = spec.fade,
	    infinite = spec.infinite,
	    index = spec.index,
	    slideCount = spec.slideCount,
	    lazyLoad = spec.lazyLoad,
	    currentSlide = spec.currentSlide,
	    centerMode = spec.centerMode,
	    slidesToScroll = spec.slidesToScroll,
	    slidesToShow = spec.slidesToShow,
	    useCSS = spec.useCSS;
	  var lazyLoadedList = spec.lazyLoadedList;
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	    finalSlide,
	    animationLeft,
	    finalLeft;
	  var state = {},
	    nextState = {};
	  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList = lazyLoadedList.concat(animationSlide);
	    }
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList,
	      targetSlide: animationSlide
	    };
	    nextState = {
	      animating: false,
	      targetSlide: animationSlide
	    };
	  } else {
	    finalSlide = animationSlide;
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	    if (!infinite && animationSlide + slidesToShow >= slideCount) {
	      finalSlide = slideCount - slidesToShow;
	    }
	    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
	      slideIndex: animationSlide
	    }));
	    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
	      slideIndex: finalSlide
	    }));
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	    if (lazyLoad) {
	      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
	        currentSlide: animationSlide
	      })));
	    }
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: finalLeft
	        })),
	        lazyLoadedList: lazyLoadedList,
	        targetSlide: targetSlide
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: animationLeft
	        })),
	        lazyLoadedList: lazyLoadedList,
	        targetSlide: targetSlide
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: finalLeft
	        })),
	        swipeLeft: null,
	        targetSlide: targetSlide
	      };
	    }
	  }
	  return {
	    state: state,
	    nextState: nextState
	  };
	};
	innerSliderUtils.changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	    slidesToShow = spec.slidesToShow,
	    slideCount = spec.slideCount,
	    currentSlide = spec.currentSlide,
	    previousTargetSlide = spec.targetSlide,
	    lazyLoad = spec.lazyLoad,
	    infinite = spec.infinite;
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	    if (!infinite) {
	      targetSlide = previousTargetSlide - slidesToScroll;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	    if (!infinite) {
	      targetSlide = previousTargetSlide + slidesToScroll;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	    if (infinite) {
	      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
	        targetSlide: targetSlide
	      }));
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	  }
	  return targetSlide;
	};
	innerSliderUtils.keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	innerSliderUtils.swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && safePreventDefault(e);
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	innerSliderUtils.swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	    animating = spec.animating,
	    vertical = spec.vertical,
	    swipeToSlide = spec.swipeToSlide,
	    verticalSwiping = spec.verticalSwiping,
	    rtl = spec.rtl,
	    currentSlide = spec.currentSlide,
	    edgeFriction = spec.edgeFriction,
	    edgeDragged = spec.edgeDragged,
	    onEdge = spec.onEdge,
	    swiped = spec.swiped,
	    swiping = spec.swiping,
	    slideCount = spec.slideCount,
	    slidesToScroll = spec.slidesToScroll,
	    infinite = spec.infinite,
	    touchObject = spec.touchObject,
	    swipeEvent = spec.swipeEvent,
	    listHeight = spec.listHeight,
	    listWidth = spec.listWidth;
	  if (scrolling) return;
	  if (animating) return safePreventDefault(e);
	  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
	  var swipeLeft,
	    state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return {
	      scrolling: true
	    };
	  }
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	  if (!infinite) {
	    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	  state = _objectSpread(_objectSpread({}, state), {}, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	      left: swipeLeft
	    }))
	  });
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    safePreventDefault(e);
	  }
	  return state;
	};
	innerSliderUtils.swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	    swipe = spec.swipe,
	    touchObject = spec.touchObject,
	    listWidth = spec.listWidth,
	    touchThreshold = spec.touchThreshold,
	    verticalSwiping = spec.verticalSwiping,
	    listHeight = spec.listHeight,
	    swipeToSlide = spec.swipeToSlide,
	    scrolling = spec.scrolling,
	    onSwipe = spec.onSwipe,
	    targetSlide = spec.targetSlide,
	    currentSlide = spec.currentSlide,
	    infinite = spec.infinite;
	  if (!dragging) {
	    if (swipe) safePreventDefault(e);
	    return {};
	  }
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
	  // reset the state of touch related state variables.
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	  if (scrolling) {
	    return state;
	  }
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	  if (touchObject.swipeLength > minSwipe) {
	    safePreventDefault(e);
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	    var slideCount, newSlide;
	    var activeSlide = infinite ? currentSlide : targetSlide;
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = activeSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	      case "right":
	      case "down":
	        newSlide = activeSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	      default:
	        slideCount = activeSlide;
	    }
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
	      left: currentLeft
	    }));
	  }
	  return state;
	};
	var getNavigableIndexes = innerSliderUtils.getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	  return indexes;
	};
	var checkNavigable = innerSliderUtils.checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	      prevNavigable = navigables[n];
	    }
	  }
	  return index;
	};
	var getSlideCount = innerSliderUtils.getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	  if (spec.swipeToSlide) {
	    var swipedSlide;
	    var slickList = spec.listRef;
	    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	      return true;
	    });
	    if (!swipedSlide) {
	      return 0;
	    }
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	var checkSpecKeys = innerSliderUtils.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	var getTrackCSS = innerSliderUtils.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _objectSpread(_objectSpread({}, style), {}, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	  if (spec.fade) style = {
	    opacity: 1
	  };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight;

	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	  return style;
	};
	var getTrackAnimateCSS = innerSliderUtils.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	  return style;
	};
	var getTrackLeft = innerSliderUtils.getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	  var slideIndex = spec.slideIndex,
	    trackRef = spec.trackRef,
	    infinite = spec.infinite,
	    centerMode = spec.centerMode,
	    slideCount = spec.slideCount,
	    slidesToShow = spec.slidesToShow,
	    slidesToScroll = spec.slidesToScroll,
	    slideWidth = spec.slideWidth,
	    listWidth = spec.listWidth,
	    variableWidth = spec.variableWidth,
	    slideHeight = spec.slideHeight,
	    fade = spec.fade,
	    vertical = spec.vertical;
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = trackRef && trackRef.node;
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	  return targetLeft;
	};
	var getPreClones = innerSliderUtils.getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	var getPostClones = innerSliderUtils.getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  return spec.slideCount;
	};
	var getTotalSlides = innerSliderUtils.getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	var siblingDirection = innerSliderUtils.siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	    return "left";
	  }
	};
	var slidesOnRight = innerSliderUtils.slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	    centerMode = _ref.centerMode,
	    rtl = _ref.rtl,
	    centerPadding = _ref.centerPadding;
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	  if (rtl) {
	    return 0;
	  }
	  return slidesToShow - 1;
	};
	var slidesOnLeft = innerSliderUtils.slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	    centerMode = _ref2.centerMode,
	    rtl = _ref2.rtl,
	    centerPadding = _ref2.centerPadding;
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	  return 0;
	};
	innerSliderUtils.canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};
	var validSettings = innerSliderUtils.validSettings = Object.keys(_defaultProps["default"]);
	function filterSettings(settings) {
	  return validSettings.reduce(function (acc, settingName) {
	    if (settings.hasOwnProperty(settingName)) {
	      acc[settingName] = settings[settingName];
	    }
	    return acc;
	  }, {});
	}
	return innerSliderUtils;
}

var track = {};

var hasRequiredTrack;

function requireTrack () {
	if (hasRequiredTrack) return track;
	hasRequiredTrack = 1;

	Object.defineProperty(track, "__esModule", {
	  value: true
	});
	track.Track = void 0;
	var _react = _interopRequireDefault(React__default);
	var _classnames = _interopRequireDefault(requireClassnames());
	var _innerSliderUtils = requireInnerSliderUtils();
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  var focusedSlide;
	  if (spec.targetSlide < 0) {
	    focusedSlide = spec.targetSlide + spec.slideCount;
	  } else if (spec.targetSlide >= spec.slideCount) {
	    focusedSlide = spec.targetSlide - spec.slideCount;
	  } else {
	    focusedSlide = spec.targetSlide;
	  }
	  var slickCurrent = index === focusedSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	  };
	};
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	  if (spec.fade) {
	    style.position = "relative";
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.zIndex = spec.currentSlide === spec.index ? 999 : 998;
	    if (spec.useCSS) {
	      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	  return style;
	};
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react["default"].Children.count(spec.children);
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	  _react["default"].Children.forEach(spec.children, function (elem, index) {
	    var child;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };

	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = /*#__PURE__*/_react["default"].createElement("div", null);
	    }
	    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
	      index: index
	    }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	      index: index
	    }));
	    // push a cloned element of the desired slide
	    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames["default"])(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _objectSpread(_objectSpread({
	        outline: "none"
	      }, child.props.style || {}), childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    }));

	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec)) {
	        key = -preCloneNo;
	        if (key >= startIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	          index: key
	        }));
	        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	      key = childrenCount + index;
	      if (key < endIndex) {
	        child = elem;
	      }
	      slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	        index: key
	      }));
	      postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	        key: "postcloned" + getKey(child, key),
	        "data-index": key,
	        tabIndex: "-1",
	        className: (0, _classnames["default"])(slideClasses, slideClass),
	        "aria-hidden": !slideClasses["slick-active"],
	        style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
	        onClick: function onClick(e) {
	          child.props && child.props.onClick && child.props.onClick(e);
	          if (spec.focusOnSelect) {
	            spec.focusOnSelect(childOnClickOptions);
	          }
	        }
	      }));
	    }
	  });
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	track.Track = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	  var _super = _createSuper(Track);
	  function Track() {
	    var _this;
	    _classCallCheck(this, Track);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    _defineProperty(_assertThisInitialized(_this), "node", null);
	    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
	      _this.node = ref;
	    });
	    return _this;
	  }
	  _createClass(Track, [{
	    key: "render",
	    value: function render() {
	      var slides = renderSlides(this.props);
	      var _this$props = this.props,
	        onMouseEnter = _this$props.onMouseEnter,
	        onMouseOver = _this$props.onMouseOver,
	        onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      return /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: this.handleRef,
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents), slides);
	    }
	  }]);
	  return Track;
	}(_react["default"].PureComponent);
	return track;
}

var dots = {};

var hasRequiredDots;

function requireDots () {
	if (hasRequiredDots) return dots;
	hasRequiredDots = 1;

	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(dots, "__esModule", {
	  value: true
	});
	dots.Dots = void 0;
	var _react = _interopRequireDefault(React__default);
	var _classnames = _interopRequireDefault(requireClassnames());
	var _innerSliderUtils = requireInnerSliderUtils();
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return (String )(t); }
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	  return dots;
	};
	dots.Dots = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	  var _super = _createSuper(Dots);
	  function Dots() {
	    _classCallCheck(this, Dots);
	    return _super.apply(this, arguments);
	  }
	  _createClass(Dots, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      // In Autoplay the focus stays on clicked button even after transition
	      // to next slide. That only goes away by click somewhere outside
	      e.preventDefault();
	      this.props.clickHandler(options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	        onMouseEnter = _this$props.onMouseEnter,
	        onMouseOver = _this$props.onMouseOver,
	        onMouseLeave = _this$props.onMouseLeave,
	        infinite = _this$props.infinite,
	        slidesToScroll = _this$props.slidesToScroll,
	        slidesToShow = _this$props.slidesToShow,
	        slideCount = _this$props.slideCount,
	        currentSlide = _this$props.currentSlide;
	      var dotCount = getDotCount({
	        slideCount: slideCount,
	        slidesToScroll: slidesToScroll,
	        slidesToShow: slidesToShow,
	        infinite: infinite
	      });
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      var dots = [];
	      for (var i = 0; i < dotCount; i++) {
	        var _rightBound = (i + 1) * slidesToScroll - 1;
	        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);
	        var _leftBound = rightBound - (slidesToScroll - 1);
	        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
	        var className = (0, _classnames["default"])({
	          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
	        });
	        var dotOptions = {
	          message: "dots",
	          index: i,
	          slidesToScroll: slidesToScroll,
	          currentSlide: currentSlide
	        };
	        var onClick = this.clickHandler.bind(this, dotOptions);
	        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
	          key: i,
	          className: className
	        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
	          onClick: onClick
	        })));
	      }
	      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
	        className: this.props.dotsClass
	      }, mouseEvents));
	    }
	  }]);
	  return Dots;
	}(_react["default"].PureComponent);
	return dots;
}

var arrows = {};

var hasRequiredArrows;

function requireArrows () {
	if (hasRequiredArrows) return arrows;
	hasRequiredArrows = 1;

	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(arrows, "__esModule", {
	  value: true
	});
	arrows.PrevArrow = arrows.NextArrow = void 0;
	var _react = _interopRequireDefault(React__default);
	var _classnames = _interopRequireDefault(requireClassnames());
	var _innerSliderUtils = requireInnerSliderUtils();
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return (String )(t); }
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	arrows.PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	  var _super = _createSuper(PrevArrow);
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	    return _super.apply(this, arguments);
	  }
	  _createClass(PrevArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevClasses = {
	        "slick-arrow": true,
	        "slick-prev": true
	      };
	      var prevHandler = this.clickHandler.bind(this, {
	        message: "previous"
	      });
	      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	        prevClasses["slick-disabled"] = true;
	        prevHandler = null;
	      }
	      var prevArrowProps = {
	        key: "0",
	        "data-role": "none",
	        className: (0, _classnames["default"])(prevClasses),
	        style: {
	          display: "block"
	        },
	        onClick: prevHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var prevArrow;
	      if (this.props.prevArrow) {
	        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
	      } else {
	        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
	          key: "0",
	          type: "button"
	        }, prevArrowProps), " ", "Previous");
	      }
	      return prevArrow;
	    }
	  }]);
	  return PrevArrow;
	}(_react["default"].PureComponent);
	arrows.NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	  var _super2 = _createSuper(NextArrow);
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	    return _super2.apply(this, arguments);
	  }
	  _createClass(NextArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nextClasses = {
	        "slick-arrow": true,
	        "slick-next": true
	      };
	      var nextHandler = this.clickHandler.bind(this, {
	        message: "next"
	      });
	      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	        nextClasses["slick-disabled"] = true;
	        nextHandler = null;
	      }
	      var nextArrowProps = {
	        key: "1",
	        "data-role": "none",
	        className: (0, _classnames["default"])(nextClasses),
	        style: {
	          display: "block"
	        },
	        onClick: nextHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var nextArrow;
	      if (this.props.nextArrow) {
	        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
	      } else {
	        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
	          key: "1",
	          type: "button"
	        }, nextArrowProps), " ", "Next");
	      }
	      return nextArrow;
	    }
	  }]);
	  return NextArrow;
	}(_react["default"].PureComponent);
	return arrows;
}

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global$2 !== 'undefined' && global$2.Math === Math) {
        return global$2;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

var ResizeObserver_es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: index
});

var require$$8 = /*@__PURE__*/getAugmentedNamespace(ResizeObserver_es);

var hasRequiredInnerSlider;

function requireInnerSlider () {
	if (hasRequiredInnerSlider) return innerSlider;
	hasRequiredInnerSlider = 1;

	Object.defineProperty(innerSlider, "__esModule", {
	  value: true
	});
	innerSlider.InnerSlider = void 0;
	var _react = _interopRequireDefault(React__default);
	var _initialState = _interopRequireDefault(requireInitialState());
	var _lodash = _interopRequireDefault(requireLodash_debounce());
	var _classnames = _interopRequireDefault(requireClassnames());
	var _innerSliderUtils = requireInnerSliderUtils();
	var _track = requireTrack();
	var _dots = requireDots();
	var _arrows = requireArrows();
	var _resizeObserverPolyfill = _interopRequireDefault(require$$8);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
	innerSlider.InnerSlider = /*#__PURE__*/function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	  var _super = _createSuper(InnerSlider);
	  function InnerSlider(props) {
	    var _this;
	    _classCallCheck(this, InnerSlider);
	    _this = _super.call(this, props);
	    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
	      return _this.list = ref;
	    });
	    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
	      return _this.track = ref;
	    });
	    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    });
	    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
	      _this.props.onInit && _this.props.onInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props);
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	      _this.ro = new _resizeObserverPolyfill["default"](function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	      _this.ro.observe(_this.list);
	      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    });
	    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	        _this.callbackTimers = [];
	      }
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	      _this.ro.disconnect();
	    });
	    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
	      _this.checkImagesLoad();
	      _this.props.onReInit && _this.props.onReInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	      // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	      _this.adaptHeight();
	      var spec = _objectSpread(_objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props), _this.state);
	      var setTrackStyle = _this.didPropsChange(prevProps);
	      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	        if (_this.props.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    });
	    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash["default"])(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	      _this.debouncedResize();
	    });
	    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var isTrackMounted = Boolean(_this.track && _this.track.node);
	      // prevent warning: setting state on unmounted component (server side rendering)
	      if (!isTrackMounted) return;
	      var spec = _objectSpread(_objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props), _this.state);
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      });
	      // animating state should be cleared while resizing, otherwise autoplay stops working
	      _this.setState({
	        animating: false
	      });
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    });
	    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
	        slideIndex: updatedState.currentSlide
	      });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _objectSpread(_objectSpread({}, spec), {}, {
	        left: targetLeft
	      });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	      _this.setState(updatedState, callback);
	    });
	    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	          _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	          slideCount: _this.props.children.length
	        }));
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	        for (var _i = 0; _i < postClones; _i++) {
	          _trackWidth += childrenWidths[_i];
	        }
	        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
	          _trackLeft += childrenWidths[_i2];
	        }
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	        if (_this.props.centerMode) {
	          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
	          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
	        }
	        return {
	          trackStyle: _trackStyle
	        };
	      }
	      var childrenCount = _react["default"].Children.count(_this.props.children);
	      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        slideCount: childrenCount
	      });
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      return {
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      };
	    });
	    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
	      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
	      var imagesCount = images.length,
	        loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	          image.onclick = function (e) {
	            prevClickHandler(e);
	            image.parentNode.focus();
	          };
	        }
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    });
	    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
	      var slidesToLoad = [];
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    });
	    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	        asNavFor = _this$props.asNavFor,
	        beforeChange = _this$props.beforeChange,
	        onLazyLoad = _this$props.onLazyLoad,
	        speed = _this$props.speed,
	        afterChange = _this$props.afterChange; // capture currentslide before state is updated
	      var currentSlide = _this.state.currentSlide;
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
	          index: index
	        }, _this.props), _this.state), {}, {
	          trackRef: _this.track,
	          useCSS: _this.props.useCSS && !dontAnimate
	        })),
	        state = _slideHandler.state,
	        nextState = _slideHandler.nextState;
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	        afterChange && afterChange(currentSlide);
	        delete _this.animationEndCallback;
	      }
	      _this.setState(state, function () {
	        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
	        if (asNavFor && _this.asNavForIndex !== index) {
	          _this.asNavForIndex = index;
	          asNavFor.innerSlider.slideHandler(index);
	        }
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	            firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({
	                animating: animating
	              });
	            }, 10));
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    });
	    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	      _this.props.autoplay && _this.autoPlay("update");
	      if (_this.props.focusOnSelect) {
	        var nodes = _this.list.querySelectorAll(".slick-current");
	        nodes[0] && nodes[0].focus();
	      }
	    });
	    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      _this.clickable = true;
	    });
	    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({
	        message: dir
	      });
	    });
	    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
	      _this.changeSlide(options);
	    });
	    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	      window.ontouchmove = preventDefault;
	    });
	    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
	      window.ontouchmove = null;
	    });
	    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    });
	    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	      _this.setState(state);
	    });
	    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	      _this.setState(state);
	      if (triggerSlideHandler === undefined) return;
	      _this.slideHandler(triggerSlideHandler);
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    });
	    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
	      _this.swipeEnd(e);
	      _this.clickable = true;
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "previous"
	        });
	      }, 0));
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "next"
	        });
	      }, 0));
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    });
	    _defineProperty(_assertThisInitialized(_this), "play", function () {
	      var nextIndex;
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	      _this.slideHandler(nextIndex);
	    });
	    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	      _this.setState({
	        autoplaying: "playing"
	      });
	    });
	    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (pauseType === "paused") {
	        _this.setState({
	          autoplaying: "paused"
	        });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "focused"
	          });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "hovered"
	          });
	        }
	      }
	    });
	    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
	      return _this.props.autoplay && _this.pause("focused");
	    });
	    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    });
	    _defineProperty(_assertThisInitialized(_this), "render", function () {
	      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
	      });
	      var dots;
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
	      }
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	      if (_this.props.arrows) {
	        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
	      }
	      var verticalHeightStyle = null;
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	      var centerPaddingStyle = null;
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.touchEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr",
	        style: _this.props.style
	      };
	      if (_this.props.unslick) {
	        listProps = {
	          className: "slick-list"
	        };
	        innerSliderProps = {
	          className: className
	        };
	      }
	      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: _this.listRefHandler
	      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
	        ref: _this.trackRefHandler
	      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    });
	    _this.list = null;
	    _this.track = null;
	    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
	      currentSlide: _this.props.initialSlide,
	      targetSlide: _this.props.initialSlide ? _this.props.initialSlide : 0,
	      slideCount: _react["default"].Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    var ssrState = _this.ssrInit();
	    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
	    return _this;
	  }
	  _createClass(InnerSlider, [{
	    key: "didPropsChange",
	    value: function didPropsChange(prevProps) {
	      var setTrackStyle = false;
	      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
	        var key = _Object$keys[_i3];
	        if (!prevProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function" || isNaN(prevProps[key])) {
	          continue;
	        }
	        if (prevProps[key] !== this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
	    }
	  }]);
	  return InnerSlider;
	}(_react["default"].Component);
	return innerSlider;
}

var camel2hyphen_1;
var hasRequiredCamel2hyphen;

function requireCamel2hyphen () {
	if (hasRequiredCamel2hyphen) return camel2hyphen_1;
	hasRequiredCamel2hyphen = 1;
	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};

	camel2hyphen_1 = camel2hyphen;
	return camel2hyphen_1;
}

var json2mq_1;
var hasRequiredJson2mq;

function requireJson2mq () {
	if (hasRequiredJson2mq) return json2mq_1;
	hasRequiredJson2mq = 1;
	var camel2hyphen = requireCamel2hyphen();

	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};

	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and ';
	    }
	  });
	  return mq;
	};

	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', ';
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};

	json2mq_1 = json2mq;
	return json2mq_1;
}

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */

var QueryHandler_1;
var hasRequiredQueryHandler;

function requireQueryHandler () {
	if (hasRequiredQueryHandler) return QueryHandler_1;
	hasRequiredQueryHandler = 1;
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}

	QueryHandler.prototype = {

	    constructor : QueryHandler,

	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },

	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },

	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },

	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },

	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }

	};

	QueryHandler_1 = QueryHandler;
	return QueryHandler_1;
}

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */

var Util;
var hasRequiredUtil;

function requireUtil () {
	if (hasRequiredUtil) return Util;
	hasRequiredUtil = 1;
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;

	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}

	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}

	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}

	Util = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};
	return Util;
}

var MediaQuery_1;
var hasRequiredMediaQuery;

function requireMediaQuery () {
	if (hasRequiredMediaQuery) return MediaQuery_1;
	hasRequiredMediaQuery = 1;
	var QueryHandler = requireQueryHandler();
	var each = requireUtil().each;

	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);

	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}

	MediaQuery.prototype = {

	    constuctor : MediaQuery,

	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);

	        this.matches() && qh.on();
	    },

	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },

	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },

	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },

	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';

	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};

	MediaQuery_1 = MediaQuery;
	return MediaQuery_1;
}

var MediaQueryDispatch_1;
var hasRequiredMediaQueryDispatch;

function requireMediaQueryDispatch () {
	if (hasRequiredMediaQueryDispatch) return MediaQueryDispatch_1;
	hasRequiredMediaQueryDispatch = 1;
	var MediaQuery = requireMediaQuery();
	var Util = requireUtil();
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;

	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }

	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}

	MediaQueryDispatch.prototype = {

	    constructor : MediaQueryDispatch,

	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;

	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }

	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });

	        return this;
	    },

	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];

	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }

	        return this;
	    }
	};

	MediaQueryDispatch_1 = MediaQueryDispatch;
	return MediaQueryDispatch_1;
}

var src;
var hasRequiredSrc;

function requireSrc () {
	if (hasRequiredSrc) return src;
	hasRequiredSrc = 1;
	var MediaQueryDispatch = requireMediaQueryDispatch();
	src = new MediaQueryDispatch();
	return src;
}

var hasRequiredSlider;

function requireSlider () {
	if (hasRequiredSlider) return slider;
	hasRequiredSlider = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;
		var _react = _interopRequireDefault(React__default);
		var _innerSlider = requireInnerSlider();
		var _json2mq = _interopRequireDefault(requireJson2mq());
		var _defaultProps = _interopRequireDefault(requireDefaultProps());
		var _innerSliderUtils = requireInnerSliderUtils();
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
		function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
		function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
		function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
		function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
		function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
		function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
		function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
		function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
		function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
		function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
		function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
		function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
		function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
		var enquire = (0, _innerSliderUtils.canUseDOM)() && requireSrc();
		exports["default"] = /*#__PURE__*/function (_React$Component) {
		  _inherits(Slider, _React$Component);
		  var _super = _createSuper(Slider);
		  function Slider(props) {
		    var _this;
		    _classCallCheck(this, Slider);
		    _this = _super.call(this, props);
		    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
		      return _this.innerSlider = ref;
		    });
		    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
		      return _this.innerSlider.slickPrev();
		    });
		    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
		      return _this.innerSlider.slickNext();
		    });
		    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
		      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
		      return _this.innerSlider.slickGoTo(slide, dontAnimate);
		    });
		    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
		      return _this.innerSlider.pause("paused");
		    });
		    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
		      return _this.innerSlider.autoPlay("play");
		    });
		    _this.state = {
		      breakpoint: null
		    };
		    _this._responsiveMediaHandlers = [];
		    return _this;
		  }
		  _createClass(Slider, [{
		    key: "media",
		    value: function media(query, handler) {
		      // javascript handler for  css media query
		      enquire.register(query, handler);
		      this._responsiveMediaHandlers.push({
		        query: query,
		        handler: handler
		      });
		    } // handles responsive breakpoints
		  }, {
		    key: "componentDidMount",
		    value: function componentDidMount() {
		      var _this2 = this;
		      // performance monitoring
		      //if (process.env.NODE_ENV !== 'production') {
		      //const { whyDidYouUpdate } = require('why-did-you-update')
		      //whyDidYouUpdate(React)
		      //}
		      if (this.props.responsive) {
		        var breakpoints = this.props.responsive.map(function (breakpt) {
		          return breakpt.breakpoint;
		        });
		        // sort them in increasing order of their numerical value
		        breakpoints.sort(function (x, y) {
		          return x - y;
		        });
		        breakpoints.forEach(function (breakpoint, index) {
		          // media query for each breakpoint
		          var bQuery;
		          if (index === 0) {
		            bQuery = (0, _json2mq["default"])({
		              minWidth: 0,
		              maxWidth: breakpoint
		            });
		          } else {
		            bQuery = (0, _json2mq["default"])({
		              minWidth: breakpoints[index - 1] + 1,
		              maxWidth: breakpoint
		            });
		          }
		          // when not using server side rendering
		          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
		            _this2.setState({
		              breakpoint: breakpoint
		            });
		          });
		        });

		        // Register media query for full screen. Need to support resize from small to large
		        // convert javascript object to media query string
		        var query = (0, _json2mq["default"])({
		          minWidth: breakpoints.slice(-1)[0]
		        });
		        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
		          _this2.setState({
		            breakpoint: null
		          });
		        });
		      }
		    }
		  }, {
		    key: "componentWillUnmount",
		    value: function componentWillUnmount() {
		      this._responsiveMediaHandlers.forEach(function (obj) {
		        enquire.unregister(obj.query, obj.handler);
		      });
		    }
		  }, {
		    key: "render",
		    value: function render() {
		      var _this3 = this;
		      var settings;
		      var newProps;
		      if (this.state.breakpoint) {
		        newProps = this.props.responsive.filter(function (resp) {
		          return resp.breakpoint === _this3.state.breakpoint;
		        });
		        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
		      } else {
		        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
		      }

		      // force scrolling by one if centerMode is on
		      if (settings.centerMode) {
		        if (settings.slidesToScroll > 1 && browser$1.env.NODE_ENV !== "production") {
		          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
		        }
		        settings.slidesToScroll = 1;
		      }
		      // force showing one slide and scrolling by one if the fade mode is on
		      if (settings.fade) {
		        if (settings.slidesToShow > 1 && browser$1.env.NODE_ENV !== "production") {
		          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
		        }
		        if (settings.slidesToScroll > 1 && browser$1.env.NODE_ENV !== "production") {
		          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
		        }
		        settings.slidesToShow = 1;
		        settings.slidesToScroll = 1;
		      }

		      // makes sure that children is an array, even when there is only 1 child
		      var children = _react["default"].Children.toArray(this.props.children);

		      // Children may contain false or null, so we should filter them
		      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
		      children = children.filter(function (child) {
		        if (typeof child === "string") {
		          return !!child.trim();
		        }
		        return !!child;
		      });

		      // rows and slidesPerRow logic is handled here
		      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
		        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
		        settings.variableWidth = false;
		      }
		      var newChildren = [];
		      var currentWidth = null;
		      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
		        var newSlide = [];
		        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
		          var row = [];
		          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
		            if (settings.variableWidth && children[k].props.style) {
		              currentWidth = children[k].props.style.width;
		            }
		            if (k >= children.length) break;
		            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
		              key: 100 * i + 10 * j + k,
		              tabIndex: -1,
		              style: {
		                width: "".concat(100 / settings.slidesPerRow, "%"),
		                display: "inline-block"
		              }
		            }));
		          }
		          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
		            key: 10 * i + j
		          }, row));
		        }
		        if (settings.variableWidth) {
		          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
		            key: i,
		            style: {
		              width: currentWidth
		            }
		          }, newSlide));
		        } else {
		          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
		            key: i
		          }, newSlide));
		        }
		      }
		      if (settings === "unslick") {
		        var className = "regular slider " + (this.props.className || "");
		        return /*#__PURE__*/_react["default"].createElement("div", {
		          className: className
		        }, children);
		      } else if (newChildren.length <= settings.slidesToShow && !settings.infinite) {
		        settings.unslick = true;
		      }
		      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
		        style: this.props.style,
		        ref: this.innerSliderRefHandler
		      }, (0, _innerSliderUtils.filterSettings)(settings)), newChildren);
		    }
		  }]);
		  return Slider;
		}(_react["default"].Component); 
	} (slider));
	return slider;
}

var hasRequiredLib;

function requireLib () {
	if (hasRequiredLib) return lib;
	hasRequiredLib = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;
		var _slider = _interopRequireDefault(requireSlider());
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
		exports["default"] = _slider["default"]; 
	} (lib));
	return lib;
}

var libExports = requireLib();
var SlickSlider = /*@__PURE__*/getDefaultExportFromCjs(libExports);

var css_248z$c = "@charset \"UTF-8\";\n.tc-quick-view_container__a9n8I,\n.tc-quick-view_container-fluid__7eT0F,\n.tc-quick-view_container-xxxl2__KT1cX,\n.tc-quick-view_container-xxxl__HIanW,\n.tc-quick-view_container-xxl__clvO0,\n.tc-quick-view_container-xl__BgYYC,\n.tc-quick-view_container-lg__L0ndu,\n.tc-quick-view_container-md__uDdXn,\n.tc-quick-view_container-sm__euhS8 {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-quick-view_container-sm__euhS8, .tc-quick-view_container__a9n8I {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-quick-view_container-md__uDdXn, .tc-quick-view_container-sm__euhS8, .tc-quick-view_container__a9n8I {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-quick-view_container-lg__L0ndu, .tc-quick-view_container-md__uDdXn, .tc-quick-view_container-sm__euhS8, .tc-quick-view_container__a9n8I {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-quick-view_container-xl__BgYYC, .tc-quick-view_container-lg__L0ndu, .tc-quick-view_container-md__uDdXn, .tc-quick-view_container-sm__euhS8, .tc-quick-view_container__a9n8I {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-quick-view_container-xxl__clvO0, .tc-quick-view_container-xl__BgYYC, .tc-quick-view_container-lg__L0ndu, .tc-quick-view_container-md__uDdXn, .tc-quick-view_container-sm__euhS8, .tc-quick-view_container__a9n8I {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-quick-view_container-xxxl__HIanW, .tc-quick-view_container-xxl__clvO0, .tc-quick-view_container-xl__BgYYC, .tc-quick-view_container-lg__L0ndu, .tc-quick-view_container-md__uDdXn, .tc-quick-view_container-sm__euhS8, .tc-quick-view_container__a9n8I {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-quick-view_container-xxxl2__KT1cX, .tc-quick-view_container-xxxl__HIanW, .tc-quick-view_container-xxl__clvO0, .tc-quick-view_container-xl__BgYYC, .tc-quick-view_container-lg__L0ndu, .tc-quick-view_container-md__uDdXn, .tc-quick-view_container-sm__euhS8, .tc-quick-view_container__a9n8I {\n    max-width: 182rem;\n  }\n}\n.tc-quick-view_timesList_list__1Z-xA, .tc-quick-view_checkList_list__5DbH6, .tc-quick-view_list_list__id2VJ {\n  column-count: 1;\n}\n\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_list__7ngQD, .tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_list__D-PY7 {\n  column-count: 2;\n}\n\n@media (min-width: 768px) {\n  .tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_item__-NHk5,\n  .tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_list__7ngQD li, .tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_item__Qj270,\n  .tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_list__D-PY7 li, .tc-quick-view_timesList_item__y0cSi,\n  .tc-quick-view_timesList_list__1Z-xA li, .tc-quick-view_checkList_item__6Bvcg,\n  .tc-quick-view_checkList_list__5DbH6 li, .tc-quick-view_list_item__pd2iN,\n  .tc-quick-view_list_list__id2VJ li {\n    font-size: 1.8rem;\n  }\n}\n.tc-quick-view_list_list__id2VJ {\n  margin-bottom: 2.5rem;\n  padding-left: calc((3.2rem) / 2);\n  list-style: none;\n}\n@media (min-width: 992px) {\n  .tc-quick-view_list_list__id2VJ {\n    margin-bottom: 3.5rem;\n  }\n}\n@media (max-width: 991.98px) {\n  .tc-quick-view_list_list__id2VJ {\n    column-count: 2;\n  }\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_list_list__id2VJ {\n    column-count: 1;\n  }\n}\n\n.tc-quick-view_list_item__pd2iN,\n.tc-quick-view_list_list__id2VJ li {\n  position: relative;\n  margin-bottom: 1.2rem;\n  padding-left: 3.5rem;\n}\n.tc-quick-view_list_item__pd2iN::before,\n.tc-quick-view_list_list__id2VJ li::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  vertical-align: sub;\n  color: #1b8158;\n  font-size: 2em;\n  line-height: 0.9;\n  font-weight: bold;\n  font-family: \"Font Awesome 5 Free\";\n  content: \"• \";\n}\n.tc-quick-view_list_item__pd2iN.tc-quick-view_action_item__U-vsX:nth-child(n+10),\n.tc-quick-view_list_list__id2VJ li.tc-quick-view_action_item__U-vsX:nth-child(n+10) {\n  display: none;\n}\n\n.tc-quick-view_checkList_list__5DbH6 {\n  margin-bottom: 2.5rem;\n  padding-left: calc((3.2rem) / 2);\n  list-style: none;\n}\n@media (min-width: 992px) {\n  .tc-quick-view_checkList_list__5DbH6 {\n    margin-bottom: 3.5rem;\n  }\n}\n@media (max-width: 991.98px) {\n  .tc-quick-view_checkList_list__5DbH6 {\n    column-count: 2;\n  }\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_checkList_list__5DbH6 {\n    column-count: 1;\n  }\n}\n\n.tc-quick-view_checkList_item__6Bvcg,\n.tc-quick-view_checkList_list__5DbH6 li {\n  position: relative;\n  margin-bottom: 1.2rem;\n  padding-left: 3.5rem;\n}\n.tc-quick-view_checkList_item__6Bvcg::before,\n.tc-quick-view_checkList_list__5DbH6 li::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  vertical-align: sub;\n  font-weight: bold;\n  font-family: \"Font Awesome 5 Free\";\n  content: \"\\f00c\";\n  color: #72c6ea;\n}\n.tc-quick-view_checkList_item__6Bvcg.tc-quick-view_action_item__U-vsX:nth-child(n+10),\n.tc-quick-view_checkList_list__5DbH6 li.tc-quick-view_action_item__U-vsX:nth-child(n+10) {\n  display: none;\n}\n\n.tc-quick-view_timesList_list__1Z-xA {\n  margin-bottom: 2.5rem;\n  padding-left: calc((3.2rem) / 2);\n  list-style: none;\n}\n@media (min-width: 992px) {\n  .tc-quick-view_timesList_list__1Z-xA {\n    margin-bottom: 3.5rem;\n  }\n}\n@media (max-width: 991.98px) {\n  .tc-quick-view_timesList_list__1Z-xA {\n    column-count: 2;\n  }\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_timesList_list__1Z-xA {\n    column-count: 1;\n  }\n}\n\n.tc-quick-view_timesList_item__y0cSi,\n.tc-quick-view_timesList_list__1Z-xA li {\n  position: relative;\n  margin-bottom: 1.2rem;\n  padding-left: 3.5rem;\n}\n.tc-quick-view_timesList_item__y0cSi::before,\n.tc-quick-view_timesList_list__1Z-xA li::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  vertical-align: sub;\n  font-weight: bold;\n  font-family: \"Font Awesome 5 Free\";\n  content: \"\\f00d\";\n  color: #e06f4f;\n}\n.tc-quick-view_timesList_item__y0cSi.tc-quick-view_action_item__U-vsX:nth-child(n+10),\n.tc-quick-view_timesList_list__1Z-xA li.tc-quick-view_action_item__U-vsX:nth-child(n+10) {\n  display: none;\n}\n\n.tc-quick-view_product__XYfP6 {\n  height: auto;\n  max-height: 94vh;\n  overflow-y: auto;\n}\n.tc-quick-view_product__XYfP6 .MuiBox-root {\n  padding: 0;\n}\n.tc-quick-view_product__description-wrapper__6RHkh {\n  padding-right: 2rem;\n  overflow-y: auto;\n}\n.tc-quick-view_product__advertised-promotion__x-OEI {\n  display: flex;\n  align-items: center;\n  margin-bottom: 3rem;\n  font-size: 1.8rem;\n}\n.tc-quick-view_product__advertised-promotion__x-OEI::before {\n  display: block;\n  min-width: 4.5rem;\n  height: 4.5rem;\n  margin-top: 1rem;\n  margin-right: 0.8rem;\n  margin-bottom: 1rem;\n  color: #fff;\n  font-weight: 700;\n  font-size: 1.9rem;\n  line-height: 4.5rem;\n  text-align: center;\n  background: #c23326;\n  border-radius: 50%;\n  content: \"%\";\n}\n@media (max-width: 991.98px) {\n  .tc-quick-view_product__advertised-promotion__x-OEI {\n    font-size: 1.5rem;\n  }\n}\n.tc-quick-view_product__advertised-promotion-label__TVx44 {\n  color: #c23326;\n  white-space: nowrap;\n}\n\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_list__D-PY7 {\n  margin-bottom: 2.5rem;\n  padding-left: calc((3.2rem) / 2);\n  list-style: none;\n}\n@media (min-width: 992px) {\n  .tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_list__D-PY7 {\n    margin-bottom: 3.5rem;\n  }\n}\n@media (max-width: 991.98px) {\n  .tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_list__D-PY7 {\n    column-count: 2;\n  }\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_list__D-PY7 {\n    column-count: 1;\n  }\n}\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_item__Qj270,\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_list__D-PY7 li {\n  position: relative;\n  margin-bottom: 1.2rem;\n  padding-left: 3.5rem;\n}\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_item__Qj270::before,\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_list__D-PY7 li::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  vertical-align: sub;\n  font-weight: bold;\n  font-family: \"Font Awesome 5 Free\";\n  content: \"\\f00c\";\n  color: #72c6ea;\n}\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_item__Qj270.tc-quick-view_action_item__U-vsX:nth-child(n+10),\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_list__D-PY7 li.tc-quick-view_action_item__U-vsX:nth-child(n+10) {\n  display: none;\n}\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_list__7ngQD {\n  margin-bottom: 2.5rem;\n  padding-left: calc((3.2rem) / 2);\n  list-style: none;\n}\n@media (min-width: 992px) {\n  .tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_list__7ngQD {\n    margin-bottom: 3.5rem;\n  }\n}\n@media (max-width: 991.98px) {\n  .tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_list__7ngQD {\n    column-count: 2;\n  }\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_list__7ngQD {\n    column-count: 1;\n  }\n}\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_item__-NHk5,\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_list__7ngQD li {\n  position: relative;\n  margin-bottom: 1.2rem;\n  padding-left: 3.5rem;\n}\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_item__-NHk5::before,\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_list__7ngQD li::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  vertical-align: sub;\n  font-weight: bold;\n  font-family: \"Font Awesome 5 Free\";\n  content: \"\\f00d\";\n  color: #e06f4f;\n}\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_item__-NHk5.tc-quick-view_action_item__U-vsX:nth-child(n+10),\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_list__7ngQD li.tc-quick-view_action_item__U-vsX:nth-child(n+10) {\n  display: none;\n}\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListChecked_item__Qj270,\n.tc-quick-view_quickView__modal__hl-gR .tc-quick-view_quickViewListTimes_item__-NHk5 {\n  font-size: 1.4rem !important;\n}\n.tc-quick-view_quickView__modal__hl-gR .accordion_button::before, .tc-quick-view_quickView__modal__hl-gR .accordion_button::after {\n  top: 0.5rem;\n}\n.tc-quick-view_quickView__modal__hl-gR .accordion_item {\n  position: relative;\n  overflow: hidden;\n}\n.tc-quick-view_quickView__modal__hl-gR .accordion_item::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 0.4rem;\n  background-color: #b2deba;\n  border-radius: 0.2rem;\n  content: \"\";\n}\n\n.tc-quick-view_productImages__slider__7xR9Y {\n  display: flex;\n}\n@media (min-width: 992px) {\n  .tc-quick-view_productImages__slider__7xR9Y {\n    height: 35.625vw;\n    max-height: 58.5rem;\n  }\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_productImages__slider__7xR9Y {\n    width: 100vw;\n    height: 95.313vw;\n    margin-left: -1.6rem;\n    overflow: hidden;\n  }\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I {\n  width: 16%;\n  margin-right: 1.5rem;\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I {\n    width: 100%;\n    max-width: 100%;\n    margin-right: 0;\n  }\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-list {\n  padding: 1.2rem 1.6rem 1.2rem 0 !important;\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-list {\n    padding: 0 1.6rem 0 0 !important;\n  }\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-track {\n  flex-direction: column;\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-track {\n    display: block;\n    flex-direction: row;\n  }\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-slide {\n  min-width: 6rem;\n  margin-bottom: 1.7rem;\n  padding: 0;\n  overflow: hidden;\n  border: 0.1rem solid #5e6469;\n  border-radius: 1rem;\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-slide {\n    display: block;\n    width: 75vw !important;\n    max-height: 75vw;\n    margin: 1.2rem 0.7rem 1.7rem;\n    border: none;\n    border-radius: 2rem;\n    box-shadow: 0 0.2rem 1.5rem rgba(0, 0, 0, 0.16);\n  }\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-slide.slick-current {\n  box-shadow: 0 0.2rem 1.5rem rgba(27, 129, 88, 0.13);\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-slide.slick-current {\n    box-shadow: 0 0.2rem 1.5rem rgba(0, 0, 0, 0.16);\n  }\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-slide:hover {\n  cursor: pointer;\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-slide > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .thumbnail {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  height: 10rem;\n  padding: 0.5rem;\n}\n@media (max-width: 1599.98px) {\n  .tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .thumbnail {\n    height: 7rem;\n  }\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .thumbnail {\n    max-width: 75vw;\n    height: 75vw;\n  }\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .thumbnail img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-dots {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-dots {\n    margin-bottom: 2rem;\n  }\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-dots li {\n  width: 1rem;\n  height: 1rem;\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-dots li button {\n  width: 1rem;\n  height: 1rem;\n  background: #1b8158;\n  border-radius: 50%;\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-dots li button::before {\n  content: none;\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__slider-thumbs__8Ue9I .slick-dots li.tc-quick-view_slick-active__oC6n7 button {\n  background: #005c35;\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__main-slider__FiZqV {\n  position: relative;\n  width: 84%;\n}\n@media (max-width: 767.98px) {\n  .tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__main-slider__FiZqV {\n    display: none;\n  }\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__main-slider__FiZqV .slick-arrow {\n  top: 50%;\n  bottom: unset;\n  width: 2.4vw;\n  height: 2.4vw;\n  margin: 0;\n  border-radius: 50%;\n  transform: translateY(-50%);\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__main-slider__FiZqV .slick-arrow + .slick-list {\n  padding-bottom: 0;\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__main-slider__FiZqV .slick-arrow::before {\n  font-size: 1vw;\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__main-slider__FiZqV .slick-prev {\n  left: 0.8vw;\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__main-slider__FiZqV .slick-next {\n  right: 0.8vw;\n  left: unset;\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__main-slider__FiZqV .slick-slide {\n  padding: 0;\n}\n@media (min-width: 992px) {\n  .tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__main-slider__FiZqV .slick-slide {\n    height: 35.625vw;\n    max-height: 58.5rem;\n  }\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__main-slider__FiZqV .slick-slide [class^=\"tmb-\"] {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n.tc-quick-view_productImages__slider__7xR9Y .tc-quick-view_productImages__main-slider__FiZqV .slick-slide img {\n  display: inline-block;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.tc-quick-view_productImages__product-advertise__-HODQ {\n  position: absolute;\n  top: 1.2rem;\n  left: 2rem;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 9.6rem;\n  height: 9.6rem;\n  color: #fff;\n  font-weight: 700;\n  font-size: 2rem;\n  line-height: 1;\n  text-align: center;\n  word-spacing: 1rem;\n  background: #c23326;\n  border-radius: 50%;\n}\n@media (max-width: 991.98px) {\n  .tc-quick-view_productImages__product-advertise__-HODQ {\n    display: none;\n  }\n}";
var css$6 = {"quickView__modal":"tc-quick-view_quickView__modal__hl-gR","quickViewListTimes_list":"tc-quick-view_quickViewListTimes_list__7ngQD","quickViewListChecked_list":"tc-quick-view_quickViewListChecked_list__D-PY7","quickViewListTimes_item":"tc-quick-view_quickViewListTimes_item__-NHk5","quickViewListChecked_item":"tc-quick-view_quickViewListChecked_item__Qj270","product":"tc-quick-view_product__XYfP6","product__description-wrapper":"tc-quick-view_product__description-wrapper__6RHkh","product__advertised-promotion":"tc-quick-view_product__advertised-promotion__x-OEI","product__advertised-promotion-label":"tc-quick-view_product__advertised-promotion-label__TVx44","productImages__slider":"tc-quick-view_productImages__slider__7xR9Y","productImages__slider-thumbs":"tc-quick-view_productImages__slider-thumbs__8Ue9I","productImages__main-slider":"tc-quick-view_productImages__main-slider__FiZqV","productImages__product-advertise":"tc-quick-view_productImages__product-advertise__-HODQ"};
styleInject(css_248z$c);

var ProductImageSlider = function ProductImageSlider(_ref) {
  var images = _ref.images,
    isOnSale = _ref.isOnSale,
    translations = _ref.translations;
  // Carousel settings for main slider
  var mainSliderSettings = {
    arrows: images.length > 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        unslick: true
      }
    }]
  };

  // Settings for thumbnail slider
  var thumbSliderSettings = {
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
    vertical: true,
    variableWidth: true,
    infinite: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        dots: true,
        slidesToShow: 1,
        variableWidth: true,
        vertical: false
      }
    }]
  };
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    nav1 = _useState2[0],
    setNav1 = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    nav2 = _useState4[0],
    setNav2 = _useState4[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "productImages__wrapper col-lg-6",
    "data-hook": "product_left_part_wrap"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$6.productImages__slider,
    id: "slick-carousel"
  }, /*#__PURE__*/React__default.createElement(SlickSlider, _extends$2({
    className: css$6['productImages__slider-thumbs']
  }, thumbSliderSettings, {
    asNavFor: nav1,
    ref: function ref(slider) {
      return setNav2(slider);
    }
  }), images.map(function (image, i) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "thumbnail tmb-".concat(i),
      key: image
    }, /*#__PURE__*/React__default.createElement("img", {
      alt: "tmb-".concat(i),
      src: image
    }));
  })), /*#__PURE__*/React__default.createElement(SlickSlider, _extends$2({
    className: "".concat(css$6['productImages__main-slider'], " ").concat(isOnSale ? 'on-sale' : '')
  }, mainSliderSettings, {
    asNavFor: nav2,
    ref: function ref(slider) {
      return setNav1(slider);
    }
  }), images.map(function (image, i) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "tmb-".concat(i),
      key: image
    }, isOnSale && /*#__PURE__*/React__default.createElement("div", {
      className: css$6['productImages__product-advertise']
    }, /*#__PURE__*/React__default.createElement("span", null, translations.on_sale)), /*#__PURE__*/React__default.createElement("img", {
      alt: "thumbnail-".concat(i),
      src: image
    }));
  }))));
};
ProductImageSlider.propTypes = {
  images: PropTypes.array.isRequired,
  isOnSale: PropTypes.bool.isRequired,
  translations: PropTypes.object.isRequired
};

var WhatYouCanRecycle = function WhatYouCanRecycle(_ref) {
  var data = _ref.data,
    translations = _ref.translations;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "accordion mt-5",
    id: "quick_view_accordion"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "accordion_item"
  }, /*#__PURE__*/React__default.createElement("h5", {
    className: "accordion_header"
  }, /*#__PURE__*/React__default.createElement("button", {
    "aria-controls": "collapse1",
    "aria-expanded": "false",
    className: "accordion_button",
    "data-bs-target": "#collapse1",
    "data-bs-toggle": "collapse",
    type: "button"
  }, translations.what_you_can_recycle_title)), /*#__PURE__*/React__default.createElement("div", {
    "aria-labelledby": "heading1",
    className: "accordion_collapse collapse",
    "data-bs-parent": "#quick_view_accordion",
    id: "collapse1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "accordion_body"
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "".concat(css$6.quickViewListChecked_list, " mb-4}")
  }, data.can_recycle_taxons.map(function (item) {
    return /*#__PURE__*/React__default.createElement("li", {
      className: "".concat(css$6.quickViewListChecked_item),
      key: item
    }, item);
  })), /*#__PURE__*/React__default.createElement("div", null, translations.what_you_can_recycle_do_not_send), /*#__PURE__*/React__default.createElement("ul", {
    className: "".concat(css$6.quickViewListTimes_list, " mt-4 mb-0}")
  }, data.cannot_recycle_taxons.map(function (item) {
    return /*#__PURE__*/React__default.createElement("li", {
      className: "".concat(css$6.quickViewListTimes_item),
      key: item
    }, item);
  }))))));
};
WhatYouCanRecycle.propTypes = {
  data: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired
};

var getCookie = function getCookie(name) {
  var value = "; ".concat(document.cookie);
  var parts = value.split("; ".concat(name, "="));
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

var css_248z$b = ".tc-add-to-cart_container__SiDi8,\n.tc-add-to-cart_container-fluid__kEKkU,\n.tc-add-to-cart_container-xxxl2__2lerH,\n.tc-add-to-cart_container-xxxl__4Wwlt,\n.tc-add-to-cart_container-xxl__RIH37,\n.tc-add-to-cart_container-xl__vbFSN,\n.tc-add-to-cart_container-lg__WZfOD,\n.tc-add-to-cart_container-md__7gLM6,\n.tc-add-to-cart_container-sm__IsPTy {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-add-to-cart_container-sm__IsPTy, .tc-add-to-cart_container__SiDi8 {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-add-to-cart_container-md__7gLM6, .tc-add-to-cart_container-sm__IsPTy, .tc-add-to-cart_container__SiDi8 {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-add-to-cart_container-lg__WZfOD, .tc-add-to-cart_container-md__7gLM6, .tc-add-to-cart_container-sm__IsPTy, .tc-add-to-cart_container__SiDi8 {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-add-to-cart_container-xl__vbFSN, .tc-add-to-cart_container-lg__WZfOD, .tc-add-to-cart_container-md__7gLM6, .tc-add-to-cart_container-sm__IsPTy, .tc-add-to-cart_container__SiDi8 {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-add-to-cart_container-xxl__RIH37, .tc-add-to-cart_container-xl__vbFSN, .tc-add-to-cart_container-lg__WZfOD, .tc-add-to-cart_container-md__7gLM6, .tc-add-to-cart_container-sm__IsPTy, .tc-add-to-cart_container__SiDi8 {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-add-to-cart_container-xxxl__4Wwlt, .tc-add-to-cart_container-xxl__RIH37, .tc-add-to-cart_container-xl__vbFSN, .tc-add-to-cart_container-lg__WZfOD, .tc-add-to-cart_container-md__7gLM6, .tc-add-to-cart_container-sm__IsPTy, .tc-add-to-cart_container__SiDi8 {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-add-to-cart_container-xxxl2__2lerH, .tc-add-to-cart_container-xxxl__4Wwlt, .tc-add-to-cart_container-xxl__RIH37, .tc-add-to-cart_container-xl__vbFSN, .tc-add-to-cart_container-lg__WZfOD, .tc-add-to-cart_container-md__7gLM6, .tc-add-to-cart_container-sm__IsPTy, .tc-add-to-cart_container__SiDi8 {\n    max-width: 182rem;\n  }\n}\n.tc-add-to-cart_product__content-wrapper__p6f4E {\n  display: flex;\n  justify-content: center;\n  padding-bottom: 2.5rem;\n  border-bottom: 0.1rem solid #e2e2e2;\n}\n.tc-add-to-cart_product__info-wrapper__BE-EP {\n  margin-left: 4rem;\n}\n.tc-add-to-cart_product__section__S0QXR {\n  display: flex;\n}\n.tc-add-to-cart_product__name__k3IqL {\n  min-width: 36rem;\n  margin: 0;\n  font-weight: 700;\n  font-size: 2rem;\n}\n.tc-add-to-cart_product__description__okxwP {\n  color: #707070;\n  font-weight: 500;\n  font-size: 1.6rem;\n  line-height: 3rem;\n}\n.tc-add-to-cart_product__price-wrapper__9N7UZ {\n  display: flex;\n  align-items: center;\n}\n.tc-add-to-cart_product__price-wrapper__9N7UZ.onSale .tc-add-to-cart_product__price__ks9Nv {\n  color: #c23326;\n}\n.tc-add-to-cart_product__price-wrapper__9N7UZ .volumePrice {\n  margin-left: 0.4rem;\n  padding-left: 0.3rem;\n  color: #acacac;\n  font-weight: 400;\n  text-decoration: line-through;\n  border-left: 0.1rem solid #b2deba;\n}\n.tc-add-to-cart_product__price__ks9Nv {\n  margin: 0;\n  color: #1b8158;\n  font-weight: 700;\n  font-size: 2rem;\n}\n.tc-add-to-cart_product__separator__9PcZn {\n  margin: 0 4rem;\n  border-left: 0.1rem solid #e2e2e2;\n}\n\n.tc-add-to-cart_info-section__kcq4c {\n  position: relative;\n  min-width: 30rem;\n}\n.tc-add-to-cart_info-section__item__wI5mQ {\n  display: flex;\n  justify-content: space-between;\n}\n.tc-add-to-cart_info-section__item__wI5mQ p:first-of-type {\n  width: 70%;\n}\n.tc-add-to-cart_info-section__item__wI5mQ p {\n  margin: 0;\n  font-weight: 600;\n}\n\n.tc-add-to-cart_recommendations__wrapper__i3wZc {\n  position: relative;\n  min-width: auto;\n  min-height: 38rem;\n}\n.tc-add-to-cart_recommendations__wrapper__i3wZc .tc-add-to-cart_error-center__diQ2f {\n  padding: 0 0 3rem;\n  text-align: center;\n}\n.tc-add-to-cart_recommendations__wrapper__i3wZc .collectionCard_quickView {\n  bottom: -1rem;\n  padding: 0.5rem 2rem;\n  font-size: 1.6rem;\n}\n.tc-add-to-cart_recommendations__section__wox9C {\n  display: flex;\n  justify-content: center;\n  margin: 0 -1rem;\n}\n.tc-add-to-cart_recommendations__section__wox9C .collection-item__content {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n.tc-add-to-cart_recommendations__section__wox9C .collection-item {\n  width: 20%;\n  margin-bottom: 0;\n  padding: 0 1rem;\n}\n\n.tc-add-to-cart_product-select__h2qx9 .MuiFormControl-root {\n  width: 100%;\n  padding: 0;\n  border: none;\n  border-radius: 2.3rem;\n}\n.tc-add-to-cart_product-select__h2qx9 .MuiInputBase-root {\n  height: 4.5rem;\n  font-family: \"Poppins\", verdana, sans-serif;\n}\n.tc-add-to-cart_product-select__h2qx9 .MuiInputBase-root.Mui-focused .MuiSelect-select {\n  border-bottom-width: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.tc-add-to-cart_product-select__h2qx9 .MuiInputBase-root.Mui-focused .MuiSelect-select:focus {\n  border-radius: 2.3rem;\n  box-shadow: inset 0 0 0 0.1rem #1b8158;\n}\n.tc-add-to-cart_product-select__h2qx9 .MuiSelect-select {\n  box-sizing: border-box;\n  height: 100%;\n  margin: 0;\n  padding: 0 2.4rem;\n  color: #13220f;\n  font-size: 1.6rem;\n  line-height: 2.8125;\n  border: none;\n  border-radius: 2.3rem;\n  box-shadow: inset 0 0 0 0.1rem #1b8158;\n}\n.tc-add-to-cart_product-select__h2qx9 .MuiSelect-select:focus {\n  border-radius: 2.3rem;\n  box-shadow: inset 0 0 0 0.1rem #1b8158;\n}\n.tc-add-to-cart_product-select__h2qx9 .MuiSelect-nativeInput {\n  height: 0;\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n.tc-add-to-cart_product-select__h2qx9 .MuiSelect-icon {\n  top: 50%;\n  right: 1.35rem;\n  width: 3.6rem;\n  height: 3.6rem;\n  border-left-width: 0;\n  transform: translateY(-50%);\n  transition: transform 10ms ease;\n  fill: #1b8158;\n}\n.tc-add-to-cart_product-select__h2qx9 .MuiSelect-icon.MuiSelect-iconOpen {\n  transform: translateY(-50%) rotate(180deg);\n}\n.tc-add-to-cart_product-select__h2qx9 fieldset {\n  border: none;\n}\n\n.tc-add-to-cart_subscription-select__j89E5.MuiPopover-paper {\n  margin-top: -0.3rem;\n  border-radius: 0 0 2.3rem 2.3rem;\n  box-shadow: none;\n}\n.tc-add-to-cart_subscription-select__j89E5 .MuiMenu-list {\n  padding: 0;\n  overflow: hidden;\n  border: 0.12rem solid #1b8158;\n  border-top-width: 0;\n  border-radius: 0 0 2.3rem 2.3rem;\n}\n.tc-add-to-cart_subscription-select__j89E5 .MuiMenuItem-root {\n  height: 4rem;\n  padding: 0 2.4rem;\n  color: #13220f;\n  font-size: 1.6rem;\n  font-family: \"Poppins\", verdana, sans-serif;\n  border-top: 0.1rem solid #f2f2f2;\n}\n.tc-add-to-cart_subscription-select__j89E5 .MuiMenuItem-root.Mui-selected {\n  background: #f7f7f7;\n}";
var css$5 = {"product__content-wrapper":"tc-add-to-cart_product__content-wrapper__p6f4E","product__info-wrapper":"tc-add-to-cart_product__info-wrapper__BE-EP","product__section":"tc-add-to-cart_product__section__S0QXR","product__name":"tc-add-to-cart_product__name__k3IqL","product__description":"tc-add-to-cart_product__description__okxwP","product__price-wrapper":"tc-add-to-cart_product__price-wrapper__9N7UZ","product__price":"tc-add-to-cart_product__price__ks9Nv","product__separator":"tc-add-to-cart_product__separator__9PcZn","info-section":"tc-add-to-cart_info-section__kcq4c","info-section__item":"tc-add-to-cart_info-section__item__wI5mQ","recommendations__wrapper":"tc-add-to-cart_recommendations__wrapper__i3wZc","recommendations__section":"tc-add-to-cart_recommendations__section__wox9C","product-select":"tc-add-to-cart_product-select__h2qx9","subscription-select":"tc-add-to-cart_subscription-select__j89E5"};
styleInject(css_248z$b);

var ItemPropertySelector = function ItemPropertySelector(_ref) {
  var _ref$itemList = _ref.itemList,
    itemList = _ref$itemList === void 0 ? [] : _ref$itemList,
    itemName = _ref.itemName,
    updateValue = _ref.updateValue,
    variant = _ref.variant,
    sizeClass = _ref.sizeClass;
  var _React$useState = React__default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isDropdownOpen = _React$useState2[0],
    setDropdownOpen = _React$useState2[1];
  var handleScrollDocument = useCallback(function () {
    setDropdownOpen(false);
  }, []);
  useEffect(function () {
    window.addEventListener('scroll', handleScrollDocument);
    return function () {
      window.removeEventListener('scroll', handleScrollDocument);
    };
  }, [handleScrollDocument]);

  // Filter valid items
  var filteredItems = itemList.filter(function (item) {
    return item.name;
  });

  // Handle dropdown value change
  var handleChange = function handleChange(e) {
    updateValue(e.target.value);
  };
  if (!filteredItems.length) return null; // Return null if no valid items

  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(itemName, " ").concat(sizeClass)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bootstrapForm_formGroup select"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bootstrapForm_label"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(css$5['product-select'], " bootstrapForm_input")
  }, /*#__PURE__*/React__default.createElement(FormControl, null, /*#__PURE__*/React__default.createElement(Select, {
    disableUnderline: true,
    IconComponent: ArrowDropDown,
    inputProps: {
      id: 'item-simple',
      name: 'value'
    },
    MenuProps: {
      anchorOrigin: {
        horizontal: 'left',
        vertical: 'bottom'
      },
      classes: {
        paper: css$5['subscription-select']
      },
      disableScrollLock: true,
      transformOrigin: {
        horizontal: 'left',
        vertical: 'top'
      }
    },
    onChange: handleChange,
    onClose: function onClose() {
      return setDropdownOpen(false);
    },
    onOpen: function onOpen() {
      return setDropdownOpen(true);
    },
    open: isDropdownOpen,
    value: variant,
    variant: "standard"
  }, filteredItems.map(function (item) {
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      key: item.value,
      value: item.value
    }, item.name);
  })))))));
};
ItemPropertySelector.propTypes = {
  itemList: PropTypes.array,
  itemName: PropTypes.string.isRequired,
  sizeClass: PropTypes.string,
  updateValue: PropTypes.func.isRequired,
  variant: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

var css_248z$a = ".tc-product-quantity_container__I96Vq,\n.tc-product-quantity_container-fluid__H6nH3,\n.tc-product-quantity_container-xxxl2__Nq1Ir,\n.tc-product-quantity_container-xxxl__Ygpfi,\n.tc-product-quantity_container-xxl__hpVOG,\n.tc-product-quantity_container-xl__ZPzLN,\n.tc-product-quantity_container-lg__pzwZW,\n.tc-product-quantity_container-md__cT2fd,\n.tc-product-quantity_container-sm__VH4Qz {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-product-quantity_container-sm__VH4Qz, .tc-product-quantity_container__I96Vq {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-product-quantity_container-md__cT2fd, .tc-product-quantity_container-sm__VH4Qz, .tc-product-quantity_container__I96Vq {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-product-quantity_container-lg__pzwZW, .tc-product-quantity_container-md__cT2fd, .tc-product-quantity_container-sm__VH4Qz, .tc-product-quantity_container__I96Vq {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-product-quantity_container-xl__ZPzLN, .tc-product-quantity_container-lg__pzwZW, .tc-product-quantity_container-md__cT2fd, .tc-product-quantity_container-sm__VH4Qz, .tc-product-quantity_container__I96Vq {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-product-quantity_container-xxl__hpVOG, .tc-product-quantity_container-xl__ZPzLN, .tc-product-quantity_container-lg__pzwZW, .tc-product-quantity_container-md__cT2fd, .tc-product-quantity_container-sm__VH4Qz, .tc-product-quantity_container__I96Vq {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-product-quantity_container-xxxl__Ygpfi, .tc-product-quantity_container-xxl__hpVOG, .tc-product-quantity_container-xl__ZPzLN, .tc-product-quantity_container-lg__pzwZW, .tc-product-quantity_container-md__cT2fd, .tc-product-quantity_container-sm__VH4Qz, .tc-product-quantity_container__I96Vq {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-product-quantity_container-xxxl2__Nq1Ir, .tc-product-quantity_container-xxxl__Ygpfi, .tc-product-quantity_container-xxl__hpVOG, .tc-product-quantity_container-xl__ZPzLN, .tc-product-quantity_container-lg__pzwZW, .tc-product-quantity_container-md__cT2fd, .tc-product-quantity_container-sm__VH4Qz, .tc-product-quantity_container__I96Vq {\n    max-width: 182rem;\n  }\n}\n.product__quantity {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: 2rem 0;\n}\n@media (min-width: 576px) and (max-width: 767.98px) {\n  .product__quantity {\n    justify-content: space-between;\n  }\n  .product__quantity > div {\n    width: calc(50% - 1.6rem);\n  }\n}\n@media (max-width: 575.98px) {\n  .product__quantity {\n    flex-direction: column;\n  }\n}\n\n.product__quantity-add-to-cart {\n  flex-grow: initial;\n}\n@media (min-width: 768px) {\n  .product__quantity-add-to-cart {\n    width: 48%;\n  }\n}\n.product__quantity-add-to-cart button {\n  width: 100%;\n}\n.product__quantity-add-to-cart button {\n  width: 100%;\n}\n\n.product__quantity-select {\n  display: flex;\n  margin: 0;\n}\n@media (min-width: 768px) {\n  .product__quantity-select {\n    width: 48%;\n  }\n}\n@media (max-width: 1199.98px) {\n  .product__quantity-select {\n    margin-bottom: 3rem;\n  }\n}\n\n.product__quantity-button {\n  width: 20%;\n  height: 4.1rem;\n  color: #005c35;\n  font-weight: 700;\n  font-size: 1.4rem;\n  background-color: #f7f7f7;\n  border: none;\n}\n.product__quantity-button:hover {\n  color: #fff;\n  background-color: #1b8158;\n}\n@media (min-width: 576px) {\n  .product__quantity-button {\n    width: 5.4rem;\n    height: 5.5rem;\n    font-size: 2.5rem;\n  }\n}\n\n.product__quantity-button.less {\n  border-radius: 5rem 0 0 5rem;\n}\n\n.product__quantity-button.more {\n  border-radius: 0 5rem 5rem 0;\n}\n\n.product__quantity-input {\n  width: 60%;\n  height: 4.1rem;\n  color: #005c35;\n  font-weight: 700;\n  font-size: 1.8rem;\n  text-align: center;\n  background: #f7f7f7;\n  border: none;\n  outline: 0 none;\n  appearance: textfield;\n}\n@media (min-width: 576px) {\n  .product__quantity-input {\n    height: 5.5rem;\n  }\n}\n@media (min-width: 992px) {\n  .product__quantity-input {\n    font-size: 2.5rem;\n  }\n}\n.product__quantity-input::-webkit-outer-spin-button, .product__quantity-input::-webkit-inner-spin-button {\n  margin: 0;\n  appearance: none;\n}";
styleInject(css_248z$a);

var NumberInput = function NumberInput(_ref) {
  var itemValue = _ref.itemValue,
    updateValue = _ref.updateValue;
  var MIN_VALUE = 1;
  var MAX_VALUE = 10000;
  var ensureValidRange = function ensureValidRange(value) {
    if (!value || value < MIN_VALUE) return MIN_VALUE;
    if (value > MAX_VALUE) return MAX_VALUE;
    return value;
  };
  var decrease = function decrease() {
    updateValue(ensureValidRange(Number(itemValue) - 1));
  };
  var increase = function increase() {
    updateValue(ensureValidRange(Number(itemValue) + 1));
  };
  var handleChange = function handleChange(e) {
    var cleanedValue = e.target.value.replace(/^0+/, ''); // Removes leading zeros
    updateValue(cleanedValue ? Number(cleanedValue) : '');
  };
  var handleBlur = function handleBlur() {
    updateValue(ensureValidRange(Number(itemValue)));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "product__quantity-select"
  }, /*#__PURE__*/React__default.createElement("button", {
    "aria-label": "Decrease quantity",
    className: "product__quantity-button less shopping-cart-item-quantity-decrease-btn",
    name: "decrease",
    onClick: decrease,
    type: "button"
  }, "-"), /*#__PURE__*/React__default.createElement("input", {
    "aria-label": "quantity",
    className: "product__quantity-input",
    id: "quantityInput",
    max: MAX_VALUE,
    min: MIN_VALUE,
    onBlur: handleBlur // Ensures input is validated after leaving the input field
    ,
    onChange: handleChange,
    type: "number",
    value: itemValue
  }), /*#__PURE__*/React__default.createElement("button", {
    "aria-label": "Increase quantity",
    className: "product__quantity-button more",
    name: "increase",
    onClick: increase,
    type: "button"
  }, "+"));
};
NumberInput.propTypes = {
  itemValue: PropTypes.number.isRequired,
  updateValue: PropTypes.func.isRequired
};

var RadioSizeSelector = function RadioSizeSelector(_ref) {
  var itemName = _ref.itemName,
    _ref$itemList = _ref.itemList,
    itemList = _ref$itemList === void 0 ? [] : _ref$itemList,
    updateValue = _ref.updateValue,
    variant = _ref.variant;
  var filteredItemList = itemList.filter(function (item) {
    return !!item.name;
  });
  if (!filteredItemList.length) return null;
  var handleChange = function handleChange(e) {
    updateValue(Number(e.target.value));
  };
  var ItemImage = function ItemImage(_ref2) {
    var imagePath = _ref2.imagePath,
      value = _ref2.value;
    return imagePath ? /*#__PURE__*/React__default.createElement("div", {
      className: productCss['product-size-select__img']
    }, /*#__PURE__*/React__default.createElement("img", {
      alt: value,
      src: imagePath
    })) : null;
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(itemName, " col-xl-12")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bootstrapForm_formGroup select"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bootstrapForm_label"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(productCss['product-size-select__radio'], " bootstrapForm_radio")
  }, /*#__PURE__*/React__default.createElement(FormControl, null, /*#__PURE__*/React__default.createElement(RadioGroup, {
    name: itemName,
    onChange: handleChange,
    value: variant
  }, filteredItemList.map(function (item) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: productCss['product-size-select__input'],
      key: item.value
    }, /*#__PURE__*/React__default.createElement(ItemImage, {
      imagePath: item.image_path,
      value: item.value
    }), /*#__PURE__*/React__default.createElement(FormControlLabel, {
      control: /*#__PURE__*/React__default.createElement(Radio, null),
      label: item.price,
      value: item.value
    }));
  })))))));
};
RadioSizeSelector.propTypes = {
  itemList: PropTypes.array,
  itemName: PropTypes.string,
  updateValue: PropTypes.func,
  variant: PropTypes.number
};

var _excluded$1 = ["children", "value", "index"];
var TabPanel = function TabPanel(_ref) {
  var children = _ref.children,
    value = _ref.value,
    index = _ref.index,
    other = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/React__default.createElement("div", _extends$2({
    "aria-labelledby": "simple-tab-".concat(index),
    hidden: value !== index,
    id: "simple-tabpanel-".concat(index),
    role: "tabpanel"
  }, other), value === index && /*#__PURE__*/React__default.createElement(Box, {
    p: 3
  }, /*#__PURE__*/React__default.createElement("div", null, children)));
};
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

var TcReview = function TcReview(_ref) {
  var avg_rating = _ref.avg_rating,
    product_url = _ref.product_url,
    reviews_count = _ref.reviews_count,
    translations = _ref.translations;
  var renderStarsPercentage = function renderStarsPercentage(itemRate) {
    var totalStars = 5;
    var starPercentageRounded = Math.round(itemRate / totalStars * 100);
    return /*#__PURE__*/React__default.createElement("div", {
      className: productCss['rating__stars-inner'],
      key: btoa(itemRate.toString()),
      style: {
        width: "".concat(starPercentageRounded, "%")
      }
    });
  };
  var scrollToReviews = function scrollToReviews() {
    var reviews = document.getElementById('reviews');
    if (reviews && window.location.pathname === product_url) {
      reviews.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      window.open("".concat(product_url, "/#reviews"), '_self');
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: productCss.rating
  }, /*#__PURE__*/React__default.createElement("div", {
    className: productCss.rating__stars
  }, renderStarsPercentage(parseFloat(avg_rating))), /*#__PURE__*/React__default.createElement("span", {
    className: productCss.rating__count,
    onClick: scrollToReviews
  }, reviews_count, ' ', reviews_count === 1 ? translations.review : translations.reviews));
};
TcReview.propTypes = {
  avg_rating: PropTypes.string.isRequired,
  product_url: PropTypes.string.isRequired,
  reviews_count: PropTypes.number.isRequired,
  translations: PropTypes.object.isRequired
};

var TcVolumePricesTable = function TcVolumePricesTable(_ref) {
  var ranges = _ref.ranges,
    translations = _ref.translations;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React__default.createElement("h5", null, translations.volume_pricing), /*#__PURE__*/React__default.createElement("div", {
    className: "tableComponent"
  }, /*#__PURE__*/React__default.createElement("table", {
    className: "tableComponent_table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, translations.volume_prices_quantity), /*#__PURE__*/React__default.createElement("th", null, translations.volume_prices_price))), /*#__PURE__*/React__default.createElement("tbody", null, ranges.map(function (item) {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: "".concat(item.price, "-").concat(item.range.join('-'))
    }, /*#__PURE__*/React__default.createElement("td", null, item.range[1] === '99999' ? "".concat(item.range[0], "+") : item.range.join(' - ')), /*#__PURE__*/React__default.createElement("td", null, item.price));
  }))))));
};
TcVolumePricesTable.propTypes = {
  ranges: PropTypes.arrayOf(PropTypes.shape({
    price: PropTypes.string.isRequired,
    range: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
  }).isRequired).isRequired,
  translations: PropTypes.shape({
    volume_pricing: PropTypes.string.isRequired,
    volume_prices_quantity: PropTypes.string.isRequired,
    volume_prices_price: PropTypes.string.isRequired
  }).isRequired
};

var css_248z$9 = ".tc-sticky-add-to-cart_container__DfAV4,\n.tc-sticky-add-to-cart_container-fluid__c0P53,\n.tc-sticky-add-to-cart_container-xxxl2__sV0Xa,\n.tc-sticky-add-to-cart_container-xxxl__RZ7Ll,\n.tc-sticky-add-to-cart_container-xxl__OT-jV,\n.tc-sticky-add-to-cart_container-xl__6xw3A,\n.tc-sticky-add-to-cart_container-lg__fr7bv,\n.tc-sticky-add-to-cart_container-md__I-XfX,\n.tc-sticky-add-to-cart_container-sm__LTU1b {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-sticky-add-to-cart_container-sm__LTU1b, .tc-sticky-add-to-cart_container__DfAV4 {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-sticky-add-to-cart_container-md__I-XfX, .tc-sticky-add-to-cart_container-sm__LTU1b, .tc-sticky-add-to-cart_container__DfAV4 {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-sticky-add-to-cart_container-lg__fr7bv, .tc-sticky-add-to-cart_container-md__I-XfX, .tc-sticky-add-to-cart_container-sm__LTU1b, .tc-sticky-add-to-cart_container__DfAV4 {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-sticky-add-to-cart_container-xl__6xw3A, .tc-sticky-add-to-cart_container-lg__fr7bv, .tc-sticky-add-to-cart_container-md__I-XfX, .tc-sticky-add-to-cart_container-sm__LTU1b, .tc-sticky-add-to-cart_container__DfAV4 {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-sticky-add-to-cart_container-xxl__OT-jV, .tc-sticky-add-to-cart_container-xl__6xw3A, .tc-sticky-add-to-cart_container-lg__fr7bv, .tc-sticky-add-to-cart_container-md__I-XfX, .tc-sticky-add-to-cart_container-sm__LTU1b, .tc-sticky-add-to-cart_container__DfAV4 {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-sticky-add-to-cart_container-xxxl__RZ7Ll, .tc-sticky-add-to-cart_container-xxl__OT-jV, .tc-sticky-add-to-cart_container-xl__6xw3A, .tc-sticky-add-to-cart_container-lg__fr7bv, .tc-sticky-add-to-cart_container-md__I-XfX, .tc-sticky-add-to-cart_container-sm__LTU1b, .tc-sticky-add-to-cart_container__DfAV4 {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-sticky-add-to-cart_container-xxxl2__sV0Xa, .tc-sticky-add-to-cart_container-xxxl__RZ7Ll, .tc-sticky-add-to-cart_container-xxl__OT-jV, .tc-sticky-add-to-cart_container-xl__6xw3A, .tc-sticky-add-to-cart_container-lg__fr7bv, .tc-sticky-add-to-cart_container-md__I-XfX, .tc-sticky-add-to-cart_container-sm__LTU1b, .tc-sticky-add-to-cart_container__DfAV4 {\n    max-width: 182rem;\n  }\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: auto;\n  padding: 2.1rem 0 2rem;\n  background: #fff;\n  box-shadow: 0 0.4rem 0.9rem rgba(0, 0, 0, 0.25);\n  translate: 0 -100% 0;\n  opacity: 0;\n  transition: top 0.3s linear, opacity 0.3s ease-out, translate 0.3s ease;\n}\n@media (max-width: 991.98px) {\n  .tc-sticky-add-to-cart_stickyBar__Z2UeA {\n    padding: 1rem;\n  }\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA.tc-sticky-add-to-cart_scrolled__9hHR2 {\n  z-index: 999;\n  translate: 0 0 0;\n  opacity: 1;\n}\n@media (max-width: 991.98px) {\n  .tc-sticky-add-to-cart_stickyBar__Z2UeA.tc-sticky-add-to-cart_scrolled__9hHR2 {\n    top: unset;\n    bottom: 0;\n    transform: translateY(0);\n  }\n}\n@media (min-width: 768px) {\n  .tc-sticky-add-to-cart_stickyBar__Z2UeA.tc-sticky-add-to-cart_combined__Yx3AM {\n    z-index: 99;\n    translate: 0 10rem 0;\n    opacity: 1;\n  }\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .tc-sticky-add-to-cart_productImage__x4vZN {\n  width: 10.6rem;\n  height: 10.2rem;\n  object-fit: contain;\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .tc-sticky-add-to-cart_productRightSide__rating__H9r9p {\n  display: none;\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .tc-sticky-add-to-cart_productRightSide__name__FWevi {\n  margin-bottom: 0;\n  font-weight: 700;\n  font-size: 2.2rem;\n  line-height: 1.818;\n}\n@media (min-width: 992px) and (max-width: 1599.98px) {\n  .tc-sticky-add-to-cart_stickyBar__Z2UeA .tc-sticky-add-to-cart_productRightSide__name__FWevi {\n    font-size: 1.8rem;\n  }\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .product__quantity-select {\n  width: unset;\n  margin-right: 3.2rem;\n}\n@media (min-width: 992px) and (max-width: 1599.98px) {\n  .tc-sticky-add-to-cart_stickyBar__Z2UeA .product__quantity-select {\n    margin-right: 1rem;\n    margin-bottom: 0;\n    margin-left: 1rem;\n  }\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .product__quantity-input {\n  width: 21.2rem;\n  height: 6.8rem;\n}\n@media (min-width: 992px) and (max-width: 1599.98px) {\n  .tc-sticky-add-to-cart_stickyBar__Z2UeA .product__quantity-input {\n    width: 11.2rem;\n  }\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .product__quantity-button {\n  height: 6.8rem;\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .product__quantity-add-to-cart {\n  width: 32rem;\n}\n@media (min-width: 992px) and (max-width: 1599.98px) {\n  .tc-sticky-add-to-cart_stickyBar__Z2UeA .product__quantity-add-to-cart {\n    width: 22rem;\n  }\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .product__quantity-add-to-cart .tc-sticky-add-to-cart_stickyAddToCart__UawER {\n  width: 100%;\n  padding: 1.582rem 4rem;\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .tc-sticky-add-to-cart_stickyBarSelectWrapp__hA9uN .MuiBox-root {\n  padding: 0;\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .stickyBarSelect .MuiInputBase-root {\n  height: 4rem;\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .stickyBarSelect .MuiInputBase-root .MuiSelect-select.MuiSelect-select {\n  padding-right: 5rem;\n  font-size: 1.6rem;\n  line-height: 2.5;\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .tc-sticky-add-to-cart_stickyBarMobile__uW5k6 .tc-sticky-add-to-cart_productRightSide__OFjo- .tc-sticky-add-to-cart_productRightSide__name__FWevi {\n  margin-bottom: 0;\n  font-size: 1.8rem;\n  line-height: 1.8;\n}\n.tc-sticky-add-to-cart_stickyBar__Z2UeA .tc-sticky-add-to-cart_stickyBarMobile__uW5k6 .tc-sticky-add-to-cart_productRightSide__OFjo- .tc-sticky-add-to-cart_productRightSide__priceNormal__iLSVB {\n  margin-left: 1rem;\n  font-size: 2.2rem;\n}\n@media (max-width: 767.98px) {\n  .tc-sticky-add-to-cart_stickyBar__Z2UeA .tc-sticky-add-to-cart_stickyBarMobile__uW5k6 .tc-sticky-add-to-cart_productRightSide__OFjo- .tc-sticky-add-to-cart_productRightSide__priceNormal__iLSVB {\n    padding-left: 1.5rem;\n  }\n}";
var stickyCss = {"container":"tc-sticky-add-to-cart_container__DfAV4","container-fluid":"tc-sticky-add-to-cart_container-fluid__c0P53","container-xxxl2":"tc-sticky-add-to-cart_container-xxxl2__sV0Xa","container-xxxl":"tc-sticky-add-to-cart_container-xxxl__RZ7Ll","container-xxl":"tc-sticky-add-to-cart_container-xxl__OT-jV","container-xl":"tc-sticky-add-to-cart_container-xl__6xw3A","container-lg":"tc-sticky-add-to-cart_container-lg__fr7bv","container-md":"tc-sticky-add-to-cart_container-md__I-XfX","container-sm":"tc-sticky-add-to-cart_container-sm__LTU1b","stickyBar":"tc-sticky-add-to-cart_stickyBar__Z2UeA","scrolled":"tc-sticky-add-to-cart_scrolled__9hHR2","combined":"tc-sticky-add-to-cart_combined__Yx3AM","productImage":"tc-sticky-add-to-cart_productImage__x4vZN","productRightSide__rating":"tc-sticky-add-to-cart_productRightSide__rating__H9r9p","productRightSide__name":"tc-sticky-add-to-cart_productRightSide__name__FWevi","stickyAddToCart":"tc-sticky-add-to-cart_stickyAddToCart__UawER","stickyBarSelectWrapp":"tc-sticky-add-to-cart_stickyBarSelectWrapp__hA9uN","stickyBarMobile":"tc-sticky-add-to-cart_stickyBarMobile__uW5k6","productRightSide":"tc-sticky-add-to-cart_productRightSide__OFjo-","productRightSide__priceNormal":"tc-sticky-add-to-cart_productRightSide__priceNormal__iLSVB"};
styleInject(css_248z$9);

var TcStickyAddToCart = function TcStickyAddToCart(_ref) {
  var children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    scrolled = _useState2[0],
    setScrolled = _useState2[1];
  var _useState3 = useState({
      scrollDirection: null,
      scrollPos: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    scrollStatus = _useState4[0],
    setScrollStatus = _useState4[1];
  useEffect(function () {
    var handleScrollDocument = function handleScrollDocument() {
      setScrollStatus(function (prev) {
        return {
          scrollDirection: document.body.getBoundingClientRect().top > prev.scrollPos ? 'up' : 'down',
          scrollPos: document.body.getBoundingClientRect().top
        };
      });
    };
    window.addEventListener('scroll', handleScrollDocument);
    return function () {
      return window.removeEventListener('scroll', handleScrollDocument);
    };
  }, []);
  useEffect(function () {
    var handleScroll = function handleScroll() {
      var offset = window.scrollY;
      var mainAddToCart = document.getElementById('mainAddToCart');
      if (mainAddToCart) {
        var pos = mainAddToCart.offsetTop;
        if (offset > pos) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  var classNames = [stickyCss.stickyBar];
  if (scrolled) {
    classNames.push(stickyCss.scrolled);
  }
  if (scrollStatus.scrollDirection === 'up' && scrolled) {
    classNames.push(stickyCss.combined);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames.join(' ')
  }, children);
};
TcStickyAddToCart.propTypes = {
  children: PropTypes.any
};

var TcPaymentMethodSelector = function TcPaymentMethodSelector(_ref) {
  var _data$subscriptions$, _state$variant$volume, _state$variant$volume2;
  var addToCartCustomClass = _ref.addToCartCustomClass,
    avg_rating = _ref.avg_rating,
    cartType = _ref.cartType,
    closeQuickViewModal = _ref.closeQuickViewModal,
    data = _ref.data,
    out_of_stock = _ref.out_of_stock,
    product_img_url = _ref.product_img_url,
    product_name = _ref.product_name,
    product_url = _ref.product_url,
    quickViewConfig = _ref.quickViewConfig,
    reviews_count = _ref.reviews_count,
    self_served = _ref.self_served,
    show_sticky_add_to_cart = _ref.show_sticky_add_to_cart;
  quickViewConfig = quickViewConfig || window.quickViewConfig;
  if (!quickViewConfig) {
    console.error('quickViewConfig is undefined');
    return null;
  }
  var _quickViewConfig = quickViewConfig,
    env = _quickViewConfig.env,
    endpoints = _quickViewConfig.endpoints,
    translations = _quickViewConfig.translations,
    current_user = _quickViewConfig.current_user;
  var paymentData = useMemo(function () {
    var dataCopy = data.payment_data ? _objectSpread2({}, data.payment_data) : _objectSpread2({}, data);
    if (dataCopy.variants.length) {
      var matchingVariant = dataCopy.variants.find(function (variant) {
        return variant.price === dataCopy.price;
      });
      var selectedVariant = matchingVariant || dataCopy.variants[0];
      dataCopy.price = selectedVariant.price;
      dataCopy.variantId = selectedVariant.value;
      dataCopy.variant = selectedVariant;
      dataCopy.product_name = dataCopy.product_name || selectedVariant.product_name || product_name;
    }
    return dataCopy;
  }, [data, product_name]);
  var recurring = data.subscribable;
  var selectedSubscription = recurring && ((_data$subscriptions$ = data.subscriptions[0]) === null || _data$subscriptions$ === void 0 ? void 0 : _data$subscriptions$.value);
  var mobileHeaderRootRef = useRef(null);
  var _useState = useState({
      addedCartItem: {},
      brand_name: paymentData.brand_name,
      buttonDisabled: out_of_stock,
      isCheckboxChecked: false,
      limit: paymentData.limit,
      old_price: paymentData.old_price,
      on_sale: paymentData.on_sale,
      paymentData: paymentData,
      price: paymentData.price,
      product_img_url: product_img_url,
      quantity: 1,
      recurring: recurring,
      selectedSubscription: selectedSubscription,
      showCheckboxHint: false,
      subsidy: paymentData.subsidy,
      tabIndex: 0,
      title: paymentData.product_name || product_name,
      variant: paymentData.variant,
      variantId: paymentData.variantId,
      volume_prices: paymentData.variant.volume_prices
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    // Unmounting behavior
    return function () {
      setState(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), {}, {
          buttonDisabled: false
        });
      });
      // Cleanup mobile header root if it exists
      if (mobileHeaderRootRef.current) {
        mobileHeaderRootRef.current.unmount();
        mobileHeaderRootRef.current = null;
      }
    };
  }, []);
  useEffect(function () {
    var mobileHeaderContainer = document.getElementById('mobile-product-header');
    if (mobileHeaderContainer) {
      if (!mobileHeaderRootRef.current) {
        mobileHeaderRootRef.current = createRoot(mobileHeaderContainer);
      }

      // Render the mobile header
      mobileHeaderRootRef.current.render(/*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(TcReview, {
        avg_rating: avg_rating,
        product_url: product_url,
        reviews_count: reviews_count,
        translations: translations
      }), /*#__PURE__*/React__default.createElement("h1", {
        className: "productRightSide_name h3"
      }, state.title), /*#__PURE__*/React__default.createElement("div", {
        className: "productRightSide_price"
      }, /*#__PURE__*/React__default.createElement(PriceLabel, priceProps))));
    }
  }, [state.brand_name, state.old_price, state.on_sale, state.price, state.subsidy, state.title, avg_rating, product_url, reviews_count, self_served, translations]);
  var a11yProps = function a11yProps(index) {
    return {
      'aria-controls': "simple-tabpanel-".concat(index),
      id: "simple-tab-".concat(index)
    };
  };
  var handleOpenModal = function handleOpenModal() {
    var _data$subscriptions$f;
    var isSubscriptionSelected = recurring && state.tabIndex === 1;
    var subscriptionSelectedName = isSubscriptionSelected ? (_data$subscriptions$f = data.subscriptions.find(function (subs) {
      return subs.value === state.selectedSubscription;
    })) === null || _data$subscriptions$f === void 0 ? void 0 : _data$subscriptions$f.name : null;
    trigger('openAddToCartSuccessModal', {
      addedCartItem: state.addedCartItem,
      paymentData: state.paymentData,
      quantity: state.quantity,
      variant: state.variant,
      volume_price: state.volumePrice,
      isSubscription: isSubscriptionSelected,
      selectedSubscriptionName: subscriptionSelectedName
    });
    if (closeQuickViewModal) {
      closeQuickViewModal();
    }
  };
  var handleChange = function handleChange(event, newValue) {
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        tabIndex: newValue,
        buttonDisabled: newValue === 1 ? !current_user : out_of_stock
      });
    });
  };
  var handleCheckboxChange = function handleCheckboxChange(event) {
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        isCheckboxChecked: event.target.checked,
        showCheckboxHint: false
      });
    });
  };
  var gaAddToCart = function gaAddToCart(variant, quantity, dataLayerCartType) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ecommerce: null
    });
    window.dataLayer.push({
      ecommerce: {
        items: [{
          currency: variant.currency,
          item_id: variant.sku,
          item_name: variant.product_name,
          price: parseFloat(variant.price.replace(/[^\d.-]/g, '')),
          cart_type: dataLayerCartType,
          quantity: quantity
        }]
      },
      event: 'add_to_cart_new'
    });
  };
  var addToCart = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var fromStickyButton,
        dataLayerCartType,
        checkboxElement,
        checkboxPosition,
        options,
        subscription,
        orderToken,
        cartResponse,
        headers,
        addToCartResponse,
        _addToCartResponse$da,
        _addToCartResponse$da2,
        responseData,
        dataLayer,
        isMobile,
        quantitySection,
        _error$response,
        errorMessage,
        _args = arguments,
        _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            fromStickyButton = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            dataLayerCartType = 'main';
            if (typeof cartType === 'string') {
              dataLayerCartType = cartType;
            } else if (fromStickyButton) {
              dataLayerCartType = 'sticky';
            }
            if (!(state.tabIndex === 1 && !state.isCheckboxChecked)) {
              _context.n = 1;
              break;
            }
            setState(function (prevState) {
              return _objectSpread2(_objectSpread2({}, prevState), {}, {
                showCheckboxHint: true
              });
            });
            if (fromStickyButton) {
              checkboxElement = document.getElementById('acceptPurchase');
              if (checkboxElement) {
                checkboxPosition = checkboxElement.getBoundingClientRect().top + window.pageYOffset - 290;
                window.scrollTo({
                  behavior: 'smooth',
                  top: checkboxPosition
                });
              }
            }
            return _context.a(2);
          case 1:
            setState(function (prevState) {
              return _objectSpread2(_objectSpread2({}, prevState), {}, {
                buttonDisabled: true
              });
            });
            if (state.tabIndex) {
              subscription = data.subscriptions.find(function (subs) {
                return subs.value === state.selectedSubscription;
              });
              options = _defineProperty({
                subscribe: true
              }, subscription.options.type, subscription.options.id);
            }
            _context.p = 2;
            orderToken = getCookie("order_token_".concat(env));
            if (orderToken) {
              _context.n = 5;
              break;
            }
            _context.n = 3;
            return axios.post(endpoints.ensure_cart, {}, {
              withCredentials: true
            });
          case 3:
            cartResponse = _context.v;
            if (!(cartResponse.status === 200 && cartResponse.data.token)) {
              _context.n = 4;
              break;
            }
            orderToken = cartResponse.data.token;
            _context.n = 5;
            break;
          case 4:
            throw new Error('Failed to ensure cart');
          case 5:
            headers = {
              'Content-Type': 'application/json',
              'X-Spree-Order-Token': orderToken
            };
            _context.n = 6;
            return axios.post(endpoints.cart_add_item, {
              variant_id: state.variantId,
              quantity: state.quantity,
              options: options
            }, {
              headers: headers
            });
          case 6:
            addToCartResponse = _context.v;
            if (addToCartResponse.status === 200) {
              responseData = ((_addToCartResponse$da = addToCartResponse.data) === null || _addToCartResponse$da === void 0 ? void 0 : _addToCartResponse$da.data) || {};
              dataLayer = ((_addToCartResponse$da2 = addToCartResponse.data) === null || _addToCartResponse$da2 === void 0 || (_addToCartResponse$da2 = _addToCartResponse$da2.meta) === null || _addToCartResponse$da2 === void 0 ? void 0 : _addToCartResponse$da2.dataLayer) || null;
              gaAddToCart(state.variant, state.quantity, dataLayerCartType);
              if (window.ElevarDataLayerHelper && dataLayer) {
                window.ElevarDataLayerHelper.pushAddToCart({
                  cartType: dataLayerCartType,
                  data: dataLayer,
                  isQuickView: !!closeQuickViewModal
                });
              }
              if (closeQuickViewModal && window.location.pathname.match(/\/checkout|\/cart/)) {
                window.location = "".concat(endpoints.cart_path);
              } else {
                document.dispatchEvent(new CustomEvent('FETCH_CART_COUNT'));
                isMobile = window.innerWidth <= 991;
                if (!isMobile) {
                  setState(function (prevState) {
                    return _objectSpread2(_objectSpread2({}, prevState), {}, {
                      addedCartItem: responseData || {},
                      buttonDisabled: false
                    });
                  });
                } else {
                  window.location = "".concat(endpoints.cart_path, "?variant_id=").concat(state.variantId);
                }
              }
            }
            _context.n = 8;
            break;
          case 7:
            _context.p = 7;
            _t = _context.v;
            quantitySection = document.querySelector('.quickViewModal #quantitySection') || document.getElementById('quantitySection');
            if (quantitySection) {
              errorMessage = 'An error occurred while adding to cart';
              if ((_error$response = _t.response) !== null && _error$response !== void 0 && (_error$response = _error$response.data) !== null && _error$response !== void 0 && _error$response.error) {
                errorMessage = _t.response.data.error;
              } else if (_t.message) {
                errorMessage = _t.message;
              }
              quantitySection.insertAdjacentHTML('beforeend', "<div class=\"error w-100\">".concat(errorMessage, "</div>"));
            }
            setState(function (prevState) {
              return _objectSpread2(_objectSpread2({}, prevState), {}, {
                buttonDisabled: false
              });
            });
          case 8:
            return _context.a(2);
        }
      }, _callee, null, [[2, 7]]);
    }));
    return function addToCart() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (state.addedCartItem && Object.keys(state.addedCartItem).length > 0) {
      handleOpenModal();
    }
  }, [state.addedCartItem]);
  var updateQuantityValue = function updateQuantityValue(quantity) {
    var volumePrice = getVolumePrice(quantity, state.variant.volume_prices);
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        quantity: quantity,
        price: volumePrice || prevState.variant.price
      });
    });
  };
  var getVolumePrice = function getVolumePrice(quantity, variantVolumePrices) {
    var _loop = function _loop() {
        var _variantVolumePrices$ = variantVolumePrices[i],
          range = _variantVolumePrices$.range,
          price = _variantVolumePrices$.price;
        var isBetter = parseFloat(price.substring(1)) <= parseFloat(state.variant.price.substring(1));
        if (quantity >= parseInt(range[0], 10) && quantity <= parseInt(range[1], 10) && isBetter) {
          setState(function (prevState) {
            return _objectSpread2(_objectSpread2({}, prevState), {}, {
              volumePrice: price
            });
          });
          return {
            v: price
          };
        }
      },
      _ret;
    for (var i = 0; i < variantVolumePrices.length; i++) {
      _ret = _loop();
      if (_ret) return _ret.v;
    }
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        volumePrice: null
      });
    });
    return false;
  };
  var updateSizeValue = function updateSizeValue(e) {
    var variant = state.paymentData.variants.find(function (item) {
      return item.value === e;
    });
    if (!variant) {
      console.error('Variant not found for value:', e);
      return;
    }

    // Calculate the correct price considering volume pricing
    var basePrice = variant.price;
    var volumePrice = getVolumePrice(state.quantity, variant.volume_prices);
    var finalPrice = volumePrice || basePrice;
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        brand_name: variant.brand_name,
        limit: variant.limit,
        old_price: variant.old_price,
        on_sale: variant.on_sale,
        price: finalPrice,
        subsidy: variant.subsidy,
        variant: variant,
        variantId: e,
        volume_prices: variant.volume_prices,
        lastUpdated: Date.now()
      });
    });
  };
  var updateSubscriptionValue = function updateSubscriptionValue(subscriptionValue) {
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        selectedSubscription: subscriptionValue
      });
    });
  };
  var filteredItemList = state.paymentData.variants.filter(function (item) {
    return !!item.name;
  });
  var authToSubscribeTranslation = function authToSubscribeTranslation() {
    return /*#__PURE__*/React__default.createElement("div", null, translations.auth_to_subscribe_account_required, "\xA0", /*#__PURE__*/React__default.createElement("a", {
      href: endpoints.sign_in_url
    }, translations.auth_to_subscribe_sign_in), "\xA0", translations.auth_to_subscribe_or, "\xA0", /*#__PURE__*/React__default.createElement("a", {
      href: endpoints.sign_up_url
    }, translations.auth_to_subscribe_create_account));
  };

  // Price props for both desktop and mobile
  var priceProps = {
    brand: state.brand_name,
    old_price: state.old_price,
    on_sale: state.on_sale,
    price: state.price,
    self_served: self_served,
    subsidy: state.subsidy,
    translations: translations
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "d-none d-md-block"
  }, /*#__PURE__*/React__default.createElement(TcReview, {
    avg_rating: avg_rating,
    product_url: product_url,
    reviews_count: reviews_count,
    translations: translations
  }), /*#__PURE__*/React__default.createElement("h3", {
    className: "product__name"
  }, state.title)), /*#__PURE__*/React__default.createElement("div", {
    className: productCss.product__price
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "d-none d-md-block"
  }, /*#__PURE__*/React__default.createElement(PriceLabel, priceProps)), recurring && /*#__PURE__*/React__default.createElement("div", {
    className: productCss.product__tabs,
    role: "tablist"
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    "aria-label": "simple tabs",
    onChange: handleChange,
    value: state.tabIndex
  }, /*#__PURE__*/React__default.createElement(Tab, _extends$2({
    label: translations.payment_selector_labels_one_time_order
  }, a11yProps(0))), /*#__PURE__*/React__default.createElement(Tab, _extends$2({
    label: translations.payment_selector_labels_subscription
  }, a11yProps(1)))))), /*#__PURE__*/React__default.createElement("div", {
    className: "bootstrapForm"
  }, filteredItemList.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: productCss['product__size-label']
  }, /*#__PURE__*/React__default.createElement("span", null, translations.payment_selector_labels_size, ":", ' ', /*#__PURE__*/React__default.createElement("strong", null, state.variant.name))), /*#__PURE__*/React__default.createElement(TabPanel, {
    index: 0,
    value: state.tabIndex
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement(RadioSizeSelector, {
    itemList: paymentData.variants,
    itemName: "size",
    sizeClass: "col-md-6",
    updateValue: updateSizeValue,
    variant: state.variant.value
  }))), recurring && /*#__PURE__*/React__default.createElement(TabPanel, {
    index: 1,
    value: state.tabIndex
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement(RadioSizeSelector, {
    itemList: paymentData.variants,
    itemName: "size",
    sizeClass: "col-md-6",
    updateValue: updateSizeValue,
    variant: state.variant.value
  }), current_user !== null && /*#__PURE__*/React__default.createElement(ItemPropertySelector, {
    itemList: data.subscriptions,
    itemName: "subscription",
    sizeClass: "col-md-6 mt-4",
    updateValue: updateSubscriptionValue,
    variant: state.selectedSubscription
  })), current_user !== null && /*#__PURE__*/React__default.createElement("div", {
    className: "checkbox mt-4 pt-3 subscription-consent"
  }, /*#__PURE__*/React__default.createElement("input", {
    checked: state.isCheckboxChecked,
    id: "acceptPurchase",
    name: "accept_purchase",
    onChange: handleCheckboxChange,
    type: "checkbox"
  }), /*#__PURE__*/React__default.createElement("label", {
    className: "control-label",
    htmlFor: "acceptPurchase"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "d-inline",
    dangerouslySetInnerHTML: {
      __html: translations.accept_purchase_label
    }
  }), /*#__PURE__*/React__default.createElement("abbr", {
    className: "d-inline float-none",
    title: "You are missing a required field."
  }, "*")), state.showCheckboxHint && /*#__PURE__*/React__default.createElement("div", {
    className: "help-inline"
  }, translations.accept_purchase_must_be_accepted))), /*#__PURE__*/React__default.createElement("div", {
    className: "product__quantity",
    id: "quantitySection"
  }, (!self_served || state.limit > 1) && /*#__PURE__*/React__default.createElement(NumberInput, {
    css: productCss,
    itemLabel: translations.payment_selector_labels_quantity,
    itemValue: state.quantity,
    updateValue: updateQuantityValue
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "product__quantity-add-to-cart"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "".concat(addToCartCustomClass || 'mainAddToCart', " buttonComponent--primary"),
    disabled: state.buttonDisabled,
    id: "mainAddToCart",
    onClick: function onClick() {
      return addToCart();
    },
    type: "button"
  }, state.tabIndex === 1 ? translations.payment_selector_buttons_subscribe : translations.payment_selector_buttons_add_to_cart)), state.tabIndex === 1 && current_user == null && /*#__PURE__*/React__default.createElement("div", {
    className: "mt-3 w-100"
  }, authToSubscribeTranslation()))), show_sticky_add_to_cart && /*#__PURE__*/React__default.createElement(TcStickyAddToCart, null, /*#__PURE__*/React__default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex flex-row align-items-center d-none d-lg-flex"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: state.old_price,
    className: stickyCss.productImage,
    src: state.product_img_url
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-center ms-4"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: stickyCss.productRightSide__name
  }, state.title)), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex flex-column justify-content-start h-100 ms-lg-3 ps-lg-3 ms-5 ps-5"
  }, /*#__PURE__*/React__default.createElement(PriceLabel, priceProps), /*#__PURE__*/React__default.createElement("div", {
    className: stickyCss.stickyBarSelectWrapp
  }, /*#__PURE__*/React__default.createElement(TabPanel, {
    index: 0,
    value: state.tabIndex
  }, /*#__PURE__*/React__default.createElement(ItemPropertySelector, {
    itemList: state.paymentData.variants,
    itemName: "size",
    sizeClass: "stickyBarSelect",
    updateValue: updateSizeValue,
    variant: state.variant.value
  })), state.recurring && /*#__PURE__*/React__default.createElement(TabPanel, {
    index: 1,
    value: state.tabIndex
  }, /*#__PURE__*/React__default.createElement(ItemPropertySelector, {
    itemList: state.paymentData.variants,
    itemName: "size",
    sizeClass: "stickyBarSelect mb-3",
    updateValue: updateSizeValue,
    variant: state.variant.value
  }), state.tabIndex === 1 && current_user !== null && /*#__PURE__*/React__default.createElement(ItemPropertySelector, {
    itemList: data.subscriptions,
    itemName: "subscription",
    sizeClass: "stickyBarSelect",
    updateValue: updateSubscriptionValue,
    variant: state.selectedSubscription
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "w-100"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "align-items-center d-flex justify-content-end"
  }, /*#__PURE__*/React__default.createElement(NumberInput, {
    css: stickyCss,
    itemLabel: translations.payment_selector_labels_quantity,
    itemValue: state.quantity,
    updateValue: updateQuantityValue
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "product__quantity-add-to-cart"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "".concat(stickyCss.stickyAddToCart, " buttonComponent--primary"),
    disabled: state.buttonDisabled,
    onClick: function onClick() {
      return addToCart(true);
    },
    type: "button"
  }, state.tabIndex === 1 ? translations.payment_selector_buttons_subscribe : translations.payment_selector_buttons_add_to_cart))), state.tabIndex === 1 && current_user == null && /*#__PURE__*/React__default.createElement("div", {
    className: "mt-3 text-end"
  }, authToSubscribeTranslation()))), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(stickyCss.stickyBarMobile, " d-flex d-lg-none flex-column align-items-center")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-center flex-column"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: stickyCss.product__name
  }, state.title), /*#__PURE__*/React__default.createElement(PriceLabel, priceProps)), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex w-100 justify-content-center mt-1"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "".concat(stickyCss.stickyAddToCart, " buttonComponent--primary"),
    disabled: state.buttonDisabled,
    onClick: function onClick() {
      return addToCart(true);
    },
    type: "button"
  }, state.tabIndex === 1 ? translations.payment_selector_buttons_subscribe : translations.payment_selector_buttons_add_to_cart)), state.tabIndex === 1 && current_user == null && /*#__PURE__*/React__default.createElement("div", {
    className: "mt-3 text-center smallText"
  }, authToSubscribeTranslation())))), ((_state$variant$volume = state.variant.volume_prices) === null || _state$variant$volume === void 0 ? void 0 : _state$variant$volume.length) > 0 && closeQuickViewModal && /*#__PURE__*/React__default.createElement("div", {
    className: "my-5"
  }, /*#__PURE__*/React__default.createElement("a", {
    className: "readMoreLink",
    href: "".concat(product_url)
  }, translations.volume_pricing_available)), ((_state$variant$volume2 = state.variant.volume_prices) === null || _state$variant$volume2 === void 0 ? void 0 : _state$variant$volume2.length) > 0 && !closeQuickViewModal && /*#__PURE__*/React__default.createElement(TcVolumePricesTable, {
    ranges: state.variant.volume_prices,
    translations: translations
  }));
};
TcPaymentMethodSelector.propTypes = {
  addToCartCustomClass: PropTypes.string,
  avg_rating: PropTypes.string,
  cartType: PropTypes.string,
  closeQuickViewModal: PropTypes.func,
  data: PropTypes.object.isRequired,
  out_of_stock: PropTypes.bool,
  product_img_url: PropTypes.string,
  product_name: PropTypes.string,
  product_url: PropTypes.string,
  quickViewConfig: PropTypes.object,
  reviews_count: PropTypes.number,
  self_served: PropTypes.bool,
  show_sticky_add_to_cart: PropTypes.bool
};

var QuickViewModal = function QuickViewModal(_ref) {
  var config = _ref.config;
  var paymentSelector = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    descriptionHeight = _useState6[0],
    setDescriptionHeight = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    triggerRender = _useState8[0],
    setTriggerRender = _useState8[1];
  var translations = config.translations;
  // Toggle triggerRender to force a re-render after the modal is opened.
  useEffect(function () {
    if (isModalOpen) {
      setTriggerRender(function (prev) {
        return !prev;
      });
    }
  }, [isModalOpen]);
  var openModal = useCallback(function (e) {
    setIsModalOpen(true);
    setData(e.detail);
    if (paymentSelector.current) {
      setDescriptionHeight(paymentSelector.current.offsetHeight);
    } else {
      setDescriptionHeight(0);
    }
  }, []);
  var closeModal = function closeModal() {
    setIsModalOpen(false);
    setData(null);
  };
  useEffect(function () {
    on('openQuickViewModal', openModal);
    return function () {
      off('openQuickViewModal', openModal);
    };
  }, [openModal]);
  useEffect(function () {
    if (isModalOpen && paymentSelector.current) {
      setDescriptionHeight(paymentSelector.current.offsetHeight);
    }
  }, [isModalOpen, triggerRender]);
  var modalBody = useMemo(function () {
    if (data) {
      var _paymentData$can_recy, _paymentData$cannot_r;
      var paymentData = data.paymentData,
        product_url = data.product_url,
        cartType = data.cartType;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React__default.createElement(ProductImageSlider, {
        images: paymentData.images,
        isOnSale: paymentData.advertise,
        translations: translations
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(css$6.product, " col-lg-6 pe-5")
      }, /*#__PURE__*/React__default.createElement("div", {
        ref: paymentSelector
      }, /*#__PURE__*/React__default.createElement(TcPaymentMethodSelector, {
        addToCartCustomClass: "quickViewAddToCart",
        avg_rating: paymentData.avg_rating,
        cartType: cartType,
        closeQuickViewModal: closeModal,
        data: paymentData,
        out_of_stock: !paymentData.in_stock,
        product_url: product_url,
        quickViewConfig: config,
        reviews_count: paymentData.reviews_count,
        self_served: false,
        translations: translations
      })), /*#__PURE__*/React__default.createElement("div", {
        className: css$6['product__description-wrapper'],
        style: {
          maxHeight: "calc(100vh - ".concat(descriptionHeight + 130, "px)")
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "product__description"
      }, paymentData.advertise && /*#__PURE__*/React__default.createElement("div", {
        className: css$6['product__advertised-promotion']
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "mb-0"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: css$6['product__advertised-promotion-label']
      }, /*#__PURE__*/React__default.createElement("strong", null, translations.limited_time, "\xA0")), /*#__PURE__*/React__default.createElement(SanitizeHTML, {
        className: 'd-inline',
        html: paymentData.advertised_promotion_description
      }))), /*#__PURE__*/React__default.createElement("h5", null, /*#__PURE__*/React__default.createElement("strong", null, paymentData.description_title)), /*#__PURE__*/React__default.createElement(SanitizeHTML, {
        html: paymentData.description
      })), ((_paymentData$can_recy = paymentData.can_recycle_taxons) === null || _paymentData$can_recy === void 0 ? void 0 : _paymentData$can_recy.length) > 0 && ((_paymentData$cannot_r = paymentData.cannot_recycle_taxons) === null || _paymentData$cannot_r === void 0 ? void 0 : _paymentData$cannot_r.length) > 0 && /*#__PURE__*/React__default.createElement(WhatYouCanRecycle, {
        data: paymentData,
        translations: translations
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "text-center mt-5"
      }, /*#__PURE__*/React__default.createElement("a", {
        className: "readMoreLink",
        href: "".concat(product_url)
      }, translations.quick_view_see_full_see_full_details))));
    }
    return null;
  }, [data, descriptionHeight]);
  return /*#__PURE__*/React__default.createElement(MainModal, {
    additionalClasses: "".concat(css$6.quickView__modal, " wide-modal"),
    handleClose: closeModal,
    isModalOpen: isModalOpen,
    modalBody: modalBody
  });
};
QuickViewModal.propTypes = {
  config: PropTypes.object.isRequired
};

var InfoActionSection = function InfoActionSection(_ref) {
  var addedCartItem = _ref.addedCartItem,
    config = _ref.config,
    handleClose = _ref.handleClose,
    paymentData = _ref.paymentData;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDisabled = _useState2[0],
    setIsDisabled = _useState2[1];
  var endpoints = config.endpoints,
    translations = config.translations;
  var subtotalTranslations = translations.confirmation_popup_subtotal;
  var replacedSubtotalTranslations = subtotalTranslations.replace(':quantity', addedCartItem.attributes.item_count);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, addedCartItem !== null && addedCartItem !== void 0 && addedCartItem.attributes ? /*#__PURE__*/React__default.createElement("div", {
    className: css$5['info-section']
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$5['info-section__item-wrapper']
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$5['info-section__item']
  }, /*#__PURE__*/React__default.createElement("p", null, replacedSubtotalTranslations, ":"), /*#__PURE__*/React__default.createElement("p", null, addedCartItem.attributes.display_item_total)), addedCartItem.attributes.total_discount && /*#__PURE__*/React__default.createElement("div", {
    className: css$5['info-section__item']
  }, /*#__PURE__*/React__default.createElement("p", null, translations.total_discount_applied, ":"), /*#__PURE__*/React__default.createElement("p", null, addedCartItem.attributes.total_discount))), /*#__PURE__*/React__default.createElement("div", {
    className: "actions-wrapper"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "buttonComponent--primary w-100 mt-3",
    disabled: isDisabled,
    onClick: function onClick() {
      window.location = "".concat(endpoints.cart_path, "?variant_id=").concat(paymentData.variantId);
      setIsDisabled(true);
    },
    type: "button"
  }, translations.confirmation_popup_view_cart), /*#__PURE__*/React__default.createElement("button", {
    className: "buttonComponent--secondary w-100 mt-3 ms-0",
    disabled: isDisabled,
    onClick: handleClose,
    type: "button"
  }, translations.confirmation_popup_continue_shopping))) : /*#__PURE__*/React__default.createElement(Loader, {
    isLarge: true
  }));
};
InfoActionSection.propTypes = {
  addedCartItem: PropTypes.object,
  config: PropTypes.object.isRequired,
  handleClose: PropTypes.func,
  paymentData: PropTypes.object
};

var ProductSection = function ProductSection(_ref) {
  var _addedCartItem$attrib, _variant$price;
  var data = _ref.data,
    translations = _ref.translations;
  var addedCartItem = data.addedCartItem,
    isSubscription = data.isSubscription,
    quantity = data.quantity,
    selectedSubscriptionName = data.selectedSubscriptionName,
    variant = data.variant,
    volume_price = data.volume_price;
  var lineItemPrice = addedCartItem === null || addedCartItem === void 0 || (_addedCartItem$attrib = addedCartItem.attributes) === null || _addedCartItem$attrib === void 0 ? void 0 : _addedCartItem$attrib.line_item_price;
  var isBetter = (parseFloat(volume_price === null || volume_price === void 0 ? void 0 : volume_price.substring(1)) || parseFloat(lineItemPrice === null || lineItemPrice === void 0 ? void 0 : lineItemPrice.substring(1))) >= parseFloat(variant === null || variant === void 0 || (_variant$price = variant.price) === null || _variant$price === void 0 ? void 0 : _variant$price.substring(1));
  var discountedPrice = isBetter ? lineItemPrice : volume_price || lineItemPrice;
  var isShouldBeVisible = (isBetter ? lineItemPrice : volume_price) !== variant.old_price;
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$5.product__section
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "image-wrapper"
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: variant.product_name,
    height: 158,
    src: variant.image_path,
    width: 152
  })), /*#__PURE__*/React__default.createElement("div", {
    className: css$5['product__info-wrapper']
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: css$5.product__name
  }, variant.product_name), /*#__PURE__*/React__default.createElement("div", {
    className: css$5.product__description
  }, variant.name), /*#__PURE__*/React__default.createElement("div", {
    className: css$5.product__description
  }, translations.order_item_frequency, " ", isSubscription ? selectedSubscriptionName : translations.one_time_order), /*#__PURE__*/React__default.createElement("div", {
    className: css$5.product__description
  }, translations.payment_selector_labels_quantity, ": ", quantity), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(css$5['product__price-wrapper'], " ").concat(isShouldBeVisible ? 'onSale' : '')
  }, isShouldBeVisible ? /*#__PURE__*/React__default.createElement("div", {
    className: css$5.product__price
  }, discountedPrice) : null, /*#__PURE__*/React__default.createElement("div", {
    className: isShouldBeVisible ? 'volumePrice' : css$5.product__price
  }, variant.old_price))));
};
ProductSection.propTypes = {
  data: PropTypes.object,
  translations: PropTypes.object
};

var RecommendationsSection = function RecommendationsSection(_ref) {
  var paymentData = _ref.paymentData,
    config = _ref.config;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    recommendations = _useState2[0],
    setRecommendation = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var endpoints = config.endpoints,
    translations = config.translations;
  var recommendationsRequest = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var recommendationsUrl, replacedRecommendationsUrl, response, _error$response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            recommendationsUrl = endpoints.product_recommendations;
            replacedRecommendationsUrl = recommendationsUrl.replace(':product_id', paymentData.product_id);
            _context.p = 1;
            _context.n = 2;
            return axios.get(replacedRecommendationsUrl);
          case 2:
            response = _context.v;
            setRecommendation(response.data);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            setError(((_error$response = _t.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.error) || 'An error occurred');
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function recommendationsRequest() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    recommendationsRequest();
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$5.recommendations__wrapper,
    style: error ? {
      minHeight: '10rem'
    } : {}
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "pt-4 text-center"
  }, translations.confirmation_popup_recommendations), recommendations ? /*#__PURE__*/React__default.createElement("div", {
    className: css$5.recommendations__section
  }, recommendations.map(function (item) {
    return /*#__PURE__*/React__default.createElement(CollectionCard, {
      advertise: item.advertise,
      cartType: "quick_view",
      id: item.id,
      image: item.image,
      key: item.id,
      moreThanOneVariant: item.variants_count > 1,
      name: item.name,
      oldPrice: item.discount_price,
      onSale: item.on_sale,
      price: item.price,
      quickViewModalData: config,
      topLabel: item.top_label,
      translations: translations,
      url: "".concat(endpoints.product_url).concat(item.id)
    });
  })) : error ? /*#__PURE__*/React__default.createElement("div", {
    className: "error-center"
  }, error) : /*#__PURE__*/React__default.createElement(Loader, {
    isLarge: true
  }));
};
RecommendationsSection.propTypes = {
  config: PropTypes.object.isRequired,
  paymentData: PropTypes.object
};

var TcAddToCartSuccessModal = function TcAddToCartSuccessModal(_ref) {
  var config = _ref.config;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var translations = config.translations;
  var openModal = useCallback(function (e) {
    setIsModalOpen(true);
    setData(e.detail);
  }, []);
  var closeModal = function closeModal() {
    setIsModalOpen(false);
  };
  useEffect(function () {
    on('openAddToCartSuccessModal', openModal);
    on('closeAddToCartSuccessModal', closeModal);
    return function () {
      off('closeAddToCartSuccessModal', closeModal);
    };
  }, [openModal]);
  var modalBody = function modalBody() {
    if (Object.keys(data).length !== 0) {
      var addedCartItem = data.addedCartItem,
        paymentData = data.paymentData;
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h3", {
        className: "text-center"
      }, "".concat(data.quantity, " ").concat(translations.confirmation_popup_item_added)), /*#__PURE__*/React__default.createElement("div", {
        className: "add-to-cart"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: css$5['product__content-wrapper']
      }, /*#__PURE__*/React__default.createElement(ProductSection, {
        data: data,
        translations: translations
      }), /*#__PURE__*/React__default.createElement("span", {
        className: css$5.product__separator
      }), /*#__PURE__*/React__default.createElement(InfoActionSection, {
        addedCartItem: addedCartItem,
        config: config,
        handleClose: closeModal,
        paymentData: paymentData
      })), /*#__PURE__*/React__default.createElement(RecommendationsSection, {
        config: config,
        paymentData: paymentData
      })));
    }
  };
  return /*#__PURE__*/React__default.createElement(MainModal, {
    handleClose: closeModal,
    isModalOpen: isModalOpen,
    modalBody: modalBody()
  });
};
TcAddToCartSuccessModal.propTypes = {
  config: PropTypes.object.isRequired
};

var css_248z$8 = ".tc-cart-overlay_container__KmJrg,\n.tc-cart-overlay_container-fluid__mowHH,\n.tc-cart-overlay_container-xxxl2__gY47c,\n.tc-cart-overlay_container-xxxl__x2cPC,\n.tc-cart-overlay_container-xxl__ysrMi,\n.tc-cart-overlay_container-xl__j5bgi,\n.tc-cart-overlay_container-lg__KfSlq,\n.tc-cart-overlay_container-md__--0Fm,\n.tc-cart-overlay_container-sm__sWk-J {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-cart-overlay_container-sm__sWk-J, .tc-cart-overlay_container__KmJrg {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-cart-overlay_container-md__--0Fm, .tc-cart-overlay_container-sm__sWk-J, .tc-cart-overlay_container__KmJrg {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-cart-overlay_container-lg__KfSlq, .tc-cart-overlay_container-md__--0Fm, .tc-cart-overlay_container-sm__sWk-J, .tc-cart-overlay_container__KmJrg {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-cart-overlay_container-xl__j5bgi, .tc-cart-overlay_container-lg__KfSlq, .tc-cart-overlay_container-md__--0Fm, .tc-cart-overlay_container-sm__sWk-J, .tc-cart-overlay_container__KmJrg {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-cart-overlay_container-xxl__ysrMi, .tc-cart-overlay_container-xl__j5bgi, .tc-cart-overlay_container-lg__KfSlq, .tc-cart-overlay_container-md__--0Fm, .tc-cart-overlay_container-sm__sWk-J, .tc-cart-overlay_container__KmJrg {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-cart-overlay_container-xxxl__x2cPC, .tc-cart-overlay_container-xxl__ysrMi, .tc-cart-overlay_container-xl__j5bgi, .tc-cart-overlay_container-lg__KfSlq, .tc-cart-overlay_container-md__--0Fm, .tc-cart-overlay_container-sm__sWk-J, .tc-cart-overlay_container__KmJrg {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-cart-overlay_container-xxxl2__gY47c, .tc-cart-overlay_container-xxxl__x2cPC, .tc-cart-overlay_container-xxl__ysrMi, .tc-cart-overlay_container-xl__j5bgi, .tc-cart-overlay_container-lg__KfSlq, .tc-cart-overlay_container-md__--0Fm, .tc-cart-overlay_container-sm__sWk-J, .tc-cart-overlay_container__KmJrg {\n    max-width: 182rem;\n  }\n}\n.tc-cart-overlay_cart-dialog__fXH3b {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1002;\n  display: block;\n  width: 56rem;\n  max-width: 100%;\n  height: 100%;\n  margin-right: 0;\n  padding: 0;\n  overflow: hidden auto;\n  background: #fff;\n  border-width: 0;\n  transform: translateX(100%);\n  transition: transform 0.3s ease-in-out;\n}\n.tc-cart-overlay_cart-dialog--show__LcJB9 {\n  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.17);\n  transform: translateX(0);\n}\n.tc-cart-overlay_cart-dialog__fXH3b .collectionCard_quickView {\n  bottom: -1rem;\n  padding: 0.5rem 2rem;\n  font-size: 1.6rem;\n}\n\n.tc-cart-overlay_cart-dialog-backdrop__nGpg5 {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1001;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(112, 112, 112, 0.58);\n}\n\n.tc-cart-overlay_cart-dialog__container__sv8jU {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 4.2rem 2.4rem 20rem;\n  overflow: hidden auto;\n}\n\n.tc-cart-overlay_cart-dialog__heading-row__lWFYV {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 3.6rem 3rem 1.2rem;\n  border-bottom: 0.1rem solid #e5e5e5;\n}\n\n.tc-cart-overlay_cart-dialog__heading__03k4O {\n  margin-bottom: 0;\n}\n\n.tc-cart-overlay_product-items__mGw3t {\n  position: relative;\n  margin-bottom: 3rem;\n  padding-top: 3rem;\n  border-bottom: 0.1rem solid #e5e5e5;\n}\n\n.tc-cart-overlay_product-item__v9BmC {\n  position: relative;\n  display: flex;\n  gap: 2rem;\n  justify-content: space-between;\n  margin-bottom: 4rem;\n}\n.tc-cart-overlay_product-item__image-link__UUQzr {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.tc-cart-overlay_product-item__title__YdccB {\n  margin-bottom: 0.6rem;\n  color: #13220f;\n  font-weight: 700;\n  font-size: 1.5rem;\n  line-height: 2.5rem;\n}\n.tc-cart-overlay_product-item__title__YdccB > a {\n  color: #13220f;\n}\n.tc-cart-overlay_product-item__option__bC3jL {\n  margin-bottom: 1.53rem;\n  color: #707070;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n}\n.tc-cart-overlay_product-item__quantity-input__K-lpR {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 12rem;\n  overflow: hidden;\n  color: #1b8158;\n  font-weight: 700;\n  font-size: 1.8rem;\n  line-height: 2.7rem;\n  text-align: center;\n  background: #f7f7f7;\n  border-radius: 3.3rem;\n}\n.tc-cart-overlay_product-item__quantity-input__K-lpR > button {\n  display: flex;\n  flex-basis: 100%;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #1b8158;\n  font-weight: 700;\n  font-size: 1.5rem;\n  background: #f7f7f7;\n  border-width: 0;\n}\n.tc-cart-overlay_product-item__quantity-input__K-lpR > button:hover {\n  color: #fff;\n  background-color: #005c35;\n}\n.tc-cart-overlay_product-item__quantity-input__K-lpR > button[disabled] {\n  color: #fff;\n  background: #acacac;\n  cursor: not-allowed;\n}\n.tc-cart-overlay_product-item__quantity-input__K-lpR > input {\n  width: 5.7rem;\n  color: #1b8158;\n  font-weight: 700;\n  text-align: center;\n  background: #f7f7f7;\n  border-width: 0;\n}\n.tc-cart-overlay_product-item__remove__jWPt5 {\n  align-self: end;\n  padding-right: 0;\n  color: #1b8158;\n  font-weight: 600;\n  font-size: 1.5rem;\n  line-height: 2.3rem;\n  text-decoration: underline;\n  background: none;\n  border-width: 0;\n}\n.tc-cart-overlay_product-item__remove__jWPt5:disabled {\n  color: #acacac;\n  text-decoration: none;\n  cursor: not-allowed;\n}\n.tc-cart-overlay_product-item__quantity__jbVKJ, .tc-cart-overlay_product-item__price__hpalL {\n  font-size: 1.6rem;\n}\n.tc-cart-overlay_product-item__info__wYzqy {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.tc-cart-overlay_product-item__price-wrapper__zYsCl {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: space-between;\n}\n.tc-cart-overlay_product-item__price__hpalL {\n  display: flex;\n  margin-bottom: auto;\n  color: #1b8158;\n  font-weight: 700;\n  line-height: 2.4rem;\n}\n.tc-cart-overlay_product-item__old-price__ymErX {\n  margin-left: 0.4rem;\n  padding-left: 0.5rem;\n  color: #acacac;\n  font-weight: 400;\n  text-decoration: line-through;\n  border-left: 0.1rem solid #b2deba;\n}\n.tc-cart-overlay_product-item__image__VsBw- {\n  width: 100px;\n  height: 100px;\n}\n.tc-cart-overlay_product-item__v9BmC .tc-cart-overlay_hint__yE9U3 {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  margin-top: 0.5rem;\n  overflow: hidden;\n  color: #d92f2f;\n  font-weight: 700;\n  font-size: 1.4rem;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  background-color: #fff;\n}\n\n.tc-cart-overlay_discount__input__6EU5Y {\n  display: block;\n  width: 100%;\n  margin-right: 1rem;\n  padding: 0.8rem 2.4rem;\n  color: #13220f;\n  font-size: 1.6rem;\n  line-height: 2.5rem;\n  border: 0.1rem solid #e5e5e5;\n  border-radius: 2.3rem;\n  box-shadow: 0 0.3rem 0.6rem 0 rgba(33, 134, 82, 0.08);\n  transition: 0.15s ease-in-out;\n}\n.tc-cart-overlay_discount__input__6EU5Y:focus {\n  border-color: #1b8158;\n  outline: none;\n}\n.tc-cart-overlay_discount__input__6EU5Y::placeholder {\n  color: #d3d3d3;\n  opacity: 1;\n}\n.tc-cart-overlay_discount__input__6EU5Y:input-placeholder {\n  color: #d3d3d3;\n}\n.tc-cart-overlay_discount__input__6EU5Y::input-placeholder {\n  color: #d3d3d3;\n}\n.tc-cart-overlay_discount__input--error__tFh1Y {\n  color: #d92f2f;\n  border-color: #d92f2f;\n}\n.tc-cart-overlay_discount__error__wVkuZ {\n  margin-top: 0.5rem;\n  margin-bottom: 0;\n  color: #d92f2f;\n  font-size: 1.5rem;\n}\n.tc-cart-overlay_discount__row__-7NBM {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 3rem;\n  padding-bottom: 3rem;\n  border-bottom: 0.1rem solid #e2e2e2;\n}\n.tc-cart-overlay_discount__wrapper__sVRW3 {\n  display: flex;\n  width: 100%;\n}\n.tc-cart-overlay_discount__wrapper__sVRW3 button {\n  min-width: unset;\n  white-space: nowrap;\n}\n\n.tc-cart-overlay_totals__vm6Mo {\n  margin-bottom: 3rem;\n  padding-bottom: 3rem;\n  border-bottom: 0.1rem solid #e2e2e2;\n}\n.tc-cart-overlay_totals__row__D5UoV {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n.tc-cart-overlay_totals__value--emphasis__AGXKK {\n  color: #1b8158;\n}\n\n.tc-cart-overlay_actions__hW1Jt {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  align-items: center;\n  width: 100%;\n  padding: 2.4rem;\n  background: #fff;\n  box-shadow: 0 -0.4rem 0.6rem 0 rgba(0, 0, 0, 0.2);\n}\n\n.no-overflow-y {\n  overflow-y: hidden !important;\n}\n\n.tc-cart-overlay_upsellProducts__slider_container__CfIju {\n  margin-top: auto;\n}\n\n.tc-cart-overlay_upsellProducts__list__ohLsq {\n  display: flex;\n  margin: 0 -1rem;\n}\n.tc-cart-overlay_upsellProducts__list__ohLsq > div {\n  max-width: 23.8rem;\n  padding: 0 1rem;\n}\n\n.upsellProducts__slider .slick-track {\n  padding: 0 0.6rem;\n}\n.upsellProducts__slider .slick-slide {\n  padding: 0 1rem;\n}\n.upsellProducts__slider .slick-list {\n  width: 42.5rem;\n  margin-right: calc(-1 * 3.2rem / 2);\n  margin-left: calc(-1 * 3.8rem / 2);\n  padding: 2rem 0 6rem;\n  overflow: visible;\n}\n@media (min-width: 1600px) {\n  .upsellProducts__slider .slick-list {\n    width: 42.5rem;\n  }\n}";
var css$4 = {"cart-dialog":"tc-cart-overlay_cart-dialog__fXH3b","cart-dialog--show":"tc-cart-overlay_cart-dialog--show__LcJB9","cart-dialog-backdrop":"tc-cart-overlay_cart-dialog-backdrop__nGpg5","cart-dialog__container":"tc-cart-overlay_cart-dialog__container__sv8jU","cart-dialog__heading-row":"tc-cart-overlay_cart-dialog__heading-row__lWFYV","cart-dialog__heading":"tc-cart-overlay_cart-dialog__heading__03k4O","product-items":"tc-cart-overlay_product-items__mGw3t","product-item":"tc-cart-overlay_product-item__v9BmC","product-item__image-link":"tc-cart-overlay_product-item__image-link__UUQzr","product-item__title":"tc-cart-overlay_product-item__title__YdccB","product-item__option":"tc-cart-overlay_product-item__option__bC3jL","product-item__quantity-input":"tc-cart-overlay_product-item__quantity-input__K-lpR","product-item__remove":"tc-cart-overlay_product-item__remove__jWPt5","product-item__quantity":"tc-cart-overlay_product-item__quantity__jbVKJ","product-item__price":"tc-cart-overlay_product-item__price__hpalL","product-item__info":"tc-cart-overlay_product-item__info__wYzqy","product-item__price-wrapper":"tc-cart-overlay_product-item__price-wrapper__zYsCl","product-item__old-price":"tc-cart-overlay_product-item__old-price__ymErX","product-item__image":"tc-cart-overlay_product-item__image__VsBw-","hint":"tc-cart-overlay_hint__yE9U3","discount__input":"tc-cart-overlay_discount__input__6EU5Y","discount__input--error":"tc-cart-overlay_discount__input--error__tFh1Y","discount__error":"tc-cart-overlay_discount__error__wVkuZ","discount__row":"tc-cart-overlay_discount__row__-7NBM","discount__wrapper":"tc-cart-overlay_discount__wrapper__sVRW3","totals":"tc-cart-overlay_totals__vm6Mo","totals__row":"tc-cart-overlay_totals__row__D5UoV","totals__value--emphasis":"tc-cart-overlay_totals__value--emphasis__AGXKK","actions":"tc-cart-overlay_actions__hW1Jt","upsellProducts__slider_container":"tc-cart-overlay_upsellProducts__slider_container__CfIju","upsellProducts__list":"tc-cart-overlay_upsellProducts__list__ohLsq"};
styleInject(css_248z$8);

var cartIcon = "data:image/svg+xml,%3Csvg%20height%3D%2231.164%22%20width%3D%2238.715%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M34.416%2023.555l4.171-13.9a2.792%202.792%200%200%200-2.654-3.625H10.595L9.37%201.975A2.778%202.778%200%200%200%206.7%200H1.915a1.915%201.915%200%201%200%200%203.83h4.011l1.349%204.445c.01.031.025.059.036.09s.017.085.03.128l4.574%2015.069a1.914%201.914%200%200%200%201.255%201.268%203.4%203.4%200%201%200%203.575.092h12.464a3.4%203.4%200%201%200%203.685-.026%201.915%201.915%200%200%200%201.522-1.341z%22%20fill%3D%22%231B8158%22%2F%3E%3C%2Fsvg%3E";

function useMiniCartStore() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    miniCartData = _useState2[0],
    setMiniCartData = _useState2[1];
  var clearMiniCartData = function clearMiniCartData() {
    setMiniCartData([]);
  };
  var findById = function findById(lineItemId) {
    return miniCartData.find(function (li) {
      return li.item_id === Number(lineItemId);
    });
  };
  var populateMiniCart = function populateMiniCart(payload) {
    var tempArray = payload.included.map(function (lineItem) {
      var id = parseInt(lineItem.id, 10);
      var _lineItem$attributes = lineItem.attributes,
        currency = _lineItem$attributes.currency,
        name = _lineItem$attributes.name,
        price = _lineItem$attributes.price,
        quantity = _lineItem$attributes.quantity,
        sku = _lineItem$attributes.sku;
      var formattedPrice = parseFloat(price);
      return {
        currency: currency,
        item_id: id,
        item_name: name,
        price: formattedPrice,
        quantity: quantity,
        sku: sku
      };
    });
    clearMiniCartData();
    setMiniCartData(tempArray);
  };
  var removeById = function removeById(lineItemId) {
    setMiniCartData(function (prevData) {
      return prevData.filter(function (li) {
        return li.item_id !== lineItemId;
      });
    });
  };
  var updateById = function updateById(lineItemId) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setMiniCartData(function (prevData) {
      return prevData.map(function (li) {
        if (li.item_id === lineItemId) {
          return _objectSpread2(_objectSpread2({}, li), params);
        }
        return li;
      });
    });
  };
  return {
    clearMiniCartData: clearMiniCartData,
    miniCartData: miniCartData,
    findById: findById,
    populateMiniCart: populateMiniCart,
    removeById: removeById,
    updateById: updateById
  };
}

var useDataLayerEvent = function useDataLayerEvent() {
  var _useMiniCartStore = useMiniCartStore(),
    miniCartData = _useMiniCartStore.miniCartData,
    findById = _useMiniCartStore.findById;
  var handleDataLayerEvent = function handleDataLayerEvent(removeProductId) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ecommerce: null
    });
    var eventType = removeProductId ? 'remove_from_cart' : 'begin_checkout';
    var itemsToPush = [];
    if (eventType === 'remove_from_cart') {
      var removedProduct = findById(removeProductId);
      if (removedProduct) {
        itemsToPush = [_objectSpread2(_objectSpread2({}, removedProduct), {}, {
          quantity: 1
        })];
      }
    } else {
      itemsToPush = miniCartData;
    }
    window.dataLayer.push({
      ecommerce: {
        items: itemsToPush
      },
      event: eventType
    });
  };
  return handleDataLayerEvent;
};
var handleElevarDataLayerEvent = function handleElevarDataLayerEvent(_ref) {
  var data = _ref.data,
    eventType = _ref.eventType;
  if (!window.ElevarDataLayerHelper) {
    console.warn('ElevarDataLayerHelper not available');
    return false;
  }
  if (!eventType) {
    return false;
  }
  var eventMap = {
    add_to_cart: 'pushAddToCart',
    remove_from_cart: 'pushRemoveFromCart',
    view_cart: 'pushViewCart'
  };
  var action = eventMap[eventType];
  if (!action) {
    console.warn("Unsupported event type: ".concat(eventType));
    return false;
  }
  if (typeof window.ElevarDataLayerHelper[action] !== 'function') {
    console.warn("Method ".concat(action, " not available on ElevarDataLayerHelper"));
    return false;
  }
  try {
    window.ElevarDataLayerHelper[action]({
      data: data
    });
    return true;
  } catch (error) {
    console.error('Error calling ElevarDataLayerHelper:', error);
    return false;
  }
};
var handleMenuLinksDataLayer = function handleMenuLinksDataLayer(event, title, url, menuSection) {
  var data = {
    event: event,
    data: {
      clickText: title,
      clickUrl: url,
      menuSection: menuSection
    }
  };
  window.dataLayer = window.dataLayer || [];
  dataLayer.push(data);
};

var ProductItem = function ProductItem(_ref) {
  var item = _ref.item,
    handleIncrement = _ref.handleIncrement,
    handleDecrement = _ref.handleDecrement,
    handleQuantityChange = _ref.handleQuantityChange,
    handleDeleteCartItem = _ref.handleDeleteCartItem,
    loadingItems = _ref.loadingItems,
    translations = _ref.translations,
    cartItemErrors = _ref.cartItemErrors,
    endpoints = _ref.endpoints;
  var attributes = item.attributes;
  var product_url = "".concat(endpoints.shop_products_url).concat(attributes.slug);
  var itemId = item.id;
  var subscriptionInfo = "".concat(translations.order_item_frequency, " ").concat(attributes.display_frequency);
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$4['product-item'],
    key: itemId
  }, /*#__PURE__*/React__default.createElement("a", {
    "aria-label": attributes.name,
    className: css$4['product-item__image-link'],
    href: product_url
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: attributes.name,
    className: css$4['product-item__image'],
    src: attributes.product_thumb_image
  })), /*#__PURE__*/React__default.createElement("div", {
    className: css$4['product-item__info']
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: css$4['product-item__title']
  }, /*#__PURE__*/React__default.createElement("a", {
    className: css$4['product-item__link'],
    href: product_url
  }, attributes.name)), /*#__PURE__*/React__default.createElement("div", {
    className: css$4['product-item__option']
  }, attributes.front_end_options_text, /*#__PURE__*/React__default.createElement("br", null), subscriptionInfo), /*#__PURE__*/React__default.createElement("div", {
    className: css$4['product-item__quantity']
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$4['product-item__quantity-input']
  }, /*#__PURE__*/React__default.createElement("button", {
    "aria-label": "Decrement",
    disabled: loadingItems.includes(item.id) || attributes.quantity === 1,
    onClick: function onClick() {
      return handleDecrement(item.id, attributes.quantity);
    }
  }, "-"), /*#__PURE__*/React__default.createElement("input", {
    "aria-label": "Quantity",
    disabled: loadingItems.includes(item.id),
    min: "1",
    onChange: function onChange(e) {
      return handleQuantityChange(item.id, e);
    },
    step: "1",
    type: "number",
    value: attributes.quantity
  }), /*#__PURE__*/React__default.createElement("button", {
    "aria-label": "Increment",
    disabled: loadingItems.includes(item.id),
    onClick: function onClick() {
      return handleIncrement(item.id, attributes.quantity);
    }
  }, "+")))), /*#__PURE__*/React__default.createElement("div", {
    className: css$4['product-item__price-wrapper']
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$4['product-item__price']
  }, attributes.display_price, attributes.variant_old_price && attributes.variant_old_price !== attributes.display_price && /*#__PURE__*/React__default.createElement("div", {
    className: css$4['product-item__old-price']
  }, attributes.variant_old_price)), /*#__PURE__*/React__default.createElement("button", {
    "aria-label": "".concat(translations.remove_coupon_code, " ").concat(attributes.name),
    className: css$4['product-item__remove'],
    disabled: loadingItems.includes(item.id),
    onClick: function onClick() {
      return handleDeleteCartItem(item.id);
    }
  }, translations.remove_coupon_code)), cartItemErrors[itemId] && /*#__PURE__*/React__default.createElement("div", {
    className: css$4.hint,
    title: cartItemErrors[itemId]
  }, cartItemErrors[itemId]));
};
ProductItem.propTypes = {
  cartItemErrors: PropTypes.object,
  endpoints: PropTypes.object.isRequired,
  handleDecrement: PropTypes.func.isRequired,
  handleDeleteCartItem: PropTypes.func.isRequired,
  handleIncrement: PropTypes.func.isRequired,
  handleQuantityChange: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  loadingItems: PropTypes.array.isRequired,
  translations: PropTypes.object.isRequired
};

var setAuthHeaders = function setAuthHeaders(env) {
  var authToken = getCookie("shop_token_".concat(env));
  var orderToken = getCookie("order_token_".concat(env));
  var headers = {};
  if (authToken) {
    headers.Authorization = authToken;
    console.log("Auth token found for env: ".concat(env));
  } else {
    console.warn("No auth token found for env: ".concat(env, " - some requests may fail"));
  }
  if (orderToken) {
    headers['X-Spree-Order-Token'] = orderToken;
    console.log("Order token found for env: ".concat(env));
  } else {
    console.warn("No order token found for env: ".concat(env, " - cart requests may fail"));
  }
  return headers;
};
var handleApiError = function handleApiError(error, fallbackMessage) {
  var _error$response;
  var errorMessage = ((_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.error) || fallbackMessage;
  throw new Error(errorMessage);
};
var fetchCartData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(endpoints, headers) {
    var response, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return axios.get(endpoints.get_cart, {
            headers: headers,
            withCredentials: true
          });
        case 1:
          response = _context.v;
          return _context.a(2, response.data);
        case 2:
          _context.p = 2;
          _t = _context.v;
          handleApiError(_t, 'Failed to fetch cart data.');
        case 3:
          return _context.a(2);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function fetchCartData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var deleteCartItem = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(endpoints, headers, itemId) {
    var baseUrl, response, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          baseUrl = endpoints.delete_cart_item.endsWith('/') ? endpoints.delete_cart_item.slice(0, -1) : endpoints.delete_cart_item;
          _context2.p = 1;
          _context2.n = 2;
          return axios["delete"]("".concat(baseUrl, "/").concat(itemId, "?include_data_layer=true"), {
            headers: headers
          });
        case 2:
          response = _context2.v;
          return _context2.a(2, response.data);
        case 3:
          _context2.p = 3;
          _t2 = _context2.v;
          handleApiError(_t2, 'Failed to delete cart item.');
        case 4:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 3]]);
  }));
  return function deleteCartItem(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
var updateCartItemQuantity = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(endpoints, headers, itemId, newQuantity) {
    var formData, response, _t3;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          formData = new FormData();
          formData.append('line_item_id', itemId);
          formData.append('quantity', newQuantity);
          _context3.p = 1;
          _context3.n = 2;
          return axios.patch(endpoints.patch_quantity, formData, {
            headers: _objectSpread2(_objectSpread2({}, headers), {}, {
              'Content-Type': 'multipart/form-data'
            })
          });
        case 2:
          response = _context3.v;
          return _context3.a(2, response.data);
        case 3:
          _context3.p = 3;
          _t3 = _context3.v;
          handleApiError(_t3, 'Failed to update quantity.');
        case 4:
          return _context3.a(2);
      }
    }, _callee3, null, [[1, 3]]);
  }));
  return function updateCartItemQuantity(_x6, _x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();
var deleteDiscountCode = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(endpoints, headers, promoCode) {
    var response, _t4;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.p = 0;
          _context4.n = 1;
          return axios["delete"]("".concat(endpoints.delete_coupon_code, "/").concat(promoCode), {
            headers: headers
          });
        case 1:
          response = _context4.v;
          return _context4.a(2, response.data);
        case 2:
          _context4.p = 2;
          _t4 = _context4.v;
          handleApiError(_t4, 'Failed to remove discount code.');
        case 3:
          return _context4.a(2);
      }
    }, _callee4, null, [[0, 2]]);
  }));
  return function deleteDiscountCode(_x0, _x1, _x10) {
    return _ref4.apply(this, arguments);
  };
}();
var applyDiscountCode = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(endpoints, headers, discountCode) {
    var response, _t5;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          _context5.p = 0;
          _context5.n = 1;
          return axios.patch(endpoints.patch_coupon_code, {
            coupon_code: discountCode
          }, {
            headers: headers
          });
        case 1:
          response = _context5.v;
          return _context5.a(2, response.data);
        case 2:
          _context5.p = 2;
          _t5 = _context5.v;
          handleApiError(_t5, 'Failed to apply discount code.');
        case 3:
          return _context5.a(2);
      }
    }, _callee5, null, [[0, 2]]);
  }));
  return function applyDiscountCode(_x11, _x12, _x13) {
    return _ref5.apply(this, arguments);
  };
}();

var DiscountSection = function DiscountSection(_ref) {
  var _cartData$data;
  var cartData = _ref.cartData,
    handleFetchCartData = _ref.handleFetchCartData,
    translations = _ref.translations,
    endpoints = _ref.endpoints,
    env = _ref.env,
    setCartData = _ref.setCartData;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    discountCode = _useState2[0],
    setDiscountCode = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isProcessing = _useState4[0],
    setIsProcessing = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    discountError = _useState6[0],
    setDiscountError = _useState6[1];
  var promoCode = cartData === null || cartData === void 0 || (_cartData$data = cartData.data) === null || _cartData$data === void 0 || (_cartData$data = _cartData$data.attributes) === null || _cartData$data === void 0 || (_cartData$data = _cartData$data.promocodes) === null || _cartData$data === void 0 ? void 0 : _cartData$data.find(function (promo) {
    return promo.code;
  });
  var handleDiscount = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event, action) {
      var headers, data, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            event.preventDefault();
            if (!(action === 'apply' && discountCode.trim() === '')) {
              _context.n = 1;
              break;
            }
            setDiscountError('Discount code cannot be empty.');
            return _context.a(2);
          case 1:
            if (!(action === 'delete' && !promoCode)) {
              _context.n = 2;
              break;
            }
            setDiscountError('No discount code found.');
            return _context.a(2);
          case 2:
            setIsProcessing(true);
            headers = setAuthHeaders(env);
            _context.p = 3;
            if (!(action === 'apply')) {
              _context.n = 5;
              break;
            }
            _context.n = 4;
            return applyDiscountCode(endpoints, headers, discountCode);
          case 4:
            _t = _context.v;
            _context.n = 7;
            break;
          case 5:
            _context.n = 6;
            return deleteDiscountCode(endpoints, headers, promoCode.code);
          case 6:
            _t = _context.v;
          case 7:
            data = _t;
            setCartData(function (prevCartData) {
              return _objectSpread2(_objectSpread2({}, prevCartData), {}, {
                data: data.data || prevCartData.data
              });
            });
            if (action === 'apply') setDiscountCode('');
            setDiscountError('');
            _context.n = 9;
            break;
          case 8:
            _context.p = 8;
            _t2 = _context.v;
            setDiscountError(_t2.message);
          case 9:
            _context.p = 9;
            setIsProcessing(false);
            handleFetchCartData(false);
            return _context.f(9);
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[3, 8, 9, 10]]);
    }));
    return function handleDiscount(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$4.discount__row
  }, /*#__PURE__*/React__default.createElement("form", {
    className: css$4.discount__wrapper,
    onSubmit: function onSubmit(e) {
      return handleDiscount(e, promoCode ? 'delete' : 'apply');
    }
  }, /*#__PURE__*/React__default.createElement("input", {
    className: "".concat(css$4.discount__input, " ").concat(discountError ? css$4['discount__input--error'] : ''),
    disabled: isProcessing || !!promoCode,
    onChange: function onChange(e) {
      return setDiscountCode(e.target.value);
    },
    placeholder: translations.add_promo_code,
    readOnly: !!promoCode,
    type: "text",
    value: promoCode ? promoCode.label : discountCode
  }), /*#__PURE__*/React__default.createElement("button", {
    className: "buttonComponent--primary buttonComponent--small",
    disabled: isProcessing,
    type: "submit"
  }, promoCode ? translations.delete_discount_code : translations.apply_promo_code)), discountError && /*#__PURE__*/React__default.createElement("p", {
    className: css$4.discount__error,
    role: "alert"
  }, discountError));
};
DiscountSection.propTypes = {
  cartData: PropTypes.object,
  endpoints: PropTypes.object.isRequired,
  env: PropTypes.string.isRequired,
  handleFetchCartData: PropTypes.func.isRequired,
  setCartData: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired
};

var TotalsSection = function TotalsSection(_ref) {
  var cartData = _ref.cartData,
    translations = _ref.translations;
  var _cartData$data$attrib = cartData.data.attributes,
    itemCount = _cartData$data$attrib.item_count,
    displayItemTotal = _cartData$data$attrib.display_item_total,
    displayPromoTotal = _cartData$data$attrib.display_promo_total,
    displayTotal = _cartData$data$attrib.display_total;
  var subtotalTranslation = translations.subtotal.replace('%{quantity}', itemCount);
  var promoCode = cartData.data.attributes.promocodes.find(function (promo) {
    return promo.code !== null || promo.label !== null;
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$4.totals
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$4.totals__row
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("strong", null, subtotalTranslation, ":")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("strong", null, "\xA0", displayItemTotal))), promoCode && /*#__PURE__*/React__default.createElement("div", {
    className: css$4.totals__row
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("strong", null, promoCode.label, ":")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("strong", null, "\xA0", displayPromoTotal))), /*#__PURE__*/React__default.createElement("div", {
    className: css$4.totals__row
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("strong", null, translations.total, ":")), /*#__PURE__*/React__default.createElement("div", {
    className: css$4['totals__value--emphasis']
  }, /*#__PURE__*/React__default.createElement("strong", null, "\xA0", displayTotal))));
};
TotalsSection.propTypes = {
  cartData: PropTypes.object,
  translations: PropTypes.object.isRequired
};

var css_248z$7 = "/* Slider */\n.slick_slick-slider__oM7KC\n{\n    position: relative;\n\n    display: block;\n    box-sizing: border-box;\n\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-touch-action: pan-y;\n        touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.slick_slick-list__iOqXF\n{\n    position: relative;\n\n    display: block;\n    overflow: hidden;\n\n    margin: 0;\n    padding: 0;\n}\n.slick_slick-list__iOqXF:focus\n{\n    outline: none;\n}\n.slick_slick-list__iOqXF.slick_dragging__6gBI-\n{\n    cursor: pointer;\n    cursor: hand;\n}\n\n.slick_slick-slider__oM7KC .slick_slick-track__uctt7,\n.slick_slick-slider__oM7KC .slick_slick-list__iOqXF\n{\n    -webkit-transform: translate3d(0, 0, 0);\n       -moz-transform: translate3d(0, 0, 0);\n        -ms-transform: translate3d(0, 0, 0);\n         -o-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n\n.slick_slick-track__uctt7\n{\n    position: relative;\n    top: 0;\n    left: 0;\n\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n.slick_slick-track__uctt7:before,\n.slick_slick-track__uctt7:after\n{\n    display: table;\n\n    content: '';\n}\n.slick_slick-track__uctt7:after\n{\n    clear: both;\n}\n.slick_slick-loading__8Fjzx .slick_slick-track__uctt7\n{\n    visibility: hidden;\n}\n\n.slick_slick-slide__m2QTw\n{\n    display: none;\n    float: left;\n\n    height: 100%;\n    min-height: 1px;\n}\n[dir='rtl'] .slick_slick-slide__m2QTw\n{\n    float: right;\n}\n.slick_slick-slide__m2QTw img\n{\n    display: block;\n}\n.slick_slick-slide__m2QTw.slick_slick-loading__8Fjzx img\n{\n    display: none;\n}\n.slick_slick-slide__m2QTw.slick_dragging__6gBI- img\n{\n    pointer-events: none;\n}\n.slick_slick-initialized__aQs3t .slick_slick-slide__m2QTw\n{\n    display: block;\n}\n.slick_slick-loading__8Fjzx .slick_slick-slide__m2QTw\n{\n    visibility: hidden;\n}\n.slick_slick-vertical__3Otm4 .slick_slick-slide__m2QTw\n{\n    display: block;\n\n    height: auto;\n\n    border: 1px solid transparent;\n}\n.slick_slick-arrow__0HenY.slick_slick-hidden__DqzNK {\n    display: none;\n}\n";
styleInject(css_248z$7);

var css_248z$6 = "@charset 'UTF-8';\n/* Slider */\n.slick-theme_slick-loading__-bQxh .slick-theme_slick-list__hOFwm\n{\n    background: #fff url('./ajax-loader.gif') center center no-repeat;\n}\n\n/* Icons */\n@font-face\n{\n    font-family: 'slick';\n    font-weight: normal;\n    font-style: normal;\n\n    src: url('./fonts/slick.eot');\n    src: url('./fonts/slick.eot?#iefix') format('embedded-opentype'), url('./fonts/slick.woff') format('woff'), url('./fonts/slick.ttf') format('truetype'), url('./fonts/slick.svg#slick') format('svg');\n}\n/* Arrows */\n.slick-theme_slick-prev__aRAPV,\n.slick-theme_slick-next__9ZOh0\n{\n    font-size: 0;\n    line-height: 0;\n\n    position: absolute;\n    top: 50%;\n\n    display: block;\n\n    width: 20px;\n    height: 20px;\n    padding: 0;\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n\n    cursor: pointer;\n\n    color: transparent;\n    border: none;\n    outline: none;\n    background: transparent;\n}\n.slick-theme_slick-prev__aRAPV:hover,\n.slick-theme_slick-prev__aRAPV:focus,\n.slick-theme_slick-next__9ZOh0:hover,\n.slick-theme_slick-next__9ZOh0:focus\n{\n    color: transparent;\n    outline: none;\n    background: transparent;\n}\n.slick-theme_slick-prev__aRAPV:hover:before,\n.slick-theme_slick-prev__aRAPV:focus:before,\n.slick-theme_slick-next__9ZOh0:hover:before,\n.slick-theme_slick-next__9ZOh0:focus:before\n{\n    opacity: 1;\n}\n.slick-theme_slick-prev__aRAPV.slick-theme_slick-disabled__I6CvQ:before,\n.slick-theme_slick-next__9ZOh0.slick-theme_slick-disabled__I6CvQ:before\n{\n    opacity: .25;\n}\n\n.slick-theme_slick-prev__aRAPV:before,\n.slick-theme_slick-next__9ZOh0:before\n{\n    font-family: 'slick';\n    font-size: 20px;\n    line-height: 1;\n\n    opacity: .75;\n    color: white;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.slick-theme_slick-prev__aRAPV\n{\n    left: -25px;\n}\n[dir='rtl'] .slick-theme_slick-prev__aRAPV\n{\n    right: -25px;\n    left: auto;\n}\n.slick-theme_slick-prev__aRAPV:before\n{\n    content: '←';\n}\n[dir='rtl'] .slick-theme_slick-prev__aRAPV:before\n{\n    content: '→';\n}\n\n.slick-theme_slick-next__9ZOh0\n{\n    right: -25px;\n}\n[dir='rtl'] .slick-theme_slick-next__9ZOh0\n{\n    right: auto;\n    left: -25px;\n}\n.slick-theme_slick-next__9ZOh0:before\n{\n    content: '→';\n}\n[dir='rtl'] .slick-theme_slick-next__9ZOh0:before\n{\n    content: '←';\n}\n\n/* Dots */\n.slick-theme_slick-dotted__maUFb.slick-theme_slick-slider__qStzt\n{\n    margin-bottom: 30px;\n}\n\n.slick-theme_slick-dots__Egs5F\n{\n    position: absolute;\n    bottom: -25px;\n\n    display: block;\n\n    width: 100%;\n    padding: 0;\n    margin: 0;\n\n    list-style: none;\n\n    text-align: center;\n}\n.slick-theme_slick-dots__Egs5F li\n{\n    position: relative;\n\n    display: inline-block;\n\n    width: 20px;\n    height: 20px;\n    margin: 0 5px;\n    padding: 0;\n\n    cursor: pointer;\n}\n.slick-theme_slick-dots__Egs5F li button\n{\n    font-size: 0;\n    line-height: 0;\n\n    display: block;\n\n    width: 20px;\n    height: 20px;\n    padding: 5px;\n\n    cursor: pointer;\n\n    color: transparent;\n    border: 0;\n    outline: none;\n    background: transparent;\n}\n.slick-theme_slick-dots__Egs5F li button:hover,\n.slick-theme_slick-dots__Egs5F li button:focus\n{\n    outline: none;\n}\n.slick-theme_slick-dots__Egs5F li button:hover:before,\n.slick-theme_slick-dots__Egs5F li button:focus:before\n{\n    opacity: 1;\n}\n.slick-theme_slick-dots__Egs5F li button:before\n{\n    font-family: 'slick';\n    font-size: 6px;\n    line-height: 20px;\n\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 20px;\n    height: 20px;\n\n    content: '•';\n    text-align: center;\n\n    opacity: .25;\n    color: black;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.slick-theme_slick-dots__Egs5F li.slick-theme_slick-active__QTcxr button:before\n{\n    opacity: .75;\n    color: black;\n}\n";
styleInject(css_248z$6);

var _excluded = ["items"];
var Arrow = function Arrow(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    direction = _ref.direction,
    carouselControlsButtonStyles = _ref.carouselControlsButtonStyles;
  return /*#__PURE__*/React__default.createElement("button", {
    className: className,
    onClick: onClick,
    style: _objectSpread2({}, carouselControlsButtonStyles)
  }, direction === 'prev' ? 'Previous' : 'Next');
};
Arrow.propTypes = {
  carouselControlsButtonStyles: PropTypes.object,
  className: PropTypes.string,
  direction: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
var Slider = function Slider(_ref2) {
  var items = _ref2.items,
    settings = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React__default.createElement(SlickSlider, settings, items);
};
Slider.propTypes = {
  items: PropTypes.node.isRequired
};

var UpsellProductsSlider = function UpsellProductsSlider(_ref) {
  var products = _ref.products,
    quickViewModalData = _ref.quickViewModalData,
    translations = _ref.translations;
  var hasEnoughProductsForSlider = products.length > 2;
  var carouselSettings = {
    slidesToScroll: 1,
    slidesToShow: 2,
    nextArrow: /*#__PURE__*/React__default.createElement(Arrow, {
      direction: "next"
    }),
    prevArrow: /*#__PURE__*/React__default.createElement(Arrow, {
      direction: "prev"
    }),
    className: 'upsellProducts__slider'
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, products.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: css$4.upsellProducts__slider_container
  }, /*#__PURE__*/React__default.createElement("h4", null, /*#__PURE__*/React__default.createElement("b", null, translations.you_may_also_like_minicart, ":")), hasEnoughProductsForSlider ? /*#__PURE__*/React__default.createElement(Slider, _extends$2({
    items: products.map(function (item) {
      return /*#__PURE__*/React__default.createElement(CollectionCard, {
        advertise: item.attributes.advertise,
        cartType: "qv_upsell_mini",
        id: item.attributes.id,
        image: item.attributes.image,
        key: item.attributes.id,
        moreThanOneVariant: item.attributes.variants_count > 1,
        name: item.attributes.name,
        oldPrice: item.attributes.old_price,
        onSale: item.attributes.on_sale,
        price: item.attributes.price,
        quickViewModalData: quickViewModalData,
        topLabel: item.attributes.top_label,
        translations: translations,
        url: item.attributes.link
      });
    })
  }, carouselSettings)) : /*#__PURE__*/React__default.createElement("div", {
    className: css$4.upsellProducts__list
  }, products.map(function (item) {
    return /*#__PURE__*/React__default.createElement(CollectionCard, {
      advertise: item.attributes.advertise,
      cartType: "qv_upsell_mini",
      id: item.attributes.id,
      image: item.attributes.image,
      key: item.attributes.id,
      moreThanOneVariant: item.attributes.variants_count > 1,
      name: item.attributes.name,
      oldPrice: item.attributes.old_price,
      onSale: item.attributes.on_sale,
      price: item.attributes.price,
      quickViewModalData: quickViewModalData,
      topLabel: item.attributes.top_label,
      translations: translations,
      url: item.attributes.link
    });
  }))));
};
UpsellProductsSlider.propTypes = {
  products: PropTypes.array.isRequired,
  quickViewModalData: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired
};

var LinksSection = function LinksSection(_ref) {
  _ref.cartData;
    var links = _ref.links,
    translations = _ref.translations,
    handleBeginCheckoutEvent = _ref.handleBeginCheckoutEvent;
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$4.actions
  }, /*#__PURE__*/React__default.createElement("a", {
    className: "buttonComponent--primary w-100 mini-cart-checkout",
    href: links.checkout,
    onClick: handleBeginCheckoutEvent
  }, translations.title_page), /*#__PURE__*/React__default.createElement("a", {
    className: "readMoreLink",
    href: links.cart
  }, translations.view_cart));
};
LinksSection.propTypes = {
  cartData: PropTypes.object,
  handleBeginCheckoutEvent: PropTypes.func.isRequired,
  links: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired
};

var TcCartOverlay = function TcCartOverlay(_ref) {
  var _cartData$data, _cartData$data2, _cartData$data3;
  var config = _ref.config,
    quickViewModalData = _ref.quickViewModalData;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openDialog = _useState2[0],
    setOpenDialog = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFetchingCart = _useState4[0],
    setIsFetchingCart = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    loadingItems = _useState6[0],
    setLoadingItems = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    cartData = _useState8[0],
    setCartData = _useState8[1];
  var _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    cartDataError = _useState0[0],
    setCartDataError = _useState0[1];
  var _useState1 = useState({}),
    _useState10 = _slicedToArray(_useState1, 2),
    cartItemErrors = _useState10[0],
    setCartItemErrors = _useState10[1];
  var _useState11 = useState({}),
    _useState12 = _slicedToArray(_useState11, 2),
    headers = _useState12[0],
    setHeaders = _useState12[1];
  var initialEndpoints = config.endpoints,
    env = config.env,
    title = config.title;
  var _useMiniCartStore = useMiniCartStore(),
    populateMiniCart = _useMiniCartStore.populateMiniCart,
    findById = _useMiniCartStore.findById,
    removeById = _useMiniCartStore.removeById,
    updateById = _useMiniCartStore.updateById;
  var handleDataLayerEvent = useDataLayerEvent();
  var hasCartItems = (cartData === null || cartData === void 0 || (_cartData$data = cartData.data) === null || _cartData$data === void 0 || (_cartData$data = _cartData$data.attributes) === null || _cartData$data === void 0 ? void 0 : _cartData$data.item_count) > 0;
  var endpoints = (cartData === null || cartData === void 0 ? void 0 : cartData.endpoints) || initialEndpoints || {};
  var links = (cartData === null || cartData === void 0 ? void 0 : cartData.links) || {};
  var translations = (cartData === null || cartData === void 0 ? void 0 : cartData.translations) || {};
  var setHeadersFromCookies = function setHeadersFromCookies() {
    var newHeaders = setAuthHeaders(env);
    if (newHeaders['X-Spree-Order-Token']) {
      setCartDataError('');
    } else {
      setCartDataError(translations.your_cart_is_empty || config.your_cart_is_empty);
      setCartData({
        included: []
      });
      return;
    }
    setHeaders(newHeaders);
  };
  var handleFetchCartData = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var showLoader,
      _data$meta,
      currentEndpoints,
      data,
      _data$meta2,
      _args = arguments,
      _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          showLoader = _args.length > 0 && _args[0] !== undefined ? _args[0] : true;
          if (headers['X-Spree-Order-Token']) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          if (showLoader) setIsFetchingCart(true);
          _context.p = 2;
          currentEndpoints = (cartData === null || cartData === void 0 ? void 0 : cartData.endpoints) || initialEndpoints;
          _context.n = 3;
          return fetchCartData(currentEndpoints, headers);
        case 3:
          data = _context.v;
          setCartData(data);
          populateMiniCart(data);
          setCartDataError(null);
          if (data !== null && data !== void 0 && (_data$meta = data.meta) !== null && _data$meta !== void 0 && _data$meta.dataLayer) {
            handleElevarDataLayerEvent({
              data: {
                cartTotal: data.data.attributes.item_total,
                cartType: 'mini',
                impressions: data === null || data === void 0 || (_data$meta2 = data.meta) === null || _data$meta2 === void 0 ? void 0 : _data$meta2.dataLayer
              },
              eventType: 'view_cart'
            });
          }
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          setCartDataError(_t.message);
        case 5:
          _context.p = 5;
          setIsFetchingCart(false);
          return _context.f(5);
        case 6:
          return _context.a(2);
      }
    }, _callee, null, [[2, 4, 5, 6]]);
  })), [headers, initialEndpoints, populateMiniCart]);
  var handleLinkClick = useCallback(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
      var target, currentPagePath, checkoutPathPattern;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            target = event.target;
            while (target !== null && target !== document.body && !(target instanceof HTMLAnchorElement && target.className && target.className.startsWith('tc-navbar_navbar__shopping_cart'))) {
              target = target.parentElement;
            }
            if (!(target !== null && target instanceof HTMLAnchorElement && target.className && target.className.startsWith('tc-navbar_navbar__shopping_cart'))) {
              _context2.n = 3;
              break;
            }
            target.getAttribute('href');
            currentPagePath = window.location.pathname; // Use regex to match the described patterns
            checkoutPathPattern = /^\/[a-z]{2}-[A-Z]{2}\/checkout(\/[a-z]+)?\/?$/; // If the current path matches the pattern, allow the link to behave normally.
            if (!checkoutPathPattern.test(currentPagePath)) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            if (!window.matchMedia('(max-width: 991px)').matches) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2);
          case 2:
            event.preventDefault();
            setOpenDialog(true);
            setHeadersFromCookies();
            _context2.n = 3;
            return handleFetchCartData();
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [handleFetchCartData]);
  var handleBackdropClick = function handleBackdropClick() {
    setOpenDialog(false);
    if (headers['X-Spree-Order-Token']) {
      var fetchCartCountEvent = new CustomEvent('FETCH_CART_COUNT', {});
      document.dispatchEvent(fetchCartCountEvent);
    }
  };
  var handleQuantityChange = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(itemId, event) {
      var newQuantity;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            newQuantity = Number(event.target.value);
            if (!(newQuantity > 0)) {
              _context3.n = 1;
              break;
            }
            _context3.n = 1;
            return handleUpdateQuantity(itemId, newQuantity);
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function handleQuantityChange(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleDeleteCartItem = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(itemId) {
      var _data$meta3, data, dataLayer, _t2;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            setLoadingItems(function (prevLoadingItems) {
              return [].concat(_toConsumableArray(prevLoadingItems), [itemId]);
            });
            _context4.p = 1;
            _context4.n = 2;
            return deleteCartItem(endpoints, headers, itemId);
          case 2:
            data = _context4.v;
            setCartData(function (prevCartData) {
              var updatedIncluded = prevCartData.included.filter(function (item) {
                return item.id !== itemId;
              });
              return _objectSpread2(_objectSpread2({}, prevCartData), {}, {
                data: data.data || prevCartData.data,
                included: updatedIncluded
              });
            });
            handleDataLayerEvent(itemId);
            dataLayer = data === null || data === void 0 || (_data$meta3 = data.meta) === null || _data$meta3 === void 0 ? void 0 : _data$meta3.dataLayer;
            if (dataLayer) {
              handleElevarDataLayerEvent({
                data: dataLayer,
                eventType: 'remove_from_cart'
              });
            }
            removeById(itemId);
            _context4.n = 4;
            break;
          case 3:
            _context4.p = 3;
            _t2 = _context4.v;
            setCartItemErrors(function (prevErrors) {
              return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, itemId, _t2.message));
            });
          case 4:
            _context4.p = 4;
            setLoadingItems(function (prevLoadingItems) {
              return prevLoadingItems.filter(function (id) {
                return id !== itemId;
              });
            });
            return _context4.f(4);
          case 5:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 3, 4, 5]]);
    }));
    return function handleDeleteCartItem(_x4) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleUpdateQuantity = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(itemId, newQuantity) {
      var _data$meta4, data, dataLayer, existingItem, eventType, quantityDiff, _t3;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            setLoadingItems(function (prevLoadingItems) {
              return [].concat(_toConsumableArray(prevLoadingItems), [itemId]);
            });
            _context5.p = 1;
            _context5.n = 2;
            return updateCartItemQuantity(endpoints, headers, itemId, newQuantity);
          case 2:
            data = _context5.v;
            dataLayer = data === null || data === void 0 || (_data$meta4 = data.meta) === null || _data$meta4 === void 0 ? void 0 : _data$meta4.dataLayer;
            existingItem = findById(itemId);
            eventType = newQuantity > existingItem.quantity ? 'add_to_cart' : 'remove_from_cart';
            quantityDiff = Math.abs(newQuantity - existingItem.quantity);
            if (quantityDiff !== 0 && dataLayer) {
              handleElevarDataLayerEvent({
                data: _objectSpread2(_objectSpread2({}, dataLayer), {}, {
                  items: [_objectSpread2(_objectSpread2({}, dataLayer.items[0]), {}, {
                    quantity: String(quantityDiff)
                  })]
                }),
                eventType: eventType
              });
            }
            setCartData(function (prevCartData) {
              return _objectSpread2(_objectSpread2({}, prevCartData), {}, {
                data: data.data || prevCartData.data,
                included: data.included || prevCartData.included
              });
            });
            updateById(itemId, {
              quantity: newQuantity
            });
            _context5.n = 4;
            break;
          case 3:
            _context5.p = 3;
            _t3 = _context5.v;
            setCartItemErrors(function (prevErrors) {
              return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, itemId, _t3.message));
            });
          case 4:
            _context5.p = 4;
            setLoadingItems(function (prevLoadingItems) {
              return prevLoadingItems.filter(function (id) {
                return id !== itemId;
              });
            });
            return _context5.f(4);
          case 5:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 3, 4, 5]]);
    }));
    return function handleUpdateQuantity(_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();
  var handleIncrement = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(itemId, quantity) {
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            _context6.n = 1;
            return handleUpdateQuantity(itemId, quantity + 1);
          case 1:
            return _context6.a(2);
        }
      }, _callee6);
    }));
    return function handleIncrement(_x7, _x8) {
      return _ref7.apply(this, arguments);
    };
  }();
  var handleDecrement = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(itemId, quantity) {
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            if (!(quantity > 1)) {
              _context7.n = 2;
              break;
            }
            _context7.n = 1;
            return handleUpdateQuantity(itemId, quantity - 1);
          case 1:
            handleDataLayerEvent(itemId);
          case 2:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    return function handleDecrement(_x9, _x0) {
      return _ref8.apply(this, arguments);
    };
  }();
  useEffect(function () {
    document.addEventListener('click', handleLinkClick);
    return function () {
      document.removeEventListener('click', handleLinkClick);
    };
  }, [handleLinkClick]);
  useEffect(function () {
    var handleQuickViewOpen = function handleQuickViewOpen() {
      return setOpenDialog(false);
    };
    document.addEventListener('openQuickViewModal', handleQuickViewOpen);
    return function () {
      document.removeEventListener('openQuickViewModal', handleQuickViewOpen);
    };
  }, []);
  useEffect(function () {
    if (openDialog) {
      setHeadersFromCookies();
      document.body.classList.add('no-overflow-y');
    } else {
      document.body.classList.remove('no-overflow-y');
    }
  }, [openDialog]);
  useEffect(function () {
    if (openDialog && headers['X-Spree-Order-Token'] && !cartDataError && !cartData) {
      handleFetchCartData();
    }
  }, [openDialog, headers['X-Spree-Order-Token'], cartDataError]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, openDialog && /*#__PURE__*/React__default.createElement("div", {
    className: css$4['cart-dialog-backdrop'],
    onClick: handleBackdropClick
  }), /*#__PURE__*/React__default.createElement("dialog", {
    className: "".concat(css$4['cart-dialog'], " ").concat(openDialog ? css$4['cart-dialog--show'] : ''),
    open: openDialog
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$4['cart-dialog__container'],
    style: hasCartItems ? {} : {
      paddingBottom: '4rem'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$4['cart-dialog__heading-row']
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: css$4['cart-dialog__heading']
  }, title), /*#__PURE__*/React__default.createElement("img", {
    alt: "Cart Icon",
    height: "31.164",
    src: cartIcon,
    width: "38.715"
  })), isFetchingCart ? /*#__PURE__*/React__default.createElement("div", {
    className: "loader"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "loader_spinner"
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: css$4['product-items']
  }, cartDataError ? /*#__PURE__*/React__default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: cartDataError
    }
  }) : hasCartItems ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (cartData === null || cartData === void 0 || (_cartData$data2 = cartData.data) === null || _cartData$data2 === void 0 || (_cartData$data2 = _cartData$data2.relationships) === null || _cartData$data2 === void 0 || (_cartData$data2 = _cartData$data2.user) === null || _cartData$data2 === void 0 ? void 0 : _cartData$data2.data) == null && /*#__PURE__*/React__default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: translations.cart_authorize
    }
  }), translations.referrer_discount_applied && /*#__PURE__*/React__default.createElement("p", null, translations.referrer_discount_applied), translations.referrer_cg_error && /*#__PURE__*/React__default.createElement("p", null, translations.referrer_cg_error), cartData.included.map(function (item) {
    return /*#__PURE__*/React__default.createElement(ProductItem, {
      cartItemErrors: cartItemErrors,
      endpoints: endpoints,
      handleDecrement: handleDecrement,
      handleDeleteCartItem: handleDeleteCartItem,
      handleIncrement: handleIncrement,
      handleQuantityChange: handleQuantityChange,
      item: item,
      key: item.id,
      loadingItems: loadingItems,
      translations: translations
    });
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (cartData === null || cartData === void 0 || (_cartData$data3 = cartData.data) === null || _cartData$data3 === void 0 || (_cartData$data3 = _cartData$data3.relationships) === null || _cartData$data3 === void 0 || (_cartData$data3 = _cartData$data3.user) === null || _cartData$data3 === void 0 ? void 0 : _cartData$data3.data) == null && /*#__PURE__*/React__default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: translations.cart_authorize
    }
  }), /*#__PURE__*/React__default.createElement("p", null, translations.your_cart_is_empty))), hasCartItems && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DiscountSection, {
    cartData: cartData,
    endpoints: endpoints,
    env: env,
    handleFetchCartData: handleFetchCartData,
    setCartData: setCartData,
    translations: translations
  }), /*#__PURE__*/React__default.createElement(TotalsSection, {
    cartData: cartData,
    translations: translations
  }), /*#__PURE__*/React__default.createElement(UpsellProductsSlider, {
    products: cartData.data.attributes.cross_selling,
    quickViewModalData: quickViewModalData,
    translations: translations
  })))), hasCartItems && /*#__PURE__*/React__default.createElement(LinksSection, {
    cartData: cartData,
    handleBeginCheckoutEvent: function handleBeginCheckoutEvent() {
      return handleDataLayerEvent(null);
    },
    links: links,
    translations: translations
  })));
};
TcCartOverlay.propTypes = {
  config: PropTypes.shape({
    endpoints: PropTypes.shape({
      get_cart: PropTypes.string,
      get_cart_count: PropTypes.string
    }),
    env: PropTypes.string.isRequired,
    title: PropTypes.string,
    your_cart_is_empty: PropTypes.string
  }).isRequired,
  quickViewModalData: PropTypes.object.isRequired
};

var css_248z$5 = ".tc-footer_container__b5jzZ, .tc-footer_footer__content__KS2Bb,\n.tc-footer_container-fluid__wp1Z-,\n.tc-footer_container-xxxl2__FCC1h,\n.tc-footer_container-xxxl__eRVqu,\n.tc-footer_container-xxl__4N5xb,\n.tc-footer_container-xl__J7Hsy,\n.tc-footer_container-lg__ywQhr,\n.tc-footer_container-md__Hsv41,\n.tc-footer_container-sm__vfL1o {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-footer_container-sm__vfL1o, .tc-footer_container__b5jzZ, .tc-footer_footer__content__KS2Bb {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-footer_container-md__Hsv41, .tc-footer_container-sm__vfL1o, .tc-footer_container__b5jzZ, .tc-footer_footer__content__KS2Bb {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-footer_container-lg__ywQhr, .tc-footer_container-md__Hsv41, .tc-footer_container-sm__vfL1o, .tc-footer_container__b5jzZ, .tc-footer_footer__content__KS2Bb {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-footer_container-xl__J7Hsy, .tc-footer_container-lg__ywQhr, .tc-footer_container-md__Hsv41, .tc-footer_container-sm__vfL1o, .tc-footer_container__b5jzZ, .tc-footer_footer__content__KS2Bb {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-footer_container-xxl__4N5xb, .tc-footer_container-xl__J7Hsy, .tc-footer_container-lg__ywQhr, .tc-footer_container-md__Hsv41, .tc-footer_container-sm__vfL1o, .tc-footer_container__b5jzZ, .tc-footer_footer__content__KS2Bb {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-footer_container-xxxl__eRVqu, .tc-footer_container-xxl__4N5xb, .tc-footer_container-xl__J7Hsy, .tc-footer_container-lg__ywQhr, .tc-footer_container-md__Hsv41, .tc-footer_container-sm__vfL1o, .tc-footer_container__b5jzZ, .tc-footer_footer__content__KS2Bb {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-footer_container-xxxl2__FCC1h, .tc-footer_container-xxxl__eRVqu, .tc-footer_container-xxl__4N5xb, .tc-footer_container-xl__J7Hsy, .tc-footer_container-lg__ywQhr, .tc-footer_container-md__Hsv41, .tc-footer_container-sm__vfL1o, .tc-footer_container__b5jzZ, .tc-footer_footer__content__KS2Bb {\n    max-width: 182rem;\n  }\n}\n.tc-footer_footer__lAExO {\n  padding: 3rem 0;\n  color: #13220f;\n  font-size: 1.2rem;\n  font-family: \"Poppins\", verdana, sans-serif;\n  border-top: 1.5rem solid #1b8158;\n}\n.tc-footer_footer__content__KS2Bb {\n  position: relative;\n}\n.tc-footer_footer__column_item__hSVxO[class*=MuiAccordion-root] {\n  margin: 0 !important;\n  background-color: transparent;\n  border-radius: 0 !important;\n  box-shadow: unset;\n}\n.tc-footer_footer__column_item__hSVxO[class*=MuiAccordion-root]::before {\n  display: none;\n}\n.tc-footer_footer__column_item__hSVxO [class*=MuiAccordionDetails-root] {\n  padding: 0;\n}\n.tc-footer_footer__column_item__hSVxO [class*=MuiAccordionSummary-root],\n.tc-footer_footer__column_item__hSVxO [class*=MuiAccordionSummary-content],\n.tc-footer_footer__column_item__hSVxO [class*=Mui-expanded] {\n  min-height: auto !important;\n  margin: 0 !important;\n  padding: 0;\n}\n.tc-footer_footer__column_title__mXVr8 {\n  width: 100%;\n  margin-bottom: 1.5rem;\n  color: #005c35;\n  font-weight: bolder;\n}\n.tc-footer_footer__column_title__mXVr8:empty {\n  display: none;\n}\n.tc-footer_footer__column_links__2bwvB {\n  margin-bottom: 4rem;\n  padding: 0;\n  list-style: none;\n}\n.tc-footer_footer__column_links__2bwvB:empty {\n  display: none;\n}\n.tc-footer_footer__column__OF-2c a,\n.tc-footer_footer__column__OF-2c button {\n  padding: 0;\n  color: #13220f;\n  font-weight: 400;\n  background: none;\n  border: none;\n}\n.tc-footer_footer__column__OF-2c a:hover, .tc-footer_footer__column__OF-2c a:active,\n.tc-footer_footer__column__OF-2c button:hover,\n.tc-footer_footer__column__OF-2c button:active {\n  color: #1b8158;\n  font-weight: 700;\n}\n.tc-footer_footer__social_icons__fK77J {\n  font-size: 2.5rem;\n}\n.tc-footer_footer__social_icon__-a7wn {\n  margin: 0 0.5rem;\n}\n.tc-footer_footer__social_icon__-a7wn a {\n  color: #005c35;\n}\n.tc-footer_footer__term_link_wrapper__xmOsX {\n  margin: 1.6rem;\n}\n.tc-footer_footer__term_link_wrapper__xmOsX:first-of-type {\n  margin-left: 0;\n}\n.tc-footer_footer__term_link_wrapper__xmOsX:last-of-type {\n  margin-right: 0;\n}\n.tc-footer_footer__copyright__DUN1X, .tc-footer_footer__term_link__Qazdh {\n  color: #528d6f;\n  font-weight: 400;\n}\n@media (max-width: 767.98px) {\n  .tc-footer_footer__term_link__Qazdh {\n    white-space: nowrap;\n  }\n}\n@media (max-width: 991.98px) {\n  .tc-footer_footer__column_title__mXVr8 {\n    position: relative;\n    margin-bottom: 0;\n    cursor: pointer;\n  }\n  .tc-footer_footer__column_title__mXVr8::after {\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin: 0 1.5rem;\n    border-style: solid;\n    content: \"\";\n    border-color: #1b8158 transparent transparent transparent;\n    border-width: 0.6rem 0.6rem 0;\n  }\n  .tc-footer_footer__column_title__mXVr8::after {\n    position: absolute;\n    top: 0.8rem;\n    right: 0;\n  }\n  .tc-footer_footer__column_links__2bwvB {\n    margin: 1rem 0 0;\n  }\n  .tc-footer_footer__column__OF-2c:last-of-type .tc-footer_footer__column_item__hSVxO:last-of-type {\n    border-bottom: none;\n  }\n  .tc-footer_footer__column_item__hSVxO {\n    padding: 2.5rem 0;\n    border-bottom: 0.1rem solid #bdd8ca;\n  }\n  .tc-footer_footer__social_icons__fK77J {\n    display: flex;\n    justify-content: space-between;\n    max-width: 40rem;\n    margin: 2rem auto;\n  }\n  .tc-footer_footer__legal__1QqLr {\n    text-align: center;\n  }\n  .tc-footer_footer__back_to_top__J1cjN {\n    display: none;\n  }\n}\n@media (min-width: 992px) {\n  .tc-footer_footer__lAExO {\n    padding-top: 10rem;\n    font-size: 1.4rem;\n  }\n  .tc-footer_footer__links__WIXeI {\n    min-height: 35rem;\n    padding-bottom: 5rem;\n    overflow: hidden;\n  }\n  .tc-footer_footer__column__OF-2c {\n    float: left;\n    width: 20%;\n    max-width: 34rem;\n    padding: 0 calc(-1 * 3.2rem / 2);\n  }\n  .tc-footer_footer__column__OF-2c:last-of-type {\n    padding-right: 6rem;\n  }\n  .tc-footer_footer__column_item__hSVxO [class*=MuiButtonBase-root] {\n    pointer-events: none;\n  }\n  .tc-footer_footer__column_item__hSVxO [class*=MuiCollapse-hidden] {\n    height: auto !important;\n    visibility: visible !important;\n  }\n  .tc-footer_footer__column_item__hSVxO {\n    margin-bottom: 5rem;\n  }\n  .tc-footer_footer__column_item__hSVxO li {\n    margin-bottom: 1.5rem;\n  }\n  .tc-footer_footer__social__EltDn {\n    clear: left;\n  }\n  .tc-footer_footer__social_icons__fK77J {\n    position: absolute;\n    top: 0;\n    right: calc(-1 * 3.2rem / 2);\n  }\n  .tc-footer_footer__social_icon__-a7wn {\n    margin: 2.5rem 0;\n    text-align: center;\n  }\n  .tc-footer_footer__social_icon__-a7wn:first-of-type {\n    margin-top: 0;\n  }\n  .tc-footer_footer__legal__1QqLr {\n    display: flex;\n    justify-content: space-between;\n    clear: left;\n    padding-top: 3rem;\n    border-top: 1px solid #005c35;\n  }\n  .tc-footer_footer__term_link__Qazdh:last-of-type::after {\n    display: none;\n  }\n  .tc-footer_footer__back_to_top__J1cjN {\n    position: relative;\n    display: inline-block;\n    margin-right: 4rem;\n    padding: 0;\n    color: #13220f;\n    font-weight: 700;\n    font-size: 1.6rem;\n    background: none;\n    border: none;\n    cursor: pointer;\n  }\n  .tc-footer_footer__back_to_top_line__WNQO- {\n    position: absolute;\n    bottom: -0.3rem;\n    left: 0;\n    display: inline-block;\n    width: 100%;\n    height: 0.3rem;\n    background: #005c35;\n    border-radius: 5rem;\n  }\n}\n.tc-footer_footer__acknowledgement_of_country_wrapper__ee2sP {\n  border-top: 1px solid #005c35;\n}\n@media (max-width: 991.98px) {\n  .tc-footer_footer__acknowledgement_of_country_wrapper__ee2sP {\n    margin: 3rem 0;\n    border-bottom: 1px solid #005c35;\n  }\n}\n.tc-footer_footer__acknowledgement_of_country__bZlkq {\n  padding: 3rem 0;\n}\n@media (max-width: 991.98px) {\n  .tc-footer_footer__acknowledgement_of_country__bZlkq {\n    overflow: hidden;\n  }\n}\n.tc-footer_footer__acknowledgement_of_country_text__O25QZ {\n  margin-bottom: 0;\n  color: #13220f;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 1.8;\n}\n\n.footer__cookieLink {\n  padding: 0 !important;\n  color: #528d6f !important;\n  font-weight: 400 !important;\n  font-size: 12px !important;\n  background: none !important;\n  border: none !important;\n}\n.footer__cookieLink:hover, .footer__cookieLink:active {\n  color: #055f30 !important;\n  text-decoration: none;\n}";
var footerCss = {"container":"tc-footer_container__b5jzZ","footer__content":"tc-footer_footer__content__KS2Bb","container-fluid":"tc-footer_container-fluid__wp1Z-","container-xxxl2":"tc-footer_container-xxxl2__FCC1h","container-xxxl":"tc-footer_container-xxxl__eRVqu","container-xxl":"tc-footer_container-xxl__4N5xb","container-xl":"tc-footer_container-xl__J7Hsy","container-lg":"tc-footer_container-lg__ywQhr","container-md":"tc-footer_container-md__Hsv41","container-sm":"tc-footer_container-sm__vfL1o","footer":"tc-footer_footer__lAExO","footer__column_item":"tc-footer_footer__column_item__hSVxO","footer__column_title":"tc-footer_footer__column_title__mXVr8","footer__column_links":"tc-footer_footer__column_links__2bwvB","footer__column":"tc-footer_footer__column__OF-2c","footer__social_icons":"tc-footer_footer__social_icons__fK77J","footer__social_icon":"tc-footer_footer__social_icon__-a7wn","footer__term_link_wrapper":"tc-footer_footer__term_link_wrapper__xmOsX","footer__copyright":"tc-footer_footer__copyright__DUN1X","footer__term_link":"tc-footer_footer__term_link__Qazdh","footer__legal":"tc-footer_footer__legal__1QqLr","footer__back_to_top":"tc-footer_footer__back_to_top__J1cjN","footer__links":"tc-footer_footer__links__WIXeI","footer__social":"tc-footer_footer__social__EltDn","footer__back_to_top_line":"tc-footer_footer__back_to_top_line__WNQO-","footer__acknowledgement_of_country_wrapper":"tc-footer_footer__acknowledgement_of_country_wrapper__ee2sP","footer__acknowledgement_of_country":"tc-footer_footer__acknowledgement_of_country__bZlkq","footer__acknowledgement_of_country_text":"tc-footer_footer__acknowledgement_of_country_text__O25QZ"};
styleInject(css_248z$5);

// TcFooter component renders the footer section of the application
var TcFooter = function TcFooter(_ref) {
  var _ref$acknowledgementO = _ref.acknowledgementOfCountry,
    acknowledgementOfCountry = _ref$acknowledgementO === void 0 ? '' : _ref$acknowledgementO,
    footerItems = _ref.footerItems,
    _ref$isAcknowledgemen = _ref.isAcknowledgementOfCountryEnabled,
    isAcknowledgementOfCountryEnabled = _ref$isAcknowledgemen === void 0 ? false : _ref$isAcknowledgemen;
  useEffect(function () {
    // Set the current year in the footer
    document.getElementById('year').innerHTML = new Date().getFullYear();
  }, []);

  // Render acknowledgement of country if enabled
  var renderAcknowledgementOfCountry = function renderAcknowledgementOfCountry() {
    if (isAcknowledgementOfCountryEnabled && acknowledgementOfCountry) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: footerCss.footer__acknowledgement_of_country_wrapper
      }, /*#__PURE__*/React__default.createElement("div", {
        className: footerCss.footer__acknowledgement_of_country
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col-lg-5"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: footerCss.footer__acknowledgement_of_country_text
      }, acknowledgementOfCountry)))));
    }
    return null;
  };

  // Render main footer items (links)
  var renderFooterItems = function renderFooterItems() {
    return Object.entries(footerItems.footer_titles).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      return /*#__PURE__*/React__default.createElement("div", {
        className: footerCss.footer__column,
        key: key
      }, Object.entries(value).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          subKey = _ref5[0],
          subValue = _ref5[1];
        return subValue && !Object.values(footerItems[subKey]).every(function (x) {
          return x.title === '';
        }) && /*#__PURE__*/React__default.createElement(Accordion, {
          className: footerCss.footer__column_item,
          key: subKey
        }, /*#__PURE__*/React__default.createElement(AccordionSummary, null, /*#__PURE__*/React__default.createElement("h6", {
          className: footerCss.footer__column_title
        }, subValue)), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("ul", {
          className: footerCss.footer__column_links
        }, renderSubFooterItems(subKey))));
      }));
    });
  };

  // Render sub footer items for each main footer item
  var renderSubFooterItems = function renderSubFooterItems(titleItem) {
    return Object.entries(footerItems[titleItem]).map(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        key = _ref7[0],
        footerItem = _ref7[1];
      return footerItem.title && (footerItem.link || footerItem.tclink) && /*#__PURE__*/React__default.createElement("li", {
        key: footerItem.link || footerItem.tclink || footerItem.title
      }, /*#__PURE__*/React__default.createElement("a", _extends$2({
        href: footerItem.link ? footerItem.link : footerItem.tclink
      }, footerItem.link ? {
        rel: 'noreferrer',
        target: '_blank'
      } : '', key === 'faq' ? {
        className: 'ga-faq-link'
      } : {}), footerItem.title));
    });
  };

  // Render social media icons
  var renderFooterIcons = function renderFooterIcons() {
    return Object.values(footerItems.footer_icons).map(function (iconItem) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(footerCss.footer__social_icon, " ").concat(footerCss[iconItem.icon_class]),
        key: iconItem.link || iconItem.icon_name
      }, /*#__PURE__*/React__default.createElement("a", {
        "aria-label": iconItem.icon_name,
        href: iconItem.link,
        rel: "noreferrer",
        target: "_blank"
      }, /*#__PURE__*/React__default.createElement("i", {
        className: "fab fa-".concat(iconItem.icon_name)
      })));
    });
  };

  // Render footer terms (e.g., privacy policy, terms of service)
  var renderFooterTerms = function renderFooterTerms() {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Object.entries(footerItems.footer_terms).map(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2);
        _ref9[0];
        var termItem = _ref9[1];
      return termItem.link && termItem.title ? /*#__PURE__*/React__default.createElement("span", {
        className: footerCss.footer__term_link_wrapper,
        key: termItem.link || termItem.title
      }, /*#__PURE__*/React__default.createElement("a", {
        className: footerCss.footer__term_link,
        href: termItem.link
      }, termItem.title)) : null;
    }));
  };

  // Render cookie consent button
  var renderFooterCookieConsent = function renderFooterCookieConsent() {
    return /*#__PURE__*/React__default.createElement("span", {
      className: footerCss.footer__term_link_wrapper
    }, /*#__PURE__*/React__default.createElement("button", {
      className: "ot-sdk-show-settings footer__cookieLink",
      id: "ot-sdk-btn"
    }, "CookieSettings"));
  };

  // Function to scroll to the top of the page
  var scrollToTop = function scrollToTop(e) {
    e.preventDefault();
    window.scrollTo({
      behavior: 'smooth',
      top: 0
    });
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: footerCss.footer
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-lg-12"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: footerCss.footer__content
  }, /*#__PURE__*/React__default.createElement("div", {
    className: footerCss.footer__links
  }, renderFooterItems()), /*#__PURE__*/React__default.createElement("div", {
    className: footerCss.footer__social
  }, /*#__PURE__*/React__default.createElement("div", {
    className: footerCss.footer__social_icons
  }, renderFooterIcons())), renderAcknowledgementOfCountry(), /*#__PURE__*/React__default.createElement("div", {
    className: footerCss.footer__legal
  }, /*#__PURE__*/React__default.createElement("div", {
    className: footerCss.footer__terms
  }, /*#__PURE__*/React__default.createElement("button", {
    className: footerCss.footer__back_to_top,
    onClick: scrollToTop
  }, footerItems.back_to_top, /*#__PURE__*/React__default.createElement("span", {
    className: footerCss.footer__back_to_top_line
  })), renderFooterTerms(), renderFooterCookieConsent()), /*#__PURE__*/React__default.createElement("span", {
    className: footerCss.footer__copyright
  }, footerItems.copyright, " \xA9 ", /*#__PURE__*/React__default.createElement("span", {
    id: "year"
  }), ".", ' ', footerItems.all_rights)))))));
};
TcFooter.propTypes = {
  acknowledgementOfCountry: PropTypes.string,
  footerItems: PropTypes.object.isRequired,
  isAcknowledgementOfCountryEnabled: PropTypes.bool
};

var css_248z$4 = ".tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_navbar__container__X9ZaQ,\n.tc-navbar_container-fluid__klPus,\n.tc-navbar_container-xxxl2__zsUfQ,\n.tc-navbar_container-xxxl__3wi7c,\n.tc-navbar_container-xxl__LyGYL,\n.tc-navbar_container-xl__JU-8c,\n.tc-navbar_container-lg__Lq-5v,\n.tc-navbar_container-md__OgXz0,\n.tc-navbar_container-sm__j4SLu {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-navbar_container-sm__j4SLu, .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-navbar_container-md__OgXz0, .tc-navbar_container-sm__j4SLu, .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-md__OgXz0, .tc-navbar_container-sm__j4SLu, .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-navbar_container-xl__JU-8c, .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-md__OgXz0, .tc-navbar_container-sm__j4SLu, .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-navbar_container-xxl__LyGYL, .tc-navbar_container-xl__JU-8c, .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-md__OgXz0, .tc-navbar_container-sm__j4SLu, .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-navbar_container-xxxl__3wi7c, .tc-navbar_container-xxl__LyGYL, .tc-navbar_container-xl__JU-8c, .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-md__OgXz0, .tc-navbar_container-sm__j4SLu, .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-navbar_container-xxxl2__zsUfQ, .tc-navbar_container-xxxl__3wi7c, .tc-navbar_container-xxl__LyGYL, .tc-navbar_container-xl__JU-8c, .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-md__OgXz0, .tc-navbar_container-sm__j4SLu, .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 182rem;\n  }\n}\n.tc-navbar_navbar__O4jV- {\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  width: 100%;\n  background: #fff;\n}\n.tc-navbar_navbar__O4jV-.fixed {\n  position: fixed;\n  top: 0;\n  left: 0;\n  box-shadow: 0 0.3rem 1rem 0 rgba(27, 114, 69, 0.15);\n}\n@media (max-width: 767.98px) {\n  .tc-navbar_navbar__O4jV-.fixed {\n    max-width: 100vw;\n  }\n}\n@media (min-width: 992px) {\n  .tc-navbar_navbar__O4jV-.fixed {\n    transform: translateY(0) !important;\n    transition: 0.3s transform;\n  }\n}\n.tc-navbar_navbar__O4jV-.searchHidden .tc-navbar_navbar__adornment__Kfud9 {\n  display: block;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.tc-navbar_navbar__O4jV-.searchHidden .tc-navbar_navbar__adornment__Kfud9 .iconSearch {\n  font-size: 3.5rem !important;\n}\n.tc-navbar_navbar__O4jV- ul {\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none;\n}\n.tc-navbar_navbar__wrapp__6E27V {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n.tc-navbar_navbar__investor__r9Lna .tc-navbar_navbar__subLink__-2yFA {\n  border-bottom: none;\n}\n.tc-navbar_navbar__investor__r9Lna .tc-navbar_navbar__subLink__-2yFA span {\n  display: none;\n}\n.tc-navbar_navbar__investor__r9Lna .tc-navbar_submenu__mobile__0hhvh .tc-navbar_navbar__subLink__-2yFA span {\n  display: block;\n}\n.tc-navbar_navbar__logo__h36Xq {\n  display: inline-block;\n  width: 5.5rem;\n  padding: 0.6rem 0;\n}\n.tc-navbar_navbar__logo__h36Xq img {\n  max-width: 100%;\n}\n.tc-navbar_navbar__nav__MFWs5 {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  width: 100%;\n  height: 100%;\n}\n.tc-navbar_navbar__nav_icons__v2v3E {\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-end;\n}\n.tc-navbar_navbar__profile__vFx9Z, .tc-navbar_navbar__shopping_cart__h8KYh,\n.tc-navbar_navbar__O4jV- .tc-navbar_navbar__adornment__Kfud9 {\n  margin: 0 0.8rem;\n  cursor: pointer;\n}\n.tc-navbar_navbar__profile__vFx9Z i, .tc-navbar_navbar__shopping_cart__h8KYh i,\n.tc-navbar_navbar__O4jV- .tc-navbar_navbar__adornment__Kfud9 i {\n  color: #707070;\n  font-size: 2rem;\n}\n.tc-navbar_navbar__profile__vFx9Z.tc-navbar_open__H5mLb > i, .tc-navbar_navbar__shopping_cart__h8KYh.tc-navbar_open__H5mLb > i,\n.tc-navbar_navbar__O4jV- .tc-navbar_navbar__adornment__Kfud9.tc-navbar_open__H5mLb > i {\n  color: #1b8158;\n}\n@media (max-width: 991.98px) {\n  .tc-navbar_navbar__profile__vFx9Z, .tc-navbar_navbar__shopping_cart__h8KYh,\n  .tc-navbar_navbar__O4jV- .tc-navbar_navbar__adornment__Kfud9 {\n    display: flex;\n    align-items: center;\n    min-height: 100%;\n    margin-right: 0;\n    margin-left: 0;\n    padding: 0 0.8rem;\n  }\n}\n.tc-navbar_navbar__shopping_cart__h8KYh {\n  position: relative;\n  align-self: center;\n  margin-right: 0 !important;\n}\n.tc-navbar_navbar__shopping_cart_count__Il4GB {\n  position: absolute;\n  top: -1rem;\n  right: -1.3rem;\n  display: block;\n  width: 2.7rem;\n  height: 2.7rem;\n  color: #005c35;\n  font-weight: 700;\n  font-size: 1.4rem;\n  line-height: 2.7rem;\n  text-align: center;\n  background-color: #fff;\n  border: 0.1rem solid #e2e2e2;\n  border-radius: 50%;\n  box-shadow: 0 0.3rem 0.6rem 0 rgba(28, 143, 97, 0.31);\n}\n.tc-navbar_navbar__menu_icon__x5wbC {\n  margin-right: -0.8rem;\n  padding: 0.8rem 0.8rem 0.8rem 2rem;\n}\n.tc-navbar_navbar__menu_icon__x5wbC span {\n  display: block;\n  width: 3rem;\n  height: 0.3rem;\n  margin: 0.5rem 0;\n  background: #005c35;\n}\n.tc-navbar_navbar__menu_icon_text__BfT2W {\n  color: #005c35;\n  font-weight: bold;\n  font-size: 1rem;\n  line-height: 1;\n  text-align: center;\n}\n.tc-navbar_navbar__subLink__-2yFA {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.6rem 2rem;\n  font-weight: 500;\n  font-size: 1.2rem;\n  border-bottom: 0.1rem solid #e2e2e2;\n}\n.tc-navbar_navbar__O4jV- .tc-navbar_navbar__adornment__Kfud9 {\n  display: none;\n}\n.tc-navbar_navbar__O4jV- .tc-navbar_navbar__adornment__Kfud9:hover {\n  background-color: transparent !important;\n}\n.tc-navbar_navbar__O4jV- .iconSearch,\n.tc-navbar_navbar__O4jV- .iconClear {\n  font-size: 2.5rem !important;\n}\n@media (max-width: 991.98px) {\n  .tc-navbar_navbar_search_input_overlay__3Uinj {\n    position: absolute;\n    top: 6rem;\n    left: 0;\n    z-index: 100;\n    width: 100%;\n    height: 100vh;\n    background-color: rgba(25, 38, 31, 0.66);\n  }\n}\n\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__sign__HA7ps {\n  padding: 1rem 2rem;\n  font-weight: 500;\n  font-size: 1.2rem;\n  background-color: #edfdf5;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__sign__HA7ps i {\n  margin-right: 1rem;\n  color: #bdd8ca;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__overlay__rnu4- {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(25, 38, 31, 0.66);\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__content__iMQEL {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1001;\n  width: 85%;\n  height: 100%;\n  overflow-y: auto;\n  background-color: #f7f7f7;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__menu__GlOHV a {\n  display: block;\n  padding: 1.6rem 2rem;\n  color: #172c21;\n  font-weight: 500;\n  font-size: 1.2rem;\n  background-color: #fff;\n  border-bottom: 0.1rem solid #e2e2e2;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__menu__GlOHV .tc-navbar_submenu__link__c-wop {\n  width: 100%;\n  padding: 1.6rem 2rem;\n  font-weight: 700;\n  font-size: 1.6rem;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__menu__GlOHV .tc-navbar_submenu__image_item_mobile__pbM0Z {\n  display: none;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title__jKR8l:not(a), .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop:not(a), .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__link__c-wop:not(a), .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title_level_2__EaR5S {\n  position: relative;\n  width: 100%;\n  padding: 1.6rem calc(2rem + 1rem) 1.6rem 2rem;\n  font-weight: 700;\n  font-size: 1.6rem;\n  background-color: #fff;\n  border-bottom: 0.1rem solid #e2e2e2;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title__jKR8l:not(a)::after, .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop:not(a)::after, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__link__c-wop:not(a)::after, .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title_level_2__EaR5S::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin: 0 1.5rem;\n  border-style: solid;\n  content: \"\";\n  border-color: transparent transparent transparent #1b8158;\n  border-width: 0.6rem 0 0.6rem 0.6rem;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title__jKR8l:not(a)::after, .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop:not(a)::after, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__link__c-wop:not(a)::after, .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title_level_2__EaR5S::after {\n  position: absolute;\n  top: 50%;\n  right: 2.2rem;\n  margin: 0;\n  transform: translateY(-50%);\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title_level_2__EaR5S {\n  font-weight: 500;\n  font-size: 1.4rem;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0 > .tc-navbar_submenu__list__-bnAC {\n  display: none;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened > .tc-navbar_submenu__list__-bnAC {\n  display: block;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened > .tc-navbar_submenu__list__-bnAC .tc-navbar_submenu__item_level_1__uGQ47.noTitle {\n  display: none;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened > .tc-navbar_submenu__list__-bnAC .tc-navbar_submenu__item_level_1__uGQ47 > ul {\n  display: none;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened > .tc-navbar_submenu__list__-bnAC.active > .tc-navbar_submenu__item_level_1__uGQ47:not(.opened) {\n  display: none;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened .tc-navbar_submenu__title__jKR8l, .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened .tc-navbar_submenu__link__c-wop {\n  padding-left: 3rem;\n  text-align: center;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened .tc-navbar_submenu__title__jKR8l::after, .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop::after, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened .tc-navbar_submenu__link__c-wop::after {\n  left: 2.2rem;\n  transform: rotate(-180deg) translateY(50%);\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened .tc-navbar_submenu__title__jKR8l.hidden, .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop.hidden, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened .tc-navbar_submenu__link__c-wop.hidden {\n  display: none;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened .tc-navbar_submenu__item_level_1__uGQ47.opened > .tc-navbar_submenu__title_level_2__EaR5S {\n  padding-left: 3rem;\n  text-align: center;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened .tc-navbar_submenu__item_level_1__uGQ47.opened > .tc-navbar_submenu__title_level_2__EaR5S::after {\n  left: 2.2rem;\n  transform: rotate(-180deg) translateY(50%);\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0.opened .tc-navbar_submenu__item_level_1__uGQ47.opened > ul {\n  display: block;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title_wrapper__ehDQa {\n  display: flex;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title_wrapper__ehDQa .tc-navbar_submenu__toggle__uBvBE {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin: 0;\n  padding-right: 2.2rem;\n  padding-left: 2.2rem;\n  background: white;\n  border-bottom: 0.1rem solid #e2e2e2;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title_wrapper__ehDQa .tc-navbar_submenu__toggle__uBvBE::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin: 0 1.5rem;\n  border-style: solid;\n  content: \"\";\n  border-color: transparent #1b8158 transparent transparent;\n  border-width: 0.6rem 0.6rem 0.6rem 0;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title_wrapper__ehDQa .tc-navbar_submenu__toggle__uBvBE::after {\n  margin: 0 !important;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title_wrapper__ehDQa a.tc-navbar_submenu__title__jKR8l, .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title_wrapper__ehDQa .tc-navbar_submenu__desktop__9zRPi a.tc-navbar_submenu__link__c-wop, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title_wrapper__ehDQa a.tc-navbar_submenu__link__c-wop {\n  width: 100%;\n  padding: 1.6rem calc(2rem + 1rem) 1.6rem 2rem;\n  padding-left: 0 !important;\n  color: #1b8158;\n  font-weight: 700;\n  font-size: 1.6rem;\n  background-color: #fff;\n  border-bottom: 0.1rem solid #e2e2e2;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__title_wrapper__ehDQa.hidden {\n  display: none;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__menu__GlOHV.active > .tc-navbar_submenu__item__svEh0:not(.opened) {\n  display: none;\n}\n.tc-navbar_submenu__mobile__0hhvh .tc-navbar_submenu__item__svEh0:not(.opened) > .submenu__list {\n  display: none;\n}\n\n/* For desktop layout */\n.tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_navbar__container__X9ZaQ,\n.tc-navbar_container-fluid__klPus,\n.tc-navbar_container-sm__j4SLu,\n.tc-navbar_container-md__OgXz0,\n.tc-navbar_container-lg__Lq-5v,\n.tc-navbar_container-xl__JU-8c,\n.tc-navbar_container-xxl__LyGYL,\n.tc-navbar_container-xxxl__3wi7c,\n.tc-navbar_container-xxxl2__zsUfQ {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_container-sm__j4SLu, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_container-sm__j4SLu, .tc-navbar_container-md__OgXz0, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_container-sm__j4SLu, .tc-navbar_container-md__OgXz0, .tc-navbar_container-lg__Lq-5v, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_container-sm__j4SLu, .tc-navbar_container-md__OgXz0, .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-xl__JU-8c, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_container-sm__j4SLu, .tc-navbar_container-md__OgXz0, .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-xl__JU-8c, .tc-navbar_container-xxl__LyGYL, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_container-sm__j4SLu, .tc-navbar_container-md__OgXz0, .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-xl__JU-8c, .tc-navbar_container-xxl__LyGYL, .tc-navbar_container-xxxl__3wi7c, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4, .tc-navbar_container-sm__j4SLu, .tc-navbar_container-md__OgXz0, .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-xl__JU-8c, .tc-navbar_container-xxl__LyGYL, .tc-navbar_container-xxxl__3wi7c, .tc-navbar_container-xxxl2__zsUfQ, .tc-navbar_navbar__container__X9ZaQ {\n    max-width: 182rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-navbar_navbar__O4jV-.searchHidden .tc-navbar_navbar__logo__h36Xq {\n    width: 10rem;\n  }\n  .tc-navbar_navbar__O4jV-.searchHidden .tc-navbar_navbar__wrapp__6E27V {\n    align-items: center;\n    padding: 2rem 0;\n  }\n  .tc-navbar_navbar__O4jV-.searchHidden .tc-navbar_navbar__nav_content__grcJ- {\n    align-items: center;\n  }\n  .tc-navbar_navbar__O4jV-:not(.tc-navbar_navbar__O4jV-.searchHidden) .tc-navbar_navbar__wrapp__6E27V {\n    height: 16.5rem;\n  }\n  .tc-navbar_navbar__investor__r9Lna {\n    height: unset !important;\n  }\n  .tc-navbar_navbar__investor__r9Lna .tc-navbar_navbar__nav_icons__v2v3E {\n    margin-top: 0;\n  }\n  .tc-navbar_navbar__logo__h36Xq {\n    width: 17rem;\n    margin-top: -0.5rem;\n    padding: 0;\n    transition: 0.15s ease-in-out;\n    will-change: width;\n  }\n  .tc-navbar_navbar__nav__MFWs5 {\n    margin: 0 2rem 0 6rem;\n  }\n  .tc-navbar_navbar__wrapp__6E27V {\n    padding: 3rem 0;\n  }\n  .tc-navbar_navbar__nav_icons__v2v3E {\n    position: relative;\n    align-items: normal;\n    margin-top: 1.5rem;\n    line-height: 1;\n  }\n  .tc-navbar_navbar__nav_content__grcJ- {\n    display: flex;\n    flex-direction: row-reverse;\n    width: 100%;\n  }\n  .tc-navbar_navbar__shopping_cart__h8KYh {\n    align-self: flex-start;\n  }\n  .tc-navbar_navbar__shopping_cart_count__Il4GB {\n    top: -1.5rem;\n    width: 2.7rem;\n    height: 2.7rem;\n    font-size: 1.4rem;\n    line-height: 2.7rem;\n  }\n  .tc-navbar_navbar__O4jV- .tc-navbar_profile__lKf0I, .tc-navbar_navbar__shopping_cart__h8KYh,\n  .tc-navbar_navbar__O4jV- .tc-navbar_navbar__adornment__Kfud9,\n  .tc-navbar_navbar__O4jV- .tc-navbar_countrySelector__VPckd {\n    position: relative;\n    margin: 0 1.5rem;\n  }\n  .tc-navbar_navbar__O4jV- .tc-navbar_profile__lKf0I i, .tc-navbar_navbar__shopping_cart__h8KYh i,\n  .tc-navbar_navbar__O4jV- .tc-navbar_navbar__adornment__Kfud9 i,\n  .tc-navbar_navbar__O4jV- .tc-navbar_countrySelector__VPckd i {\n    font-size: 2.5rem;\n  }\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__dropdown__Fh7LM {\n  margin-top: 0 !important;\n  border-radius: 0;\n  position: absolute;\n  top: 100%;\n  right: 0;\n  z-index: 102;\n  width: 100%;\n  max-height: 0;\n  margin-top: 2.8rem;\n  overflow: hidden;\n  background-color: #fff;\n  border-top: 0;\n  border-radius: 0 0 1.5rem 1.5rem;\n  box-shadow: 0 0.2rem 1.3rem 0 rgba(0, 145, 87, 0.14);\n  transition: max-height 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);\n  will-change: max-height;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__dropdown__Fh7LM::before {\n  display: block;\n  width: 100%;\n  height: 0.6rem;\n  background-color: #b2deba;\n  content: \"\";\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__dropdown__Fh7LM > div {\n  border-top: 0;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__dropdown_level_2__C3pqH {\n  padding: 0;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4 {\n  max-height: 80vh;\n  overflow: auto;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__list__-bnAC {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 130rem;\n  margin: 0 auto;\n  padding: 4rem 4.5rem !important;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__menu__GlOHV {\n  display: flex;\n  justify-content: flex-end;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__title__jKR8l, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  max-height: 6rem;\n  color: #005c35;\n  font-weight: 700;\n  font-size: 1.6rem;\n  line-height: 1.4;\n  text-align: center;\n  cursor: pointer;\n}\n@media (min-width: 1400px) {\n  .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__title__jKR8l, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop {\n    font-size: 1.8rem;\n  }\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__title_level_2__EaR5S {\n  font-weight: 700;\n  font-size: 1.8rem;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item__svEh0 {\n  margin: 0 0.8rem;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item__svEh0:last-of-type {\n  margin-right: 0;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item__svEh0:hover .tc-navbar_submenu__title__jKR8l, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item__svEh0:hover .tc-navbar_submenu__link__c-wop {\n  position: relative;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item__svEh0:hover .tc-navbar_submenu__title__jKR8l::after, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item__svEh0:hover .tc-navbar_submenu__link__c-wop::after {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  z-index: 2;\n  width: 0;\n  height: 0;\n  margin-top: 1.7rem;\n  border-color: transparent transparent #b2deba;\n  border-style: solid;\n  border-width: 0 1.6rem 1.3rem;\n  transform: translateX(-50%);\n  content: \"\";\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item__svEh0:hover .tc-navbar_submenu__title__jKR8l::before, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item__svEh0:hover .tc-navbar_submenu__link__c-wop::before {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  height: 4rem;\n  content: \"\";\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item__svEh0:hover .tc-navbar_submenu__dropdown__Fh7LM {\n  max-height: 80vh;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item_level_1__uGQ47 {\n  margin-bottom: 4rem;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item_level_1__uGQ47:last-of-type {\n  margin-bottom: 0;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item_level_2__I0tl0 {\n  margin: 1rem 2rem 1rem 0;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item_level_2__I0tl0 a {\n  display: inline-block;\n  color: #172c21;\n  font-weight: 500;\n  font-size: 1.6rem;\n  line-height: 1.4;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item_level_2__I0tl0 a:hover, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item_level_2__I0tl0 a:active {\n  color: #1b8158;\n  font-weight: 700;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item__svEh0 > .tc-navbar_submenu__title__jKR8l, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item__svEh0 > .tc-navbar_submenu__link__c-wop {\n  transition: none;\n}\n@media (min-width: 1400px) {\n  .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__item__svEh0 {\n    margin: 0 2rem;\n  }\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__column__6JcQt {\n  flex: 0 0 auto;\n  width: 25%;\n  max-width: 100%;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop {\n  transition: none;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop::after {\n  display: none;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop + .tc-navbar_submenu__dropdown__Fh7LM {\n  display: none;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__image__pplyi {\n  position: absolute;\n  right: 0;\n  bottom: -0.1rem;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__image_title__PQ9Rm {\n  position: relative;\n  z-index: 1;\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__image_item__4z4gB {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 17rem;\n  margin-bottom: 1.5rem;\n  padding: 2rem;\n  overflow: hidden;\n  color: #fff !important;\n  font-weight: 500;\n  font-size: 1.6rem;\n  background: linear-gradient(135deg, rgb(5, 95, 48) 0%, rgb(28, 143, 97) 100%);\n  border-radius: 1.5rem;\n}\n@media (max-width: 1199.98px) {\n  .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__image_item__4z4gB {\n    height: 13rem;\n  }\n}\n.tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__image_item__4z4gB img {\n  max-width: 100%;\n}\n\n.tc-navbar_navbar__O4jV-.searchHidden .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__title__jKR8l, .tc-navbar_navbar__O4jV-.searchHidden .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop {\n  height: 6rem;\n}\n.tc-navbar_navbar__O4jV-.searchHidden .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__title__jKR8l::after, .tc-navbar_navbar__O4jV-.searchHidden .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__link__c-wop::after {\n  margin-top: 1rem;\n}\n.tc-navbar_navbar__O4jV-.searchHidden .tc-navbar_navbar__nav_icons__v2v3E {\n  margin-top: 0;\n}\n\n.tc-navbar_container__3gWjj, .tc-navbar_navbar__container__X9ZaQ, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4,\n.tc-navbar_container-fluid__klPus,\n.tc-navbar_container-sm__j4SLu,\n.tc-navbar_container-md__OgXz0,\n.tc-navbar_container-lg__Lq-5v,\n.tc-navbar_container-xl__JU-8c,\n.tc-navbar_container-xxl__LyGYL,\n.tc-navbar_container-xxxl__3wi7c,\n.tc-navbar_container-xxxl2__zsUfQ {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_container-sm__j4SLu, .tc-navbar_navbar__container__X9ZaQ, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4 {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_container-sm__j4SLu, .tc-navbar_container-md__OgXz0, .tc-navbar_navbar__container__X9ZaQ, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4 {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_container-sm__j4SLu, .tc-navbar_container-md__OgXz0, .tc-navbar_container-lg__Lq-5v, .tc-navbar_navbar__container__X9ZaQ, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4 {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_container-sm__j4SLu, .tc-navbar_container-md__OgXz0, .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-xl__JU-8c, .tc-navbar_navbar__container__X9ZaQ, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4 {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_container-sm__j4SLu, .tc-navbar_container-md__OgXz0, .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-xl__JU-8c, .tc-navbar_container-xxl__LyGYL, .tc-navbar_navbar__container__X9ZaQ, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4 {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_container-sm__j4SLu, .tc-navbar_container-md__OgXz0, .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-xl__JU-8c, .tc-navbar_container-xxl__LyGYL, .tc-navbar_container-xxxl__3wi7c, .tc-navbar_navbar__container__X9ZaQ, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4 {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-navbar_container__3gWjj, .tc-navbar_container-sm__j4SLu, .tc-navbar_container-md__OgXz0, .tc-navbar_container-lg__Lq-5v, .tc-navbar_container-xl__JU-8c, .tc-navbar_container-xxl__LyGYL, .tc-navbar_container-xxxl__3wi7c, .tc-navbar_container-xxxl2__zsUfQ, .tc-navbar_navbar__container__X9ZaQ, .tc-navbar_submenu__desktop__9zRPi .tc-navbar_submenu__container__0guV4 {\n    max-width: 182rem;\n  }\n}\n.tc-navbar_countrySelector__dropdown__ochuJ {\n  width: 94.5rem !important;\n  position: absolute;\n  right: 0;\n  z-index: 102;\n  max-height: 0;\n  margin-top: 2.8rem;\n  overflow: hidden;\n  background-color: #fff;\n  border-top: 0;\n  border-radius: 0 0 1.5rem 1.5rem;\n  box-shadow: 0 0.2rem 1.3rem 0 rgba(0, 145, 87, 0.14);\n  transition: max-height 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);\n  will-change: max-height;\n}\n.tc-navbar_countrySelector__dropdown__ochuJ::before {\n  display: block;\n  width: 100%;\n  height: 0.6rem;\n  background-color: #b2deba;\n  content: \"\";\n}\n.tc-navbar_countrySelector__dropdown__ochuJ > div {\n  border: 0.1rem solid #eef4f1;\n  border-top: 0;\n}\n.tc-navbar_countrySelector__container__UhubB {\n  padding: 4rem 4.5rem 1rem 4.5rem;\n  overflow: hidden;\n}\n.tc-navbar_countrySelector__heading__29zED {\n  margin-bottom: 0.5rem;\n  font-weight: 700;\n  font-size: 1.8rem;\n}\n.tc-navbar_countrySelector__localeBlock__xJS8L {\n  position: relative;\n  padding-right: 3rem;\n  cursor: pointer;\n}\n.tc-navbar_countrySelector__localeBlock__xJS8L::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin: 0 1.5rem;\n  border-style: solid;\n  content: \"\";\n  border-color: #707070 transparent transparent transparent;\n  border-width: 0.6rem 0.6rem 0;\n}\n.tc-navbar_countrySelector__localeBlock__xJS8L::after {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  margin: 0;\n  transform: translateY(-50%);\n}\n.tc-navbar_countrySelector__localeBlock__xJS8L .tc-navbar_countrySelector__localeFlag__n1gOp {\n  width: 4rem;\n  height: 3.2rem;\n}\n.tc-navbar_countrySelector__localeList__xZFcs {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0;\n  list-style: none;\n}\n.tc-navbar_countrySelector__localeItem__LpIDj {\n  width: 50%;\n}\n.tc-navbar_countrySelector__localeFlag__n1gOp {\n  width: 3.3rem;\n  height: 2.2rem;\n}\n.tc-navbar_countrySelector__localeLink__3zh2i {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  color: #172c21;\n  font-weight: 500;\n  font-size: 1.4rem;\n  border-radius: 0.4rem;\n}\n.tc-navbar_countrySelector__localeName__uBoLS {\n  margin-left: 1.5rem;\n  line-height: 1.6;\n}\n.tc-navbar_countrySelector__VPckd:hover .tc-navbar_countrySelector__locale__zBXCv {\n  position: relative;\n}\n.tc-navbar_countrySelector__VPckd:hover .tc-navbar_countrySelector__locale__zBXCv::after {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  z-index: 2;\n  width: 0;\n  height: 0;\n  margin-top: 1.7rem;\n  border-color: transparent transparent #b2deba;\n  border-style: solid;\n  border-width: 0 1.6rem 1.3rem;\n  transform: translateX(-50%);\n  content: \"\";\n}\n.tc-navbar_countrySelector__VPckd:hover .tc-navbar_countrySelector__locale__zBXCv::before {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  height: 4rem;\n  content: \"\";\n}\n.tc-navbar_countrySelector__VPckd:hover .tc-navbar_countrySelector__localeBlock__xJS8L::after {\n  transform: translateY(-50%) rotate(180deg);\n}\n.tc-navbar_countrySelector__VPckd:hover .tc-navbar_countrySelector__dropdown__ochuJ {\n  max-height: 80vh;\n}\n@media (max-width: 991.98px) {\n  .tc-navbar_countrySelector__region__jMWK8 {\n    padding: 1.6rem;\n  }\n  .tc-navbar_countrySelector__localeLink__3zh2i {\n    padding-left: 0;\n  }\n  .tc-navbar_countrySelector__localeLink__3zh2i.activeLocale {\n    color: #1b8158;\n    font-weight: 700;\n  }\n}\n@media (min-width: 768px) and (max-width: 991.98px) {\n  .tc-navbar_countrySelector__localeItem__LpIDj {\n    width: 33.3%;\n  }\n}\n@media (min-width: 992px) {\n  .tc-navbar_countrySelector__localeList__xZFcs {\n    margin: 0 0 3rem -1rem !important;\n  }\n  .tc-navbar_countrySelector__localeLink__3zh2i {\n    font-size: 1.6rem;\n  }\n  .tc-navbar_countrySelector__localeLink__3zh2i.activeLocale, .tc-navbar_countrySelector__localeLink__3zh2i:hover {\n    color: #1b8158;\n    font-weight: 700;\n    background-color: #f7f7f7;\n  }\n  .tc-navbar_countrySelector__region__jMWK8 {\n    float: left;\n    width: 50%;\n    padding-right: 1rem;\n  }\n  .tc-navbar_countrySelector__region__jMWK8:nth-of-type(2) {\n    float: right;\n  }\n}\n\n.MuiBox-root:focus-visible {\n  outline: none;\n}\n\n.tc-navbar_profile__lKf0I {\n  position: relative;\n}\n.tc-navbar_profile__lKf0I .tc-navbar_profile__dropdown__j6jvU br {\n  display: none;\n}\n@media (max-width: 991.98px) {\n  .tc-navbar_profile__lKf0I .tc-navbar_profile__dropdown__j6jvU br {\n    display: block;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-navbar_profile__lKf0I:not(.touch):hover .tc-navbar_navbar__profile__vFx9Z {\n    position: relative;\n  }\n  .tc-navbar_profile__lKf0I:not(.touch):hover .tc-navbar_navbar__profile__vFx9Z::after {\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    z-index: 2;\n    width: 0;\n    height: 0;\n    margin-top: 1.7rem;\n    border-color: transparent transparent #b2deba;\n    border-style: solid;\n    border-width: 0 1.6rem 1.3rem;\n    transform: translateX(-50%);\n    content: \"\";\n  }\n  .tc-navbar_profile__lKf0I:not(.touch):hover .tc-navbar_navbar__profile__vFx9Z::before {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    height: 4rem;\n    content: \"\";\n  }\n  .tc-navbar_profile__lKf0I:not(.touch):hover .tc-navbar_profile__dropdown__j6jvU {\n    max-height: 80vh;\n  }\n}\n.tc-navbar_profile__lKf0I.showProfile .tc-navbar_navbar__profile__vFx9Z {\n  position: relative;\n}\n.tc-navbar_profile__lKf0I.showProfile .tc-navbar_navbar__profile__vFx9Z::after {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  z-index: 2;\n  width: 0;\n  height: 0;\n  margin-top: 1.7rem;\n  border-color: transparent transparent #b2deba;\n  border-style: solid;\n  border-width: 0 1.6rem 1.3rem;\n  transform: translateX(-50%);\n  content: \"\";\n}\n.tc-navbar_profile__lKf0I.showProfile .tc-navbar_navbar__profile__vFx9Z::before {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  height: 4rem;\n  content: \"\";\n}\n.tc-navbar_profile__lKf0I.showProfile .tc-navbar_profile__dropdown__j6jvU {\n  max-height: 80vh;\n}\n.tc-navbar_profile__dropdown__j6jvU {\n  width: auto !important;\n  min-width: 18rem;\n  position: absolute;\n  right: 0;\n  z-index: 102;\n  max-height: 0;\n  margin-top: 2.8rem;\n  overflow: hidden;\n  background-color: #fff;\n  border-top: 0;\n  border-radius: 0 0 1.5rem 1.5rem;\n  box-shadow: 0 0.2rem 1.3rem 0 rgba(0, 145, 87, 0.14);\n  transition: max-height 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);\n  will-change: max-height;\n}\n.tc-navbar_profile__dropdown__j6jvU::before {\n  display: block;\n  width: 100%;\n  height: 0.6rem;\n  background-color: #b2deba;\n  content: \"\";\n}\n.tc-navbar_profile__dropdown__j6jvU > div {\n  border: 0.1rem solid #eef4f1;\n  border-top: 0;\n}\n@media (max-width: 991.98px) {\n  .tc-navbar_profile__dropdown__j6jvU {\n    margin-top: 2rem;\n  }\n}\n@media (max-width: 575.98px) {\n  .tc-navbar_profile__dropdown__j6jvU {\n    width: 60vw;\n  }\n}\n.tc-navbar_profile__container__7-9cG {\n  padding: 1rem 3rem;\n  overflow: hidden;\n}\n.tc-navbar_profile__user_name__VbeNb {\n  margin: 1rem 0;\n  font-weight: 700;\n  white-space: nowrap;\n}\n@media (min-width: 992px) {\n  .tc-navbar_profile__user_name__VbeNb {\n    margin: 2rem 0;\n  }\n}\n.tc-navbar_profile__user_name__VbeNb span {\n  padding-left: 1rem;\n  color: #1b8158;\n}\n@media (max-width: 575.98px) {\n  .tc-navbar_profile__user_name__VbeNb span {\n    padding-left: 0;\n  }\n}\n@media (max-width: 575.98px) {\n  .tc-navbar_profile__user_name__VbeNb {\n    display: -webkit-box;\n    overflow: hidden;\n    white-space: unset;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n  }\n}\n.tc-navbar_profile__list_item__xV85o {\n  margin: 1rem 0;\n  white-space: nowrap;\n}\n@media (min-width: 992px) {\n  .tc-navbar_profile__list_item__xV85o {\n    margin: 2rem 0;\n  }\n}\n.tc-navbar_profile__list_item__xV85o a {\n  color: #13220f;\n  font-weight: 500;\n}\n.tc-navbar_profile__list_item__xV85o a:hover, .tc-navbar_profile__list_item__xV85o a:active {\n  color: #005c35;\n}\n@media (min-width: 992px) {\n  .tc-navbar_profile__list_item__xV85o a {\n    font-size: 1.6rem;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .tc-navbar_navbar__profile__vFx9Z::after {\n    margin-top: 0.8rem !important;\n  }\n}";
var css$3 = {"submenu__desktop":"tc-navbar_submenu__desktop__9zRPi","submenu__container":"tc-navbar_submenu__container__0guV4","navbar__container":"tc-navbar_navbar__container__X9ZaQ","navbar":"tc-navbar_navbar__O4jV-","navbar__adornment":"tc-navbar_navbar__adornment__Kfud9","navbar__wrapp":"tc-navbar_navbar__wrapp__6E27V","navbar__investor":"tc-navbar_navbar__investor__r9Lna","navbar__subLink":"tc-navbar_navbar__subLink__-2yFA","submenu__mobile":"tc-navbar_submenu__mobile__0hhvh","navbar__logo":"tc-navbar_navbar__logo__h36Xq","navbar__nav":"tc-navbar_navbar__nav__MFWs5","navbar__nav_icons":"tc-navbar_navbar__nav_icons__v2v3E","navbar__profile":"tc-navbar_navbar__profile__vFx9Z","navbar__shopping_cart":"tc-navbar_navbar__shopping_cart__h8KYh","navbar__shopping_cart_count":"tc-navbar_navbar__shopping_cart_count__Il4GB","navbar__menu_icon":"tc-navbar_navbar__menu_icon__x5wbC","navbar__menu_icon_text":"tc-navbar_navbar__menu_icon_text__BfT2W","navbar_search_input_overlay":"tc-navbar_navbar_search_input_overlay__3Uinj","submenu__sign":"tc-navbar_submenu__sign__HA7ps","submenu__overlay":"tc-navbar_submenu__overlay__rnu4-","submenu__content":"tc-navbar_submenu__content__iMQEL","submenu__menu":"tc-navbar_submenu__menu__GlOHV","submenu__link":"tc-navbar_submenu__link__c-wop","submenu__image_item_mobile":"tc-navbar_submenu__image_item_mobile__pbM0Z","submenu__title":"tc-navbar_submenu__title__jKR8l","submenu__title_level_2":"tc-navbar_submenu__title_level_2__EaR5S","submenu__item":"tc-navbar_submenu__item__svEh0","submenu__list":"tc-navbar_submenu__list__-bnAC","submenu__item_level_1":"tc-navbar_submenu__item_level_1__uGQ47","submenu__title_wrapper":"tc-navbar_submenu__title_wrapper__ehDQa","submenu__toggle":"tc-navbar_submenu__toggle__uBvBE","navbar__nav_content":"tc-navbar_navbar__nav_content__grcJ-","profile":"tc-navbar_profile__lKf0I","countrySelector":"tc-navbar_countrySelector__VPckd","submenu__dropdown":"tc-navbar_submenu__dropdown__Fh7LM","submenu__item_level_2":"tc-navbar_submenu__item_level_2__I0tl0","submenu__column":"tc-navbar_submenu__column__6JcQt","submenu__image":"tc-navbar_submenu__image__pplyi","submenu__image_title":"tc-navbar_submenu__image_title__PQ9Rm","submenu__image_item":"tc-navbar_submenu__image_item__4z4gB","countrySelector__dropdown":"tc-navbar_countrySelector__dropdown__ochuJ","countrySelector__container":"tc-navbar_countrySelector__container__UhubB","countrySelector__heading":"tc-navbar_countrySelector__heading__29zED","countrySelector__localeBlock":"tc-navbar_countrySelector__localeBlock__xJS8L","countrySelector__localeFlag":"tc-navbar_countrySelector__localeFlag__n1gOp","countrySelector__localeList":"tc-navbar_countrySelector__localeList__xZFcs","countrySelector__localeItem":"tc-navbar_countrySelector__localeItem__LpIDj","countrySelector__localeLink":"tc-navbar_countrySelector__localeLink__3zh2i","countrySelector__localeName":"tc-navbar_countrySelector__localeName__uBoLS","countrySelector__locale":"tc-navbar_countrySelector__locale__zBXCv","countrySelector__region":"tc-navbar_countrySelector__region__jMWK8","profile__dropdown":"tc-navbar_profile__dropdown__j6jvU","profile__container":"tc-navbar_profile__container__7-9cG","profile__user_name":"tc-navbar_profile__user_name__VbeNb","profile__list_item":"tc-navbar_profile__list_item__xV85o"};
styleInject(css_248z$4);

var TcSubMenu = function TcSubMenu(_ref) {
  var isMobile = _ref.isMobile,
    menuItems = _ref.menuItems,
    menuSection = _ref.menuSection;
  var submenuLinkEventName = 'submenu_link';
  var submenuImageEventName = 'submenu_image';
  var renderSubMenuItem = function renderSubMenuItem(submenuItem) {
    if (isMobile && !submenuItem.title) {
      return null;
    }
    var submenuClass = "".concat(submenuItem.title.replace(/\s+/g, '_').toLowerCase(), "_ga submenu_link_ga");
    return /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(submenuItem.submenuLinks.length !== 0 ? "".concat(css$3.submenu__item_level_1, " hasSubmenu") : ''),
      key: submenuItem.url || submenuItem.title
    }, submenuItem.submenuLinks.length !== 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: css$3.submenu__title_level_2
    }, submenuItem.title), /*#__PURE__*/React__default.createElement("ul", {
      className: css$3.submenu__list_level_2
    }, submenuItem.submenuLinks.filter(function (item) {
      return item.title;
    }).map(function (item) {
      return /*#__PURE__*/React__default.createElement("li", {
        className: css$3.submenu__item_level_2,
        key: item.url || item.title
      }, /*#__PURE__*/React__default.createElement("a", _extends$2({
        className: item.image ? "".concat(css$3.submenu__image_item, " ").concat(css$3.submenu__image_item_mobile) : submenuClass,
        href: item.url,
        onClick: function onClick() {
          return handleMenuLinksDataLayer(item.image ? submenuImageEventName : submenuLinkEventName, {
            title: item.title,
            url: item.url,
            menu_section: menuSection
          });
        }
      }, item.image && {
        rel: 'noreferrer',
        target: '_blank'
      }), item.image && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
        className: css$3.submenu__image_title
      }, item.title), /*#__PURE__*/React__default.createElement("img", {
        alt: item.title,
        className: css$3.submenu__image,
        src: item.image
      })), !item.image && item.title));
    }))));
  };
  return isMobile && menuItems.length ? menuItems.map(function (column, columnIndex) {
    return column.map(function (submenuItem) {
      return renderSubMenuItem(submenuItem);
    });
  }) : menuItems.map(function (column, columnIndex) {
    var _column$;
    var hasNonEmptySubmenuLinks = column.some(function (submenuItem) {
      return submenuItem.submenuLinks.length > 0;
    });
    if (!hasNonEmptySubmenuLinks) return null;
    return /*#__PURE__*/React__default.createElement("li", {
      className: css$3.submenu__column,
      key: ((_column$ = column[0]) === null || _column$ === void 0 ? void 0 : _column$.url) || columnIndex
    }, column.map(function (submenuItem, submenuIndex) {
      return submenuItem.submenuLinks.length > 0 && /*#__PURE__*/React__default.createElement("div", {
        key: submenuItem.url || submenuIndex
      }, renderSubMenuItem(submenuItem));
    }));
  });
};
TcSubMenu.propTypes = {
  isMobile: PropTypes.bool,
  menuItems: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string,
    submenuLinks: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      image: PropTypes.string,
      target: PropTypes.string
    })).isRequired
  })).isRequired).isRequired,
  menuSection: PropTypes.string
};

var TcSubMenuMobile = function TcSubMenuMobile(_ref) {
  var menuItems = _ref.menuItems,
    profileData = _ref.profileData,
    renderCountrySelector = _ref.renderCountrySelector,
    t = _ref.t,
    toggleMenu = _ref.toggleMenu;
  var profileName = profileData.profile_name,
    profileLinks = profileData.profile_links;
  var _useState = useState(new Set()),
    _useState2 = _slicedToArray(_useState, 2),
    openedItems = _useState2[0],
    setOpenedItems = _useState2[1];
  var mainMenuEventName = 'main_menu_click';
  var handleToggleSubItems = useCallback(function (event, key) {
    event.stopPropagation();
    var newOpenedItems = new Set(openedItems);
    var activeElement = event.target.parentNode.classList;
    var activeList = event.target.parentNode.parentNode;
    var isTitleLevel2 = event.target.classList.contains(css$3.submenu__title_level_2);
    var isTitleWrapper = event.target.parentNode.classList.contains(css$3.submenu__title_wrapper);
    if (isTitleWrapper) {
      activeElement = event.target.parentNode.parentNode.classList;
      activeList = event.target.parentNode.parentNode.parentNode;
    }
    if (activeElement.contains('opened')) {
      activeElement.remove('opened');
      activeList.classList.remove('active');
      activeList.previousElementSibling.classList.remove('hidden');
      if (!isTitleLevel2) {
        newOpenedItems["delete"](key);
      }
    } else {
      activeElement.add('opened');
      activeList.classList.add('active');
      activeList.previousElementSibling.classList.add('hidden');
      if (!isTitleLevel2) {
        newOpenedItems.add(key);
      }
    }
    setOpenedItems(newOpenedItems);
  }, [openedItems]);
  var generateUniqueKey = function generateUniqueKey(item, index) {
    return item.url || "".concat(item.title, "-").concat(index);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$3.submenu__mobile
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$3.submenu__overlay,
    onClick: toggleMenu
  }), /*#__PURE__*/React__default.createElement("div", {
    className: css$3.submenu__content
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$3.submenu__sign
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "fas fa-user"
  }), profileName === null ? profileLinks.map(function (link, index) {
    return /*#__PURE__*/React__default.createElement("span", {
      key: link.url || index
    }, /*#__PURE__*/React__default.createElement("a", _extends$2({
      href: link.url
    }, link.data_attr), link.title), index === 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "\xA0or\xA0"));
  }) : /*#__PURE__*/React__default.createElement("span", {
    className: "tcProfile__user-name"
  }, t.signed_in, ": ", /*#__PURE__*/React__default.createElement("span", null, profileName))), /*#__PURE__*/React__default.createElement("ul", {
    className: css$3.submenu__menu
  }, menuItems.map(function (menuItem, index) {
    var itemKey = generateUniqueKey(menuItem, index);
    var itemClass = "".concat(css$3.submenu__item, " ").concat(menuItem.submenuItems.length !== 0 ? 'hasSubmenu' : '', " ").concat(openedItems.has(itemKey) ? 'opened' : '');
    return /*#__PURE__*/React__default.createElement("li", {
      className: itemClass,
      key: itemKey,
      onClick: menuItem.submenuItems.length !== 0 ? function (event) {
        return handleToggleSubItems(event, itemKey);
      } : undefined
    }, menuItem.submenuItems.length !== 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, openedItems.has(itemKey) && menuItem.url ? /*#__PURE__*/React__default.createElement("div", {
      className: css$3.submenu__title_wrapper,
      id: itemKey
    }, /*#__PURE__*/React__default.createElement("span", {
      className: css$3.submenu__toggle,
      onClick: function onClick(event) {
        return handleToggleSubItems(event, itemKey);
      }
    }), /*#__PURE__*/React__default.createElement("a", {
      className: css$3.submenu__title,
      href: menuItem.url,
      onClick: function onClick() {
        return handleMenuLinksDataLayer(mainMenuEventName, menuItem.title, menuItem.url);
      }
    }, menuItem.title)) : /*#__PURE__*/React__default.createElement("div", {
      className: css$3.submenu__title,
      id: itemKey
    }, menuItem.title), /*#__PURE__*/React__default.createElement("ul", {
      className: css$3.submenu__list
    }, /*#__PURE__*/React__default.createElement(TcSubMenu, {
      isMobile: true,
      menuItems: menuItem.submenuItems,
      menuSection: menuItem.data_layer_value
    }))) : /*#__PURE__*/React__default.createElement("a", {
      className: css$3.submenu__link,
      href: menuItem.url,
      onClick: function onClick() {
        return handleMenuLinksDataLayer(mainMenuEventName, menuItem.title, menuItem.url);
      }
    }, menuItem.title));
  })), renderCountrySelector));
};
TcSubMenuMobile.propTypes = {
  menuItems: PropTypes.array.isRequired,
  profileData: PropTypes.shape({
    profile_links: PropTypes.arrayOf(PropTypes.shape({
      data_attr: PropTypes.object,
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })),
    profile_name: PropTypes.string
  }).isRequired,
  renderCountrySelector: PropTypes.node.isRequired,
  t: PropTypes.any.isRequired,
  toggleMenu: PropTypes.func.isRequired
};

var TcSubMenuDesktop = function TcSubMenuDesktop(_ref) {
  var isMobile = _ref.isMobile,
    menuItems = _ref.menuItems,
    toggleDocumentScroll = _ref.toggleDocumentScroll;
  var mainMenuEventName = 'main_menu_click';
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$3.submenu__desktop
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: css$3.submenu__menu
  }, menuItems.map(function (menuItem) {
    return /*#__PURE__*/React__default.createElement("li", {
      className: css$3.submenu__item,
      key: menuItem.url || menuItem.title,
      onMouseOut: function onMouseOut() {
        return toggleDocumentScroll(false);
      },
      onMouseOver: function onMouseOver() {
        return toggleDocumentScroll(true);
      }
    }, menuItem.submenuItems && menuItem.submenuItems.length !== 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, menuItem.url ? /*#__PURE__*/React__default.createElement("a", {
      className: css$3.submenu__title,
      href: menuItem.url,
      onClick: function onClick() {
        return handleMenuLinksDataLayer(mainMenuEventName, menuItem.title, menuItem.url);
      }
    }, menuItem.title) : /*#__PURE__*/React__default.createElement("div", {
      className: css$3.submenu__title
    }, menuItem.title), /*#__PURE__*/React__default.createElement("div", {
      className: css$3.submenu__dropdown
    }, /*#__PURE__*/React__default.createElement("div", {
      className: css$3.submenu__container
    }, /*#__PURE__*/React__default.createElement("ul", {
      className: css$3.submenu__list
    }, /*#__PURE__*/React__default.createElement(TcSubMenu, {
      isMobile: isMobile,
      menuItems: menuItem.submenuItems,
      menuSection: menuItem.data_layer_value
    }))))) : /*#__PURE__*/React__default.createElement("a", {
      className: css$3.submenu__link,
      href: menuItem.url,
      onClick: function onClick() {
        return handleMenuLinksDataLayer(mainMenuEventName, menuItem.title, menuItem.url);
      }
    }, menuItem.title));
  })));
};
TcSubMenuDesktop.propTypes = {
  isMobile: PropTypes.bool,
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string,
    submenuItems: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      submenuLinks: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        image: PropTypes.string
      })).isRequired
    }))).isRequired
  })).isRequired,
  toggleDocumentScroll: PropTypes.func.isRequired
};

var css_248z$3 = ".tc-search-bar_container__rILoj, .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__form__0bbXM,\n.tc-search-bar_container-fluid__prqGR,\n.tc-search-bar_container-xxxl2__64CSP,\n.tc-search-bar_container-xxxl__f0HU9,\n.tc-search-bar_container-xxl__0syG7,\n.tc-search-bar_container-xl__vPPhB,\n.tc-search-bar_container-lg__n7W1a,\n.tc-search-bar_container-md__dTAli,\n.tc-search-bar_container-sm__a1gRB {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-search-bar_container-sm__a1gRB, .tc-search-bar_container__rILoj, .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__form__0bbXM {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-search-bar_container-md__dTAli, .tc-search-bar_container-sm__a1gRB, .tc-search-bar_container__rILoj, .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__form__0bbXM {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-search-bar_container-lg__n7W1a, .tc-search-bar_container-md__dTAli, .tc-search-bar_container-sm__a1gRB, .tc-search-bar_container__rILoj, .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__form__0bbXM {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-search-bar_container-xl__vPPhB, .tc-search-bar_container-lg__n7W1a, .tc-search-bar_container-md__dTAli, .tc-search-bar_container-sm__a1gRB, .tc-search-bar_container__rILoj, .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__form__0bbXM {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-search-bar_container-xxl__0syG7, .tc-search-bar_container-xl__vPPhB, .tc-search-bar_container-lg__n7W1a, .tc-search-bar_container-md__dTAli, .tc-search-bar_container-sm__a1gRB, .tc-search-bar_container__rILoj, .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__form__0bbXM {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-search-bar_container-xxxl__f0HU9, .tc-search-bar_container-xxl__0syG7, .tc-search-bar_container-xl__vPPhB, .tc-search-bar_container-lg__n7W1a, .tc-search-bar_container-md__dTAli, .tc-search-bar_container-sm__a1gRB, .tc-search-bar_container__rILoj, .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__form__0bbXM {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-search-bar_container-xxxl2__64CSP, .tc-search-bar_container-xxxl__f0HU9, .tc-search-bar_container-xxl__0syG7, .tc-search-bar_container-xl__vPPhB, .tc-search-bar_container-lg__n7W1a, .tc-search-bar_container-md__dTAli, .tc-search-bar_container-sm__a1gRB, .tc-search-bar_container__rILoj, .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__form__0bbXM {\n    max-width: 182rem;\n  }\n}\n.tc-search-bar_search__input__4ggjZ .MuiInputBase-input {\n  height: 1.6rem;\n  padding: 1rem 5rem 1rem 3rem;\n  font-weight: 600;\n  font-size: 1.6rem;\n  font-family: \"Poppins\", verdana, sans-serif;\n  border: 0.1rem solid #d3d3d3;\n  border-radius: 5rem 0 0 5rem;\n  box-shadow: none;\n}\n@media (min-width: 992px) {\n  .tc-search-bar_search__input__4ggjZ .MuiInputBase-input {\n    height: 4rem;\n  }\n}\n@media (max-width: 575.98px) {\n  .tc-search-bar_search__input__4ggjZ .MuiInputBase-input {\n    padding: 1rem 0 1rem 2rem;\n  }\n}\n.tc-search-bar_search__input__4ggjZ.Mui-focused .MuiInputBase-input {\n  border: 0.1rem solid #1b8158;\n  box-shadow: 0 0.3rem 0.6rem 0 rgba(33, 134, 82, 0.2);\n}\n.tc-search-bar_search__input__4ggjZ::before {\n  position: absolute;\n  top: 0.1rem;\n  right: 0.1rem;\n  z-index: 1;\n  width: 4rem;\n  height: 95%;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 70%);\n  content: \"\";\n}\n\n.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__input__4ggjZ.MuiInputBase-adornedEnd::before {\n  display: none;\n}\n@media (max-width: 575.98px) {\n  .tc-search-bar_search__paper__rv0Ak .MuiInputBase-adornedEnd .MuiInputBase-input {\n    padding-right: 5rem;\n  }\n}\n\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak {\n  position: relative;\n  z-index: 101;\n  flex-grow: 1;\n  height: 5.8rem;\n  border-radius: 0;\n  transition: 0.15s ease-in-out;\n  will-change: height;\n}\n@media (max-width: 991.98px) {\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak {\n    padding-right: calc((3.2rem) / 2);\n    padding-left: calc((3.2rem) / 2);\n  }\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__submit__ub--0 {\n  width: 5rem;\n  height: 3.8rem;\n  margin-left: -0.1rem;\n  color: #fff;\n  background-color: #005c35;\n  border-radius: 0 5rem 5rem 0;\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__submit__ub--0:hover {\n  background-color: #005c35 !important;\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__clear__bqBqA {\n  position: absolute;\n  right: 0;\n  color: #005c35;\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__clear__bqBqA:hover {\n  background-color: transparent !important;\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__form__0bbXM {\n  position: relative;\n  display: flex;\n  margin-bottom: 1rem;\n}\n@media (max-width: 991.98px) {\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak {\n    position: absolute;\n    top: 5.4rem;\n    left: 0;\n    width: 100%;\n    box-shadow: 0 0.2rem 0.4rem 0 rgba(27, 114, 69, 0.15);\n  }\n}\n@media (min-width: 992px) {\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak {\n    height: 6.2rem;\n    box-shadow: none;\n  }\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__form__0bbXM {\n    padding: 0 !important;\n  }\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__submit__ub--0 {\n    width: 7rem;\n    height: auto;\n  }\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__result__3N7Dq {\n  position: absolute;\n  top: calc(100% - 2.5rem);\n  left: 3rem;\n  width: calc(100% - 10rem);\n  max-height: calc(95vh - 9.2rem);\n  overflow-y: auto;\n  background: #fff;\n  border-bottom-right-radius: 2rem;\n  border-bottom-left-radius: 2rem;\n  box-shadow: 0 0.2rem 1.3rem 0 rgba(0, 145, 87, 0.14);\n}\n@media (max-width: 991.98px) {\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__result__3N7Dq {\n    top: calc(100% - 1rem);\n    left: 6.3rem;\n    width: calc(100% - 15.9rem);\n  }\n}\n@media (max-width: 767.98px) {\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__result__3N7Dq {\n    left: 3.6rem;\n    width: calc(100% - 10.2rem);\n  }\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__result__3N7Dq:empty {\n  display: none;\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__resultTitle__lIi6I {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 4rem;\n  background: #f7f7f7;\n}\n@media (max-width: 767.98px) {\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__resultTitle__lIi6I {\n    padding: 1rem;\n  }\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__resultTitleLabel__u-3FT {\n  color: #13220f;\n  font-weight: bold;\n  font-size: 1.6rem;\n}\n@media (max-width: 767.98px) {\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__resultTitleLabel__u-3FT {\n    font-size: 1rem;\n  }\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__resultTitleAction__HGSJq {\n  color: #707070;\n  font-weight: 500;\n  font-size: 1.4rem;\n}\n@media (max-width: 767.98px) {\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__resultTitleAction__HGSJq {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    font-size: 0;\n  }\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__resultItem__fiGbX {\n  display: flex;\n  align-items: center;\n  margin: 1.5rem 0;\n  padding: 0 4rem;\n  color: #0a3323;\n  font-weight: 500;\n  font-size: 1.6rem;\n}\n@media (max-width: 767.98px) {\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__resultItem__fiGbX {\n    margin: 1rem 0;\n    padding: 0 1rem;\n  }\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__resultItem__fiGbX .iconSearch {\n    font-size: 1.8rem !important;\n  }\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__resultItemLabel__Kyw7m {\n  margin-left: 1rem;\n  color: #0a3323;\n  font-weight: 500;\n  font-size: 1.6rem;\n}\n@media (max-width: 767.98px) {\n  .MuiPaper-root.tc-search-bar_search__paper__rv0Ak .tc-search-bar_search__resultItemLabel__Kyw7m {\n    overflow: hidden;\n    font-size: 1.5rem;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .loader {\n  position: absolute;\n  top: 50%;\n  left: calc(100% - 13rem);\n  transform: translate(-50%, -50%);\n}\n.MuiPaper-root.tc-search-bar_search__paper__rv0Ak .loader_spinner {\n  width: 2.5rem;\n  height: 2.5rem;\n  border: 0.3rem solid #1b8158;\n  border-radius: 50%;\n  animation: tc-search-bar_spinner-bulqg1__ctfjY 0.8s infinite linear alternate, tc-search-bar_spinner-oaa3wk__4cRD- 1.6s infinite linear;\n}\n@keyframes tc-search-bar_spinner-bulqg1__ctfjY {\n  0% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);\n  }\n  12.5% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%);\n  }\n  25% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%);\n  }\n  50% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%);\n  }\n  62.5% {\n    clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%);\n  }\n  75% {\n    clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%);\n  }\n  100% {\n    clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%);\n  }\n}\n@keyframes tc-search-bar_spinner-oaa3wk__4cRD- {\n  0% {\n    transform: scaleY(1) rotate(0deg);\n  }\n  49.99% {\n    transform: scaleY(1) rotate(135deg);\n  }\n  50% {\n    transform: scaleY(-1) rotate(0deg);\n  }\n  100% {\n    transform: scaleY(-1) rotate(-135deg);\n  }\n}\n\n.searchHidden .tc-search-bar_search__paper__rv0Ak {\n  max-height: 0;\n  overflow: hidden;\n  opacity: 0;\n}";
var css$2 = {"search__paper":"tc-search-bar_search__paper__rv0Ak","search__form":"tc-search-bar_search__form__0bbXM","search__input":"tc-search-bar_search__input__4ggjZ","search__submit":"tc-search-bar_search__submit__ub--0","search__clear":"tc-search-bar_search__clear__bqBqA","search__result":"tc-search-bar_search__result__3N7Dq","search__resultTitle":"tc-search-bar_search__resultTitle__lIi6I","search__resultTitleLabel":"tc-search-bar_search__resultTitleLabel__u-3FT","search__resultTitleAction":"tc-search-bar_search__resultTitleAction__HGSJq","search__resultItem":"tc-search-bar_search__resultItem__fiGbX","search__resultItemLabel":"tc-search-bar_search__resultItemLabel__Kyw7m"};
styleInject(css_248z$3);

var build$1 = {exports: {}};

var build = build$1.exports;

var hasRequiredBuild;

function requireBuild () {
	if (hasRequiredBuild) return build$1.exports;
	hasRequiredBuild = 1;
	(function (module, exports) {
		(function(a,b){module.exports=b();})('undefined'==typeof self?build:self,function(){return function(a){function b(d){if(c[d])return c[d].exports;var e=c[d]={i:d,l:false,exports:{}};return a[d].call(e.exports,e,e.exports,b),e.l=true,e.exports}var c={};return b.m=a,b.c=c,b.d=function(a,c,d){b.o(a,c)||Object.defineProperty(a,c,{configurable:false,enumerable:true,get:d});},b.n=function(a){var c=a&&a.__esModule?function(){return a['default']}:function(){return a};return b.d(c,'a',c),c},b.o=function(a,b){return Object.prototype.hasOwnProperty.call(a,b)},b.p='./',b(b.s=2)}([function(a,b,c){Object.defineProperty(b,'__esModule',{value:true}),b.useClickOutside=function(){function a(a){b&&b.current&&(b.current.contains(a.target)?h({hasClickedOutside:false}):h({hasClickedOutside:true}));}const b=Object(d.useRef)();var c=Object(d.useState)({hasClickedOutside:false}),e=f(c,2);const g=e[0],h=e[1];return Object(d.useEffect)(()=>(window.PointerEvent?document.addEventListener('pointerdown',a):(document.addEventListener('mousedown',a),document.addEventListener('touchstart',a)),()=>{window.PointerEvent?document.addEventListener('pointerdown',a):(document.removeEventListener('mousedown',a),document.removeEventListener('touchstart',a));}),[]),[b,g.hasClickedOutside]};var d=c(1);c.n(d);var f=function(){function a(a,b){var c=[],d=true,e=false,f=void 0;try{for(var g,h=a[Symbol.iterator]();!(d=(g=h.next()).done)&&(c.push(g.value),!(b&&c.length===b));d=!0);}catch(a){e=true,f=a;}finally{try{!d&&h['return']&&h['return']();}finally{if(e)throw f}}return c}return function(b,c){if(Array.isArray(b))return b;if(Symbol.iterator in Object(b))return a(b,c);throw new TypeError('Invalid attempt to destructure non-iterable instance')}}();},function(a){a.exports=React__default;},function(a,b,c){a.exports=c(3);},function(a,b,c){Object.defineProperty(b,'__esModule',{value:true});var d=c(0);c.d(b,'useClickOutside',function(){return d.useClickOutside});}])});
		
	} (build$1));
	return build$1.exports;
}

var buildExports = requireBuild();

function useDebounce(value, timeout, callback) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    timer = _useState2[0],
    setTimer = _useState2[1];
  var clearTimer = function clearTimer() {
    if (timer) clearTimeout(timer);
  };
  useEffect(function () {
    clearTimer();
    if (value && callback) {
      var newTimer = setTimeout(callback, timeout);
      setTimer(newTimer);
    }
  }, [value]);
}

var TcSearchInput = function TcSearchInput(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useClickOutside = buildExports.useClickOutside(),
    _useClickOutside2 = _slicedToArray(_useClickOutside, 2),
    parentRef = _useClickOutside2[0],
    isClickedOutside = _useClickOutside2[1];
  var inputRef = useRef();
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchQuery = _useState4[0],
    setSearchQuery = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    searchItems = _useState6[0],
    setSearchItems = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    noSearchItems = _useState8[0],
    setNoSearchItems = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    minCharactersText = _useState0[0],
    setMinCharactersText = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isLoading = _useState10[0],
    setLoading = _useState10[1];
  var isEmpty = !searchItems || searchItems.length === 0;
  var expandContainer = function expandContainer() {
    setExpanded(true);
  };
  var changeHandler = function changeHandler(e) {
    e.preventDefault();
    var value = e.target.value.trim();
    if (value === '') {
      setNoSearchItems(false);
      setMinCharactersText(false);
      setSearchItems([]);
    } else if (value.length < props.apiSearch.minSearchCharacters) {
      setNoSearchItems(false);
      setMinCharactersText(true);
      setSearchItems([]);
    } else {
      setMinCharactersText(false);
    }
    setSearchQuery(e.target.value);
  };
  useEffect(function () {
    if (isClickedOutside) collapseContainer();
  }, [isClickedOutside]);
  var collapseContainer = function collapseContainer() {
    setExpanded(false);
    setSearchQuery('');
    setNoSearchItems(false);
    setSearchItems([]);
    setLoading(false);
    if (inputRef.current) inputRef.current.value = '';
  };
  var prepareSearchQuery = function prepareSearchQuery(query) {
    var _props$apiSearch = props.apiSearch,
      limit = _props$apiSearch.limit,
      path = _props$apiSearch.path;
    var _props$profileData$br = props.profileData.brigade_ids,
      brigadeIds = _props$profileData$br === void 0 ? [] : _props$profileData$br;
    var url = "".concat(path, "?query=").concat(query);
    if (limit) {
      url += "&limit=".concat(limit);
    }
    brigadeIds.forEach(function (brigadeId) {
      url += "&brigade_ids[]=".concat(brigadeId);
    });
    return encodeURI(url);
  };
  var handleSubmit = function handleSubmit() {
    if (!searchQuery || searchQuery.trim() === '' || searchQuery.length < props.apiSearch.minSearchCharacters) return;
    sendAnalytics({
      data: searchItems
    }, searchQuery);
    window.location = "".concat(props.apiSearch.submitPath).concat(searchQuery);
  };
  var keyPressed = function keyPressed(event) {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };
  var sendAnalytics = function sendAnalytics(res) {
    var _res$data, _res$data2, _res$data3;
    var keyword = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var totalItems = ((res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.programs) === null || _res$data === void 0 ? void 0 : _res$data.length) || 0) + ((res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.products) === null || _res$data2 === void 0 ? void 0 : _res$data2.length) || 0) + ((res === null || res === void 0 || (_res$data3 = res.data) === null || _res$data3 === void 0 || (_res$data3 = _res$data3.contests) === null || _res$data3 === void 0 ? void 0 : _res$data3.length) || 0);
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'search_results',
      data: {
        searchTerm: keyword,
        resultsCount: totalItems
      }
    });
  };
  var doSearch = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var URL, response;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(!searchQuery || searchQuery.trim() === '' || searchQuery.length < props.apiSearch.minSearchCharacters)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setMinCharactersText(false);
            setNoSearchItems(false);
            setLoading(true);
            URL = prepareSearchQuery(searchQuery);
            _context.n = 2;
            return axios.get(URL);
          case 2:
            response = _context.v;
            if (response) {
              if (response.data && response.data.length === 0 || response.data.products.length === 0 && response.data.programs.length === 0 && response.data.contests.length === 0) setNoSearchItems(true);
              setSearchItems(response.data);
            }
            setLoading(false);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function doSearch() {
      return _ref.apply(this, arguments);
    };
  }();
  useDebounce(searchQuery, 500, doSearch);
  return /*#__PURE__*/React__default.createElement(Paper, {
    className: "searchPaper ".concat(css$2.search__paper),
    ref: parentRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(css$2.search__form, " container")
  }, /*#__PURE__*/React__default.createElement(InputBase, {
    autoFocus: props.autoFocus,
    className: css$2.search__input,
    endAdornment: searchQuery && /*#__PURE__*/React__default.createElement(IconButton, {
      "aria-label": "toggle visibility",
      className: css$2.search__clear,
      onClick: collapseContainer
    }, /*#__PURE__*/React__default.createElement(CloseOutlined, {
      className: "iconClear"
    })),
    fullWidth: true,
    id: "searchInput",
    inputProps: {
      'aria-label': 'searchInput'
    },
    onChange: changeHandler,
    onFocus: expandContainer,
    onKeyDown: keyPressed,
    placeholder: props.t.placeholder,
    ref: inputRef,
    type: "text",
    value: searchQuery
  }), /*#__PURE__*/React__default.createElement(IconButton, {
    "aria-label": "search",
    className: css$2.search__submit,
    onClick: handleSubmit
  }, /*#__PURE__*/React__default.createElement(SearchRounded, {
    className: "iconSearch"
  })), isLoading && /*#__PURE__*/React__default.createElement("div", {
    className: "loader"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "loader_spinner"
  }))), isExpanded && /*#__PURE__*/React__default.createElement("div", {
    className: css$2.search__result
  }, !isEmpty && searchItems.programs.length !== 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: css$2.search__resultTitle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$2.search__resultTitleLabel
  }, props.t.programs), /*#__PURE__*/React__default.createElement("a", {
    className: css$2.search__resultTitleAction,
    href: "".concat(props.apiSearch.programsAllPath).concat(searchQuery)
  }, props.t.search_all_programs)), searchItems.programs.map(function (item) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: css$2.search__resultItem,
      key: item.url || item.name
    }, /*#__PURE__*/React__default.createElement(SearchRounded, {
      className: "iconSearch"
    }), /*#__PURE__*/React__default.createElement("a", {
      className: css$2.search__resultItemLabel,
      href: item.url,
      onClick: function onClick() {
        return sendAnalytics({
          data: searchItems
        }, searchQuery);
      }
    }, item.name));
  })), !isEmpty && searchItems.products.length !== 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: css$2.search__resultTitle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$2.search__resultTitleLabel
  }, props.t.products), /*#__PURE__*/React__default.createElement("a", {
    className: css$2.search__resultTitleAction,
    href: "".concat(props.apiSearch.productsAllPath).concat(searchQuery)
  }, props.t.search_all_products)), searchItems.products.map(function (item) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: css$2.search__resultItem,
      key: item.url || item.name
    }, /*#__PURE__*/React__default.createElement(SearchRounded, {
      className: "iconSearch"
    }), /*#__PURE__*/React__default.createElement("a", {
      className: css$2.search__resultItemLabel,
      href: item.url,
      onClick: function onClick() {
        return sendAnalytics({
          data: searchItems
        }, searchQuery);
      }
    }, item.name));
  })), !isEmpty && searchItems.contests.length !== 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: css$2.search__resultTitle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$2.search__resultTitleLabel
  }, props.t.contests)), searchItems.contests.map(function (item) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: css$2.search__resultItem,
      key: item.url || item.title
    }, /*#__PURE__*/React__default.createElement(SearchRounded, {
      className: "iconSearch"
    }), /*#__PURE__*/React__default.createElement("a", {
      className: css$2.search__resultItemLabel,
      href: item.url,
      onClick: function onClick() {
        return sendAnalytics({
          data: searchItems
        }, searchQuery);
      }
    }, item.title));
  })), (noSearchItems || minCharactersText) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: css$2.search__resultTitle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$2.search__resultTitleLabel
  }, noSearchItems ? /*#__PURE__*/React__default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: props.t.no_results
    }
  }) : props.t.min_characters)))));
};
TcSearchInput.propTypes = {
  apiSearch: PropTypes.shape({
    minSearchCharacters: PropTypes.number.isRequired,
    path: PropTypes.string.isRequired,
    limit: PropTypes.number,
    submitPath: PropTypes.string.isRequired,
    programsAllPath: PropTypes.string.isRequired,
    productsAllPath: PropTypes.string.isRequired
  }).isRequired,
  autoFocus: PropTypes.bool,
  profileData: PropTypes.shape({
    brigade_ids: PropTypes.arrayOf(PropTypes.number)
  }).isRequired,
  t: PropTypes.shape({
    placeholder: PropTypes.string.isRequired,
    programs: PropTypes.string.isRequired,
    search_all_programs: PropTypes.string.isRequired,
    products: PropTypes.string.isRequired,
    search_all_products: PropTypes.string.isRequired,
    contests: PropTypes.string.isRequired,
    no_results: PropTypes.string.isRequired,
    min_characters: PropTypes.string.isRequired
  }).isRequired
};

var renderLocaleFlags = function renderLocaleFlags(localeCode) {
  return /*#__PURE__*/React__default.createElement("svg", {
    className: css$3.countrySelector__localeFlag
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#".concat(localeCode)
  }));
};
var renderLocales = function renderLocales(locales, activeLocaleCode) {
  return Object.entries(locales).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      countries = _ref2[1];
    return /*#__PURE__*/React__default.createElement("div", {
      className: css$3.countrySelector__region,
      key: key
    }, /*#__PURE__*/React__default.createElement("div", {
      className: css$3.countrySelector__heading
    }, key), /*#__PURE__*/React__default.createElement("ul", {
      className: css$3.countrySelector__localeList
    }, countries.map(function (item) {
      return /*#__PURE__*/React__default.createElement("li", {
        className: css$3.countrySelector__localeItem,
        key: item.code
      }, /*#__PURE__*/React__default.createElement("a", {
        className: "".concat(css$3.countrySelector__localeLink, " ").concat(activeLocaleCode === item.code ? 'activeLocale' : ''),
        href: item.link
      }, renderLocaleFlags(item.code), /*#__PURE__*/React__default.createElement("span", {
        className: css$3.countrySelector__localeName
      }, item.name)));
    })));
  });
};
var TcCountrySelector = function TcCountrySelector(_ref3) {
  var activeLocaleCode = _ref3.activeLocaleCode,
    isMobile = _ref3.isMobile,
    localeFlags = _ref3.localeFlags,
    locales = _ref3.locales,
    t = _ref3.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenModal = _useState2[0],
    setIsOpenModal = _useState2[1];
  useEffect(function () {
    var fetchLocaleFlags = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, div;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return axios.get(localeFlags);
            case 1:
              response = _context.v;
              div = document.createElement('div');
              div.innerHTML = response.data;
              div.className = 'd-none';
              document.body.insertBefore(div, document.body.firstChild);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function fetchLocaleFlags() {
        return _ref4.apply(this, arguments);
      };
    }();
    fetchLocaleFlags();
  }, [localeFlags]);
  var handleOpenModal = useCallback(function () {
    setIsOpenModal(true);
  }, []);
  var handleCloseModal = useCallback(function () {
    setIsOpenModal(false);
  }, []);
  var modalBody = /*#__PURE__*/React__default.createElement("div", {
    className: css$3.modal__content
  }, renderLocales(locales, activeLocaleCode));
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$3.countrySelector
  }, isMobile ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: css$3.navbar__subLink,
    onClick: handleOpenModal
  }, /*#__PURE__*/React__default.createElement("span", null, t.country_region), renderLocaleFlags(activeLocaleCode)), /*#__PURE__*/React__default.createElement(MainModal, {
    additionalClasses: "country-selector__modal",
    handleClose: handleCloseModal,
    isModalOpen: isOpenModal,
    modalBody: modalBody
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: css$3.countrySelector__locale
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$3.countrySelector__localeBlock
  }, renderLocaleFlags(activeLocaleCode))), /*#__PURE__*/React__default.createElement("div", {
    className: css$3.countrySelector__dropdown
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$3.countrySelector__container
  }, renderLocales(locales, activeLocaleCode)))));
};
TcCountrySelector.propTypes = {
  activeLocaleCode: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  localeFlags: PropTypes.string.isRequired,
  locales: PropTypes.object.isRequired,
  t: PropTypes.any.isRequired
};

var css_248z$2 = ".sticky-subheader_container__UFuaq,\n.sticky-subheader_container-fluid__YQo6g,\n.sticky-subheader_container-xxxl2__S1jLZ,\n.sticky-subheader_container-xxxl__VRq65,\n.sticky-subheader_container-xxl__xQSD3,\n.sticky-subheader_container-xl__BuR9o,\n.sticky-subheader_container-lg__Y11v5,\n.sticky-subheader_container-md__aN-z5,\n.sticky-subheader_container-sm__ISpFv {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .sticky-subheader_container-sm__ISpFv, .sticky-subheader_container__UFuaq {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-subheader_container-md__aN-z5, .sticky-subheader_container-sm__ISpFv, .sticky-subheader_container__UFuaq {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-subheader_container-lg__Y11v5, .sticky-subheader_container-md__aN-z5, .sticky-subheader_container-sm__ISpFv, .sticky-subheader_container__UFuaq {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-subheader_container-xl__BuR9o, .sticky-subheader_container-lg__Y11v5, .sticky-subheader_container-md__aN-z5, .sticky-subheader_container-sm__ISpFv, .sticky-subheader_container__UFuaq {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-subheader_container-xxl__xQSD3, .sticky-subheader_container-xl__BuR9o, .sticky-subheader_container-lg__Y11v5, .sticky-subheader_container-md__aN-z5, .sticky-subheader_container-sm__ISpFv, .sticky-subheader_container__UFuaq {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .sticky-subheader_container-xxxl__VRq65, .sticky-subheader_container-xxl__xQSD3, .sticky-subheader_container-xl__BuR9o, .sticky-subheader_container-lg__Y11v5, .sticky-subheader_container-md__aN-z5, .sticky-subheader_container-sm__ISpFv, .sticky-subheader_container__UFuaq {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .sticky-subheader_container-xxxl2__S1jLZ, .sticky-subheader_container-xxxl__VRq65, .sticky-subheader_container-xxl__xQSD3, .sticky-subheader_container-xl__BuR9o, .sticky-subheader_container-lg__Y11v5, .sticky-subheader_container-md__aN-z5, .sticky-subheader_container-sm__ISpFv, .sticky-subheader_container__UFuaq {\n    max-width: 182rem;\n  }\n}\n.sticky-subheader_stickySubheader__6dBfz {\n  display: flex;\n  align-items: center;\n  min-height: 5rem;\n  padding: 0.5rem 0;\n  border-top: 0.1rem solid rgba(172, 172, 172, 0.35);\n}\n@media (min-width: 992px) {\n  .sticky-subheader_stickySubheader__6dBfz {\n    height: 10rem;\n  }\n}\n.sticky-subheader_stickySubheader__content__wwdG7 {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n@media (max-width: 767.98px) {\n  .sticky-subheader_stickySubheader__content__wwdG7 > div {\n    width: 100%;\n    font-size: 1.4rem;\n  }\n}\n@media (max-width: 991.98px) {\n  .sticky-subheader_stickySubheader__button__KDSB6 {\n    font-size: 1.4rem;\n  }\n}\n@media (max-width: 767.98px) {\n  .sticky-subheader_stickySubheader__button__KDSB6 {\n    width: 80%;\n  }\n  .sticky-subheader_stickySubheader__button__KDSB6::after {\n    content: none;\n  }\n}";
var css$1 = {"stickySubheader":"sticky-subheader_stickySubheader__6dBfz","stickySubheader__content":"sticky-subheader_stickySubheader__content__wwdG7","stickySubheader__button":"sticky-subheader_stickySubheader__button__KDSB6"};
styleInject(css_248z$2);

var StickySubHeader = function StickySubHeader(_ref) {
  var t = _ref.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$1.stickySubheader
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$1.stickySubheader__content
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "me-md-5"
  }, t.sticky_line_text), /*#__PURE__*/React__default.createElement("a", {
    className: "buttonComponent--primary readMoreLink--white ".concat(css$1.stickySubheader__button),
    href: t.sticky_line_button_url
  }, t.sticky_line_button))));
};
StickySubHeader.propTypes = {
  t: PropTypes.any
};

var TcProfileDropdown = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var profileData = _ref.profileData,
    t = _ref.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: css$3.profile__dropdown,
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$3.profile__container
  }, profileData.profile_name && /*#__PURE__*/React__default.createElement("div", {
    className: css$3.profile__user_name
  }, t.signed_in, ":", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("a", {
    href: profileData.profile_links[0].url
  }, /*#__PURE__*/React__default.createElement("span", null, profileData.profile_name))), /*#__PURE__*/React__default.createElement("ul", {
    className: css$3.profile__list
  }, profileData.profile_links.map(function (link) {
    return /*#__PURE__*/React__default.createElement("li", {
      className: css$3.profile__list_item,
      key: link.url
    }, /*#__PURE__*/React__default.createElement("a", _extends$2({
      href: link.url
    }, link.data_attr), link.title));
  }))));
});
TcProfileDropdown.displayName = 'TcProfileDropdown';
TcProfileDropdown.propTypes = {
  profileData: PropTypes.object.isRequired,
  t: PropTypes.any.isRequired
};

var cartIconGrey = "data:image/svg+xml,%3Csvg%20height%3D%2231.164%22%20transform%3D%22scale%28.9%29%22%20width%3D%2238.715%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M34.416%2023.555l4.171-13.9a2.792%202.792%200%200%200-2.654-3.625H10.595L9.37%201.975A2.778%202.778%200%200%200%206.7%200H1.915a1.915%201.915%200%201%200%200%203.83h4.011l1.349%204.445c.01.031.025.059.036.09s.017.085.03.128l4.574%2015.069a1.914%201.914%200%200%200%201.255%201.268%203.4%203.4%200%201%200%203.575.092h12.464a3.4%203.4%200%201%200%203.685-.026%201.915%201.915%200%200%200%201.522-1.341z%22%20fill%3D%22%23707070%22%2F%3E%3C%2Fsvg%3E";

var profileIcon = "data:image/svg+xml,%3Csvg%20data-name%3D%22Group%202382%22%20height%3D%2231.164%22%20transform%3D%22scale%28.9%29%22%20width%3D%2222.091%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle%20cx%3D%227.594%22%20cy%3D%227.594%22%20data-name%3D%22Ellipse%2033%22%20fill%3D%22%23707070%22%20r%3D%227.594%22%20transform%3D%22translate%283.383%29%22%2F%3E%3Cpath%20d%3D%22M14.415%2017.272c-.045%200-.09%200-.136-.007-.121-.005-.24-.018-.362-.018H8.174c-.123%200-.243.013-.365.018-.044%200-.088%200-.132.007A8.183%208.183%200%200%200%200%2025.395v4.954a.815.815%200%200%200%20.815.815h20.461a.815.815%200%200%200%20.815-.815v-4.957a8.183%208.183%200%200%200-7.676-8.12z%22%20data-name%3D%22Path%20626%22%20fill%3D%22%23707070%22%2F%3E%3C%2Fsvg%3E";

var TcNavbar = function TcNavbar(_ref) {
  var activeLocaleCode = _ref.activeLocaleCode,
    apiSearch = _ref.apiSearch,
    cartConfig = _ref.cartConfig,
    cartPath = _ref.cartPath,
    isInvestor = _ref.isInvestor,
    isShop = _ref.isShop,
    localeFlags = _ref.localeFlags,
    locales = _ref.locales,
    logo = _ref.logo,
    logoUrl = _ref.logoUrl,
    menuItems = _ref.menuItems,
    profileData = _ref.profileData,
    showStickySubHeader = _ref.showStickySubHeader,
    t = _ref.t;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    cartCount = _useState2[0],
    setCartCount = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    fixedHeader = _useState4[0],
    setFixedHeader = _useState4[1];
  var _useState5 = useState(window.innerWidth <= 991),
    _useState6 = _slicedToArray(_useState5, 2),
    isMobile = _useState6[0],
    setIsMobile = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isOpenMenu = _useState8[0],
    setIsOpenMenu = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isOpenProfile = _useState0[0],
    setIsOpenProfile = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isTouchDevice = _useState10[0],
    setIsTouchDevice = _useState10[1];
  var _useState11 = useState(window.innerWidth >= 991),
    _useState12 = _slicedToArray(_useState11, 2),
    searchBarVisible = _useState12[0],
    setSearchBarVisible = _useState12[1];
  var profileDropdownRef = useRef(null);
  var fetchCartCountEvent = new CustomEvent('FETCH_CART_COUNT', {});
  var handleWindowSizeChange = useCallback(function () {
    overflowView(false);
    setIsMobile(window.innerWidth <= 991);
  }, []);
  var hideSearch = useCallback(function (isOpen) {
    var header = document.getElementById('tcHeader');
    if (isOpen) {
      header.style.height = "".concat(header.clientHeight, "px");
      setSearchBarVisible(false);
    } else {
      setSearchBarVisible(true);
    }
  }, []);
  var stickyHeader = useCallback(function () {
    var navbar = document.getElementById('tcNavbar');
    var header = document.getElementById('tcHeader');
    if (window.pageYOffset > header.clientHeight) {
      if (!isMobile) {
        navbar.style.transform = 'translateY(-100%)';
        hideSearch(true);
      }
      setTimeout(function () {
        return setFixedHeader(true);
      }, 100);
    } else {
      setTimeout(function () {
        navbar.removeAttribute('style');
        if (!isMobile) {
          hideSearch(false);
        }
        if (window.pageYOffset === 0) {
          header.removeAttribute('style');
          setFixedHeader(false);
        }
      }, 100);
    }
  }, [isMobile, hideSearch]);
  var toggleDocumentScroll = function toggleDocumentScroll(isOpen) {
    var htmlTag = document.getElementsByTagName('html')[0];
    if (isMobile) {
      isOpen ? htmlTag.style.overflow = 'hidden' : htmlTag.removeAttribute('style');
    }
  };
  var overflowView = function overflowView(isOpen) {
    var htmlTag = document.getElementsByTagName('html')[0];
    if (isMobile) {
      if (isOpen) {
        htmlTag.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100vh';
      } else {
        htmlTag.removeAttribute('style');
        document.body.removeAttribute('style');
      }
    }
  };
  var fetchCartCount = function fetchCartCount() {
    var orderToken = getCookie("order_token_".concat(cartConfig.env));
    if (!orderToken || !orderToken.length) {
      return;
    }
    axios({
      headers: {
        'X-Spree-Order-Token': getCookie("order_token_".concat(cartConfig.env))
      },
      method: 'GET',
      url: cartConfig.endpoints.get_cart_count
    }).then(function (response) {
      setCartCount(response.data.count);
    })["catch"](function (error) {
      console.error('Error fetching cart count:', error);
    });
  };
  var toggleMenu = function toggleMenu() {
    setIsOpenMenu(function (prev) {
      return !prev;
    });
    toggleDocumentScroll(!isOpenMenu);
  };
  var handleClickOutsideProfile = function handleClickOutsideProfile(event) {
    if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
      setIsOpenProfile(false);
    }
  };
  var toggleProfile = function toggleProfile() {
    if (isMobile || isTouchDevice) {
      setIsOpenProfile(function (prev) {
        return !prev;
      });
    }
  };
  var renderSearchBar = function renderSearchBar() {
    return /*#__PURE__*/React__default.createElement(TcSearchInput, {
      apiSearch: apiSearch,
      autoFocus: isMobile && searchBarVisible,
      profileData: profileData,
      t: t
    });
  };
  var renderCountrySelector = function renderCountrySelector() {
    if (Object.entries(locales).length === 0 && locales.constructor === Object) return null;
    return /*#__PURE__*/React__default.createElement(TcCountrySelector, {
      activeLocaleCode: activeLocaleCode,
      isInvestor: isInvestor,
      isMobile: isMobile,
      localeFlags: localeFlags,
      locales: locales,
      t: t
    });
  };
  useEffect(function () {
    window.addEventListener('resize', handleWindowSizeChange);
    window.addEventListener('scroll', stickyHeader);
    document.addEventListener('mousedown', handleClickOutsideProfile);
    document.addEventListener('FETCH_CART_COUNT', fetchCartCount);
    document.dispatchEvent(fetchCartCountEvent);
    if ('ontouchstart' in window || navigator.maxTouchPoints) {
      setIsTouchDevice(true);
    }
    return function () {
      window.removeEventListener('resize', handleWindowSizeChange);
      window.removeEventListener('scroll', stickyHeader);
      document.removeEventListener('mousedown', handleClickOutsideProfile);
      document.addEventListener('FETCH_CART_COUNT', fetchCartCount);
    };
  }, [handleWindowSizeChange, stickyHeader]);
  return /*#__PURE__*/React__default.createElement("header", {
    className: "".concat(css$3.navbar, " ").concat(fixedHeader && !isInvestor ? 'fixed' : '', " ").concat(!searchBarVisible || isInvestor ? 'searchHidden' : ''),
    id: "tcNavbar"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-lg-12"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$3.navbar__container
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(css$3.navbar__wrapp, " ").concat(isInvestor ? "".concat(css$3.navbar__investor) : '')
  }, /*#__PURE__*/React__default.createElement("a", {
    className: css$3.navbar__logo,
    href: logoUrl
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "logo",
    height: "auto",
    src: logo,
    width: "135"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: css$3.navbar__nav_content
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$3.navbar__nav_icons
  }, !isInvestor && /*#__PURE__*/React__default.createElement(IconButton, {
    "aria-label": "search",
    className: css$3.navbar__adornment,
    onClick: function onClick() {
      hideSearch(false);
      if (isMobile) {
        overflowView(true);
      }
    }
  }, /*#__PURE__*/React__default.createElement(SearchRounded, {
    className: "iconSearch"
  })), isInvestor ? renderCountrySelector() : !isMobile && renderCountrySelector(), /*#__PURE__*/React__default.createElement("div", {
    "aria-label": "profile",
    className: "".concat(css$3.profile).concat(isOpenProfile ? ' showProfile' : '', " ").concat(isTouchDevice ? 'touch' : ''),
    onClick: toggleProfile,
    ref: profileDropdownRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: css$3.navbar__profile
  }, isMobile ? /*#__PURE__*/React__default.createElement("img", {
    alt: "Profile Icon",
    height: "31.164",
    src: profileIcon,
    width: "22.091"
  }) : /*#__PURE__*/React__default.createElement("a", {
    href: profileData.profile_icon_link
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "Profile Icon",
    height: "31.164",
    src: profileIcon,
    width: "22.091"
  }))), /*#__PURE__*/React__default.createElement(TcProfileDropdown, {
    profileData: profileData,
    ref: profileDropdownRef,
    t: t
  })), isShop && !isInvestor && /*#__PURE__*/React__default.createElement("a", {
    "aria-label": "shopping cart",
    className: css$3.navbar__shopping_cart,
    href: cartPath
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "Cart Icon",
    height: "31.164",
    src: cartIconGrey,
    width: "38.715"
  }), cartCount > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: css$3.navbar__shopping_cart_count
  }, cartCount)), isMobile && /*#__PURE__*/React__default.createElement("div", {
    className: css$3.navbar__menu_icon,
    onClick: toggleMenu
  }, /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("div", {
    className: css$3.navbar__menu_icon_text
  }, "MENU")), !isInvestor && isMobile && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, searchBarVisible && renderSearchBar(), searchBarVisible && /*#__PURE__*/React__default.createElement("div", {
    className: "searchInputOverlay ".concat(css$3.navbar_search_input_overlay),
    onClick: function onClick() {
      setIsOpenProfile(false);
      setSearchBarVisible(false);
      overflowView(false);
    }
  }))), isInvestor && !isMobile && /*#__PURE__*/React__default.createElement("div", {
    className: css$3.navbar__nav
  }, /*#__PURE__*/React__default.createElement(TcSubMenuDesktop, {
    isMobile: isMobile,
    menuItems: menuItems,
    toggleDocumentScroll: toggleDocumentScroll
  })), isMobile && isOpenMenu && /*#__PURE__*/React__default.createElement(TcSubMenuMobile, {
    menuItems: menuItems,
    profileData: profileData,
    renderCountrySelector: renderCountrySelector(),
    t: t,
    toggleMenu: toggleMenu
  }), !isInvestor && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isMobile ? isOpenMenu && /*#__PURE__*/React__default.createElement(TcSubMenuMobile, {
    menuItems: menuItems,
    profileData: profileData,
    renderCountrySelector: renderCountrySelector(),
    t: t,
    toggleMenu: toggleMenu
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: css$3.navbar__nav
  }, renderSearchBar(), /*#__PURE__*/React__default.createElement(TcSubMenuDesktop, {
    menuItems: menuItems,
    toggleDocumentScroll: toggleDocumentScroll
  }))))))))), showStickySubHeader && fixedHeader && /*#__PURE__*/React__default.createElement(StickySubHeader, {
    t: t
  }));
};
TcNavbar.propTypes = {
  activeLocaleCode: PropTypes.string,
  apiSearch: PropTypes.object,
  cartConfig: PropTypes.object,
  cartPath: PropTypes.string,
  isInvestor: PropTypes.bool,
  isShop: PropTypes.bool,
  localeFlags: PropTypes.string,
  locales: PropTypes.object,
  logo: PropTypes.string,
  logoUrl: PropTypes.string,
  menuItems: PropTypes.array,
  profileData: PropTypes.object,
  showStickySubHeader: PropTypes.bool,
  t: PropTypes.any
};

var setQueryParams = function setQueryParams(_ref) {
  var _ref$availability = _ref.availability,
    availability = _ref$availability === void 0 ? [] : _ref$availability,
    _ref$priceValue = _ref.priceValue,
    priceValue = _ref$priceValue === void 0 ? null : _ref$priceValue,
    _ref$keyword = _ref.keyword,
    keyword = _ref$keyword === void 0 ? null : _ref$keyword,
    _ref$category = _ref.category,
    category = _ref$category === void 0 ? [] : _ref$category,
    _ref$taxonValue = _ref.taxonValue,
    taxonValue = _ref$taxonValue === void 0 ? null : _ref$taxonValue,
    _ref$sortByValue = _ref.sortByValue,
    sortByValue = _ref$sortByValue === void 0 ? null : _ref$sortByValue,
    _ref$isShop = _ref.isShop,
    isShop = _ref$isShop === void 0 ? false : _ref$isShop;
  var url = new URL(window.location);
  if (!isShop && availability && availability.length > 0) {
    url.searchParams.set('availabilities[]', availability);
  }
  if (!isShop && category.length > 0) {
    category.forEach(function (item) {
      if (!url.search.includes("categories%5B%5D=".concat(item))) {
        url.searchParams.append('categories[]', item);
      }
    });
  }
  if (isShop && taxonValue) {
    url.searchParams.set('taxon', taxonValue);
  }
  if (priceValue) {
    url.searchParams.set('price', priceValue);
  }
  if (keyword) {
    url.searchParams.set(isShop ? 'keywords' : 'query', keyword);
  }
  if (isShop && sortByValue) {
    url.searchParams.set('sort_by', sortByValue);
  }
  if (availability || priceValue || keyword || category.length > 0 || taxonValue || sortByValue) {
    window.history.pushState({}, '', url);
  }
};
var deleteQueryParams = function deleteQueryParams(_ref2) {
  var _ref2$isKeywordParams = _ref2.isKeywordParamsRemoved,
    isKeywordParamsRemoved = _ref2$isKeywordParams === void 0 ? false : _ref2$isKeywordParams,
    _ref2$isTaxonParamsRe = _ref2.isTaxonParamsRemoved,
    isTaxonParamsRemoved = _ref2$isTaxonParamsRe === void 0 ? false : _ref2$isTaxonParamsRe,
    _ref2$isAvailabilityP = _ref2.isAvailabilityParamsRemoved,
    isAvailabilityParamsRemoved = _ref2$isAvailabilityP === void 0 ? false : _ref2$isAvailabilityP,
    _ref2$isCategoryParam = _ref2.isCategoryParamsRemoved,
    isCategoryParamsRemoved = _ref2$isCategoryParam === void 0 ? false : _ref2$isCategoryParam,
    _ref2$isPriceParamsRe = _ref2.isPriceParamsRemoved,
    isPriceParamsRemoved = _ref2$isPriceParamsRe === void 0 ? false : _ref2$isPriceParamsRe,
    _ref2$isSortByParamsR = _ref2.isSortByParamsRemoved,
    isSortByParamsRemoved = _ref2$isSortByParamsR === void 0 ? false : _ref2$isSortByParamsR,
    _ref2$isShop = _ref2.isShop,
    isShop = _ref2$isShop === void 0 ? false : _ref2$isShop;
  var url = new URL(window.location);
  if (isShop) {
    if (isTaxonParamsRemoved) url.searchParams["delete"]('taxon');
    if (isPriceParamsRemoved) url.searchParams["delete"]('price');
    if (isKeywordParamsRemoved) url.searchParams["delete"]('keywords');
    if (isSortByParamsRemoved) url.searchParams["delete"]('sort_by');
  } else {
    if (isCategoryParamsRemoved) url.searchParams["delete"]('categories[]');
    if (isAvailabilityParamsRemoved) url.searchParams["delete"]('availabilities[]');
    if (isPriceParamsRemoved) url.searchParams["delete"]('price');
    if (isKeywordParamsRemoved) url.searchParams["delete"]('query');
  }
  if (isKeywordParamsRemoved || isTaxonParamsRemoved || isAvailabilityParamsRemoved || isCategoryParamsRemoved || isPriceParamsRemoved) {
    window.history.pushState({}, '', url);
  }
};
var deleteCategoriesQueryParams = function deleteCategoriesQueryParams(isCategoryParamsRemoved, categoryValue) {
  var url = new URL(window.location);
  url.searchParams["delete"]('categories[]', categoryValue);
  window.history.pushState({}, '', url);
};
var getQueryParams = function getQueryParams(isShop) {
  var url = new URL(window.location);
  if (isShop) {
    var keyword = url.searchParams.get('keywords') || '';
    var price = url.searchParams.get('price') || '';
    var taxon = url.searchParams.get('taxon') || '';
    var sortBy = url.searchParams.get('sort_by') || '';
    return {
      keyword: keyword,
      price: price,
      taxon: taxon,
      sortBy: sortBy
    };
  } else {
    var _keyword = url.searchParams.get('query') || '';
    var _price = url.searchParams.get('price') || '';
    var availability = url.searchParams.get('availabilities[]') || '';
    var category = url.searchParams.getAll('categories[]') || '';
    return {
      availability: availability,
      category: category,
      keyword: _keyword,
      price: _price
    };
  }
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var breadcrumbs = _ref.breadcrumbs;
  var lastIndex = (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) - 1;
  return /*#__PURE__*/React__default.createElement("nav", {
    id: "breadcrumbs"
  }, /*#__PURE__*/React__default.createElement("ol", {
    className: "breadcrumb"
  }, breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(function (item, index) {
    if (index === lastIndex) {
      return /*#__PURE__*/React__default.createElement("li", {
        className: "breadcrumb-item",
        key: Math.random()
      }, /*#__PURE__*/React__default.createElement("span", null, item.label));
    } else {
      return /*#__PURE__*/React__default.createElement("li", {
        className: "breadcrumb-item",
        key: Math.random()
      }, /*#__PURE__*/React__default.createElement("a", {
        href: item.url
      }, /*#__PURE__*/React__default.createElement("span", null, item.label)));
    }
  })));
};
Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array
};

function useOutsideClickEvent(ref, setIsToggled) {
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsToggled(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

var CollectionFilter = function CollectionFilter(_ref) {
  var _collectionFilters$fi;
  var collectionFilters = _ref.collectionFilters,
    filterValue = _ref.filterValue,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    isMobile = _ref.isMobile;
    _ref.isShop;
    var setFilterTitle = _ref.setFilterTitle,
    setFilterValue = _ref.setFilterValue,
    setIsParamsRemoved = _ref.setIsParamsRemoved;
  var _useState = useState(!!isMobile),
    _useState2 = _slicedToArray(_useState, 2),
    isToggled = _useState2[0],
    setIsToggled = _useState2[1];
  var wrapperRef = useRef(null);

  // Close the dropdown if the user clicks outside, only on desktop
  if (!isMobile) {
    useOutsideClickEvent(wrapperRef, setIsToggled);
  }

  // Collapse / toggle classes
  var collapsedPanelClass = isToggled ? 'collectionFilter_options collapse show' : 'collectionFilter_options collapse';
  var collectionFilterToggle = isToggled ? 'collectionFilter_toggle toggle-open' : 'collectionFilter_toggle';

  // User clicks a filter option (parent or child):
  var handleFilterClick = function handleFilterClick(itemTitle, itemValue) {
    if (!isLoading) {
      // Update parent states
      setFilterTitle(itemTitle);
      setFilterValue(itemValue);
      setIsParamsRemoved(false);
      // On desktop, close the dropdown after selection
      if (!isMobile) {
        setIsToggled(false);
      }
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "collectionFilter_item",
    ref: wrapperRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "position-relative",
    id: "taxonomies"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: collectionFilterToggle,
    onClick: function onClick() {
      return setIsToggled(!isToggled);
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "label-wrapper"
  }, collectionFilters !== null && collectionFilters !== void 0 && collectionFilters.title ? collectionFilters.title : 'Loading...')), /*#__PURE__*/React__default.createElement("div", {
    className: collapsedPanelClass
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "cost-list"
  }, collectionFilters === null || collectionFilters === void 0 || (_collectionFilters$fi = collectionFilters.filters) === null || _collectionFilters$fi === void 0 ? void 0 : _collectionFilters$fi.map(function (item) {
    // For each top-level item
    var isSelected = item.value.toString() === (filterValue === null || filterValue === void 0 ? void 0 : filterValue.toString());
    return /*#__PURE__*/React__default.createElement("li", {
      className: "cost-item",
      key: item.value
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "filterCosts ".concat(isLoading ? 'disabled' : '', " ").concat(isSelected ? 'selected' : ''),
      onClick: function onClick() {
        return handleFilterClick(item.title, item.value);
      }
    }, item.title), Array.isArray(item.filters) && item.filters.length > 0 && /*#__PURE__*/React__default.createElement("ul", {
      className: "sub-category-menu"
    }, item.filters.map(function (nestedItem) {
      var nestedIsSelected = nestedItem.value.toString() === (filterValue === null || filterValue === void 0 ? void 0 : filterValue.toString());
      return /*#__PURE__*/React__default.createElement("li", {
        className: "cost-item",
        key: nestedItem.value
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "filterCosts ".concat(isLoading ? 'disabled' : '', " ").concat(nestedIsSelected ? 'selected' : ''),
        onClick: function onClick() {
          return handleFilterClick(nestedItem.title, nestedItem.value);
        }
      }, nestedItem.title));
    })));
  })))));
};
CollectionFilter.propTypes = {
  collectionFilters: PropTypes.object,
  filterValue: PropTypes.any,
  isLoading: PropTypes.bool,
  isMobile: PropTypes.bool,
  isShop: PropTypes.bool,
  setFilterTitle: PropTypes.func,
  setFilterValue: PropTypes.func,
  setIsParamsRemoved: PropTypes.func
};

var MoreButton = function MoreButton(_ref) {
  var isLoading = _ref.isLoading,
    loadMoreProducts = _ref.loadMoreProducts,
    pagination = _ref.pagination,
    t = _ref.t;
  var isDisabled = isLoading || (pagination === null || pagination === void 0 ? void 0 : pagination.page) === (pagination === null || pagination === void 0 ? void 0 : pagination.total_pages);
  return /*#__PURE__*/React__default.createElement("button", {
    className: "moreButton buttonComponent--secondary",
    disabled: isDisabled,
    onClick: function onClick() {
      loadMoreProducts((pagination === null || pagination === void 0 ? void 0 : pagination.page) + 1);
    }
  }, t.load_more, isLoading ? /*#__PURE__*/React__default.createElement("div", {
    className: "loaderWrapper",
    style: {
      left: '90%',
      position: 'absolute',
      top: '50%'
    }
  }, /*#__PURE__*/React__default.createElement(Loader, null)) : null);
};
MoreButton.propTypes = {
  isLoading: PropTypes.bool,
  loadMoreProducts: PropTypes.func,
  pagination: PropTypes.object,
  t: PropTypes.object
};

var ProgressBar = function ProgressBar(_ref) {
  var displayedItemsNumber = _ref.displayedItemsNumber,
    pagination = _ref.pagination;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  useMemo(function () {
    var calculatedValue = displayedItemsNumber / (pagination === null || pagination === void 0 ? void 0 : pagination.total_count) * 100;
    setWidth(calculatedValue);
  }, [displayedItemsNumber, pagination === null || pagination === void 0 ? void 0 : pagination.total_count]);
  var progressWidth = {
    width: "".concat(width, "%")
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "progressWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "progressLine",
    style: displayedItemsNumber && progressWidth
  }));
};
ProgressBar.propTypes = {
  displayedItemsNumber: PropTypes.number,
  pagination: PropTypes.object
};

var Viewing = function Viewing(_ref) {
  var displayedItemsNumber = _ref.displayedItemsNumber,
    pagination = _ref.pagination,
    t = _ref.t;
  var currentCount = displayedItemsNumber || 0;
  var overallCount = pagination && pagination.total_count ? pagination.total_count : 0;
  var viewingTranslation = t.viewing_of_count.replace(':count', currentCount).replace(':total_count', overallCount);
  return /*#__PURE__*/React__default.createElement("div", null, viewingTranslation);
};
Viewing.propTypes = {
  displayedItemsNumber: PropTypes.number,
  pagination: PropTypes.shape({
    total_count: PropTypes.number
  }),
  t: PropTypes.object
};

var LoadMore = function LoadMore(_ref) {
  var displayedItemsNumber = _ref.displayedItemsNumber,
    isLoading = _ref.isLoading,
    loadMoreProducts = _ref.loadMoreProducts,
    pagination = _ref.pagination,
    t = _ref.t;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, pagination.total_count > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Viewing, {
    displayedItemsNumber: displayedItemsNumber,
    pagination: pagination,
    t: t
  }), pagination.total_count <= 24 || pagination.page === pagination.total_pages ? null : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ProgressBar, {
    displayedItemsNumber: displayedItemsNumber,
    pagination: pagination
  }), /*#__PURE__*/React__default.createElement(MoreButton, {
    isLoading: isLoading,
    loadMoreProducts: loadMoreProducts,
    pagination: pagination,
    t: t
  }))) : null);
};
LoadMore.propTypes = {
  displayedItemsNumber: PropTypes.number,
  isLoading: PropTypes.bool,
  loadMoreProducts: PropTypes.func,
  pagination: PropTypes.object,
  t: PropTypes.object
};

var ActiveFilters = function ActiveFilters(_ref) {
  var activeFilters = _ref.activeFilters,
    checkBoxFilters = _ref.checkBoxFilters,
    setAvailabilityTitle = _ref.setAvailabilityTitle,
    setAvailabilityValue = _ref.setAvailabilityValue,
    setCategoryTitle = _ref.setCategoryTitle,
    setCategoryValue = _ref.setCategoryValue,
    setIsAvailabilityParamsRemoved = _ref.setIsAvailabilityParamsRemoved,
    setIsKeywordParamsRemoved = _ref.setIsKeywordParamsRemoved,
    setIsPriceParamsRemoved = _ref.setIsPriceParamsRemoved,
    setIsTaxonParamsRemoved = _ref.setIsTaxonParamsRemoved,
    setKeyword = _ref.setKeyword,
    setPriceTitle = _ref.setPriceTitle,
    setPriceValue = _ref.setPriceValue,
    setTaxonTitle = _ref.setTaxonTitle,
    setTaxonValue = _ref.setTaxonValue,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$isShop = _ref.isShop,
    isShop = _ref$isShop === void 0 ? false : _ref$isShop,
    handleClearAllFilters = _ref.handleClearAllFilters;
  var removeItem = function removeItem(arr, item) {
    return arr.filter(function (f) {
      return f !== item;
    });
  };
  var handleRemove = function handleRemove(item) {
    if (isShop) {
      if (item.type === 'taxon') {
        setIsTaxonParamsRemoved(true);
        setTaxonTitle('');
        setTaxonValue('');
      } else if (item.type === 'keyword') {
        setIsKeywordParamsRemoved(true);
        setKeyword('');
      } else if (item.type === 'price') {
        setIsPriceParamsRemoved(true);
        setPriceTitle('');
        setPriceValue('');
      }
    } else {
      if (item.type === 'availabilities[]') {
        setIsAvailabilityParamsRemoved(true);
        setAvailabilityTitle('');
        setAvailabilityValue('');
      } else if (item.type === 'keyword') {
        setIsKeywordParamsRemoved(true);
        setKeyword('');
      } else if (item.type === 'price') {
        setIsPriceParamsRemoved(true);
        setPriceTitle('');
        setPriceValue('');
      } else if (item.type === 'categories[]') {
        var removedFilter = checkBoxFilters.filters.find(function (filter) {
          return filter.title === item.title;
        });
        deleteCategoriesQueryParams(true, removedFilter === null || removedFilter === void 0 ? void 0 : removedFilter.value);
        setCategoryTitle(function (prevTitles) {
          return removeItem(prevTitles, item.title);
        });
        setCategoryValue(function (prevValues) {
          return removeItem(prevValues, removedFilter === null || removedFilter === void 0 ? void 0 : removedFilter.value);
        });
      }
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "collectionFilter_filter-tags"
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "collectionFilter_filter-tags-list"
  }, activeFilters.map(function (item) {
    var title = isShop ? item.name : item.title;
    var isCategory = isShop ? false : item.type === 'categories[]';
    if (title && title.length > 0 && !isCategory) {
      return /*#__PURE__*/React__default.createElement("li", {
        className: "collectionFilter_filter-tags-item",
        key: "".concat(item.type, "-").concat(title)
      }, /*#__PURE__*/React__default.createElement("span", null, title), /*#__PURE__*/React__default.createElement("button", {
        className: "collectionFilter_filter-tags-remove",
        disabled: isLoading,
        onClick: function onClick() {
          return !isLoading && handleRemove(item);
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "plusIcon"
      }, "+")));
    } else if (!isShop && item.type === 'categories[]') {
      return item.title.map(function (filterName) {
        return /*#__PURE__*/React__default.createElement("li", {
          className: "collectionFilter_filter-tags-item",
          key: "".concat(item.type, "-").concat(filterName)
        }, /*#__PURE__*/React__default.createElement("span", null, filterName), /*#__PURE__*/React__default.createElement("button", {
          className: "collectionFilter_filter-tags-remove",
          disabled: isLoading,
          onClick: function onClick() {
            return !isLoading && handleRemove({
              title: filterName,
              type: 'categories[]'
            });
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "plusIcon"
        }, "+")));
      });
    }
    return null;
  })), isShop ? activeFilters.filter(function (item) {
    return item.name !== '';
  }).length ? /*#__PURE__*/React__default.createElement("button", {
    className: "collectionFilter_filter-tags-clear",
    disabled: isLoading,
    onClick: function onClick() {
      return !isLoading && handleClearAllFilters();
    }
  }, "Clear Filters") : null : activeFilters.filter(function (item) {
    return item.title !== '' && item.title.length > 0 && item.type !== 'categories[]' || item.type === 'categories[]' && item.title.length !== 0;
  }).length ? /*#__PURE__*/React__default.createElement("button", {
    className: "collectionFilter_filter-tags-clear",
    disabled: isLoading,
    onClick: function onClick() {
      return !isLoading && handleClearAllFilters();
    }
  }, "Clear Filters") : null);
};
ActiveFilters.propTypes = {
  activeFilters: PropTypes.array.isRequired,
  checkBoxFilters: PropTypes.object,
  handleClearAllFilters: PropTypes.func,
  isLoading: PropTypes.bool,
  isShop: PropTypes.bool,
  setAvailabilityTitle: PropTypes.func,
  setAvailabilityValue: PropTypes.func,
  setCategoryTitle: PropTypes.func,
  setCategoryValue: PropTypes.func,
  setIsAvailabilityParamsRemoved: PropTypes.func,
  setIsKeywordParamsRemoved: PropTypes.func,
  setIsPriceParamsRemoved: PropTypes.func,
  setIsTaxonParamsRemoved: PropTypes.func,
  setKeyword: PropTypes.func,
  setPriceTitle: PropTypes.func,
  setPriceValue: PropTypes.func,
  setTaxonTitle: PropTypes.func,
  setTaxonValue: PropTypes.func
};

var CollectionFilterCheckBox = function CollectionFilterCheckBox(_ref) {
  var availabilityValue = _ref.availabilityValue,
    categoryValue = _ref.categoryValue,
    collectionFilters = _ref.collectionFilters,
    isBrigades = _ref.isBrigades,
    isLoading = _ref.isLoading,
    setFilterTitle = _ref.setFilterTitle,
    setFilterValue = _ref.setFilterValue,
    setIsParamsRemoved = _ref.setIsParamsRemoved,
    isMobile = _ref.isMobile;
  var wrapperRef = useRef(null);
  var _useState = useState(!!isMobile),
    _useState2 = _slicedToArray(_useState, 2),
    isToggled = _useState2[0],
    setIsToggled = _useState2[1];
  if (!isMobile) {
    useOutsideClickEvent(wrapperRef, setIsToggled);
  }
  var collapsedPanelClass = isToggled ? 'collectionFilter_options collapse show' : 'collectionFilter_options collapse';
  var collectionFilterToggle = isToggled ? 'collectionFilter_toggle toggle-open' : 'collectionFilter_toggle';
  var removeItem = function removeItem(arr, item) {
    return arr.filter(function (f) {
      return f !== item;
    });
  };
  var brigadeFilters = collectionFilters === null || collectionFilters === void 0 ? void 0 : collectionFilters.filters.filter(function (item) {
    if (item.value === 'zwb_product' || item.value === 'merch_product') return null;
    return item;
  });
  var filtersToRender = isBrigades ? brigadeFilters : collectionFilters === null || collectionFilters === void 0 ? void 0 : collectionFilters.filters;
  var handleSelectCategory = function handleSelectCategory(event) {
    var value = event.target.value;
    var name = event.target.getAttribute('name');
    var isChecked = event.target.checked;
    if (isChecked) {
      // Add checked item into checkList
      setFilterTitle(function (prevTitles) {
        return [].concat(_toConsumableArray(prevTitles), [name]);
      });
      setFilterValue(function (prevValues) {
        return [].concat(_toConsumableArray(prevValues), [value]);
      });
    } else {
      // Remove unchecked item from checkList
      setFilterTitle(function (prevTitles) {
        return removeItem(prevTitles, name);
      });
      setFilterValue(function (prevValues) {
        return removeItem(prevValues, value);
      });
      deleteCategoriesQueryParams(true, value);
    }
  };
  var handleSelectAvailability = function handleSelectAvailability(event) {
    var value = event.target.value;
    var name = event.target.getAttribute('name');
    var isChecked = event.target.checked;
    if (isChecked) {
      // Set the selected availability
      setFilterTitle(name);
      setFilterValue(value);
      setIsParamsRemoved(false);
    } else {
      // Clear the availability filter
      setFilterTitle('');
      setFilterValue('');
      setIsParamsRemoved(true);
      deleteCategoriesQueryParams(true, value);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "collectionFilter_item"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "position-relative",
    id: "taxonomies",
    ref: wrapperRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: collectionFilterToggle,
    onClick: function onClick() {
      return setIsToggled(!isToggled);
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "label-wrapper"
  }, collectionFilters !== null && collectionFilters !== void 0 && collectionFilters.title ? collectionFilters === null || collectionFilters === void 0 ? void 0 : collectionFilters.title : 'Loading...')), /*#__PURE__*/React__default.createElement("div", {
    className: collapsedPanelClass
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "cost-list"
  }, filtersToRender && filtersToRender.map(function (item) {
    return /*#__PURE__*/React__default.createElement("li", {
      className: "cost-item",
      key: item.value
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "filterCosts checkbox"
    }, /*#__PURE__*/React__default.createElement("input", {
      checked: availabilityValue === item.value || (categoryValue === null || categoryValue === void 0 ? void 0 : categoryValue.includes(item.value)),
      disabled: isLoading,
      name: item.title,
      onChange: function onChange(event) {
        if (availabilityValue !== null) {
          handleSelectAvailability(event);
        } else {
          handleSelectCategory(event);
          setIsParamsRemoved(false);
        }
      },
      type: "checkbox",
      value: item.value
    }), /*#__PURE__*/React__default.createElement("label", {
      className: "control-label"
    }, item.title)));
  })))));
};
var CollectionFilterCheckBox$1 = /*#__PURE__*/React__default.memo(CollectionFilterCheckBox);
CollectionFilterCheckBox.propTypes = {
  availabilityValue: PropTypes.string,
  categoryValue: PropTypes.array,
  collectionFilters: PropTypes.object,
  isBrigades: PropTypes.bool,
  isLoading: PropTypes.bool,
  isMobile: PropTypes.bool,
  setFilterTitle: PropTypes.func,
  setFilterValue: PropTypes.func,
  setIsParamsRemoved: PropTypes.func
};

var Search = function Search(_ref) {
  _ref.isShop;
    _ref.getProducts;
    var isLoading = _ref.isLoading,
    keyword = _ref.keyword,
    removeQueryParameter = _ref.removeQueryParameter,
    setKeyword = _ref.setKeyword,
    t = _ref.t;
  var url = new URL(window.location);
  var _useState = useState(keyword),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    setValue(keyword);
  }, [keyword]);
  var handleChange = function handleChange(event) {
    setValue(event.target.value);
  };
  var deleteQueryKeywords = function deleteQueryKeywords() {
    url.searchParams["delete"](removeQueryParameter);
    window.history.pushState({}, '', url);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "searchWrapper collectionFilter_instant-filter col-lg-4 col-xl-5"
  }, /*#__PURE__*/React__default.createElement("input", {
    className: "collectionFilter_instant-search",
    disabled: isLoading,
    onChange: handleChange,
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter') {
        setKeyword(value);
        if (value === '') deleteQueryKeywords();
      }
    },
    placeholder: t.search_placeholder,
    value: value
  }), /*#__PURE__*/React__default.createElement("button", {
    className: "collectionFilter_instant-button",
    disabled: isLoading,
    onClick: function onClick() {
      setKeyword(value);
      value === '' && deleteQueryKeywords();
    }
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("svg", {
    focusable: "false",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
  })))));
};
Search.propTypes = {
  getProducts: PropTypes.func,
  isLoading: PropTypes.bool,
  isShop: PropTypes.bool,
  keyword: PropTypes.string,
  removeQueryParameter: PropTypes.string,
  setKeyword: PropTypes.func,
  t: PropTypes.object
};

var HeroImage = function HeroImage(_ref) {
  var taxonHero = _ref.taxonHero;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "imageOverlay",
    style: {
      backgroundImage: "url('".concat(taxonHero === null || taxonHero === void 0 ? void 0 : taxonHero.icon_url, "')")
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "imageOverlay_container container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "imageOverlay_row contentWrapper_large"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "imageOverlay_content m-0"
  }, /*#__PURE__*/React__default.createElement("h1", {
    className: "imageOverlay_heading"
  }, taxonHero.name), /*#__PURE__*/React__default.createElement("div", {
    className: "imageOverlay_text"
  }, /*#__PURE__*/React__default.createElement("p", null, taxonHero.description))))));
};
HeroImage.propTypes = {
  taxonHero: PropTypes.object
};

var SortOrder = function SortOrder(_ref) {
  var _t$selectedOption;
  var t = _ref.t,
    selectedOption = _ref.selectedOption,
    setSortByValue = _ref.setSortByValue,
    isMobile = _ref.isMobile;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isToggled = _useState2[0],
    setIsToggled = _useState2[1];
  var wrapperRef = useRef(null);
  useState(selectedOption);
  useOutsideClickEvent(wrapperRef, setIsToggled);
  var urlSearchParams = new URL(window.location.href).searchParams;
  var defaultSortBy = urlSearchParams.has('sort_by') ? urlSearchParams.get('sort_by') : 'most_popular';
  var collapsedPanelClass = isToggled ? 'sortOrder_options collapse show' : 'sortOrder_options collapse';
  var sortOrderToggle = isToggled ? 'sortOrder_toggle toggle-open' : 'sortOrder_toggle';
  var sortOptions = [{
    title: t.most_popular,
    value: 'most_popular'
  }, {
    title: t.price_asc,
    value: 'price_asc'
  }, {
    title: t.price_desc,
    value: 'price_desc'
  }, {
    title: t.top_rated,
    value: 'top_rated'
  }, {
    title: t.name_asc,
    value: 'name_asc'
  }, {
    title: t.name_desc,
    value: 'name_desc'
  }];
  var handleChange = function handleChange(value) {
    setSortByValue(value);
    setIsToggled(false);
  };
  useEffect(function () {
    setSortByValue(defaultSortBy);
  }, [defaultSortBy]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sortOrder",
    ref: wrapperRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "position-relative"
  }, isMobile ? /*#__PURE__*/React__default.createElement("div", {
    className: "sortOrder_toggle--mobile"
  }, /*#__PURE__*/React__default.createElement("select", {
    className: sortOrderToggle,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    value: selectedOption
  }, sortOptions.map(function (_ref2) {
    var title = _ref2.title,
      value = _ref2.value;
    return /*#__PURE__*/React__default.createElement("option", {
      key: value,
      value: value
    }, title);
  }))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: sortOrderToggle,
    onClick: function onClick() {
      return setIsToggled(!isToggled);
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "sortOrder_title"
  }, /*#__PURE__*/React__default.createElement("b", {
    className: "d-none d-md-inline"
  }, t.sort_by, !isToggled && ': '), !isToggled && ((_t$selectedOption = t[selectedOption]) !== null && _t$selectedOption !== void 0 ? _t$selectedOption : selectedOption))), /*#__PURE__*/React__default.createElement("div", {
    className: collapsedPanelClass
  }, /*#__PURE__*/React__default.createElement("ul", null, sortOptions.map(function (_ref3) {
    var title = _ref3.title,
      value = _ref3.value;
    return /*#__PURE__*/React__default.createElement("li", {
      key: value
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "radio"
    }, /*#__PURE__*/React__default.createElement("input", {
      checked: selectedOption === value,
      onChange: function onChange() {
        return handleChange(value);
      },
      type: "radio",
      value: value
    }), /*#__PURE__*/React__default.createElement("label", {
      className: "collection_radio_buttons"
    }, title)));
  }))))));
};
SortOrder.propTypes = {
  isMobile: PropTypes.bool,
  selectedOption: PropTypes.string,
  setSortByValue: PropTypes.func,
  t: PropTypes.object
};

var _path$1;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.5 17v2h6v-2zm0-12v2h10V5zm10 16v-2h8v-2h-8v-2h-2v6zm-6-12v2h-4v2h4v2h2V9zm14 4v-2h-10v2zm-6-4h2V7h4V5h-4V3h-2z"
  })));
};

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#13220F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M5.636 6.136 12 12.5m0 0 6.364 6.364M12 12.5l-6.364 6.364M12 12.5l6.364-6.364"
  })));
};

var FiltersModal = function FiltersModal(_ref) {
  var isLoading = _ref.isLoading,
    productTotalCount = _ref.productTotalCount,
    renderFilters = _ref.renderFilters,
    handleClearAllFilters = _ref.handleClearAllFilters,
    t = _ref.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenFilter = _useState2[0],
    setIsOpenFilter = _useState2[1];
  var resultsTitleTranslations = t.filters_results_title;
  var replacedResultsTitleTranslations = resultsTitleTranslations.replace(':number_of_items', productTotalCount);
  var toggleFilterModal = function toggleFilterModal() {
    var htmlTag = document.getElementsByTagName('html')[0];
    setIsOpenFilter(function (prevState) {
      var nextState = !prevState;
      if (nextState) {
        htmlTag.style.overflow = 'hidden';
      } else {
        htmlTag.removeAttribute('style');
      }
      return nextState;
    });
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("button", {
    className: "filterButton buttonComponent--primary buttonComponent--small w-100",
    onClick: function onClick() {
      return toggleFilterModal();
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "w-100"
  }, t.filters_button_title), /*#__PURE__*/React__default.createElement(SvgFilterIcon, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "filterPopup"
  }, isOpenFilter && /*#__PURE__*/React__default.createElement("div", {
    className: "filterPopup__overlay",
    onClick: function onClick() {
      return toggleFilterModal();
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "filterPopup__wrapper ".concat(isOpenFilter && 'isOpen')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "filterPopup__header mb-3"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "mb-0"
  }, t.filters_modal_title), /*#__PURE__*/React__default.createElement(SvgCloseIcon, {
    onClick: function onClick() {
      return toggleFilterModal();
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "filterPopup__content"
  }, renderFilters && renderFilters()), /*#__PURE__*/React__default.createElement("div", {
    className: "filterPopup__button-group"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "buttonComponent--secondary buttonComponent--small w-100",
    onClick: function onClick() {
      return handleClearAllFilters();
    }
  }, t.filters_clear_all_title), /*#__PURE__*/React__default.createElement("button", {
    className: "filterButton buttonComponent--primary buttonComponent--small mt-2 m-0 w-100",
    disabled: isLoading,
    onClick: function onClick() {
      return toggleFilterModal();
    }
  }, isLoading ? 'Loading...' : replacedResultsTitleTranslations)))));
};
FiltersModal.propTypes = {
  handleClearAllFilters: PropTypes.func,
  isLoading: PropTypes.bool,
  productTotalCount: PropTypes.number,
  renderFilters: PropTypes.func,
  t: PropTypes.object
};

var css_248z$1 = ".__listingPage_container__QBXXN,\n.__listingPage_container-fluid__pMWve,\n.__listingPage_container-xxxl2__NQUf9,\n.__listingPage_container-xxxl__8kMua,\n.__listingPage_container-xxl__xg8sx,\n.__listingPage_container-xl__yUvdD,\n.__listingPage_container-lg__v4Nuw,\n.__listingPage_container-md__-Ze9C,\n.__listingPage_container-sm__d5TaJ {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .__listingPage_container-sm__d5TaJ, .__listingPage_container__QBXXN {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .__listingPage_container-md__-Ze9C, .__listingPage_container-sm__d5TaJ, .__listingPage_container__QBXXN {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .__listingPage_container-lg__v4Nuw, .__listingPage_container-md__-Ze9C, .__listingPage_container-sm__d5TaJ, .__listingPage_container__QBXXN {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .__listingPage_container-xl__yUvdD, .__listingPage_container-lg__v4Nuw, .__listingPage_container-md__-Ze9C, .__listingPage_container-sm__d5TaJ, .__listingPage_container__QBXXN {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .__listingPage_container-xxl__xg8sx, .__listingPage_container-xl__yUvdD, .__listingPage_container-lg__v4Nuw, .__listingPage_container-md__-Ze9C, .__listingPage_container-sm__d5TaJ, .__listingPage_container__QBXXN {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .__listingPage_container-xxxl__8kMua, .__listingPage_container-xxl__xg8sx, .__listingPage_container-xl__yUvdD, .__listingPage_container-lg__v4Nuw, .__listingPage_container-md__-Ze9C, .__listingPage_container-sm__d5TaJ, .__listingPage_container__QBXXN {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .__listingPage_container-xxxl2__NQUf9, .__listingPage_container-xxxl__8kMua, .__listingPage_container-xxl__xg8sx, .__listingPage_container-xl__yUvdD, .__listingPage_container-lg__v4Nuw, .__listingPage_container-md__-Ze9C, .__listingPage_container-sm__d5TaJ, .__listingPage_container__QBXXN {\n    max-width: 182rem;\n  }\n}\n.collectionCard-listing {\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .collectionCard-listing {\n    margin: 0 -0.8rem;\n  }\n}\n.collectionCard-listing .loaderWrapper {\n  height: 7.5rem;\n  margin: 0 auto;\n}\n.collectionCard-listing .collectionCard_img-link {\n  position: absolute;\n  z-index: 2;\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n@media (min-width: 992px) {\n  .collectionCard-listing .collection-item__advertise {\n    width: 4.7rem;\n    height: 4.7rem;\n    font-size: 1rem;\n  }\n}\n.collectionCard-listing .responsiveImageEmpty {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 100%;\n  margin-top: -1px;\n}\n.collectionCard-listing .responsiveImageEmpty img {\n  max-height: 100%;\n}\n.collectionCard-listing .onSale {\n  margin-left: 0.4rem;\n  padding-left: 0.3rem;\n  color: #acacac;\n  font-weight: 400;\n  text-decoration: line-through;\n  border-left: 0.1rem solid #b2deba;\n}\n@media (max-width: 991.98px) {\n  .collectionCard-listing .collection-item__title {\n    padding: 0 0.8rem;\n  }\n}\n@media (min-width: 992px) {\n  .collectionCard-listing .collection-item__title {\n    height: 4.1rem;\n    margin-top: 0;\n    font-size: 1.6rem;\n  }\n  .collectionCard-listing .collection-item__title ~ div span {\n    font-size: 1.6rem;\n  }\n}\n.collectionCard-listing .collection-item__price-label {\n  color: #acacac;\n}\n@keyframes __listingPage_blurring__0Fe7o {\n  from {\n    backdrop-filter: blur(0.9rem);\n  }\n  to {\n    backdrop-filter: blur(1.4rem);\n  }\n}\n.collectionCard-listing .blurred {\n  position: absolute;\n  z-index: 2;\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(1.4rem);\n  animation-name: __listingPage_blurring__0Fe7o;\n  animation-duration: 1.5s;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n}\n\n.__listingPage_container__QBXXN,\n.__listingPage_container-fluid__pMWve,\n.__listingPage_container-sm__d5TaJ,\n.__listingPage_container-md__-Ze9C,\n.__listingPage_container-lg__v4Nuw,\n.__listingPage_container-xl__yUvdD,\n.__listingPage_container-xxl__xg8sx,\n.__listingPage_container-xxxl__8kMua,\n.__listingPage_container-xxxl2__NQUf9 {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD, .__listingPage_container-xxl__xg8sx {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD, .__listingPage_container-xxl__xg8sx, .__listingPage_container-xxxl__8kMua {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD, .__listingPage_container-xxl__xg8sx, .__listingPage_container-xxxl__8kMua, .__listingPage_container-xxxl2__NQUf9 {\n    max-width: 182rem;\n  }\n}\n.collectionFilter_search input {\n  height: 4.1rem;\n}\n@media (min-width: 992px) {\n  .collectionFilter_search input {\n    height: 4.8rem;\n  }\n}\n@media (max-width: 575.98px) {\n  .collectionFilter_search {\n    margin-bottom: 3rem;\n  }\n}\n\n.collectionFilter_instant-filter {\n  display: inline-flex;\n}\n@media (max-width: 991.98px) {\n  .collectionFilter_instant-filter {\n    order: 3;\n    width: 100%;\n    margin-top: 2rem;\n  }\n}\n\n.collectionFilter_instant-search {\n  width: 100%;\n  height: 4.1rem;\n  padding: 0.8rem 2.4rem;\n  border: 0.1rem solid #e5e5e5;\n  border-radius: 2.05rem 0 0 2.05rem;\n  box-shadow: 0 0.3rem 0.6rem 0 rgba(33, 134, 82, 0.08);\n}\n@media (min-width: 992px) {\n  .collectionFilter_instant-search {\n    height: 4.8rem;\n    border-radius: 2.4rem 0 0 2.4rem;\n  }\n}\n\n.collectionFilter_instant-button {\n  width: 4.1rem;\n  height: 4.1rem;\n  color: #fff;\n  font-size: 0.7rem;\n  background: #1b8158;\n  border: 0.2rem solid #1b8158;\n  border-radius: 0 2.05rem 2.05rem 0;\n  cursor: pointer;\n  transition: background-color 0.15s ease-in-out;\n  will-change: background-color;\n}\n.collectionFilter_instant-button:hover {\n  background-color: #005c35;\n  border-color: #005c35;\n}\n@media (min-width: 992px) {\n  .collectionFilter_instant-button {\n    width: 4.8rem;\n    height: 4.8rem;\n    border-radius: 0 2.4rem 2.4rem 0;\n  }\n}\n.collectionFilter_instant-button span svg {\n  fill: currentcolor;\n}\n\n.collectionFilter_collapse-btn {\n  position: relative;\n  display: block;\n  color: #13220f;\n  font-size: 1.8rem;\n}\n.collectionFilter_collapse-btn:hover, .collectionFilter_collapse-btn:active {\n  color: #13220f;\n}\n.collectionFilter_collapse-btn::before {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  width: 3.2rem;\n  height: 3.2rem;\n  background: #1b8158;\n  border-radius: 50%;\n  box-shadow: 0 0 0.8rem rgba(27, 129, 88, 0.36);\n  transform: translateY(-50%);\n  content: \"\";\n}\n.collectionFilter_collapse-btn::after {\n  position: absolute;\n  top: 50%;\n  right: -0.5rem;\n  transform: translateY(-50%);\n  transition: transform 0.15s ease-in-out;\n  content: \"\";\n}\n.collectionFilter_collapse-btn[aria-expanded=true]::after {\n  transform: rotate(-180deg) translateY(50%);\n}\n\n.collectionFilter_options {\n  width: 100%;\n}\n.collectionFilter_options ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.collectionFilter_options .sub-category-menu {\n  padding-left: 1.6rem;\n}\n.collectionFilter_options .form-group {\n  padding-bottom: 1rem;\n}\n.collectionFilter_options .checkbox {\n  margin-bottom: 0.5rem;\n}\n.collectionFilter_options .checkbox label {\n  font-size: 1.6rem;\n}\n.collectionFilter_options .checkbox label::before, .collectionFilter_options .checkbox label::after {\n  top: 0.2rem !important;\n}\n@media (max-width: 991.98px) {\n  .collectionFilter_options .checkbox input:checked ~ label {\n    font-weight: 700;\n  }\n}\n.collectionFilter_options .cost-list {\n  padding: 1.6rem 0;\n}\n.collectionFilter_options .show {\n  position: absolute;\n  z-index: 20;\n  padding: 0 1.6rem;\n  background-color: white;\n  border-bottom-right-radius: 2rem;\n  border-bottom-left-radius: 2rem;\n  box-shadow: 0 0.2rem 1.3rem 0 rgba(0, 145, 87, 0.14);\n  transition: 0.15s ease-in-out;\n}\n.collectionFilter_options .category-list.active > span,\n.collectionFilter_options .cost-list.active > span {\n  color: #1b8158;\n  font-weight: 700;\n}\n@media (min-width: 992px) {\n  .collectionFilter_options .category-list,\n  .collectionFilter_options .cost-list {\n    padding-left: 1em;\n    font-size: 1.6rem;\n  }\n}\n.collectionFilter_options .category-item,\n.collectionFilter_options .cost-item {\n  cursor: pointer;\n}\n.collectionFilter_options .category-item span,\n.collectionFilter_options .cost-item span {\n  display: block;\n  margin-bottom: 1rem;\n  line-height: 1.4;\n}\n@media (max-width: 991.98px) {\n  .collectionFilter_options .category-item span,\n  .collectionFilter_options .cost-item span {\n    margin-bottom: 0.5rem;\n    line-height: 2.2;\n  }\n}\n@media (min-width: 992px) {\n  .collectionFilter_options .category-item span:hover,\n  .collectionFilter_options .cost-item span:hover {\n    color: #1b8158;\n  }\n}\n@media (min-width: 768px) {\n  .collectionFilter_options {\n    position: absolute;\n    z-index: 10;\n    background: #fff;\n    border-radius: 0 0 2rem 2rem;\n    box-shadow: 0 1rem 1.3rem 0 rgba(0, 145, 87, 0.14);\n  }\n  .collectionFilter_options > ul {\n    padding: 1.6rem;\n  }\n}\n@media (max-width: 991.98px) {\n  .collectionFilter_options .selected {\n    color: #000 !important;\n    font-weight: 700;\n  }\n}\n\n.collectionFilter_filter-tags {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  width: 100%;\n  margin: 0 -1rem 2rem;\n}\n\n.collectionFilter_filter-tags-clear {\n  margin: 0.5rem 1rem;\n  color: #000;\n  font-weight: 700;\n  font-size: 1.6rem;\n  background-color: transparent;\n  border: none;\n}\n\n.collectionFilter_filter-tags-list {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.collectionFilter_filter-tags-item {\n  display: flex;\n  align-items: center;\n  margin: 0.5rem 1rem;\n  padding: 0 1rem 0 1.5rem;\n  font-size: 1.4rem;\n  background-color: #f7f7f7;\n  border-radius: 6rem;\n}\n\n.collectionFilter_filter-tags-remove {\n  padding: 0 0.6rem;\n  color: inherit;\n  font-size: 2rem;\n  background-color: transparent;\n  border: none;\n}\n.collectionFilter_filter-tags-remove div {\n  transform: rotate(45deg);\n}\n\n.collectionFilter_item {\n  width: 100%;\n  cursor: pointer;\n}\n@media (min-width: 992px) {\n  .collectionFilter_item {\n    margin-bottom: 2rem;\n  }\n}\n.collectionFilter_item .labelWrapper {\n  position: relative;\n  display: block;\n  padding: 1rem 2rem 1rem 1rem;\n  color: #13220f;\n  font-weight: 700;\n  line-height: 1.4;\n}\n.collectionFilter_item .labelWrapper::before {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin: 0 1rem;\n  border-color: #1b8158 transparent transparent transparent;\n  border-style: solid;\n  border-width: 0.6rem 0.6rem 0;\n  transform: translateY(-50%);\n  transition: 0.15s ease-in-out;\n  content: \"\";\n}\n.collectionFilter_item .labelWrapper::after {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  height: 0.4rem;\n  background-color: #b2deba;\n  border-radius: 0.2rem;\n  content: \"\";\n}\n\n.collectionFilter_toggle {\n  position: relative;\n  display: block;\n  color: #13220f;\n  font-weight: 700;\n}\n.collectionFilter_toggle:hover, .collectionFilter_toggle:active {\n  color: #13220f;\n  outline: none;\n}\n.collectionFilter_toggle span {\n  position: relative;\n  display: block;\n  padding: 1rem 2rem 1rem 0;\n  line-height: 1.4;\n}\n.collectionFilter_toggle span::after {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 0.4rem;\n  background-color: #b2deba;\n  border-radius: 0.2rem;\n  content: \"\";\n}\n.collectionFilter_toggle span::before {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin: 0 1rem;\n  border-color: #1b8158 transparent transparent transparent;\n  border-style: solid;\n  border-width: 0.6rem 0.6rem 0;\n  transform: translateY(-50%);\n  transition: 0.15s ease-in-out;\n  content: \"\";\n}\n@media (max-width: 991.98px) {\n  .collectionFilter_toggle span {\n    padding: 1.5rem 2rem 1.5rem 0;\n  }\n}\n.collectionFilter_toggle.toggle-open {\n  transition: 0.15s ease-in-out;\n}\n@media (min-width: 992px) {\n  .collectionFilter_toggle.toggle-open {\n    border-radius: 2rem 2rem 0 0;\n    box-shadow: 0 0.2rem 1.3rem 0 rgba(0, 145, 87, 0.14);\n  }\n}\n@media (max-width: 991.98px) {\n  .collectionFilter_toggle.toggle-open span::before {\n    transform: rotate(-180deg) translateY(50%);\n  }\n}\n@media (min-width: 768px) {\n  .collectionFilter_toggle {\n    padding: 0 1.6rem;\n    font-size: 1.6rem;\n  }\n  .collectionFilter_toggle[aria-expanded=true] {\n    border-radius: 2rem 2rem 0 0;\n  }\n}\n\n.searchFiltersWrapper {\n  display: flex;\n  gap: 2rem;\n  justify-content: space-between;\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .searchFiltersWrapper {\n    flex-wrap: wrap;\n    gap: 0;\n    margin: 2rem 0;\n  }\n}\n.searchFiltersWrapper .filterWrapper {\n  display: flex;\n  gap: 2rem;\n  justify-content: space-between;\n  width: 100%;\n}\n@media (max-width: 991.98px) {\n  .searchFiltersWrapper .filterWrapper {\n    display: block;\n    width: 50%;\n    padding-right: 0.8rem;\n  }\n}\n\n.filterPopup__wrapper {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 10000;\n  width: 100%;\n  height: 92%;\n  background: #fff;\n  border-radius: 2rem 2rem 0 0;\n  box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 0, 0, 0.2);\n  transform: translateY(100%);\n  transition: transform 0.3s ease-in-out;\n}\n.filterPopup__wrapper.isOpen {\n  transform: translateY(0);\n}\n\n.filterPopup__close {\n  color: #000;\n}\n\n.filterPopup__overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(25, 38, 31, 0.66);\n}\n\n.filterPopup__content {\n  height: 100%;\n  padding: 6rem 2.4rem 15rem;\n  overflow-y: auto;\n}\n\n.filterPopup__button-group {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  width: 100%;\n  padding: 2.4rem;\n  background: #fff;\n  box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 0, 0, 0.2);\n}\n\n.filterPopup__header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 2.4rem;\n  background: #fff;\n  border-radius: 2rem 2rem 0 0;\n}\n\n.__listingPage_container__QBXXN,\n.__listingPage_container-fluid__pMWve,\n.__listingPage_container-sm__d5TaJ,\n.__listingPage_container-md__-Ze9C,\n.__listingPage_container-lg__v4Nuw,\n.__listingPage_container-xl__yUvdD,\n.__listingPage_container-xxl__xg8sx,\n.__listingPage_container-xxxl__8kMua,\n.__listingPage_container-xxxl2__NQUf9 {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD, .__listingPage_container-xxl__xg8sx {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD, .__listingPage_container-xxl__xg8sx, .__listingPage_container-xxxl__8kMua {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD, .__listingPage_container-xxl__xg8sx, .__listingPage_container-xxxl__8kMua, .__listingPage_container-xxxl2__NQUf9 {\n    max-width: 182rem;\n  }\n}\n.sortOrder {\n  width: 100%;\n  max-width: 28rem;\n}\n@media (max-width: 991.98px) {\n  .sortOrder {\n    width: 50%;\n    padding-left: 0.8rem;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .sortOrder_title {\n    font-weight: bold;\n  }\n}\n\n.sortOrder_toggle {\n  position: relative;\n  display: block;\n  color: #13220f;\n  background-color: transparent;\n  cursor: pointer;\n}\n.sortOrder_toggle:hover, .sortOrder_toggle:active {\n  color: #13220f;\n  outline: none;\n}\n.sortOrder_toggle span {\n  position: relative;\n  display: block;\n  padding: 1rem 2rem 1rem 0;\n  line-height: 1.4;\n}\n.sortOrder_toggle span::after {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 0.4rem;\n  background-color: #b2deba;\n  border-radius: 0.2rem;\n  content: \"\";\n}\n.sortOrder_toggle span::before {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin: 0 1rem;\n  border-color: #1b8158 transparent transparent transparent;\n  border-style: solid;\n  border-width: 0.6rem 0.6rem 0;\n  transform: translateY(-50%);\n  transition: 0.15s ease-in-out;\n  content: \"\";\n}\n@media (max-width: 991.98px) {\n  .sortOrder_toggle span {\n    padding: 0.3rem 2rem 1.7rem 0;\n    font-size: 1.6rem;\n  }\n  .sortOrder_toggle span::before {\n    top: 38%;\n    border-width: 0.8rem 0.8rem 0;\n  }\n}\n@media (min-width: 992px) {\n  .sortOrder_toggle.toggle-open {\n    border-radius: 2rem 2rem 0 0;\n    box-shadow: 0 0.2rem 1.3rem 0 rgba(0, 145, 87, 0.14);\n    transition: 0.15s ease-in-out;\n  }\n}\n.sortOrder_toggle[aria-expanded=true] span::before {\n  transform: rotate(-180deg) translateY(50%);\n}\n@media (min-width: 768px) {\n  .sortOrder_toggle {\n    padding: 0 1.6rem;\n    font-size: 1.6rem;\n  }\n  .sortOrder_toggle[aria-expanded=true] {\n    border-radius: 2rem 2rem 0 0;\n  }\n}\n\n.sortOrder_toggle--mobile {\n  padding-bottom: 1.4rem;\n  position: relative;\n}\n.sortOrder_toggle--mobile::after {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 0.4rem;\n  background-color: #b2deba;\n  border-radius: 0.2rem;\n  content: \"\";\n}\n.sortOrder_toggle--mobile::before {\n  position: absolute;\n  top: 1.4rem;\n  right: 0;\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin: 0 1rem;\n  border-color: #1b8158 transparent transparent transparent;\n  border-style: solid;\n  border-width: 0.6rem 0.6rem 0;\n  transform: translateY(-50%);\n  transition: 0.15s ease-in-out;\n  content: \"\";\n}\n.sortOrder_toggle--mobile select {\n  width: 100%;\n  font-weight: 700;\n  border: none;\n  appearance: none;\n}\n\n.sortOrder_options ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.sortOrder_options .radio input:checked ~ label {\n  font-weight: 500 !important;\n}\n.sortOrder_options .radio label {\n  padding-left: 3rem;\n  font-size: 1.6rem;\n}\n.sortOrder_options .show {\n  position: absolute;\n  z-index: 20;\n  padding: 0 1.6rem;\n  background-color: white;\n  border-bottom-right-radius: 2rem;\n  border-bottom-left-radius: 2rem;\n  box-shadow: 0 0.2rem 1.3rem 0 rgba(0, 145, 87, 0.14);\n  transition: 0.15s ease-in-out;\n}\n@media (min-width: 768px) {\n  .sortOrder_options {\n    position: absolute;\n    z-index: 10;\n    width: 100%;\n    background: #fff;\n    border-radius: 0 0 2rem 2rem;\n    box-shadow: 0 1rem 1.3rem 0 rgba(0, 145, 87, 0.14);\n  }\n  .sortOrder_options > ul {\n    padding: 1.6rem;\n  }\n}\n\n.__listingPage_container__QBXXN,\n.__listingPage_container-fluid__pMWve,\n.__listingPage_container-sm__d5TaJ,\n.__listingPage_container-md__-Ze9C,\n.__listingPage_container-lg__v4Nuw,\n.__listingPage_container-xl__yUvdD,\n.__listingPage_container-xxl__xg8sx,\n.__listingPage_container-xxxl__8kMua,\n.__listingPage_container-xxxl2__NQUf9 {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD, .__listingPage_container-xxl__xg8sx {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD, .__listingPage_container-xxl__xg8sx, .__listingPage_container-xxxl__8kMua {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD, .__listingPage_container-xxl__xg8sx, .__listingPage_container-xxxl__8kMua, .__listingPage_container-xxxl2__NQUf9 {\n    max-width: 182rem;\n  }\n}\n.progressWrapper {\n  position: relative;\n  max-width: 30rem;\n  margin: 1rem auto;\n  border-bottom: solid 0.8rem #eef4f1;\n  border-radius: 0.5rem;\n}\n.progressWrapper .progressLine {\n  position: absolute;\n  height: 0.8rem;\n  background-color: #005c35;\n  border-radius: 0.5rem;\n}\n\n.__listingPage_container__QBXXN,\n.__listingPage_container-fluid__pMWve,\n.__listingPage_container-sm__d5TaJ,\n.__listingPage_container-md__-Ze9C,\n.__listingPage_container-lg__v4Nuw,\n.__listingPage_container-xl__yUvdD,\n.__listingPage_container-xxl__xg8sx,\n.__listingPage_container-xxxl__8kMua,\n.__listingPage_container-xxxl2__NQUf9 {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD, .__listingPage_container-xxl__xg8sx {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD, .__listingPage_container-xxl__xg8sx, .__listingPage_container-xxxl__8kMua {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .__listingPage_container__QBXXN, .__listingPage_container-sm__d5TaJ, .__listingPage_container-md__-Ze9C, .__listingPage_container-lg__v4Nuw, .__listingPage_container-xl__yUvdD, .__listingPage_container-xxl__xg8sx, .__listingPage_container-xxxl__8kMua, .__listingPage_container-xxxl2__NQUf9 {\n    max-width: 182rem;\n  }\n}\n.moreButton {\n  position: relative;\n  width: 30rem;\n  margin: 2rem 0 0;\n}\n@media (max-width: 575.98px) {\n  .moreButton {\n    width: 100%;\n  }\n}";
styleInject(css_248z$1);

// --------------------------------------
// 1) HELPER FUNCTIONS
// --------------------------------------
function findTaxonNameInFilters(filtersArray, targetTaxonId) {
  var _iterator = _createForOfIteratorHelper(filtersArray),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _f$filters;
      var f = _step.value;
      if (String(f.value) === String(targetTaxonId)) {
        return f.title;
      }
      if ((_f$filters = f.filters) !== null && _f$filters !== void 0 && _f$filters.length) {
        var childResult = findTaxonNameInFilters(f.filters, targetTaxonId);
        if (childResult) return childResult;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
}
function sendAnalyticsEvent(_ref) {
  var availability = _ref.availability,
    category = _ref.category,
    isShop = _ref.isShop,
    keyword = _ref.keyword,
    price = _ref.price,
    res = _ref.res;
  window.dataLayer = window.dataLayer || [];
  var searchResults = {
    resultsCount: res.pagination.total_count,
    searchTerm: keyword || null
  };
  if (isShop) {
    var _res$taxon_hero;
    searchResults.category = ((_res$taxon_hero = res.taxon_hero) === null || _res$taxon_hero === void 0 ? void 0 : _res$taxon_hero.name) || null;
    searchResults.cost = price;
  } else {
    searchResults.category = category || null;
    searchResults.cost = price || null;
    searchResults.availabilities = availability ? [availability] : [];
  }
  window.dataLayer.push({
    event: 'search_results',
    data: searchResults
  });
}

// --------------------------------------
// 2) MAIN COMPONENT
// --------------------------------------
var TcListingPage = function TcListingPage(_ref2) {
  var _products$pagination, _products$pagination2, _products$records;
  var _ref2$brigade_ids = _ref2.brigade_ids,
    brigade_ids = _ref2$brigade_ids === void 0 ? [] : _ref2$brigade_ids,
    config = _ref2.config,
    isBrigades = _ref2.isBrigades,
    _ref2$isShop = _ref2.isShop,
    isShop = _ref2$isShop === void 0 ? false : _ref2$isShop,
    quickViewModalData = _ref2.quickViewModalData;
  // destructuring
  var endpoints = config.endpoints,
    removeQueryParameter = config.removeQueryParameter,
    translations = config.translations;
  var pageHiddenQueryParams = isBrigades ? 'exclude_categories[]=contests&exclude_categories[]=products' : 'exclude_categories[]=contests';

  // ------------------------------
  // 2.1) LOCAL STATES
  // ------------------------------
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    filters = _useState2[0],
    setFilters = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    products = _useState4[0],
    setProducts = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    filtersError = _useState6[0],
    setFiltersError = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    productsError = _useState8[0],
    setProductsError = _useState8[1];
  var _useState9 = useState(window.innerWidth <= 991),
    _useState0 = _slicedToArray(_useState9, 2),
    isMobile = _useState0[0],
    setIsMobile = _useState0[1];
  var _useState1 = useState({
      filters: false,
      moreProducts: false,
      products: false
    }),
    _useState10 = _slicedToArray(_useState1, 2),
    loadingStates = _useState10[0],
    setLoadingStates = _useState10[1];

  // These fields represent your “selected filters”
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    keyword = _useState12[0],
    setKeyword = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    priceValue = _useState14[0],
    setPriceValue = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    taxonValue = _useState16[0],
    setTaxonValue = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    sortByValue = _useState18[0],
    setSortByValue = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    availabilityValue = _useState20[0],
    setAvailabilityValue = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    categoryValue = _useState22[0],
    setCategoryValue = _useState22[1];

  // “Titles” for active filter chips or labels
  var _useState23 = useState(''),
    _useState24 = _slicedToArray(_useState23, 2),
    priceTitle = _useState24[0],
    setPriceTitle = _useState24[1];
  var _useState25 = useState(''),
    _useState26 = _slicedToArray(_useState25, 2),
    availabilityTitle = _useState26[0],
    setAvailabilityTitle = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    categoryTitle = _useState28[0],
    setCategoryTitle = _useState28[1];
  var _useState29 = useState(''),
    _useState30 = _slicedToArray(_useState29, 2),
    taxonTitle = _useState30[0],
    setTaxonTitle = _useState30[1];

  // For removing specific query params
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    isPriceParamsRemoved = _useState32[0],
    setIsPriceParamsRemoved = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    isKeywordParamsRemoved = _useState34[0],
    setIsKeywordParamsRemoved = _useState34[1];
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    isTaxonParamsRemoved = _useState36[0],
    setIsTaxonParamsRemoved = _useState36[1];
  var _useState37 = useState(false),
    _useState38 = _slicedToArray(_useState37, 2),
    isAvailabilityParamsRemoved = _useState38[0],
    setIsAvailabilityParamsRemoved = _useState38[1];
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    isCategoryParamsRemoved = _useState40[0],
    setIsCategoryParamsRemoved = _useState40[1];

  // This flag ensures we only read from the URL once
  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    hasSyncedFromUrl = _useState42[0],
    setHasSyncedFromUrl = _useState42[1];

  // ------------------------------
  // 2.2) UTILITY
  // ------------------------------
  var isLoading = function isLoading() {
    return loadingStates.filters || loadingStates.products || loadingStates.moreProducts;
  };
  var handleWindowSizeChange = useCallback(function () {
    setIsMobile(window.innerWidth <= 991);
  }, []);

  // ------------------------------
  // 2.3) FETCH FILTERS
  // ------------------------------
  var getFilters = useCallback(function () {
    setLoadingStates(function (prev) {
      return _objectSpread2(_objectSpread2({}, prev), {}, {
        filters: true
      });
    });
    fetch(endpoints.getFilters).then(function (data) {
      return data.json();
    }).then(function (res) {
      return setFilters(res);
    })["catch"](function (error) {
      return setFiltersError(error);
    })["finally"](function () {
      setLoadingStates(function (prev) {
        return _objectSpread2(_objectSpread2({}, prev), {}, {
          filters: false
        });
      });
    });
  }, [endpoints.getFilters]);

  // ------------------------------
  // 2.4) FETCH PRODUCTS
  // ------------------------------
  var getProducts = function getProducts(_ref3) {
    var _ref3$availability = _ref3.availability,
      availability = _ref3$availability === void 0 ? availabilityValue : _ref3$availability,
      _ref3$category = _ref3.category,
      category = _ref3$category === void 0 ? categoryValue : _ref3$category,
      isShop = _ref3.isShop,
      _ref3$keyword = _ref3.keyword,
      paramsKeyword = _ref3$keyword === void 0 ? keyword : _ref3$keyword,
      _ref3$price = _ref3.price,
      price = _ref3$price === void 0 ? priceValue : _ref3$price,
      _ref3$sortBy = _ref3.sortBy,
      sortBy = _ref3$sortBy === void 0 ? sortByValue : _ref3$sortBy,
      _ref3$taxon = _ref3.taxon,
      taxon = _ref3$taxon === void 0 ? taxonValue : _ref3$taxon;
    setLoadingStates(function (prev) {
      return _objectSpread2(_objectSpread2({}, prev), {}, {
        products: true
      });
    });
    var url = '';
    if (isShop) {
      url = "".concat(endpoints.getProducts, "?sort_by=").concat(sortBy, "&taxon=").concat(taxon, "&price=").concat(price, "&keywords=").concat(paramsKeyword);
    } else {
      var categoryQP = category.map(function (c) {
        return "categories[]=".concat(c, "&");
      }).join('');
      url = "".concat(endpoints.getProducts, "?").concat(categoryQP).concat(availability ? "availabilities[]=".concat(availability, "&") : '', "price=").concat(price, "&query=").concat(paramsKeyword, "&").concat(pageHiddenQueryParams);
      brigade_ids.forEach(function (brigade_id) {
        url += "&brigade_ids[]=".concat(brigade_id);
      });
    }
    fetch(url).then(function (data) {
      return data.json();
    }).then(function (res) {
      // analytics
      sendAnalyticsEvent({
        availability: availability,
        category: isShop ? null : category,
        isShop: isShop,
        keyword: paramsKeyword,
        price: price,
        res: res
      });
      setProducts(res);
    }).then(function () {
      // no longer removing keyword param
      setIsKeywordParamsRemoved(false);
    })["catch"](function (err) {
      return setProductsError(err);
    })["finally"](function () {
      return setLoadingStates(function (prev) {
        return _objectSpread2(_objectSpread2({}, prev), {}, {
          products: false
        });
      });
    });
  };

  // ------------------------------
  // 2.5) PAGINATION: LOAD MORE
  // ------------------------------
  var loadMoreProducts = function loadMoreProducts(page) {
    setLoadingStates(function (prev) {
      return _objectSpread2(_objectSpread2({}, prev), {}, {
        moreProducts: true
      });
    });
    var endpoint = isShop ? "".concat(endpoints.getProducts, "?sort_by=").concat(sortByValue, "&taxon=").concat(taxonValue, "&price=").concat(priceValue, "&keywords=").concat(keyword, "&page=").concat(page) : "".concat(endpoints.getProducts, "?").concat(categoryValue.map(function (c) {
      return "categories[]=".concat(c, "&");
    }).join('')).concat(availabilityValue ? "availabilities[]=".concat(availabilityValue, "&") : '', "price=").concat(priceValue, "&query=").concat(keyword, "&page=").concat(page, "&").concat(pageHiddenQueryParams);
    fetch(endpoint).then(function (data) {
      return data.json();
    }).then(function (res) {
      setProducts(function (prev) {
        if (isShop) {
          return {
            breadcrumbs: res.breadcrumbs,
            pagination: res.pagination,
            records: [].concat(_toConsumableArray(prev.records || []), _toConsumableArray(res.records)),
            taxon_hero: res.taxon_hero
          };
        } else {
          return {
            pagination: res.pagination,
            records: [].concat(_toConsumableArray(prev.records || []), _toConsumableArray(res.records))
          };
        }
      });
    })["catch"](setProductsError)["finally"](function () {
      return setLoadingStates(function (prev) {
        return _objectSpread2(_objectSpread2({}, prev), {}, {
          moreProducts: false
        });
      });
    });
  };

  // ------------------------------
  // 2.6) CLEAR ALL
  // ------------------------------
  var handleClearAllFilters = function handleClearAllFilters() {
    if (isShop) {
      setIsKeywordParamsRemoved(true);
      setIsPriceParamsRemoved(true);
      setIsTaxonParamsRemoved(true);
      setKeyword('');
      setPriceTitle('');
      setPriceValue('');
      setTaxonTitle('');
      setTaxonValue('');
    } else {
      setIsAvailabilityParamsRemoved(true);
      setIsCategoryParamsRemoved(true);
      setIsKeywordParamsRemoved(true);
      setIsPriceParamsRemoved(true);
      setAvailabilityTitle('');
      setAvailabilityValue('');
      setCategoryTitle([]);
      setCategoryValue([]);
      setKeyword('');
      setPriceTitle('');
      setPriceValue('');
    }
  };

  // --------------------------------------
  // 2.7) EFFECT A: ON MOUNT
  // --------------------------------------
  useEffect(function () {
    var urlParams = getQueryParams(isShop);
    if (isShop) {
      setTaxonValue(urlParams.taxon || '');
      setPriceValue(urlParams.price || '');
      setKeyword(urlParams.keyword || '');
      setSortByValue(urlParams.sortBy || '');
    } else {
      setAvailabilityValue(urlParams.availability || '');
      setCategoryValue(urlParams.category || []);
      setPriceValue(urlParams.price || '');
      setKeyword(urlParams.keyword || '');
    }
    setHasSyncedFromUrl(true);
  }, [isShop]);

  // fetch the filters and window listener
  useEffect(function () {
    getFilters();
    window.addEventListener('resize', handleWindowSizeChange);
    return function () {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, [getFilters, handleWindowSizeChange]);

  // --------------------------------------
  // 2.8) EFFECT B: SYNC URL & FETCH
  // --------------------------------------
  useEffect(function () {
    if (!hasSyncedFromUrl) return;
    var params = isShop ? {
      isShop: true,
      keyword: keyword,
      priceValue: priceValue,
      sortByValue: sortByValue,
      taxonValue: taxonValue
    } : {
      availability: availabilityValue,
      category: categoryValue,
      isShop: false,
      keyword: keyword,
      priceValue: priceValue
    };

    // Update the browser URL
    setQueryParams(params);

    // Fetch products
    getProducts(params);
  }, [availabilityValue, hasSyncedFromUrl, isShop, JSON.stringify(categoryValue), keyword, priceValue, sortByValue, taxonValue]);

  // --------------------------------------
  // 2.9) DELETE PARAMS (CLEARING)
  // --------------------------------------
  useEffect(function () {
    var params = isShop ? {
      isKeywordParamsRemoved: isKeywordParamsRemoved,
      isPriceParamsRemoved: isPriceParamsRemoved,
      isShop: isShop,
      isTaxonParamsRemoved: isTaxonParamsRemoved
    } : {
      isAvailabilityParamsRemoved: isAvailabilityParamsRemoved,
      isCategoryParamsRemoved: isCategoryParamsRemoved,
      isKeywordParamsRemoved: isKeywordParamsRemoved,
      isPriceParamsRemoved: isPriceParamsRemoved,
      isShop: isShop
    };
    deleteQueryParams(params);
  }, [isAvailabilityParamsRemoved, isCategoryParamsRemoved, isKeywordParamsRemoved, isPriceParamsRemoved, isShop, isTaxonParamsRemoved]);

  // --------------------------------------
  // 2.10) FILL categoryTitle/availabilityTitle (non-shop)
  // --------------------------------------
  useEffect(function () {
    if (!isShop && filters !== null && filters !== void 0 && filters[0] && categoryValue.length > 0) {
      var catFilters = filters[0].filters || [];
      var selectedCategories = catFilters.filter(function (f) {
        return categoryValue.includes(f.value);
      });
      setCategoryTitle(selectedCategories.map(function (f) {
        return f.title;
      }));
    } else {
      setCategoryTitle([]);
    }
  }, [isShop, filters, categoryValue]);
  useEffect(function () {
    if (!isShop && filters !== null && filters !== void 0 && filters[1] && availabilityValue) {
      var availabilityFilters = filters[1].filters || [];
      var selected = availabilityFilters.find(function (f) {
        return f.value === availabilityValue;
      });
      setAvailabilityTitle(selected ? selected.title : '');
    } else {
      setAvailabilityTitle('');
    }
  }, [isShop, filters, availabilityValue]);

  // --------------------------------------
  // 2.11) FILL taxonTitle (shop) -- FIXED
  // --------------------------------------
  useEffect(function () {
    var _products$taxon_hero, _products$breadcrumbs;
    // Only run if we’re in shop mode and have a taxonValue
    if (!isShop || !taxonValue) return;
    if (!filters && !products) return;

    // Attempt to find a child taxon filter
    var allShopFilters = (filters || []).flatMap(function (f) {
      return f.filters || [];
    });
    var newTitle = findTaxonNameInFilters(allShopFilters, taxonValue);

    // If we didn’t find a child filter, fallback to taxon_hero
    if (!newTitle && products !== null && products !== void 0 && (_products$taxon_hero = products.taxon_hero) !== null && _products$taxon_hero !== void 0 && _products$taxon_hero.name) {
      newTitle = products.taxon_hero.name;
    }

    // If no hero name, fallback to matching breadcrumb
    if (!newTitle && products !== null && products !== void 0 && (_products$breadcrumbs = products.breadcrumbs) !== null && _products$breadcrumbs !== void 0 && _products$breadcrumbs.length) {
      var crumb = products.breadcrumbs.find(function (c) {
        var crumbUrl = new URL(c.url, window.location.origin);
        return crumbUrl.searchParams.get('taxon') === taxonValue;
      });
      if (crumb !== null && crumb !== void 0 && crumb.label) {
        newTitle = crumb.label;
      }
    }

    // Finally, update state if it changed
    if (newTitle && newTitle !== taxonTitle) {
      setTaxonTitle(newTitle);
    }
  }, [isShop, taxonValue, filters, products, taxonTitle]);

  // --------------------------------------
  // 2.12) RENDER FILTERS
  // --------------------------------------
  var renderFilters = function renderFilters() {
    if (isShop) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CollectionFilter, {
        collectionFilters: filters === null || filters === void 0 ? void 0 : filters[0],
        filterValue: taxonValue,
        isMobile: isMobile,
        setFilterTitle: setTaxonTitle,
        setFilterValue: setTaxonValue,
        setIsParamsRemoved: setIsTaxonParamsRemoved
      }), /*#__PURE__*/React__default.createElement(CollectionFilter, {
        collectionFilters: filters === null || filters === void 0 ? void 0 : filters[1],
        filterValue: priceValue,
        isMobile: isMobile,
        setFilterTitle: setPriceTitle,
        setFilterValue: setPriceValue,
        setIsParamsRemoved: setIsPriceParamsRemoved
      }));
    }
    // non-shop
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CollectionFilterCheckBox$1, {
      activeFilters: [],
      availabilityValue: null,
      categoryValue: categoryValue,
      collectionFilters: filters === null || filters === void 0 ? void 0 : filters[0],
      isBrigades: isBrigades,
      isLoading: isLoading(),
      isMobile: isMobile,
      setFilterTitle: setCategoryTitle,
      setFilterValue: setCategoryValue,
      setIsParamsRemoved: setIsCategoryParamsRemoved
    }), /*#__PURE__*/React__default.createElement(CollectionFilterCheckBox$1, {
      activeFilters: [],
      availabilityValue: availabilityValue,
      categoryValue: categoryValue,
      collectionFilters: filters === null || filters === void 0 ? void 0 : filters[1],
      isLoading: isLoading(),
      isMobile: isMobile,
      setFilterTitle: setAvailabilityTitle,
      setFilterValue: setAvailabilityValue,
      setIsParamsRemoved: setIsAvailabilityParamsRemoved
    }), !isBrigades && /*#__PURE__*/React__default.createElement(CollectionFilter, {
      collectionFilters: filters === null || filters === void 0 ? void 0 : filters[2],
      filterValue: priceValue,
      isLoading: isLoading(),
      isMobile: isMobile,
      setFilterTitle: setPriceTitle,
      setFilterValue: setPriceValue,
      setIsParamsRemoved: setIsPriceParamsRemoved
    }));
  };

  // Build activeFilters array for ActiveFilters component
  var activeFilters = isShop ? [{
    name: keyword,
    type: 'keyword'
  }, {
    name: priceTitle,
    type: 'price'
  }, {
    name: taxonTitle,
    type: 'taxon'
  }] : [{
    title: availabilityTitle,
    type: 'availabilities[]'
  }, {
    title: categoryTitle,
    type: 'categories[]',
    value: categoryValue
  }, {
    title: keyword,
    type: 'keyword'
  }, {
    title: priceTitle,
    type: 'price'
  }];

  // --------------------------------------
  // 2.13) RENDER
  // --------------------------------------
  if (productsError || filtersError) {
    return /*#__PURE__*/React__default.createElement("div", null, "Something went wrong. Please refresh and try again.");
  }
  return /*#__PURE__*/React__default.createElement("div", null, isShop && (products === null || products === void 0 ? void 0 : products.taxon_hero) && /*#__PURE__*/React__default.createElement(HeroImage, {
    taxonHero: products.taxon_hero
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "container"
  }, isShop && /*#__PURE__*/React__default.createElement(Breadcrumbs, {
    breadcrumbs: products === null || products === void 0 ? void 0 : products.breadcrumbs
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "searchFiltersWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "filterWrapper ".concat(!isShop && 'w-100 p-0')
  }, isMobile ? /*#__PURE__*/React__default.createElement(FiltersModal, {
    handleClearAllFilters: handleClearAllFilters,
    isLoading: isLoading(),
    productTotalCount: products === null || products === void 0 || (_products$pagination = products.pagination) === null || _products$pagination === void 0 ? void 0 : _products$pagination.total_count,
    renderFilters: renderFilters,
    t: translations
  }) : renderFilters()), /*#__PURE__*/React__default.createElement(Search, {
    getProducts: getProducts,
    isLoading: isLoading(),
    isShop: isShop,
    keyword: keyword,
    removeQueryParameter: removeQueryParameter,
    setKeyword: setKeyword,
    t: translations
  }), isShop && /*#__PURE__*/React__default.createElement(SortOrder, {
    isMobile: isMobile,
    isShop: isShop,
    selectedOption: sortByValue,
    setSortByValue: setSortByValue,
    t: translations
  })), isShop ? /*#__PURE__*/React__default.createElement(ActiveFilters, {
    activeFilters: activeFilters,
    handleClearAllFilters: handleClearAllFilters,
    isShop: isShop,
    setIsKeywordParamsRemoved: setIsKeywordParamsRemoved,
    setIsPriceParamsRemoved: setIsPriceParamsRemoved,
    setIsTaxonParamsRemoved: setIsTaxonParamsRemoved,
    setKeyword: setKeyword,
    setPriceTitle: setPriceTitle,
    setPriceValue: setPriceValue,
    setTaxonTitle: setTaxonTitle,
    setTaxonValue: setTaxonValue
  }) : /*#__PURE__*/React__default.createElement(ActiveFilters, {
    activeFilters: activeFilters,
    checkBoxFilters: filters ? filters[0] : null,
    handleClearAllFilters: handleClearAllFilters,
    isLoading: isLoading(),
    isShop: isShop,
    setAvailabilityTitle: setAvailabilityTitle,
    setAvailabilityValue: setAvailabilityValue,
    setCategoryTitle: setCategoryTitle,
    setCategoryValue: setCategoryValue,
    setIsAvailabilityParamsRemoved: setIsAvailabilityParamsRemoved,
    setIsKeywordParamsRemoved: setIsKeywordParamsRemoved,
    setIsPriceParamsRemoved: setIsPriceParamsRemoved,
    setKeyword: setKeyword,
    setPriceTitle: setPriceTitle,
    setPriceValue: setPriceValue
  }), /*#__PURE__*/React__default.createElement("div", null, (products === null || products === void 0 ? void 0 : products.records) && isLoading() && /*#__PURE__*/React__default.createElement("div", {
    className: "loaderWrapper",
    style: {
      position: 'relative',
      width: '100%',
      zIndex: '3'
    }
  }, /*#__PURE__*/React__default.createElement(Loader, {
    isLarge: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "collectionCard-listing row",
    style: {
      position: 'relative'
    }
  }, products !== null && products !== void 0 && products.records ? products.records.length > 0 ? products.records.map(function (item) {
    return /*#__PURE__*/React__default.createElement(CollectionCard, _extends$2({
      key: item.id || item.url
    }, item.id ? {
      id: item.id
    } : {}, item.advertise ? {
      advertise: item.advertise
    } : {}, !isShop ? {
      isShopProduct: !!item.spree_shop
    } : {}, item.more_than_one_variant ? {
      moreThanOneVariant: item.more_than_one_variant
    } : {}, item.old_price ? {
      oldPrice: item.old_price
    } : {}, item.on_sale ? {
      onSale: item.on_sale
    } : {}, item.recycling_program_tag ? {
      recyclingProgramTag: item.recycling_program_tag
    } : {}, item.top_label ? {
      topLabel: item.top_label
    } : {}, {
      additionalClasses: "col-6 col-sm-4 col-md-3 col-xxl-2",
      dataLayerItem: item.data_layer_item,
      image: item.image_url || item.image,
      imageAlt: item.image_alt,
      isListingItem: true,
      isLoading: isLoading(),
      name: item.name,
      price: item.display_price || item.price,
      quickViewModalData: quickViewModalData,
      translations: translations,
      url: item.url
    }));
  }) : /*#__PURE__*/React__default.createElement("h3", {
    dangerouslySetInnerHTML: {
      __html: translations.nothing_found_html
    },
    style: {
      margin: '2rem 0rem'
    }
  }) :
  /*#__PURE__*/
  // If no records yet, show a small loader
  React__default.createElement("div", {
    className: "loaderWrapper",
    style: {
      width: '75px',
      zIndex: '3'
    }
  }, /*#__PURE__*/React__default.createElement(Loader, {
    isLarge: true
  })))), Number(products === null || products === void 0 || (_products$pagination2 = products.pagination) === null || _products$pagination2 === void 0 ? void 0 : _products$pagination2.total_count) > 0 && /*#__PURE__*/React__default.createElement(LoadMore, {
    displayedItemsNumber: products === null || products === void 0 || (_products$records = products.records) === null || _products$records === void 0 ? void 0 : _products$records.length,
    isLoading: isLoading(),
    loadMoreProducts: loadMoreProducts,
    pagination: products.pagination,
    t: translations
  })));
};
TcListingPage.propTypes = {
  brigade_ids: PropTypes.array,
  config: PropTypes.object,
  isBrigades: PropTypes.bool,
  isShop: PropTypes.bool,
  quickViewModalData: PropTypes.object
};

var css_248z = ".tc-announcement-bar_container__Uc-m2,\n.tc-announcement-bar_container-fluid__Zry-3,\n.tc-announcement-bar_container-xxxl2__5j95D,\n.tc-announcement-bar_container-xxxl__bI2k6,\n.tc-announcement-bar_container-xxl__rJ89Z,\n.tc-announcement-bar_container-xl__Ppu3N,\n.tc-announcement-bar_container-lg__Ik3yC,\n.tc-announcement-bar_container-md__8fony,\n.tc-announcement-bar_container-sm__7Tc6A {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: calc(-1 * 3.2rem / 2);\n  padding-left: calc(-1 * 3.2rem / 2);\n}\n\n@media (min-width: 576px) {\n  .tc-announcement-bar_container-sm__7Tc6A, .tc-announcement-bar_container__Uc-m2 {\n    max-width: 57rem;\n  }\n}\n@media (min-width: 768px) {\n  .tc-announcement-bar_container-md__8fony, .tc-announcement-bar_container-sm__7Tc6A, .tc-announcement-bar_container__Uc-m2 {\n    max-width: 76rem;\n  }\n}\n@media (min-width: 992px) {\n  .tc-announcement-bar_container-lg__Ik3yC, .tc-announcement-bar_container-md__8fony, .tc-announcement-bar_container-sm__7Tc6A, .tc-announcement-bar_container__Uc-m2 {\n    max-width: 110rem;\n  }\n}\n@media (min-width: 1200px) {\n  .tc-announcement-bar_container-xl__Ppu3N, .tc-announcement-bar_container-lg__Ik3yC, .tc-announcement-bar_container-md__8fony, .tc-announcement-bar_container-sm__7Tc6A, .tc-announcement-bar_container__Uc-m2 {\n    max-width: 132rem;\n  }\n}\n@media (min-width: 1400px) {\n  .tc-announcement-bar_container-xxl__rJ89Z, .tc-announcement-bar_container-xl__Ppu3N, .tc-announcement-bar_container-lg__Ik3yC, .tc-announcement-bar_container-md__8fony, .tc-announcement-bar_container-sm__7Tc6A, .tc-announcement-bar_container__Uc-m2 {\n    max-width: 150rem;\n  }\n}\n@media (min-width: 1600px) {\n  .tc-announcement-bar_container-xxxl__bI2k6, .tc-announcement-bar_container-xxl__rJ89Z, .tc-announcement-bar_container-xl__Ppu3N, .tc-announcement-bar_container-lg__Ik3yC, .tc-announcement-bar_container-md__8fony, .tc-announcement-bar_container-sm__7Tc6A, .tc-announcement-bar_container__Uc-m2 {\n    max-width: 157rem;\n  }\n}\n@media (min-width: 1850px) {\n  .tc-announcement-bar_container-xxxl2__5j95D, .tc-announcement-bar_container-xxxl__bI2k6, .tc-announcement-bar_container-xxl__rJ89Z, .tc-announcement-bar_container-xl__Ppu3N, .tc-announcement-bar_container-lg__Ik3yC, .tc-announcement-bar_container-md__8fony, .tc-announcement-bar_container-sm__7Tc6A, .tc-announcement-bar_container__Uc-m2 {\n    max-width: 182rem;\n  }\n}\n.tc-announcement-bar_announcementBar__GtGpX {\n  display: block;\n  padding: 0.6rem 0;\n  color: #fff;\n  font-weight: 700;\n  font-size: 1.8rem;\n  text-align: center;\n  background-color: #1b8158;\n}\n.tc-announcement-bar_announcementBar__GtGpX:focus, .tc-announcement-bar_announcementBar__GtGpX:hover, .tc-announcement-bar_announcementBar__GtGpX:active {\n  color: #fff;\n}\n@media (max-width: 991.98px) {\n  .tc-announcement-bar_announcementBar__GtGpX {\n    margin-bottom: 0.5rem;\n  }\n}\n\n@media (max-width: 991.98px) {\n  [data-react-class=\"TCAnnouncementBarWrapper\"] ~ div .searchInputOverlay,\n  [data-react-class=\"TCAnnouncementBarWrapper\"] ~ div .searchPaper {\n    top: 10rem;\n  }\n}";
var css = {"announcementBar":"tc-announcement-bar_announcementBar__GtGpX"};
styleInject(css_248z);

// TcAnnouncementBar component renders the announcement bar section of the application
var TcAnnouncementBar = function TcAnnouncementBar(_ref) {
  var announcementContent = _ref.announcementContent;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, announcementContent.url.trim() !== '' ? /*#__PURE__*/React__default.createElement("a", {
    className: css.announcementBar,
    href: announcementContent.url,
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement("div", null, announcementContent.text))) : /*#__PURE__*/React__default.createElement("div", {
    className: css.announcementBar
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement("div", null, announcementContent.text))));
};
TcAnnouncementBar.propTypes = {
  announcementContent: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string
  })
};

export { Arrow, CollectionCard, Loader, MainModal, OpeningHours, OpeningHoursViewer, PriceLabel, QuickViewModal, SanitizeHTML, Slider, TcAddToCartSuccessModal, TcAnnouncementBar, TcCartOverlay, TcFooter, TcListingPage, TcNavbar, TcPaymentMethodSelector, TcQuickView, TcReview };
//# sourceMappingURL=index.es.js.map
